// Code generated by balancegen from data/locale/<tag>/*.toml and
// data/contracts/languages.toml. DO NOT EDIT.
// Regenerate with scripts/gen-data.sh.
//
// The locale lane (R328, R343, R854): every word the client's DOM
// writes. English is the source, and this file imports its tables
// statically from the language parts gen/strings.en.<n>.ts.
// data/locale/<tag>/ is an overlay on it, and each second language has
// its tables in the language parts gen/strings.<tag>.<n>.ts; a key an
// overlay leaves out carries the English words there, so no lookup falls
// back at runtime.
// The strings are not in the balance pack, so a reworded button does not
// read as a balance patch.
//
// One export per module: import the section and alias it, e.g.
// `import { overlay as S } from '../gen/strings';`. A sentence that
// carries values is a function of a named argument object.
//
// A [shared.*] section (validator.toml, winline.toml) is the client half
// of a message set the SERVER reports as well (R358, R377); the Go half is
// generated into the package that reports it.

import { LOCALE, LOCALES, languageTables } from './strings.load';

export { LOCALE, LOCALES, type Locale } from './strings.load';
import { tables as en_1 } from './strings.en.1';
import { tables as en_2 } from './strings.en.2';
import { tables as en_3 } from './strings.en.3';

/** The tables of the source language, joined from its language parts
 *  (R3123). Each section is in exactly one part, and the type names every
 *  section, so tsc fails on a part set that loses one. */
const source: StringTables = { ...en_1, ...en_2, ...en_3 };

/** The path prefix of a static document in this language (R856). The
 *  source language keeps the plain paths; a second language reads its
 *  documents under /<tag>/. */
export const PAGE_PREFIX = LOCALE === LOCALES[0] ? '' : '/' + LOCALE;

/** The tables of LOCALE when it is a second language, else undefined
 *  (R1429). The page's boot module loads them before it imports the
 *  application. A module that reaches this file before the load is a
 *  fault of the page, and it fails here: an English word on a German
 *  page must not pass in silence. */
const tables: StringTables | undefined = LOCALE === LOCALES[0] ? undefined : loadedTables();

function loadedTables(): StringTables {
  const t = languageTables();
  if (t === undefined) {
    throw new Error('gen/strings: the ' + LOCALE + ' tables are not loaded. ' +
      'The page entry must await loadLanguage() of gen/strings.load before it ' +
      'imports a module that reads gen/strings (i18n.md §1.1, R1429).');
  }
  return t;
}

/** the achievement badges, the hub RECORD grid, the RANKS board and the season journey */
export interface Achievements {
  readonly achievement_points_desc: string;
  readonly achievement_points_name: string;
  readonly arcade_bots_beaten_desc: string;
  readonly arcade_bots_beaten_name: string;
  readonly arcade_cells_desc: string;
  readonly arcade_cells_name: string;
  readonly arcade_daily_streak_desc: string;
  readonly arcade_daily_streak_name: string;
  readonly arcade_fastest_win_desc: string;
  readonly arcade_fastest_win_name: string;
  readonly arcade_hosted_desc: string;
  readonly arcade_hosted_name: string;
  readonly arcade_humans_beaten_desc: string;
  readonly arcade_humans_beaten_name: string;
  readonly arcade_kills_desc: string;
  readonly arcade_kills_name: string;
  readonly arcade_maps_desc: string;
  readonly arcade_maps_name: string;
  readonly arcade_matches_desc: string;
  readonly arcade_matches_name: string;
  readonly arcade_mined_desc: string;
  readonly arcade_mined_name: string;
  readonly arcade_scans_desc: string;
  readonly arcade_scans_name: string;
  readonly arcade_spectated_desc: string;
  readonly arcade_spectated_name: string;
  readonly arcade_torpedo_kills_desc: string;
  readonly arcade_torpedo_kills_name: string;
  readonly arcade_win_kinds_desc: string;
  readonly arcade_win_kinds_name: string;
  readonly arcade_wins_desc: string;
  readonly arcade_wins_name: string;
  readonly auto_rebuilds_desc: string;
  readonly auto_rebuilds_name: string;
  readonly battle_reports_desc: string;
  readonly battle_reports_name: string;
  readonly beacon_anchors_desc: string;
  readonly beacon_anchors_name: string;
  readonly beacons_lost_desc: string;
  readonly beacons_lost_name: string;
  readonly best_score_desc: string;
  readonly best_score_name: string;
  readonly blueprint_hulls_desc: string;
  readonly blueprint_hulls_name: string;
  readonly board_empty: string;
  readonly board_free: string;
  readonly board_grades: string;
  readonly board_life: string;
  readonly board_premium: string;
  readonly board_season: string;
  readonly board_taken: (p: { when: string | number }) => string;
  readonly branch_complete_desc: string;
  readonly branch_complete_name: string;
  readonly branches_opened_desc: string;
  readonly branches_opened_name: string;
  readonly bug_hunter_desc: string;
  readonly bug_hunter_name: string;
  readonly buildings_levels_desc: string;
  readonly buildings_levels_name: string;
  readonly cache_finders_desc: string;
  readonly cache_finders_name: string;
  readonly captain_all_round_desc: string;
  readonly captain_all_round_name: string;
  readonly captain_attr_max_desc: string;
  readonly captain_attr_max_name: string;
  readonly captain_practice_cap_desc: string;
  readonly captain_practice_cap_name: string;
  readonly captain_practice_desc: string;
  readonly captain_practice_name: string;
  readonly captain_retired_legend_desc: string;
  readonly captain_retired_legend_name: string;
  readonly captain_seasons_max_desc: string;
  readonly captain_seasons_max_name: string;
  readonly captains_captured_desc: string;
  readonly captains_captured_name: string;
  readonly captains_dismissed_desc: string;
  readonly captains_dismissed_name: string;
  readonly captains_lost_desc: string;
  readonly captains_lost_name: string;
  readonly captains_recruited_desc: string;
  readonly captains_recruited_name: string;
  readonly captains_trained_desc: string;
  readonly captains_trained_name: string;
  readonly captains_wounded_desc: string;
  readonly captains_wounded_name: string;
  readonly cargo_landed_desc: string;
  readonly cargo_landed_name: string;
  readonly cartographer_laureate_desc: string;
  readonly cartographer_laureate_name: string;
  readonly casino_hands_desc: string;
  readonly casino_hands_name: string;
  readonly casino_jackpots_desc: string;
  readonly casino_jackpots_name: string;
  readonly casino_pot_max_desc: string;
  readonly casino_pot_max_name: string;
  readonly casino_wagered_desc: string;
  readonly casino_wagered_name: string;
  readonly category_arcade: string;
  readonly category_arsenal: string;
  readonly category_casino: string;
  readonly category_clanwar: string;
  readonly category_event: string;
  readonly category_fellowship: string;
  readonly category_industry: string;
  readonly category_invention: string;
  readonly category_journey: string;
  readonly category_progress: (p: { done: string | number; total: string | number }) => string;
  readonly category_prospecting: string;
  readonly category_recognition: string;
  readonly category_research: string;
  readonly category_seamanship: string;
  readonly category_service: string;
  readonly category_shipyard: string;
  readonly category_siegecraft: string;
  readonly category_signals: string;
  readonly category_territory: string;
  readonly category_treasury: string;
  readonly category_wardroom: string;
  readonly category_warfare: string;
  readonly cells_lost_desc: string;
  readonly cells_lost_name: string;
  readonly cells_owned_max_desc: string;
  readonly cells_owned_max_name: string;
  readonly cells_taken_desc: string;
  readonly cells_taken_name: string;
  readonly challenger_count_desc: string;
  readonly challenger_count_name: string;
  readonly chat_lines_desc: string;
  readonly chat_lines_name: string;
  readonly chronicler_desc: string;
  readonly chronicler_name: string;
  readonly clan_founded_desc: string;
  readonly clan_founded_name: string;
  readonly clan_full_desc: string;
  readonly clan_full_name: string;
  readonly clan_seasons_desc: string;
  readonly clan_seasons_name: string;
  readonly clanwar_banner_wins_desc: string;
  readonly clanwar_banner_wins_name: string;
  readonly clanwar_battles_defended_desc: string;
  readonly clanwar_battles_defended_name: string;
  readonly clanwar_cells_taken_desc: string;
  readonly clanwar_cells_taken_name: string;
  readonly clanwar_division_desc: string;
  readonly clanwar_division_name: string;
  readonly clanwar_first_desc: string;
  readonly clanwar_first_name: string;
  readonly clanwar_first_war_desc: string;
  readonly clanwar_first_war_name: string;
  readonly clanwar_fleets_killed_desc: string;
  readonly clanwar_fleets_killed_name: string;
  readonly clanwar_full_muster_desc: string;
  readonly clanwar_full_muster_name: string;
  readonly clanwar_honour_desc: string;
  readonly clanwar_honour_name: string;
  readonly clanwar_kills_in_siege_desc: string;
  readonly clanwar_kills_in_siege_name: string;
  readonly clanwar_pledges_desc: string;
  readonly clanwar_pledges_name: string;
  readonly clanwar_points_desc: string;
  readonly clanwar_points_name: string;
  readonly clanwar_scan_reports_shared_desc: string;
  readonly clanwar_scan_reports_shared_name: string;
  readonly clanwar_sieges_won_desc: string;
  readonly clanwar_sieges_won_name: string;
  readonly clanwar_sieges_won_together_desc: string;
  readonly clanwar_sieges_won_together_name: string;
  readonly clanwar_victor_desc: string;
  readonly clanwar_victor_name: string;
  readonly clanwar_wars_desc: string;
  readonly clanwar_wars_finished_desc: string;
  readonly clanwar_wars_finished_name: string;
  readonly clanwar_wars_name: string;
  readonly comeback_desc: string;
  readonly comeback_name: string;
  readonly comms_max_desc: string;
  readonly comms_max_name: string;
  readonly community_pillar_desc: string;
  readonly community_pillar_name: string;
  readonly compact_units_desc: string;
  readonly compact_units_name: string;
  readonly contacts_heard_desc: string;
  readonly contacts_heard_name: string;
  readonly control_groups_desc: string;
  readonly control_groups_name: string;
  readonly credit_rush_desc: string;
  readonly credit_rush_name: string;
  readonly credits_earned_desc: string;
  readonly credits_earned_name: string;
  readonly credits_spent_desc: string;
  readonly credits_spent_name: string;
  readonly damage_dealt_desc: string;
  readonly damage_dealt_name: string;
  readonly damage_taken_survived_desc: string;
  readonly damage_taken_survived_name: string;
  readonly data_cores_found_desc: string;
  readonly data_cores_found_name: string;
  readonly data_cores_used_desc: string;
  readonly data_cores_used_name: string;
  readonly days_active_desc: string;
  readonly days_active_name: string;
  readonly decoys_dropped_desc: string;
  readonly decoys_dropped_name: string;
  readonly deep_runs_desc: string;
  readonly deep_runs_name: string;
  readonly deposits_emptied_desc: string;
  readonly deposits_emptied_name: string;
  readonly distance_travelled_desc: string;
  readonly distance_travelled_name: string;
  readonly docked_desc: string;
  readonly docked_name: string;
  readonly dozen_seasons_desc: string;
  readonly dozen_seasons_name: string;
  readonly effect_worn_desc: string;
  readonly effect_worn_name: string;
  readonly event_blitz_finished_desc: string;
  readonly event_blitz_finished_name: string;
  readonly event_captains_recruited_desc: string;
  readonly event_captains_recruited_name: string;
  readonly event_cells_taken_desc: string;
  readonly event_cells_taken_name: string;
  readonly event_every_window_desc: string;
  readonly event_every_window_name: string;
  readonly event_finished_desc: string;
  readonly event_finished_name: string;
  readonly event_first_desc: string;
  readonly event_first_name: string;
  readonly event_fleets_killed_desc: string;
  readonly event_fleets_killed_name: string;
  readonly event_gathered_desc: string;
  readonly event_gathered_name: string;
  readonly event_honour_desc: string;
  readonly event_honour_name: string;
  readonly event_journey_complete_desc: string;
  readonly event_journey_complete_name: string;
  readonly event_points_desc: string;
  readonly event_points_name: string;
  readonly event_roster_full_desc: string;
  readonly event_roster_full_name: string;
  readonly event_seasons_desc: string;
  readonly event_seasons_name: string;
  readonly event_ships_desc: string;
  readonly event_ships_name: string;
  readonly event_sieges_won_desc: string;
  readonly event_sieges_won_name: string;
  readonly event_tech_desc: string;
  readonly event_tech_name: string;
  readonly event_top_decile_desc: string;
  readonly event_top_decile_name: string;
  readonly event_top_half_desc: string;
  readonly event_top_half_name: string;
  readonly event_top_three_desc: string;
  readonly event_top_three_name: string;
  readonly event_win_kinds_desc: string;
  readonly event_win_kinds_name: string;
  readonly every_building_desc: string;
  readonly every_building_max_desc: string;
  readonly every_building_max_name: string;
  readonly every_building_name: string;
  readonly every_faction_desc: string;
  readonly every_faction_name: string;
  readonly every_faction_won_desc: string;
  readonly every_faction_won_name: string;
  readonly every_hull_desc: string;
  readonly every_hull_name: string;
  readonly every_victim_desc: string;
  readonly every_victim_name: string;
  readonly expeditions_deep_desc: string;
  readonly expeditions_deep_name: string;
  readonly expeditions_desc: string;
  readonly expeditions_name: string;
  readonly faction_champion_desc: string;
  readonly faction_champion_name: string;
  readonly faction_seasons_abyssal_compact_desc: string;
  readonly faction_seasons_abyssal_compact_name: string;
  readonly faction_seasons_kelp_syndicate_desc: string;
  readonly faction_seasons_kelp_syndicate_name: string;
  readonly faction_seasons_mariana_sisters_desc: string;
  readonly faction_seasons_mariana_sisters_name: string;
  readonly faction_seasons_rust_fleet_desc: string;
  readonly faction_seasons_rust_fleet_name: string;
  readonly faction_seasons_void_choir_desc: string;
  readonly faction_seasons_void_choir_name: string;
  readonly first_blood_of_season_desc: string;
  readonly first_blood_of_season_name: string;
  readonly first_hand_desc: string;
  readonly first_hand_name: string;
  readonly first_season_desc: string;
  readonly first_season_name: string;
  readonly first_strike_kills_desc: string;
  readonly first_strike_kills_name: string;
  readonly fleet_hours_desc: string;
  readonly fleet_hours_name: string;
  readonly fleets_killed_desc: string;
  readonly fleets_killed_name: string;
  readonly fleets_launched_desc: string;
  readonly fleets_launched_name: string;
  readonly fleets_lost_desc: string;
  readonly fleets_lost_name: string;
  readonly flips_from_enemy_desc: string;
  readonly flips_from_enemy_name: string;
  readonly frontier_days_desc: string;
  readonly frontier_days_name: string;
  readonly full_holds_desc: string;
  readonly full_holds_name: string;
  readonly gather_in_sov_desc: string;
  readonly gather_in_sov_name: string;
  readonly gathered_alloy_desc: string;
  readonly gathered_alloy_name: string;
  readonly gathered_biomass_desc: string;
  readonly gathered_biomass_name: string;
  readonly gathered_isotopes_desc: string;
  readonly gathered_isotopes_name: string;
  readonly gathered_units_desc: string;
  readonly gathered_units_name: string;
  readonly gathered_volatiles_desc: string;
  readonly gathered_volatiles_name: string;
  readonly grade_abyssal: string;
  readonly grade_bathyal: string;
  readonly grade_challenger: string;
  readonly grade_hadal: string;
  readonly grade_littoral: string;
  readonly grade_none: string;
  readonly grade_shelf: string;
  readonly granted_on: (p: { when: string | number }) => string;
  readonly groups_formed_desc: string;
  readonly groups_formed_name: string;
  readonly hall_of_fame_desc: string;
  readonly hall_of_fame_name: string;
  readonly hold_under_fire_held_desc: string;
  readonly hold_under_fire_held_name: string;
  readonly honour_total_desc: string;
  readonly honour_total_name: string;
  readonly idle_credits_desc: string;
  readonly idle_credits_name: string;
  readonly installations_held_desc: string;
  readonly installations_held_name: string;
  readonly intel_received_desc: string;
  readonly intel_received_name: string;
  readonly inventions_desc: string;
  readonly inventions_name: string;
  readonly isotopes_found_desc: string;
  readonly isotopes_found_name: string;
  readonly j_beacons_desc: string;
  readonly j_beacons_name: string;
  readonly j_buildings_desc: string;
  readonly j_buildings_name: string;
  readonly j_captain_desc: string;
  readonly j_captain_name: string;
  readonly j_captain_practised_desc: string;
  readonly j_captain_practised_name: string;
  readonly j_captain_trained_desc: string;
  readonly j_captain_trained_name: string;
  readonly j_cells_desc: string;
  readonly j_cells_name: string;
  readonly j_compacts_desc: string;
  readonly j_compacts_name: string;
  readonly j_data_cores_desc: string;
  readonly j_data_cores_name: string;
  readonly j_days_desc: string;
  readonly j_days_name: string;
  readonly j_deep_run_hours_desc: string;
  readonly j_deep_run_hours_name: string;
  readonly j_every_hull_class_desc: string;
  readonly j_every_hull_class_name: string;
  readonly j_everyone_home_desc: string;
  readonly j_everyone_home_name: string;
  readonly j_expedition_desc: string;
  readonly j_expedition_name: string;
  readonly j_first_ship_desc: string;
  readonly j_first_ship_name: string;
  readonly j_first_strike_desc: string;
  readonly j_first_strike_name: string;
  readonly j_first_tech_desc: string;
  readonly j_first_tech_name: string;
  readonly j_frontier_hours_desc: string;
  readonly j_frontier_hours_name: string;
  readonly j_gathered_desc: string;
  readonly j_gathered_name: string;
  readonly j_groups_formed_desc: string;
  readonly j_groups_formed_name: string;
  readonly j_installations_held_desc: string;
  readonly j_installations_held_name: string;
  readonly j_intel_desc: string;
  readonly j_intel_name: string;
  readonly j_inventions_desc: string;
  readonly j_inventions_name: string;
  readonly j_kills_desc: string;
  readonly j_kills_name: string;
  readonly j_kills_with_torpedo_desc: string;
  readonly j_kills_with_torpedo_name: string;
  readonly j_market_sales_desc: string;
  readonly j_market_sales_name: string;
  readonly j_night_watch_desc: string;
  readonly j_night_watch_name: string;
  readonly j_no_env_death_desc: string;
  readonly j_no_env_death_name: string;
  readonly j_objects_held_desc: string;
  readonly j_objects_held_name: string;
  readonly j_pledges_desc: string;
  readonly j_pledges_name: string;
  readonly j_prints_installed_desc: string;
  readonly j_prints_installed_name: string;
  readonly j_quake_desc: string;
  readonly j_quake_name: string;
  readonly j_ransom_desc: string;
  readonly j_ransom_name: string;
  readonly j_repairs_desc: string;
  readonly j_repairs_name: string;
  readonly j_salvage_desc: string;
  readonly j_salvage_name: string;
  readonly j_siege_desc: string;
  readonly j_siege_name: string;
  readonly j_torpedo_hits_desc: string;
  readonly j_torpedo_hits_name: string;
  readonly j_trench_cells_desc: string;
  readonly j_trench_cells_name: string;
  readonly journey_complete_desc: string;
  readonly journey_complete_name: string;
  readonly journey_done: string;
  readonly journey_empty: string;
  readonly journey_no_record: string;
  readonly journey_progress: (p: { done: string | number; total: string | number }) => string;
  readonly journey_title: string;
  readonly journeys_completed_desc: string;
  readonly journeys_completed_name: string;
  readonly keystones_desc: string;
  readonly keystones_name: string;
  readonly kill_streak_desc: string;
  readonly kill_streak_name: string;
  readonly kills_basilisk_desc: string;
  readonly kills_basilisk_name: string;
  readonly kills_beacon_desc: string;
  readonly kills_beacon_name: string;
  readonly kills_bombard_desc: string;
  readonly kills_bombard_name: string;
  readonly kills_corsair_desc: string;
  readonly kills_corsair_name: string;
  readonly kills_cutlass_desc: string;
  readonly kills_cutlass_name: string;
  readonly kills_dredger_desc: string;
  readonly kills_dredger_name: string;
  readonly kills_falconet_desc: string;
  readonly kills_falconet_name: string;
  readonly kills_in_enemy_sov_desc: string;
  readonly kills_in_enemy_sov_name: string;
  readonly kills_in_own_sov_desc: string;
  readonly kills_in_own_sov_name: string;
  readonly kills_lancer_desc: string;
  readonly kills_lancer_name: string;
  readonly kills_oracle_desc: string;
  readonly kills_oracle_name: string;
  readonly kills_sentinel_desc: string;
  readonly kills_sentinel_name: string;
  readonly kills_tender_desc: string;
  readonly kills_tender_name: string;
  readonly kills_vedette_desc: string;
  readonly kills_vedette_name: string;
  readonly kills_with_basilisk_desc: string;
  readonly kills_with_basilisk_name: string;
  readonly kills_with_bombard_desc: string;
  readonly kills_with_bombard_name: string;
  readonly kills_with_corsair_desc: string;
  readonly kills_with_corsair_name: string;
  readonly kills_with_cutlass_desc: string;
  readonly kills_with_cutlass_name: string;
  readonly kills_with_falconet_desc: string;
  readonly kills_with_falconet_name: string;
  readonly kills_with_lancer_desc: string;
  readonly kills_with_lancer_name: string;
  readonly kills_with_sentinel_desc: string;
  readonly kills_with_sentinel_name: string;
  readonly kills_with_vedette_desc: string;
  readonly kills_with_vedette_name: string;
  readonly largest_fleet_count_desc: string;
  readonly largest_fleet_count_name: string;
  readonly last_hold_standing_desc: string;
  readonly last_hold_standing_name: string;
  readonly level_academy_desc: string;
  readonly level_academy_name: string;
  readonly level_alloymine_desc: string;
  readonly level_alloymine_name: string;
  readonly level_base_desc: string;
  readonly level_base_name: string;
  readonly level_biomassfarm_desc: string;
  readonly level_biomassfarm_name: string;
  readonly level_communications_desc: string;
  readonly level_communications_name: string;
  readonly level_construction_desc: string;
  readonly level_construction_name: string;
  readonly level_harbour_desc: string;
  readonly level_harbour_name: string;
  readonly level_hospital_desc: string;
  readonly level_hospital_name: string;
  readonly level_logistics_desc: string;
  readonly level_logistics_name: string;
  readonly level_prison_desc: string;
  readonly level_prison_name: string;
  readonly level_radiationcontrol_desc: string;
  readonly level_radiationcontrol_name: string;
  readonly level_recruitment_desc: string;
  readonly level_recruitment_name: string;
  readonly level_researchlab_desc: string;
  readonly level_researchlab_name: string;
  readonly level_shipdesign_desc: string;
  readonly level_shipdesign_name: string;
  readonly level_sonar_desc: string;
  readonly level_sonar_name: string;
  readonly level_storage_desc: string;
  readonly level_storage_name: string;
  readonly level_torpedobanks_desc: string;
  readonly level_torpedobanks_name: string;
  readonly level_volatilesextractor_desc: string;
  readonly level_volatilesextractor_name: string;
  readonly level_wharf_desc: string;
  readonly level_wharf_name: string;
  readonly market_buys_desc: string;
  readonly market_buys_name: string;
  readonly market_sales_desc: string;
  readonly market_sales_name: string;
  readonly market_volume_desc: string;
  readonly market_volume_name: string;
  readonly mastery_arcade_desc: string;
  readonly mastery_arcade_name: string;
  readonly mastery_arsenal_desc: string;
  readonly mastery_arsenal_name: string;
  readonly mastery_casino_desc: string;
  readonly mastery_casino_name: string;
  readonly mastery_clanwar_desc: string;
  readonly mastery_clanwar_name: string;
  readonly mastery_event_desc: string;
  readonly mastery_event_name: string;
  readonly mastery_fellowship_desc: string;
  readonly mastery_fellowship_name: string;
  readonly mastery_industry_desc: string;
  readonly mastery_industry_name: string;
  readonly mastery_invention_desc: string;
  readonly mastery_invention_name: string;
  readonly mastery_prospecting_desc: string;
  readonly mastery_prospecting_name: string;
  readonly mastery_research_desc: string;
  readonly mastery_research_name: string;
  readonly mastery_seamanship_desc: string;
  readonly mastery_seamanship_name: string;
  readonly mastery_service_desc: string;
  readonly mastery_service_name: string;
  readonly mastery_shipyard_desc: string;
  readonly mastery_shipyard_name: string;
  readonly mastery_siegecraft_desc: string;
  readonly mastery_siegecraft_name: string;
  readonly mastery_signals_desc: string;
  readonly mastery_signals_name: string;
  readonly mastery_territory_desc: string;
  readonly mastery_territory_name: string;
  readonly mastery_treasury_desc: string;
  readonly mastery_treasury_name: string;
  readonly mastery_wardroom_desc: string;
  readonly mastery_wardroom_name: string;
  readonly mastery_warfare_desc: string;
  readonly mastery_warfare_name: string;
  readonly mined_units_desc: string;
  readonly mined_units_name: string;
  readonly missions_anchor_desc: string;
  readonly missions_anchor_name: string;
  readonly missions_attack_move_desc: string;
  readonly missions_attack_move_name: string;
  readonly missions_defend_desc: string;
  readonly missions_defend_name: string;
  readonly missions_gather_desc: string;
  readonly missions_gather_name: string;
  readonly missions_move_desc: string;
  readonly missions_move_name: string;
  readonly missions_patrol_desc: string;
  readonly missions_patrol_name: string;
  readonly module_families_desc: string;
  readonly module_families_name: string;
  readonly natural_blackjack_desc: string;
  readonly natural_blackjack_name: string;
  readonly next_threshold: (p: { value: string | number }) => string;
  readonly nights_at_sea_desc: string;
  readonly nights_at_sea_name: string;
  readonly npc_clan_left_desc: string;
  readonly npc_clan_left_name: string;
  readonly objects_held_windows_desc: string;
  readonly objects_held_windows_name: string;
  readonly objects_taken_archive_desc: string;
  readonly objects_taken_archive_name: string;
  readonly objects_taken_battery_desc: string;
  readonly objects_taken_battery_name: string;
  readonly objects_taken_drydock_desc: string;
  readonly objects_taken_drydock_name: string;
  readonly objects_taken_forge_desc: string;
  readonly objects_taken_forge_name: string;
  readonly objects_taken_kelp_desc: string;
  readonly objects_taken_kelp_name: string;
  readonly objects_taken_marshal_desc: string;
  readonly objects_taken_marshal_name: string;
  readonly objects_taken_spire_desc: string;
  readonly objects_taken_spire_name: string;
  readonly objects_taken_throne_desc: string;
  readonly objects_taken_throne_name: string;
  readonly objects_taken_ward_desc: string;
  readonly objects_taken_ward_name: string;
  readonly operator_thanks_desc: string;
  readonly operator_thanks_name: string;
  readonly oracle_shares_desc: string;
  readonly oracle_shares_name: string;
  readonly orders_given_desc: string;
  readonly orders_given_name: string;
  readonly pacifist_desc: string;
  readonly pacifist_name: string;
  readonly plank_owner_desc: string;
  readonly plank_owner_name: string;
  readonly pledges_desc: string;
  readonly pledges_name: string;
  readonly pocket_connected_desc: string;
  readonly pocket_connected_name: string;
  readonly prints_adopted_desc: string;
  readonly prints_adopted_name: string;
  readonly prints_installed_desc: string;
  readonly prints_installed_name: string;
  readonly prints_sold_desc: string;
  readonly prints_sold_name: string;
  readonly prints_spent_desc: string;
  readonly prints_spent_name: string;
  readonly prisoners_freed_desc: string;
  readonly prisoners_freed_name: string;
  readonly prisoners_ransomed_desc: string;
  readonly prisoners_ransomed_name: string;
  readonly progress_down: string;
  readonly quake_survived_desc: string;
  readonly quake_survived_name: string;
  readonly queue_hours_desc: string;
  readonly queue_hours_name: string;
  readonly queue_jobs_desc: string;
  readonly queue_jobs_name: string;
  readonly rank_titles_desc: string;
  readonly rank_titles_name: string;
  readonly ranks_pill: string;
  readonly recognition_label: string;
  readonly record_empty: string;
  readonly record_grades: (p: { count: string | number }) => string;
  readonly record_points: (p: { points: string | number }) => string;
  readonly registered_desc: string;
  readonly registered_name: string;
  readonly repairs_done_desc: string;
  readonly repairs_done_name: string;
  readonly replay_shared_desc: string;
  readonly replay_shared_name: string;
  readonly research_hours_desc: string;
  readonly research_hours_name: string;
  readonly reveals_desc: string;
  readonly reveals_name: string;
  readonly rim_saved_desc: string;
  readonly rim_saved_name: string;
  readonly rounds_shot_down_desc: string;
  readonly rounds_shot_down_name: string;
  readonly row_max: string;
  readonly row_value: (p: { value: string | number }) => string;
  readonly royal_flush_desc: string;
  readonly royal_flush_name: string;
  readonly sabbatical_kept_desc: string;
  readonly sabbatical_kept_name: string;
  readonly salvaged_desc: string;
  readonly salvaged_name: string;
  readonly scan_pings_desc: string;
  readonly scan_pings_name: string;
  readonly scan_reports_desc: string;
  readonly scan_reports_name: string;
  readonly season_first_desc: string;
  readonly season_first_name: string;
  readonly season_podium_desc: string;
  readonly season_podium_name: string;
  readonly season_top_decile_desc: string;
  readonly season_top_decile_name: string;
  readonly seasons_finished_desc: string;
  readonly seasons_finished_name: string;
  readonly seasons_played_desc: string;
  readonly seasons_played_name: string;
  readonly session_hours_desc: string;
  readonly session_hours_name: string;
  readonly ships_built_basilisk_desc: string;
  readonly ships_built_basilisk_name: string;
  readonly ships_built_beacon_desc: string;
  readonly ships_built_beacon_name: string;
  readonly ships_built_bombard_desc: string;
  readonly ships_built_bombard_name: string;
  readonly ships_built_corsair_desc: string;
  readonly ships_built_corsair_name: string;
  readonly ships_built_cutlass_desc: string;
  readonly ships_built_cutlass_name: string;
  readonly ships_built_desc: string;
  readonly ships_built_dredger_desc: string;
  readonly ships_built_dredger_name: string;
  readonly ships_built_falconet_desc: string;
  readonly ships_built_falconet_name: string;
  readonly ships_built_lancer_desc: string;
  readonly ships_built_lancer_name: string;
  readonly ships_built_name: string;
  readonly ships_built_oracle_desc: string;
  readonly ships_built_oracle_name: string;
  readonly ships_built_sentinel_desc: string;
  readonly ships_built_sentinel_name: string;
  readonly ships_built_tender_desc: string;
  readonly ships_built_tender_name: string;
  readonly ships_built_vedette_desc: string;
  readonly ships_built_vedette_name: string;
  readonly siege_kills_desc: string;
  readonly siege_kills_name: string;
  readonly sieges_defended_desc: string;
  readonly sieges_defended_name: string;
  readonly sieges_lost_desc: string;
  readonly sieges_lost_name: string;
  readonly sieges_won_desc: string;
  readonly sieges_won_name: string;
  readonly spent_building_desc: string;
  readonly spent_building_name: string;
  readonly spent_captain_desc: string;
  readonly spent_captain_name: string;
  readonly spent_expedition_desc: string;
  readonly spent_expedition_name: string;
  readonly spent_invent_desc: string;
  readonly spent_invent_name: string;
  readonly spent_market_desc: string;
  readonly spent_market_name: string;
  readonly spent_print_desc: string;
  readonly spent_print_name: string;
  readonly spent_repair_desc: string;
  readonly spent_repair_name: string;
  readonly spent_rush_desc: string;
  readonly spent_rush_name: string;
  readonly spent_ship_desc: string;
  readonly spent_ship_name: string;
  readonly spent_tech_desc: string;
  readonly spent_tech_name: string;
  readonly spent_torpedo_desc: string;
  readonly spent_torpedo_name: string;
  readonly squad_seasons_desc: string;
  readonly squad_seasons_name: string;
  readonly struck_survived_desc: string;
  readonly struck_survived_name: string;
  readonly t3_module_invented_desc: string;
  readonly t3_module_invented_name: string;
  readonly tech_recovered_desc: string;
  readonly tech_recovered_name: string;
  readonly tender_rounds_desc: string;
  readonly tender_rounds_name: string;
  readonly test_pilot_desc: string;
  readonly test_pilot_name: string;
  readonly theme_made_desc: string;
  readonly theme_made_name: string;
  readonly three_krakens_desc: string;
  readonly three_krakens_name: string;
  readonly three_slot_print_desc: string;
  readonly three_slot_print_name: string;
  readonly throne_at_close_desc: string;
  readonly throne_at_close_name: string;
  readonly throne_hours_desc: string;
  readonly throne_hours_name: string;
  readonly top_half_desc: string;
  readonly top_half_name: string;
  readonly top_ten_pct_desc: string;
  readonly top_ten_pct_name: string;
  readonly torpedo_hits_desc: string;
  readonly torpedo_hits_name: string;
  readonly torpedo_kills_desc: string;
  readonly torpedo_kills_name: string;
  readonly torpedo_kinds_desc: string;
  readonly torpedo_kinds_name: string;
  readonly torpedoes_fired_bulwark_desc: string;
  readonly torpedoes_fired_bulwark_name: string;
  readonly torpedoes_fired_desc: string;
  readonly torpedoes_fired_disruptor_desc: string;
  readonly torpedoes_fired_disruptor_name: string;
  readonly torpedoes_fired_heavy_desc: string;
  readonly torpedoes_fired_heavy_name: string;
  readonly torpedoes_fired_interceptor_desc: string;
  readonly torpedoes_fired_interceptor_name: string;
  readonly torpedoes_fired_light_desc: string;
  readonly torpedoes_fired_light_name: string;
  readonly torpedoes_fired_name: string;
  readonly torpedoes_fired_seeker_desc: string;
  readonly torpedoes_fired_seeker_name: string;
  readonly torpedoes_stowed_desc: string;
  readonly torpedoes_stowed_name: string;
  readonly tournament_victor_desc: string;
  readonly tournament_victor_name: string;
  readonly trench_cells_desc: string;
  readonly trench_cells_name: string;
  readonly undefeated_desc: string;
  readonly undefeated_name: string;
  readonly unlock_complete: (p: { total: string | number }) => string;
  readonly unlock_grade_of: (p: { grade: string | number; n: string | number; total: string | number }) => string;
  readonly unlock_handover: (p: { count: number; names: string | number }) => string;
  readonly unlock_many: (p: { count: string | number }) => string;
  readonly unlock_next: (p: { grade: string | number; value: string | number; left: string | number }) => string;
  readonly unlock_reached: (p: { value: string | number; threshold: string | number }) => string;
  readonly unlock_title: string;
  readonly value_hours: (p: { value: string | number }) => string;
  readonly value_minutes: (p: { value: string | number }) => string;
  readonly value_seconds: (p: { value: string | number }) => string;
  readonly wardroom_full_desc: string;
  readonly wardroom_full_name: string;
  readonly winning_faction_desc: string;
  readonly winning_faction_name: string;
  readonly withdrawals_desc: string;
  readonly withdrawals_name: string;
  readonly world_founder_desc: string;
  readonly world_founder_name: string;
  readonly wrecks_salvaged_desc: string;
  readonly wrecks_salvaged_name: string;
}

export const achievements: Achievements = tables?.achievements ?? source.achievements;

/** ui.advisor — the advisor line above the queue strip (player-reach.md §4, R1305): one sentence for each kind of advice, and one for each reason. A name comes from the hello catalog, never from these lines. */
export interface Advisor {
  readonly building_first: (p: { name: string | number }) => string;
  readonly building_raise: (p: { name: string | number; level: string | number }) => string;
  readonly commission: (p: { name: string | number }) => string;
  readonly design: (p: { name: string | number }) => string;
  readonly fleet_idle: (p: { name: string | number }) => string;
  readonly fold: string;
  readonly label: string;
  readonly print: (p: { name: string | number }) => string;
  readonly research: (p: { name: string | number }) => string;
  readonly save_building: (p: { name: string | number; level: string | number }) => string;
  readonly save_ship: (p: { name: string | number }) => string;
  readonly saving: (p: { pct: string | number }) => string;
  readonly ship: (p: { count: string | number; name: string | number }) => string;
  readonly title: string;
  readonly torpedo: (p: { count: string | number; name: string | number }) => string;
  readonly unfold: string;
}

export const advisor: Advisor = tables?.advisor ?? source.advisor;

/** ui/alarms.ts — the alarm screen: the signal rank, the siege row and the alarm list (ui-map-interface.md §8 and §12, R1753, card 16 of mockup round 082). */
export interface Alarms {
  readonly act_build: string;
  readonly act_build_title: string;
  readonly act_check: string;
  readonly act_check_title: string;
  readonly act_open: string;
  readonly act_open_title: string;
  readonly act_read: string;
  readonly act_read_title: string;
  readonly act_restart: string;
  readonly dev_head: string;
  readonly full_many: (p: { n: number }) => string;
  readonly full_one: (p: { name: string | number }) => string;
  readonly full_store: (p: { name: string | number; have: string | number }) => string;
  readonly full_what: (p: { stores: string | number }) => string;
  readonly go_to: string;
  readonly go_to_title: (p: { site: string | number }) => string;
  readonly inbox_head: string;
  readonly inbox_what: (p: { n: number }) => string;
  readonly link_what: string;
  readonly list_close: string;
  readonly list_count: (p: { n: number }) => string;
  readonly list_head: string;
  readonly maint_what: string;
  readonly quake_what_1: string;
  readonly quake_what_2: string;
  readonly quake_what_3: string;
  readonly reset_head: (p: { season: string | number }) => string;
  readonly reset_real: (p: { world: string | number; real: string | number }) => string;
  readonly seaview_what: string;
  readonly siege_battle: (p: { at: string | number }) => string;
  readonly siege_head: string;
  readonly siege_title: (p: { site: string | number; at: string | number }) => string;
  readonly siege_what: (p: { site: string | number; attacker: string | number }) => string;
  readonly truce_what: string;
}

export const alarms: Alarms = tables?.alarms ?? source.alarms;

/** ui.api — the meta API client: the failures it raises when no meta server answers, or answers with something the client cannot read. */
export interface Api {
  readonly meta_no_answer: (p: { error: string | number }) => string;
  readonly meta_timeout: string;
  readonly no_meta_api: (p: { status: string | number }) => string;
  readonly not_json: string;
  readonly unexpected_answer: (p: { status: string | number }) => string;
}

export const api: Api = tables?.api ?? source.api;

/** arcade/catalog.ts — the manifest: the mixed-rule row and the fetch refusal. */
export interface ArcadeCatalog {
  readonly fetch_failed: (p: { status: string | number }) => string;
  readonly mixed_win_lines: (p: { count: string | number }) => string;
}

export const arcadeCatalog: ArcadeCatalog = tables?.arcadeCatalog ?? source.arcadeCatalog;

/** arcade/chrome.ts — the match chrome: the readout line, the notice lane, the score card, VIEW, the build pane, the selection corner, the key sheet, the gesture card and the tooltip. */
export interface ArcadeChrome {
  readonly anchor_dropping: (p: { left: string | number }) => string;
  readonly anchor_weigh: string;
  readonly anchor_weighing: (p: { left: string | number }) => string;
  readonly audio_sfx_what: string;
  readonly auto_spawn_every: (p: { every: string | number }) => string;
  readonly back_arena: string;
  readonly base_fire: string;
  readonly base_fire_aiming: string;
  readonly card_arrives: string;
  readonly card_bearing: string;
  readonly card_k_cap: string;
  readonly card_k_guidance: string;
  readonly card_k_modules: string;
  readonly card_k_stock: string;
  readonly card_k_trigger: string;
  readonly card_open_title: string;
  readonly card_out: string;
  readonly card_out_solo: string;
  readonly card_sea_stocked: string;
  readonly card_seeks: string;
  readonly card_stocked: string;
  readonly chip_anchor: string;
  readonly chip_escort: string;
  readonly chip_fire: string;
  readonly chip_fire_no_rounds: string;
  readonly chip_fire_reloading: (p: { left: string | number }) => string;
  readonly chip_gather: string;
  readonly chip_hold: string;
  readonly chip_hold_fire: string;
  readonly chip_hunt: string;
  readonly chip_move: string;
  readonly chip_patrol: string;
  readonly chip_return: string;
  readonly chip_scan: string;
  readonly chip_scan_cooling: (p: { left: string | number }) => string;
  readonly chip_share: string;
  readonly chip_share_running: (p: { left: string | number }) => string;
  readonly clock_title: string;
  readonly dock_close_title: string;
  readonly dock_open_title: string;
  readonly dock_out: string;
  readonly dock_ready: (p: { count: number }) => string;
  readonly dock_tab_build: string;
  readonly dock_tab_note: string;
  readonly eyes_ops_title: string;
  readonly eyes_title: string;
  readonly gest_close: string;
  readonly gest_close_does: string;
  readonly gest_close_title: string;
  readonly gest_drag_hull: string;
  readonly gest_drag_hull_does: string;
  readonly gest_drag_water: string;
  readonly gest_drag_water_does: string;
  readonly gest_group: string;
  readonly gest_heading: string;
  readonly gest_hold_slot: string;
  readonly gest_hold_slot_does: string;
  readonly gest_note: string;
  readonly gest_pinch: string;
  readonly gest_pinch_does: string;
  readonly gest_slot: string;
  readonly gest_slot_does: string;
  readonly gest_sub: string;
  readonly gest_tap_hull: string;
  readonly gest_tap_hull_does: string;
  readonly gest_tap_water: string;
  readonly gest_tap_water_does: string;
  readonly gest_two_taps: string;
  readonly gest_two_taps_does: string;
  readonly head_auto_aside: string;
  readonly head_auto_spawn: string;
  readonly head_base_rounds: string;
  readonly head_combat: string;
  readonly head_hulls_aside: (p: { count: string | number }) => string;
  readonly head_sea_aside: string;
  readonly head_sea_objects: string;
  readonly head_ship_rounds: string;
  readonly head_support: string;
  readonly help_gestures: string;
  readonly help_gestures_what: string;
  readonly help_keys: string;
  readonly help_keys_what: string;
  readonly help_open: string;
  readonly help_sum_gestures: string;
  readonly help_sum_keys: string;
  readonly hold_theirs: (p: { team: string | number }) => string;
  readonly hold_yours: string;
  readonly hotkeys_title: string;
  readonly key_anchor: string;
  readonly key_base: string;
  readonly key_base_fire: string;
  readonly key_drill_next: string;
  readonly key_escort: string;
  readonly key_fire: string;
  readonly key_gather: string;
  readonly key_group_assign: string;
  readonly key_group_select: string;
  readonly key_hold: string;
  readonly key_hold_fire: string;
  readonly key_hunt: string;
  readonly key_map_back: string;
  readonly key_map_command: string;
  readonly key_map_command_name: string;
  readonly key_map_pan: string;
  readonly key_map_pan_name: string;
  readonly key_map_sheet: string;
  readonly key_move: string;
  readonly key_next_round: string;
  readonly key_patrol: string;
  readonly key_return: string;
  readonly key_row_ends: string;
  readonly key_row_step: string;
  readonly key_scan: string;
  readonly keys: string;
  readonly keys_close: string;
  readonly keys_group_map: string;
  readonly keys_group_orders: string;
  readonly keys_heading: string;
  readonly keys_title: string;
  readonly lane_left: (p: { clock: string | number }) => string;
  readonly leave: string;
  readonly leave_armed: string;
  readonly leave_armed_what: string;
  readonly leave_drill: string;
  readonly leave_drill_armed: string;
  readonly leave_drill_what: string;
  readonly leave_match: string;
  readonly leave_match_armed: string;
  readonly leave_match_what: string;
  readonly leave_match_what_solo: string;
  readonly leave_out_what: string;
  readonly leave_out_what_solo: string;
  readonly menu: string;
  readonly menu_back: string;
  readonly menu_title: string;
  readonly out_lobby: string;
  readonly out_lobby_title: string;
  readonly out_short: string;
  readonly out_title: string;
  readonly out_title_solo: string;
  readonly out_watching: string;
  readonly report_line: (p: { map: string | number; tick: string | number }) => string;
  readonly round_base_detail: string;
  readonly round_hull_detail: string;
  readonly row_locked: string;
  readonly row_wait: (p: { wait: string | number }) => string;
  readonly score: string;
  readonly score_fold_title: string;
  readonly score_open_title: string;
  readonly sea_row_detail: (p: { stock: string | number; sea: string | number; cap: string | number }) => string;
  readonly slot_spare_label: (p: { n: string | number }) => string;
  readonly slot_tip: string;
  readonly sov_heading: string;
  readonly stats_offline: (p: { retries: number }) => string;
  readonly stats_render: (p: { fps: string | number; scale: string | number; timescale: string | number; tactical: string | number }) => string;
  readonly stats_wire: (p: { tick: string | number; contacts: string | number; rtt: string | number; kb: string | number }) => string;
  readonly surrender: string;
  readonly surrender_armed: string;
  readonly surrender_title: string;
  readonly surrender_title_solo: string;
  readonly view_base: string;
  readonly view_gestures: string;
  readonly view_gestures_sub: string;
  readonly view_head: string;
  readonly view_keys_sub: string;
  readonly view_marks: string;
  readonly view_marks_off: string;
  readonly view_marks_on: (p: { percent: string | number }) => string;
  readonly view_muted: string;
  readonly view_score_sub: string;
  readonly view_sound: string;
  readonly view_sound_off: string;
  readonly view_sound_on: string;
  readonly view_sub: string;
  readonly view_title: string;
}

export const arcadeChrome: ArcadeChrome = tables?.arcadeChrome ?? source.arcadeChrome;

/** arcade/community.ts, communitycard.ts and mymaps.ts — the lobby sections COMMUNITY and MY MAPS, the community map card, and the COMMUNITY shelf and the FEATURED row of the PLAY board (community-maps.md §9.2-§9.4, R1973, R1974). */
export interface ArcadeCommunity {
  readonly apply: string;
  readonly apply_count: (p: { n: number }) => string;
  readonly author_tag: (p: { name: string | number; tag: string | number }) => string;
  readonly card_by: (p: { name: string | number }) => string;
  readonly card_failed: (p: { error: string | number }) => string;
  readonly card_rev: (p: { n: string | number; at: string | number }) => string;
  readonly card_updated: (p: { at: string | number }) => string;
  readonly card_waits_note: (p: { n: string | number; pin: string | number }) => string;
  readonly card_your_map: string;
  readonly cat_all: string;
  readonly cat_all_short: string;
  readonly cat_note: (p: { filter: string | number }) => string;
  readonly copy_code: string;
  readonly copy_link: string;
  readonly empty_all_line: (p: { slots: string | number }) => string;
  readonly empty_all_title: string;
  readonly empty_cat: (p: { filter: string | number }) => string;
  readonly empty_clan_line: (p: { slots: string | number }) => string;
  readonly empty_clan_title: (p: { tag: string | number }) => string;
  readonly empty_fav_line: string;
  readonly empty_fav_title: string;
  readonly empty_mine_line: string;
  readonly empty_mine_title: string;
  readonly empty_noclan_line: string;
  readonly empty_noclan_title: string;
  readonly empty_slot: string;
  readonly empty_slot_lapsed: string;
  readonly empty_slot_line: string;
  readonly fact_done: string;
  readonly fact_done_value: (p: { pct: string | number }) => string;
  readonly fact_likes: string;
  readonly fact_plays: string;
  readonly fact_plays_value: (p: { plays: string | number; d7: string | number }) => string;
  readonly featured_aside: string;
  readonly featured_elsewhere: (p: { name: string | number; size: string | number }) => string;
  readonly featured_head: string;
  readonly fig_average: string;
  readonly fig_completed: string;
  readonly fig_likes: string;
  readonly fig_plays: string;
  readonly fig_published: string;
  readonly fig_seat_wins: string;
  readonly fig_team_wins: string;
  readonly filter_all: string;
  readonly filter_clan: string;
  readonly filter_favourites: string;
  readonly filter_favourites_short: string;
  readonly filter_mine: string;
  readonly find_clan: string;
  readonly fresh_line: (p: { n: string | number }) => string;
  readonly fresh_title: string;
  readonly from_author: string;
  readonly head_7d: string;
  readonly head_done: string;
  readonly head_likes: string;
  readonly head_map: string;
  readonly head_plays: string;
  readonly head_seats: string;
  readonly host: string;
  readonly lapsed_line: string;
  readonly lapsed_title: string;
  readonly like: string;
  readonly like_own_title: string;
  readonly liked: string;
  readonly list_failed: (p: { error: string | number }) => string;
  readonly loading: string;
  readonly maps_count: (p: { n: number }) => string;
  readonly mark_featured: string;
  readonly mark_inplay: (p: { n: string | number }) => string;
  readonly mark_new: string;
  readonly mark_rated: string;
  readonly more_elsewhere: (p: { n: number; names: string | number; size: string | number }) => string;
  readonly more_title: string;
  readonly mymaps_failed: (p: { error: string | number }) => string;
  readonly note_inplay: (p: { pin: string | number }) => string;
  readonly note_waits: (p: { n: string | number }) => string;
  readonly open_designer: string;
  readonly open_designer_short: string;
  readonly open_in_designer: string;
  readonly pct: (p: { n: string | number }) => string;
  readonly pinned: string;
  readonly plays_word: string;
  readonly published_at: (p: { at: string | number }) => string;
  readonly report_head: (p: { name: string | number; n: string | number }) => string;
  readonly report_map: string;
  readonly report_reason_pick: string;
  readonly reported: string;
  readonly reset: string;
  readonly rev: (p: { n: string | number }) => string;
  readonly rev_line: (p: { at: string | number; hash: string | number; size: string | number }) => string;
  readonly revisions: string;
  readonly revisions_aside: (p: { n: number }) => string;
  readonly row_likes: (p: { n: string | number }) => string;
  readonly row_plays: (p: { n: number }) => string;
  readonly row_rev: (p: { n: string | number }) => string;
  readonly seats_word: (p: { n: number }) => string;
  readonly sec_community: string;
  readonly sec_mymaps: string;
  readonly see_premium: string;
  readonly sheet_category: string;
  readonly sheet_close: string;
  readonly sheet_title: string;
  readonly show_all: (p: { n: number }) => string;
  readonly show_cap: string;
  readonly show_more: string;
  readonly side_map: string;
  readonly size_kb: (p: { n: string | number }) => string;
  readonly slots_free: (p: { n: number }) => string;
  readonly slots_head: (p: { used: string | number; slots: string | number; tier: string | number }) => string;
  readonly sort_cap: string;
  readonly sort_liked: string;
  readonly sort_played: string;
  readonly sort_recent: string;
  readonly st_community: string;
  readonly st_featured: string;
  readonly st_inplay: (p: { n: string | number }) => string;
  readonly st_taken_down: string;
  readonly st_waits: (p: { n: string | number }) => string;
  readonly st_waits_short: (p: { n: string | number }) => string;
  readonly sum_lapsed: string;
  readonly sum_liked: (p: { maps: string | number; n: string | number }) => string;
  readonly sum_mine: (p: { used: string | number; slots: string | number; likes: string | number }) => string;
  readonly sum_new: (p: { maps: string | number; n: string | number }) => string;
  readonly sum_none: string;
  readonly taken_down: string;
  readonly team_share: (p: { n: string | number; pct: string | number }) => string;
  readonly tier_ended: string;
  readonly tier_premium: string;
  readonly unpublish: string;
  readonly unpublish_armed: string;
  readonly unpublish_line: (p: { name: string | number }) => string;
  readonly versus: string;
  readonly waits_review: string;
}

export const arcadeCommunity: ArcadeCommunity = tables?.arcadeCommunity ?? source.arcadeCommunity;

/** arcade/drill.ts — the drill in a match: the step card, the chrome highlight, the step-done notice and the end card (arcade.md §17.8). */
export interface ArcadeDrill {
  readonly act_ambush: string;
  readonly act_anchor: string;
  readonly act_braced: string;
  readonly act_build: string;
  readonly act_detonate: string;
  readonly act_escort: string;
  readonly act_fill: string;
  readonly act_goal: string;
  readonly act_guard: string;
  readonly act_haul: string;
  readonly act_hear: string;
  readonly act_hide: string;
  readonly act_launch: string;
  readonly act_mend: string;
  readonly act_outflank: string;
  readonly act_patrol: string;
  readonly act_ping: string;
  readonly act_reach: string;
  readonly act_rearm: string;
  readonly act_restock: string;
  readonly act_signature: string;
  readonly act_sink: string;
  readonly act_stern: string;
  readonly act_stow: string;
  readonly act_take: string;
  readonly end_again: string;
  readonly end_bridge_last: string;
  readonly end_complete: string;
  readonly end_fine: string;
  readonly end_kind_name: (p: { name: string | number }) => string;
  readonly end_kind_place: (p: { name: string | number; place: string | number; count: string | number }) => string;
  readonly end_left: (p: { n: string | number; total: string | number }) => string;
  readonly end_lobby: string;
  readonly end_next: string;
  readonly end_next_kind_place: (p: { place: string | number; count: string | number }) => string;
  readonly end_next_steps: (p: { n: number }) => string;
  readonly end_play: string;
  readonly end_spent: string;
  readonly end_spent_in: (p: { left: string | number }) => string;
  readonly end_steps: (p: { done: string | number; total: string | number; clock: string | number }) => string;
  readonly end_unfinished: string;
  readonly kicker: string;
  readonly next: string;
  readonly skip: string;
  readonly stat_cells: string;
  readonly stat_found: string;
  readonly stat_spent: string;
  readonly stat_sunk: string;
  readonly stat_torpedo: string;
  readonly step_done: (p: { n: string | number }) => string;
  readonly step_done_act: (p: { n: string | number; act: string | number }) => string;
  readonly step_kind: (p: { n: string | number; total: string | number }) => string;
  readonly strip_count: (p: { n: string | number; total: string | number }) => string;
}

export const arcadeDrill: ArcadeDrill = tables?.arcadeDrill ?? source.arcadeDrill;

/** arcade/format.ts — the one sentence the formatters write: why a build row is unaffordable. */
export interface ArcadeFormat {
  readonly shortfall: (p: { missing: string | number }) => string;
  readonly shortfall_wait: (p: { missing: string | number; wait: string | number }) => string;
}

export const arcadeFormat: ArcadeFormat = tables?.arcadeFormat ?? source.arcadeFormat;

/** arcade/history.ts — the player's own match history: one row per match, with the result and the watch link. */
export interface ArcadeHistory {
  readonly bot: string;
  readonly bots: (p: { n: number }) => string;
  readonly copy_link: string;
  readonly draw: string;
  readonly empty: string;
  readonly failed: (p: { error: string | number }) => string;
  readonly keep_days: (p: { n: number }) => string;
  readonly length: (p: { time: string | number }) => string;
  readonly live: string;
  readonly loading: string;
  readonly loading_more: string;
  readonly lost: string;
  readonly more: string;
  readonly retry: string;
  readonly share: string;
  readonly sign_in: string;
  readonly summary: (p: { games: string | number; won: string | number; lost: string | number }) => string;
  readonly title: string;
  readonly void: string;
  readonly watch: string;
  readonly won: string;
}

export const arcadeHistory: ArcadeHistory = tables?.arcadeHistory ?? source.arcadeHistory;

/** arcade/hosting.ts — the hosting window of a private game: the seats, the observers, the code, the map picker and the start. */
export interface ArcadeHosting {
  readonly ban: string;
  readonly ban_armed: string;
  readonly bot: string;
  readonly code: string;
  readonly copy: string;
  readonly cup_start: string;
  readonly delay: (p: { sec: string | number }) => string;
  readonly delay_label: string;
  readonly delay_unit: string;
  readonly kick: string;
  readonly kick_armed: string;
  readonly leave: string;
  readonly leave_armed: string;
  readonly link: string;
  readonly map_category: string;
  readonly map_details_mode: string;
  readonly map_details_revision: string;
  readonly map_details_size: string;
  readonly map_none: string;
  readonly map_pick: string;
  readonly observe: string;
  readonly observers: string;
  readonly observers_none: string;
  readonly open: string;
  readonly reason_banned: string;
  readonly reason_draining: string;
  readonly reason_full: string;
  readonly reason_host_left: string;
  readonly reason_kicked: string;
  readonly reason_no_such_code: string;
  readonly reason_not_host: string;
  readonly reason_seat_taken: string;
  readonly reason_start_failed: string;
  readonly reason_timed_out: string;
  readonly set_bot: string;
  readonly set_bot_armed: string;
  readonly set_open: string;
  readonly set_open_armed: string;
  readonly share: string;
  readonly slot: (p: { n: string | number }) => string;
  readonly start: string;
  readonly take: string;
  readonly team: (p: { n: string | number }) => string;
  readonly timeout: (p: { clock: string | number }) => string;
  readonly title: string;
  readonly title_cup: string;
  readonly you: string;
}

export const arcadeHosting: ArcadeHosting = tables?.arcadeHosting ?? source.arcadeHosting;

/** arcade/lobby.ts — the lobby in the section shell: the head, the sections PLAY, DRILLS, PRIVATE, COMMUNITY, MY MAPS, LADDER and HISTORY, the board rows, the drill rows and the queue panel (R1929, R1930, R1931). */
export interface ArcadeLobby {
  readonly account_guest: string;
  readonly back_to_hub: string;
  readonly back_to_tiles: string;
  readonly board_empty: string;
  readonly board_empty_size: (p: { n: number }) => string;
  readonly drill_done: string;
  readonly drill_done_note: string;
  readonly drill_minutes: (p: { steps: string | number; minutes: string | number }) => string;
  readonly drill_spent_note: string;
  readonly drill_start: string;
  readonly drill_steps: (p: { n: number }) => string;
  readonly drills_aside: (p: { n: number }) => string;
  readonly fact_depth: string;
  readonly fact_maps: string;
  readonly fact_seats: string;
  readonly fact_seats_value: (p: { seats: string | number }) => string;
  readonly guest_default_note: string;
  readonly guest_line: (p: { name: string | number }) => string;
  readonly guest_upgrade: string;
  readonly idle_chip: string;
  readonly idle_line: string;
  readonly idle_pick_last: string;
  readonly play_default: (p: { name: string | number }) => string;
  readonly private_busy: string;
  readonly private_code_bad: string;
  readonly private_code_ph: string;
  readonly private_cup_line: string;
  readonly private_cup_title: string;
  readonly private_host: string;
  readonly private_host_line: string;
  readonly private_host_title: string;
  readonly private_join: string;
  readonly private_join_line: string;
  readonly private_join_title: string;
  readonly queue_bots_fill: (p: { clock: string | number }) => string;
  readonly queue_conquest: string;
  readonly queue_found_building: string;
  readonly queue_found_captains: (p: { seats: string | number }) => string;
  readonly queue_found_humans: (p: { humans: string | number }) => string;
  readonly queue_found_state: string;
  readonly queue_found_title: string;
  readonly queue_guest_next: string;
  readonly queue_hosting_note: string;
  readonly queue_hosting_title: string;
  readonly queue_idle_title: string;
  readonly queue_label: string;
  readonly queue_leave: string;
  readonly queue_locked_chip: string;
  readonly queue_locked_title: string;
  readonly queue_over_note: string;
  readonly queue_over_state: string;
  readonly queue_over_title: string;
  readonly queue_quickjoin_name: string;
  readonly queue_refused_chip: string;
  readonly queue_refused_title: string;
  readonly queue_resume: string;
  readonly queue_running_note: string;
  readonly queue_running_state: string;
  readonly queue_running_title: string;
  readonly queue_searching: (p: { clock: string | number }) => string;
  readonly queue_seats: string;
  readonly queue_waiting_title: string;
  readonly quickjoin: string;
  readonly quickjoin_note: string;
  readonly row_account: string;
  readonly row_depth: (p: { n: number }) => string;
  readonly row_in_queue: string;
  readonly row_join: string;
  readonly row_leave: string;
  readonly row_maps: (p: { n: number }) => string;
  readonly runs_of: (p: { left: string | number; cap: string | number }) => string;
  readonly runs_resets: string;
  readonly runs_resets_in: (p: { left: string | number }) => string;
  readonly runs_spent_reason: string;
  readonly runs_supporter_link: string;
  readonly runs_today: string;
  readonly runs_unlimited: string;
  readonly seats_of: (p: { n: string | number; total: string | number }) => string;
  readonly sec_drills: string;
  readonly sec_history: string;
  readonly sec_ladder: string;
  readonly sec_play: string;
  readonly sec_private: string;
  readonly sheet_guest: string;
  readonly sheet_idle: string;
  readonly sheet_runs: (p: { runs: string | number }) => string;
  readonly sheet_spent_in: (p: { left: string | number }) => string;
  readonly sheet_waiting: (p: { name: string | number }) => string;
  readonly sheet_waiting_line: (p: { waited: string | number; fill: string | number }) => string;
  readonly shelf_count: (p: { n: number }) => string;
  readonly size_caption: string;
  readonly size_chip: (p: { n: number }) => string;
  readonly spent_band: string;
  readonly spent_drill_line: string;
  readonly sum_drills_done: (p: { done: string | number; n: string | number }) => string;
  readonly sum_drills_none: string;
  readonly sum_history_guest: string;
  readonly sum_history_played: (p: { n: number }) => string;
  readonly sum_play_guest: (p: { name: string | number }) => string;
  readonly sum_play_open: (p: { n: number }) => string;
  readonly sum_play_queue: (p: { name: string | number }) => string;
  readonly sum_play_seat: string;
  readonly sum_play_spent: string;
  readonly sum_play_waiting: (p: { n: number }) => string;
  readonly sum_private_hosting: (p: { code: string | number }) => string;
  readonly sum_private_none: string;
  readonly tag_default: string;
  readonly tag_last: string;
  readonly watermark: string;
  readonly wordmark: string;
}

export const arcadeLobby: ArcadeLobby = tables?.arcadeLobby ?? source.arcadeLobby;

/** arcade/main.ts — the arcade page shell: what it says when the manifest or the socket refuses. */
export interface ArcadeMain {
  readonly catalog_failed: string;
  readonly catalog_failed_reason: (p: { error: string | number }) => string;
  readonly client_refused: (p: { reason: string | number }) => string;
  readonly no_arcade: string;
}

export const arcadeMain: ArcadeMain = tables?.arcadeMain ?? source.arcadeMain;

/** arcade/mapschema.ts and arcade/validate.go — the map validator's problem messages, one wording for both languages. */
export interface ArcadeMapschema {
  readonly all_rock: string;
  readonly auto_ship_class_cap: (p: { variant: string | number; hull: string | number; cap: string | number }) => string;
  readonly auto_ship_period: (p: { variant: string | number; every: string | number }) => string;
  readonly auto_ship_variant: (p: { variant: string | number }) => string;
  readonly auto_torpedo_kind: (p: { kind: string | number }) => string;
  readonly auto_torpedo_period: (p: { kind: string | number; every: string | number }) => string;
  readonly base_per_slot_many: (p: { slot: string | number; count: string | number }) => string;
  readonly base_per_slot_none: (p: { slot: string | number }) => string;
  readonly base_unknown_slot: (p: { slot: string | number }) => string;
  readonly bit_present: string;
  readonly bit_range: (p: { have: string | number; max: string | number }) => string;
  readonly bit_status: (p: { status: string | number; have: string | number }) => string;
  readonly capture_sec: (p: { value: string | number; min: string | number; max: string | number }) => string;
  readonly combat_pace: (p: { value: string | number }) => string;
  readonly credits_per_sec: (p: { value: string | number }) => string;
  readonly current_scale: (p: { value: string | number; min: string | number; max: string | number }) => string;
  readonly current_scale_unused: (p: { value: string | number }) => string;
  readonly currents_symmetry: string;
  readonly cut_off: string;
  readonly den_apron: (p: { rings: string | number }) => string;
  readonly den_brotherhood: (p: { name: string | number; list: string | number }) => string;
  readonly den_design: (p: { value: string | number; max: string | number }) => string;
  readonly den_wave: (p: { value: string | number; min: string | number; max: string | number }) => string;
  readonly drill_bit: (p: { have: string | number }) => string;
  readonly drill_bots: (p: { step: string | number; bots: string | number }) => string;
  readonly drill_chrome: (p: { step: string | number; chrome: string | number }) => string;
  readonly drill_chrome_and_spot: (p: { step: string | number }) => string;
  readonly drill_count: (p: { steps: string | number; max: string | number }) => string;
  readonly drill_course_bots: (p: { step: string | number; bots: string | number }) => string;
  readonly drill_course_cell: (p: { step: string | number }) => string;
  readonly drill_done: (p: { step: string | number; done: string | number }) => string;
  readonly drill_done_count: (p: { step: string | number; count: string | number; done: string | number; max: string | number }) => string;
  readonly drill_done_haul: (p: { step: string | number; hull: string | number }) => string;
  readonly drill_done_no_count: (p: { step: string | number; count: string | number; done: string | number }) => string;
  readonly drill_done_ping: (p: { step: string | number; hull: string | number }) => string;
  readonly drill_done_rock: (p: { step: string | number }) => string;
  readonly drill_done_sov: (p: { step: string | number }) => string;
  readonly drill_done_spot: (p: { step: string | number; done: string | number }) => string;
  readonly drill_done_spot_rock: (p: { step: string | number; done: string | number }) => string;
  readonly drill_goal_drill: (p: { step: string | number; drill: string | number }) => string;
  readonly drill_goal_win: (p: { step: string | number; goal: string | number }) => string;
  readonly drill_minutes: (p: { have: string | number; max: string | number }) => string;
  readonly drill_minutes_lane: (p: { have: string | number }) => string;
  readonly drill_order: (p: { have: string | number }) => string;
  readonly drill_order_lane: (p: { have: string | number }) => string;
  readonly drill_reset: (p: { step: string | number; reset: string | number }) => string;
  readonly drill_reset_arrived: (p: { step: string | number; reset: string | number; bots: string | number }) => string;
  readonly drill_select: (p: { step: string | number; select: string | number }) => string;
  readonly drill_spawn_cell: (p: { step: string | number; variant: string | number }) => string;
  readonly drill_spawn_count: (p: { step: string | number; spawns: string | number; max: string | number }) => string;
  readonly drill_spawn_hull: (p: { step: string | number; variant: string | number; hull: string | number }) => string;
  readonly drill_spawn_ridge: (p: { step: string | number; variant: string | number }) => string;
  readonly drill_spawn_shield: (p: { step: string | number; variant: string | number; shield: string | number }) => string;
  readonly drill_spawn_slot: (p: { step: string | number; slot: string | number }) => string;
  readonly drill_spawn_variant: (p: { step: string | number; variant: string | number }) => string;
  readonly drill_spot_cell: (p: { step: string | number }) => string;
  readonly drill_spot_radius: (p: { step: string | number; radius: string | number; max: string | number }) => string;
  readonly drill_step_id: (p: { step: string | number; id: string | number }) => string;
  readonly drill_step_id_twice: (p: { id: string | number }) => string;
  readonly drill_step_text: (p: { step: string | number }) => string;
  readonly drill_steps_win: (p: { type: string | number; drill: string | number }) => string;
  readonly drill_wait: (p: { step: string | number; wait: string | number; max: string | number }) => string;
  readonly drill_win_not_goal: (p: { step: string | number; done: string | number; goal: string | number }) => string;
  readonly drill_win_steps: string;
  readonly faction_base_sonar: (p: { sonar: string | number; max: string | number }) => string;
  readonly faction_base_team: (p: { team: string | number; factions: string | number }) => string;
  readonly fairway_cell: (p: { chain: string | number }) => string;
  readonly fairway_cell_unique: (p: { chain: string | number }) => string;
  readonly fairway_count: (p: { chains: string | number; max: string | number }) => string;
  readonly fairway_gap: (p: { chain: string | number; cell: string | number }) => string;
  readonly fairway_on_ridge: (p: { chain: string | number }) => string;
  readonly fairway_short: (p: { chain: string | number; cells: string | number; min: string | number }) => string;
  readonly field_resource: (p: { resource: string | number }) => string;
  readonly field_units: (p: { units: string | number }) => string;
  readonly field_units_default: string;
  readonly fleet_cell: (p: { variant: string | number }) => string;
  readonly fleet_class_cap: (p: { slot: string | number; count: string | number; hull: string | number; cap: string | number }) => string;
  readonly fleet_on_ridge: (p: { variant: string | number }) => string;
  readonly fleet_slot: (p: { slot: string | number }) => string;
  readonly fleet_variant: (p: { variant: string | number }) => string;
  readonly grid_dims: (p: { cols: string | number; rows: string | number; min_cols: string | number; min_rows: string | number; max_cols: string | number; max_rows: string | number }) => string;
  readonly guard_reach: (p: { kind: string | number; value: string | number; min: string | number; max: string | number }) => string;
  readonly guard_reach_kind: (p: { kind: string | number }) => string;
  readonly guard_reload: (p: { kind: string | number; value: string | number; min: string | number; max: string | number }) => string;
  readonly guard_reload_kind: (p: { kind: string | number }) => string;
  readonly laid_cell: (p: { kind: string | number }) => string;
  readonly laid_heading: (p: { kind: string | number; heading: string | number; max: string | number }) => string;
  readonly laid_kind: (p: { kind: string | number }) => string;
  readonly laid_near_base: (p: { kind: string | number }) => string;
  readonly laid_on_object: (p: { kind: string | number }) => string;
  readonly laid_on_ridge: (p: { kind: string | number }) => string;
  readonly laid_team: (p: { kind: string | number; team: string | number }) => string;
  readonly lair_bounty: (p: { value: string | number; max: string | number }) => string;
  readonly lair_design: (p: { value: string | number; max: string | number }) => string;
  readonly lair_kind: (p: { name: string | number; list: string | number }) => string;
  readonly lair_respawn: (p: { value: string | number; min: string | number; max: string | number }) => string;
  readonly lair_trench: string;
  readonly marker_cell: (p: { shape: string | number }) => string;
  readonly marker_circle_heading: (p: { circle: string | number; heading: string | number }) => string;
  readonly marker_color: (p: { color: string | number; factions: string | number }) => string;
  readonly marker_count: (p: { markers: string | number; max: string | number }) => string;
  readonly marker_heading: (p: { heading: string | number; max: string | number }) => string;
  readonly marker_shape: (p: { shape: string | number; arrow: string | number; circle: string | number }) => string;
  readonly mined_credit_rate: (p: { value: string | number }) => string;
  readonly module_duplicate: (p: { variant: string | number; family: string | number }) => string;
  readonly module_family: (p: { variant: string | number; family: string | number }) => string;
  readonly module_roll: (p: { variant: string | number; family: string | number; roll: string | number; min: string | number; max: string | number }) => string;
  readonly module_roll_invention: (p: { variant: string | number; family: string | number; roll: string | number; min: string | number; max: string | number }) => string;
  readonly module_tier: (p: { variant: string | number; family: string | number; tier: string | number; min: string | number; max: string | number }) => string;
  readonly name: string;
  readonly npc_field: (p: { kind: string | number; field: string | number; owner: string | number }) => string;
  readonly object_cell: (p: { kind: string | number }) => string;
  readonly object_cell_unique: string;
  readonly object_kind: (p: { kind: string | number }) => string;
  readonly object_on_ridge: (p: { kind: string | number }) => string;
  readonly objective_unused: (p: { kind: string | number; win: string | number; hold: string | number }) => string;
  readonly player_count: (p: { seats: string | number; min: string | number; max: string | number }) => string;
  readonly player_slot_range: (p: { slot: string | number }) => string;
  readonly player_slot_unique: (p: { slot: string | number }) => string;
  readonly player_team_count: (p: { teams: string | number; max: string | number }) => string;
  readonly player_team_range: (p: { slot: string | number; team: string | number; factions: string | number }) => string;
  readonly player_team_size: (p: { team: string | number; seats: string | number; max: string | number }) => string;
  readonly regen_calm: (p: { value: string | number }) => string;
  readonly regen_refill: (p: { value: string | number }) => string;
  readonly resource_field_units: (p: { value: string | number }) => string;
  readonly revision: (p: { have: string | number }) => string;
  readonly scan_cooldown: (p: { value: string | number }) => string;
  readonly sea_object_cap: (p: { kind: string | number; cap: string | number; max: string | number }) => string;
  readonly sea_object_kind: (p: { kind: string | number }) => string;
  readonly sea_object_needs_sapper: (p: { list: string | number; kind: string | number }) => string;
  readonly sea_object_price: (p: { kind: string | number; price: string | number; max: string | number }) => string;
  readonly sea_object_twice: (p: { kind: string | number }) => string;
  readonly settings_flat: (p: { setting: string | number }) => string;
  readonly ship_class: (p: { variant: string | number; hull: string | number }) => string;
  readonly ship_class_rule: (p: { variant: string | number; hull: string | number }) => string;
  readonly ship_name_twice: (p: { variant: string | number }) => string;
  readonly ship_no_name: (p: { hull: string | number }) => string;
  readonly ship_not_buyable_price: (p: { variant: string | number; price: string | number }) => string;
  readonly ship_not_buyable_unused: (p: { variant: string | number }) => string;
  readonly ship_price: (p: { variant: string | number; price: string | number; max: string | number }) => string;
  readonly ship_rounds_count: (p: { variant: string | number; count: string | number; kind: string | number }) => string;
  readonly ship_rounds_fits: (p: { variant: string | number; cargo: string | number; hull: string | number; room: string | number }) => string;
  readonly ship_rounds_kind: (p: { variant: string | number; kind: string | number; hull: string | number }) => string;
  readonly ship_rounds_twice: (p: { variant: string | number; kind: string | number }) => string;
  readonly ship_rounds_unknown: (p: { variant: string | number; kind: string | number }) => string;
  readonly ship_rounds_unsold: (p: { variant: string | number; kind: string | number }) => string;
  readonly ship_sapper_idle: (p: { variant: string | number }) => string;
  readonly ship_shield_type: (p: { variant: string | number; system: string | number; allowed: string | number }) => string;
  readonly ship_shield_type_module: (p: { variant: string | number; system: string | number }) => string;
  readonly ship_stow_class: (p: { variant: string | number }) => string;
  readonly ship_stow_count: (p: { variant: string | number; count: string | number; kind: string | number }) => string;
  readonly ship_stow_fits: (p: { variant: string | number; cargo: string | number; room: string | number }) => string;
  readonly ship_stow_twice: (p: { variant: string | number; kind: string | number }) => string;
  readonly ship_stow_unknown: (p: { variant: string | number; kind: string | number }) => string;
  readonly ship_stow_unsold: (p: { variant: string | number; kind: string | number }) => string;
  readonly ship_weapon_type: (p: { variant: string | number; system: string | number; allowed: string | number }) => string;
  readonly ship_weapon_type_module: (p: { variant: string | number; system: string | number }) => string;
  readonly ships_present: string;
  readonly sov_cell: string;
  readonly sov_cell_unique: string;
  readonly sov_on_ridge: string;
  readonly sov_requires_enabled: (p: { cells: string | number }) => string;
  readonly sov_team: (p: { team: string | number; factions: string | number }) => string;
  readonly starting_credits: (p: { value: string | number }) => string;
  readonly starting_sea_object_count: (p: { count: string | number; kind: string | number; max: string | number }) => string;
  readonly starting_sea_object_kind: (p: { kind: string | number }) => string;
  readonly starting_sea_object_twice: (p: { kind: string | number }) => string;
  readonly starting_torpedo_count: (p: { count: string | number; kind: string | number; max: string | number }) => string;
  readonly starting_torpedo_kind: (p: { kind: string | number }) => string;
  readonly starting_torpedo_no_carrier: (p: { kind: string | number }) => string;
  readonly starting_torpedo_twice: (p: { kind: string | number }) => string;
  readonly status: (p: { have: string | number; allowed: string | number }) => string;
  readonly structure_flag: (p: { kind: string | number; flag: string | number }) => string;
  readonly structure_objective: (p: { kind: string | number }) => string;
  readonly structure_team: (p: { kind: string | number; team: string | number }) => string;
  readonly symmetry_at: (p: { kind: string | number; allowed: string | number; at: string | number }) => string;
  readonly symmetry_base: (p: { slot: string | number; image: string | number; element: string | number }) => string;
  readonly symmetry_centre_need: (p: { kind: string | number }) => string;
  readonly symmetry_centre_none: (p: { kind: string | number }) => string;
  readonly symmetry_centre_off: (p: { cell: string | number }) => string;
  readonly symmetry_centre_pair: string;
  readonly symmetry_fairway: (p: { image: string | number; element: string | number }) => string;
  readonly symmetry_fleet: (p: { image: string | number; element: string | number }) => string;
  readonly symmetry_kind: (p: { kind: string | number; allowed: string | number }) => string;
  readonly symmetry_laid: (p: { image: string | number; element: string | number }) => string;
  readonly symmetry_marker: (p: { image: string | number; element: string | number }) => string;
  readonly symmetry_object: (p: { image: string | number; element: string | number }) => string;
  readonly symmetry_required: (p: { category: string | number }) => string;
  readonly symmetry_rows: (p: { kind: string | number; rows: string | number }) => string;
  readonly symmetry_sov: (p: { image: string | number; element: string | number }) => string;
  readonly symmetry_team: (p: { element: string | number; team: string | number }) => string;
  readonly symmetry_terrain: (p: { image: string | number; element: string | number }) => string;
  readonly symmetry_unpaired: (p: { element: string | number }) => string;
  readonly symmetry_win_cell: (p: { image: string | number; element: string | number }) => string;
  readonly tactical_scale: (p: { value: string | number }) => string;
  readonly terrain_char: (p: { char: string | number; water: string | number; ridge: string | number; trench: string | number }) => string;
  readonly terrain_row_count: (p: { have: string | number; rows: string | number }) => string;
  readonly terrain_row_width: (p: { row: string | number; chars: string | number; cols: string | number }) => string;
  readonly timeout: (p: { value: string | number }) => string;
  readonly timescale: (p: { value: string | number }) => string;
  readonly torpedo_base_only: (p: { kind: string | number }) => string;
  readonly torpedo_kind: (p: { kind: string | number }) => string;
  readonly torpedo_needs_load: (p: { list: string | number; kind: string | number }) => string;
  readonly torpedo_no_carrier: (p: { kind: string | number }) => string;
  readonly torpedo_price: (p: { kind: string | number; price: string | number; max: string | number }) => string;
  readonly torpedo_twice: (p: { kind: string | number }) => string;
  readonly version: (p: { have: string | number; want: string | number }) => string;
  readonly win_class: (p: { hull: string | number }) => string;
  readonly win_count: (p: { count: string | number; max: string | number }) => string;
  readonly win_hold_structures_count: (p: { count: string | number }) => string;
  readonly win_hold_structures_hold: (p: { hold: string | number }) => string;
  readonly win_hold_structures_objectives: (p: { count: string | number; have: string | number }) => string;
  readonly win_kill_class_count: (p: { count: string | number }) => string;
  readonly win_kills_count: (p: { count: string | number }) => string;
  readonly win_means: (p: { means: string | number; any: string | number; ship: string | number; torpedo: string | number }) => string;
  readonly win_mine_field: string;
  readonly win_mine_hull: (p: { hull: string | number }) => string;
  readonly win_mine_units: (p: { units: string | number }) => string;
  readonly win_scan_class_count: (p: { count: string | number }) => string;
  readonly win_scan_hull: (p: { hull: string | number }) => string;
  readonly win_sov_cell_hold: (p: { hold: string | number }) => string;
  readonly win_sov_cell_off: string;
  readonly win_sov_cell_rock: string;
  readonly win_sov_enabled: (p: { kind: string | number }) => string;
  readonly win_sov_share_hold: (p: { hold: string | number }) => string;
  readonly win_sov_share_percent: (p: { percent: string | number }) => string;
  readonly win_type: (p: { type: string | number }) => string;
}

export const arcadeMapschema: ArcadeMapschema = tables?.arcadeMapschema ?? source.arcadeMapschema;

/** arcade/match.ts — the in-match view: the map peek over water, rock, a deposit and a base, and the two firing solutions. */
export interface ArcadeMatch {
  readonly aim_bearing: string;
  readonly aim_in_reach: (p: { reach: string | number; range: string | number }) => string;
  readonly aim_out_of_reach: (p: { over: string | number }) => string;
  readonly aim_seeker: string;
  readonly aim_title: string;
  readonly base_all_reloading: (p: { wait: string | number }) => string;
  readonly base_round: (p: { round: string | number }) => string;
  readonly base_tubes_ready: (p: { free: number }) => string;
  readonly deposit_amount: (p: { amount: string | number }) => string;
  readonly deposit_nothing_left: string;
  readonly deposit_send_hauler: string;
  readonly deposit_worked_out: string;
  readonly open_sea_title: string;
  readonly ridge_line: string;
  readonly ridge_title: string;
  readonly score_goal: (p: { percent: string | number }) => string;
  readonly score_goal_title: string;
  readonly site_base: string;
  readonly site_own_base: string;
  readonly territory_title: string;
  readonly water_base_safe: string;
  readonly water_beam: (p: { faction: string | number; gauge: string | number }) => string;
  readonly water_object_tile: string;
  readonly water_owned: (p: { faction: string | number }) => string;
  readonly water_trench: string;
  readonly water_unclaimed: string;
}

export const arcadeMatch: ArcadeMatch = tables?.arcadeMatch ?? source.arcadeMatch;

/** arcade/moments.ts — the moments over the map: the loading roster, the pre-start block, the 3-2-1 card and the end card. */
export interface ArcadeMoments {
  readonly beat_words: readonly string[];
  readonly col_captain: string;
  readonly col_cells: string;
  readonly col_kills: string;
  readonly col_losses: string;
  readonly col_mined: string;
  readonly col_scans: string;
  readonly col_team: string;
  readonly input_locked: string;
  readonly kind_over: string;
  readonly kind_replay: string;
  readonly led_ground: string;
  readonly led_kill_class: (p: { hull_class: string | number }) => string;
  readonly led_kills: string;
  readonly led_mined: string;
  readonly led_objectives: string;
  readonly led_scan_class: (p: { hull_class: string | number }) => string;
  readonly led_sea: string;
  readonly load_grace_label: string;
  readonly load_note: string;
  readonly load_title: string;
  readonly reason_draw_all_sank: string;
  readonly reason_hold_structures: (p: { team: string | number }) => string;
  readonly reason_kill_class: (p: { team: string | number; hulls: string | number }) => string;
  readonly reason_kills: (p: { team: string | number; kills: string | number }) => string;
  readonly reason_last_fleet: (p: { team: string | number }) => string;
  readonly reason_mined: (p: { team: string | number; units: string | number }) => string;
  readonly reason_scan_class: (p: { team: string | number; hulls: string | number }) => string;
  readonly reason_sov_cell: (p: { team: string | number }) => string;
  readonly reason_sov_share: (p: { team: string | number; percent: string | number }) => string;
  readonly reason_surrender: (p: { team: string | number }) => string;
  readonly reason_surrender_you: string;
  readonly reason_surrender_your_team: string;
  readonly reason_time_ran_out: string;
  readonly reason_time_ran_out_leader: (p: { team: string | number; led: string | number }) => string;
  readonly seat_bot: string;
  readonly seat_in: string;
  readonly seat_loading: string;
  readonly seat_unnamed: (p: { slot: string | number }) => string;
  readonly seat_you: (p: { name: string | number }) => string;
  readonly start_title: string;
  readonly summary_achievements: string;
  readonly summary_again: string;
  readonly summary_captains: (p: { count: string | number }) => string;
  readonly summary_exit: string;
  readonly summary_played: (p: { clock: string | number }) => string;
  readonly verdict_draw: string;
  readonly verdict_lose: string;
  readonly verdict_win: string;
  readonly viewer_again: string;
  readonly viewer_arcade: string;
  readonly viewer_share: string;
  readonly viewer_won_name: (p: { name: string | number }) => string;
  readonly viewer_won_team: (p: { team: string | number }) => string;
}

export const arcadeMoments: ArcadeMoments = tables?.arcadeMoments ?? source.arcadeMoments;

/** arcade/structures.ts — the card of an arcade structure in a match, its capture count and the objective rows of the score card. */
export interface ArcadeStructures {
  readonly capturable: string;
  readonly effect_battery_owned: string;
  readonly effect_battery_public: string;
  readonly effect_breakwater_owned: (p: { team: string | number }) => string;
  readonly effect_breakwater_public: string;
  readonly effect_idle: string;
  readonly effect_spire_owned: (p: { team: string | number }) => string;
  readonly effect_spire_public: string;
  readonly effect_throne: string;
  readonly effect_ward_owned: (p: { team: string | number }) => string;
  readonly effect_ward_public: string;
  readonly f_capture: string;
  readonly f_owner: string;
  readonly f_reach: string;
  readonly f_taking: string;
  readonly fixed: string;
  readonly guard_label: string;
  readonly kind_battery: string;
  readonly kind_breakwater: string;
  readonly kind_spire: string;
  readonly kind_throne: string;
  readonly kind_ward: string;
  readonly objective: string;
  readonly objectives_heading: string;
  readonly owner_neutral: string;
  readonly reach: (p: { px: string | number; sec: string | number }) => string;
  readonly taking: (p: { team: string | number; sec: string | number }) => string;
}

export const arcadeStructures: ArcadeStructures = tables?.arcadeStructures ?? source.arcadeStructures;

/** arcade/viewer/ — the match viewer: the timeline bar, the channel row and the key sentences. One set of words serves a finished replay and a live spectator. */
export interface ArcadeViewer {
  readonly back: string;
  readonly bad_format: string;
  readonly channel_credits: (p: { name: string | number; credits: string | number }) => string;
  readonly copy_link: string;
  readonly exit: string;
  readonly film_title: string;
  readonly forward: string;
  readonly go_live: string;
  readonly group_channels: string;
  readonly group_transport: string;
  readonly inputs: string;
  readonly inputs_title: string;
  readonly key_back: string;
  readonly key_exit: string;
  readonly key_faster: string;
  readonly key_forward: string;
  readonly key_inputs: string;
  readonly key_keys: string;
  readonly key_last: string;
  readonly key_live: string;
  readonly key_next_keyframe: string;
  readonly key_omniscient: string;
  readonly key_play: string;
  readonly key_prev_keyframe: string;
  readonly key_restart: string;
  readonly key_seat: string;
  readonly key_slower: string;
  readonly key_step_back: string;
  readonly key_step_forward: string;
  readonly live: string;
  readonly loading: string;
  readonly omni: string;
  readonly past_failed: string;
  readonly past_none: string;
  readonly past_too_large: string;
  readonly pause: string;
  readonly play: string;
  readonly restart: string;
  readonly scrub: string;
  readonly share: string;
  readonly show: string;
  readonly speed: string;
  readonly tag_live: string;
  readonly tag_replay: string;
  readonly watching: (p: { who: string | number }) => string;
  readonly with_key: (p: { name: string | number; key: string | number }) => string;
}

export const arcadeViewer: ArcadeViewer = tables?.arcadeViewer ?? source.arcadeViewer;

/** arcade/winline.go and designer/winline.ts — the win condition in words, one wording for both languages. */
export interface ArcadeWinline {
  readonly class_or: (p: { rest: string | number; last: string | number }) => string;
  readonly class_sep: string;
  readonly hold_clause: (p: { hold: string | number }) => string;
  readonly hold_minutes: (p: { count: number }) => string;
  readonly hold_minutes_range: (p: { high: number; low: string | number }) => string;
  readonly hold_seconds: (p: { count: number }) => string;
  readonly hold_seconds_range: (p: { high: number; low: string | number }) => string;
  readonly hulls: (p: { count: number; hull_class: string | number }) => string;
  readonly hulls_range: (p: { high: number; hull_class: string | number; low: string | number }) => string;
  readonly kills: (p: { count: number }) => string;
  readonly kills_range: (p: { high: number; low: string | number }) => string;
  readonly means_ship: string;
  readonly means_torpedo: string;
  readonly range: (p: { low: string | number; high: string | number }) => string;
  readonly units: (p: { count: number }) => string;
  readonly units_range: (p: { high: number; low: string | number }) => string;
  readonly win_drill: string;
  readonly win_hold_structures: (p: { count: number; hold: string | number }) => string;
  readonly win_hold_structures_now: (p: { count: number }) => string;
  readonly win_hold_structures_range: (p: { high: number; hold: string | number; low: string | number }) => string;
  readonly win_hold_structures_range_now: (p: { high: number; low: string | number }) => string;
  readonly win_kill_all: string;
  readonly win_kill_class: (p: { hulls: string | number; means: string | number }) => string;
  readonly win_kills: (p: { kills: string | number; means: string | number }) => string;
  readonly win_mine: (p: { units: string | number }) => string;
  readonly win_scan_class: (p: { hulls: string | number }) => string;
  readonly win_sov_cell: (p: { hold: string | number }) => string;
  readonly win_sov_share: (p: { percent: string | number; hold: string | number }) => string;
}

export const arcadeWinline: ArcadeWinline = tables?.arcadeWinline ?? source.arcadeWinline;

/** ui.banner — the season title card that names the world, the season and the time left. */
export interface Banner {
  readonly bar_day: (p: { day: string | number }) => string;
  readonly foot_remaining: (p: { left: string | number }) => string;
  readonly gauge_season: string;
  readonly hero_season: (p: { season: string | number }) => string;
  readonly remaining: string;
}

export const banner: Banner = tables?.banner ?? source.banner;

/** battlelab/ — the battle lab page on the lab shell: the bar, the column of ARENA, ATTACK and DEFENCE, the lab fleet card, the battle report, the presets and the key sentences (R1298, R1964, battle-lab.md §5). */
export interface Battlelab {
  readonly add_fleet: string;
  readonly add_fleet_of: (p: { n: string | number; max: string | number }) => string;
  readonly arena: string;
  readonly arena_note: string;
  readonly arena_pick: (p: { seed: string | number; object: string | number; gauge: string | number; pace: string | number }) => string;
  readonly attack_won: string;
  readonly attack_won_short: string;
  readonly batch_kicker: (p: { runs: string | number; first: string | number; last: string | number }) => string;
  readonly battle_plan: string;
  readonly before: (p: { pct: string | number }) => string;
  readonly before_title: string;
  readonly behaviour: string;
  readonly behaviour_engage: string;
  readonly behaviour_flank: string;
  readonly behaviour_hold: string;
  readonly build_price_title: string;
  readonly captain: string;
  readonly captain_title: string;
  readonly captured: string;
  readonly col_dealt: string;
  readonly col_name: string;
  readonly col_out: string;
  readonly col_shield: string;
  readonly col_taken: string;
  readonly column_hide: string;
  readonly column_hint: string;
  readonly column_show: string;
  readonly copy: string;
  readonly copy_link: string;
  readonly copy_link_title: string;
  readonly copy_title: string;
  readonly count: string;
  readonly damage_ratio: string;
  readonly dealt: string;
  readonly defaults: string;
  readonly defaults_hint: string;
  readonly defence_held: string;
  readonly defence_held_short: string;
  readonly defender_edge: string;
  readonly dice_title: string;
  readonly duration: string;
  readonly duration_value: (p: { s: string | number }) => string;
  readonly edge_value: (p: { edge: string | number }) => string;
  readonly engine_loading: string;
  readonly engine_missing: (p: { why: string | number }) => string;
  readonly engine_ready: string;
  readonly export_hint: string;
  readonly fight: string;
  readonly fight_many: (p: { runs: string | number }) => string;
  readonly fight_many_title: (p: { runs: string | number }) => string;
  readonly fit: string;
  readonly fleet_changed_title: string;
  readonly fleet_kind: (p: { side: string | number; hull: string | number; role: string | number }) => string;
  readonly fleet_title: string;
  readonly gauge: string;
  readonly gauge_label: string;
  readonly gauge_value: (p: { before: string | number; after: string | number }) => string;
  readonly home_water: string;
  readonly hull: string;
  readonly hull_pct: string;
  readonly hull_refused: (p: { hull: string | number }) => string;
  readonly import_hint: string;
  readonly key_column: string;
  readonly key_fight: string;
  readonly key_many: string;
  readonly key_watch: string;
  readonly keys: string;
  readonly kicker: (p: { object: string | number; seed: string | number }) => string;
  readonly legend_foot: (p: { gauge: string | number; edge: string | number }) => string;
  readonly legend_side: (p: { side: string | number; faction: string | number }) => string;
  readonly legend_title: (p: { object: string | number }) => string;
  readonly mean_duration: string;
  readonly mean_gauge_hit: string;
  readonly menu_file: string;
  readonly menu_run: string;
  readonly menu_view: string;
  readonly module_add_title: string;
  readonly module_remove_title: string;
  readonly modules: string;
  readonly modules_value: (p: { on: string | number; max: string | number }) => string;
  readonly name: string;
  readonly no: string;
  readonly no_renderer: string;
  readonly none: string;
  readonly notice_import_bad: (p: { file: string | number }) => string;
  readonly notice_imported: (p: { count: number }) => string;
  readonly notice_link: string;
  readonly notice_loaded: (p: { name: string | number }) => string;
  readonly notice_no_name: string;
  readonly notice_saved: (p: { name: string | number }) => string;
  readonly notice_storage_refused: string;
  readonly object: string;
  readonly objects_held: string;
  readonly out_sunk: string;
  readonly out_withdrew: string;
  readonly pace: string;
  readonly pace_core: string;
  readonly pace_event: string;
  readonly pace_value: (p: { pace: string | number; divisor: string | number }) => string;
  readonly position: string;
  readonly position_centre: string;
  readonly position_front: string;
  readonly position_rear: string;
  readonly preset_delete: string;
  readonly preset_delete_sure: string;
  readonly preset_export: string;
  readonly preset_import: string;
  readonly preset_load: string;
  readonly preset_name: string;
  readonly preset_none: string;
  readonly preset_save: string;
  readonly presets: string;
  readonly presets_pick: (p: { count: string | number }) => string;
  readonly remove: string;
  readonly remove_title: string;
  readonly report: string;
  readonly report_none: (p: { runs: string | number }) => string;
  readonly report_pick: (p: { ms: string | number }) => string;
  readonly roll_title: string;
  readonly rounds: string;
  readonly row_title: (p: { label: string | number; value: string | number }) => string;
  readonly run_failed: (p: { error: string | number }) => string;
  readonly running: string;
  readonly running_many: (p: { runs: string | number }) => string;
  readonly seats: string;
  readonly seed: string;
  readonly sentence_captured: (p: { before: string | number; after: string | number }) => string;
  readonly sentence_fell: (p: { before: string | number; after: string | number }) => string;
  readonly sentence_held: (p: { before: string | number }) => string;
  readonly sentence_out: string;
  readonly sentence_rose: (p: { before: string | number; after: string | number }) => string;
  readonly sheet_arena: (p: { seed: string | number; object: string | number; attack: string | number; defence: string | number }) => string;
  readonly sheet_tally: (p: { wins: string | number; runs: string | number }) => string;
  readonly sheet_verdict: (p: { ratio: string | number; before: string | number; after: string | number }) => string;
  readonly shield: string;
  readonly shield_pct: string;
  readonly side_attack: string;
  readonly side_defence: string;
  readonly side_group: (p: { side: string | number; faction: string | number }) => string;
  readonly side_note: (p: { fleets: string | number; hulls: string | number }) => string;
  readonly side_note_run: (p: { faction: string | number; fleets: string | number; hulls: string | number }) => string;
  readonly side_pick: (p: { fleets: string | number; hulls: string | number }) => string;
  readonly start_state: string;
  readonly status_last: (p: { seed: string | number; object: string | number; verdict: string | number }) => string;
  readonly status_many: (p: { runs: string | number; wins: string | number }) => string;
  readonly storage_off: string;
  readonly tactical_scale: string;
  readonly tag_captain: string;
  readonly tag_torpedo: (p: { n: string | number }) => string;
  readonly tech: string;
  readonly tech_none: string;
  readonly tech_of: (p: { all: string | number }) => string;
  readonly tech_title: string;
  readonly tech_value: (p: { on: string | number; all: string | number }) => string;
  readonly title: string;
  readonly torpedo: string;
  readonly torpedo_auto: string;
  readonly versus: string;
  readonly viewer_fallback: string;
  readonly watch: string;
  readonly watch_off_title: string;
  readonly weapon: string;
  readonly win_rate_sub: (p: { wins: string | number; runs: string | number }) => string;
  readonly win_rate_value: (p: { pct: string | number }) => string;
  readonly yes: string;
}

export const battlelab: Battlelab = tables?.battlelab ?? source.battlelab;

/** brandart/ — the brand art page: the deep icon, the lockup files, the platform images, the season image, the launch images and the wallpapers at their true pixel sizes, each with SAVE PNG (brand.md §6, §12). */
export interface Brandart {
  readonly card_12: string;
  readonly card_16: string;
  readonly card_17: string;
  readonly card_19: string;
  readonly card_20: string;
  readonly card_21: string;
  readonly card_22: string;
  readonly card_23: string;
  readonly card_28: string;
  readonly card_29: string;
  readonly card_live_deep_drift: string;
  readonly card_live_deep_pulse: string;
  readonly card_live_deep_sweep: string;
  readonly card_live_ping_pulse: string;
  readonly card_live_ping_sweep: string;
  readonly card_wall_chart: string;
  readonly card_wall_deep: string;
  readonly card_wall_ping: string;
  readonly check_leaves: (p: { what: string | number; guide: string | number }) => string;
  readonly check_ok: string;
  readonly check_touches: (p: { what: string | number; guide: string | number }) => string;
  readonly desc_12: string;
  readonly desc_16: string;
  readonly desc_17: string;
  readonly desc_19: string;
  readonly desc_20: string;
  readonly desc_21: string;
  readonly desc_22: string;
  readonly desc_23: string;
  readonly desc_28: string;
  readonly desc_29: string;
  readonly desc_dev: string;
  readonly desc_live_deep_drift: string;
  readonly desc_live_deep_pulse: string;
  readonly desc_live_deep_sweep: string;
  readonly desc_live_ping_pulse: string;
  readonly desc_live_ping_sweep: string;
  readonly desc_wall_chart: string;
  readonly desc_wall_deep: string;
  readonly desc_wall_ping: string;
  readonly fault: (p: { message: string | number }) => string;
  readonly ground: string;
  readonly ground_arcade: string;
  readonly ground_chart: string;
  readonly ground_clanwar: string;
  readonly ground_conquest: string;
  readonly ground_event: string;
  readonly guide_avatar: string;
  readonly guide_desktop_band: (p: { w: string | number; h: string | number }) => string;
  readonly guide_dock: string;
  readonly guide_feed_square: string;
  readonly guide_icons_mac: string;
  readonly guide_icons_windows: string;
  readonly guide_large_card: string;
  readonly guide_lock_android: string;
  readonly guide_lock_clock: string;
  readonly guide_lock_ios: string;
  readonly guide_menu_bar: string;
  readonly guide_messenger: string;
  readonly guide_notch: (p: { ratio: string | number }) => string;
  readonly guide_safe_area: (p: { w: string | number; h: string | number }) => string;
  readonly guide_safe_circle: (p: { pct: string | number }) => string;
  readonly guide_safe_wall: string;
  readonly guide_server_name: string;
  readonly guide_slot_name: string;
  readonly guide_slot_season: string;
  readonly guide_tablet_band: (p: { w: string | number; h: string | number }) => string;
  readonly guide_taskbar: string;
  readonly guide_telephone: string;
  readonly guide_title_safe: (p: { pct: string | number }) => string;
  readonly guide_ultrawide: string;
  readonly guide_under_name: string;
  readonly guides_off: string;
  readonly guides_on: string;
  readonly landscape: string;
  readonly launch_count: (p: { count: number }) => string;
  readonly launch_option: (p: { w: string | number; h: string | number; orientation: string | number; devices: string | number }) => string;
  readonly live_frame: (p: { t: string | number; i: string | number }) => string;
  readonly live_pause: string;
  readonly live_play: string;
  readonly lockup_ink: string;
  readonly lockup_label: (p: { size: string | number; ground: string | number; w: string | number; h: string | number }) => string;
  readonly lockup_large: string;
  readonly lockup_small: string;
  readonly lockup_transparent: string;
  readonly portrait: string;
  readonly save: string;
  readonly season: string;
  readonly season_name: string;
  readonly size: (p: { w: string | number; h: string | number }) => string;
  readonly sting_play: string;
  readonly sting_time: (p: { t: string | number }) => string;
  readonly sub: string;
  readonly title: string;
  readonly wall_option: (p: { w: string | number; h: string | number; devices: string | number }) => string;
  readonly what_dev: string;
  readonly what_name: string;
  readonly what_season: string;
  readonly what_sign: string;
  readonly what_slot: string;
  readonly what_tag: string;
}

export const brandart: Brandart = tables?.brandart ?? source.brandart;

/** brandart/discord/ — the Discord emojis and stickers of the brand art page: the two cards, the words of the set and the alt text of each piece (brand.md §14). */
export interface BrandartDiscord {
  readonly animated: string;
  readonly card_emoji: string;
  readonly card_kraken: string;
  readonly card_sticker: string;
  readonly desc_e_abyssal_compact: string;
  readonly desc_e_alloy: string;
  readonly desc_e_archive_vault: string;
  readonly desc_e_attack: string;
  readonly desc_e_basilisk: string;
  readonly desc_e_battle: string;
  readonly desc_e_beacon: string;
  readonly desc_e_biomass: string;
  readonly desc_e_bombard: string;
  readonly desc_e_clan_war: string;
  readonly desc_e_contact: string;
  readonly desc_e_coral_ward: string;
  readonly desc_e_corsair: string;
  readonly desc_e_cup: string;
  readonly desc_e_cutlass: string;
  readonly desc_e_danger: string;
  readonly desc_e_deep_battery: string;
  readonly desc_e_defend: string;
  readonly desc_e_dredger: string;
  readonly desc_e_drydock_shoal: string;
  readonly desc_e_falconet: string;
  readonly desc_e_forge_vent: string;
  readonly desc_e_gather: string;
  readonly desc_e_gg: string;
  readonly desc_e_hit: string;
  readonly desc_e_hold: string;
  readonly desc_e_kelp_syndicate: string;
  readonly desc_e_kelp_terrace: string;
  readonly desc_e_kraken: string;
  readonly desc_e_kraken_breach: string;
  readonly desc_e_kraken_hood: string;
  readonly desc_e_kraken_keel: string;
  readonly desc_e_ladder_blackwater: string;
  readonly desc_e_ladder_crush: string;
  readonly desc_e_ladder_midnight: string;
  readonly desc_e_ladder_shallows: string;
  readonly desc_e_ladder_sunlit: string;
  readonly desc_e_ladder_twilight: string;
  readonly desc_e_lancer: string;
  readonly desc_e_mariana_sisters: string;
  readonly desc_e_marshal_court: string;
  readonly desc_e_oracle: string;
  readonly desc_e_ping: string;
  readonly desc_e_relay_spire: string;
  readonly desc_e_rust_fleet: string;
  readonly desc_e_seaquake: string;
  readonly desc_e_sentinel: string;
  readonly desc_e_siege: string;
  readonly desc_e_sign: string;
  readonly desc_e_tender: string;
  readonly desc_e_torpedo: string;
  readonly desc_e_trench_throne: string;
  readonly desc_e_vedette: string;
  readonly desc_e_void_choir: string;
  readonly desc_e_volatiles: string;
  readonly desc_e_whale: string;
  readonly desc_e_wreck: string;
  readonly desc_emoji: string;
  readonly desc_kraken: string;
  readonly desc_s_aquaphobia: string;
  readonly desc_s_attack: string;
  readonly desc_s_clan_cup: string;
  readonly desc_s_clan_war: string;
  readonly desc_s_defend: string;
  readonly desc_s_enemy: string;
  readonly desc_s_factions: string;
  readonly desc_s_gg: string;
  readonly desc_s_help: string;
  readonly desc_s_hull_sunk: string;
  readonly desc_s_kraken_breach: string;
  readonly desc_s_kraken_dome: string;
  readonly desc_s_kraken_hood: string;
  readonly desc_s_kraken_keel: string;
  readonly desc_s_on_my_way: string;
  readonly desc_s_regroup: string;
  readonly desc_s_seaquake: string;
  readonly desc_s_siege: string;
  readonly desc_s_torpedo_away: string;
  readonly desc_sticker: string;
  readonly ground: string;
  readonly ground_dark: string;
  readonly ground_light: string;
  readonly manifest_about: string;
  readonly name_factions: string;
  readonly word_gg: string;
  readonly word_kraken: string;
}

export const brandartDiscord: BrandartDiscord = tables?.brandartDiscord ?? source.brandartDiscord;

/** ui/briefing.ts, ui/inbox/sinceleft.ts and ui/inbox/digest.ts — the return briefing on the seat card of the hub (ui-map-interface.md §12.6, R1605), and SINCE YOU LEFT with the DIGEST at the head of the INBOX (inbox.md §7, R1851). */
export interface Briefing {
  readonly all_figures: string;
  readonly auction: (p: { lots: string | number; credits: string | number }) => string;
  readonly away_for: (p: { span: string | number }) => string;
  readonly away_span: (p: { away: string | number; span: string | number }) => string;
  readonly back: string;
  readonly cell_credits: string;
  readonly cell_isotopes: string;
  readonly cell_sinkings: string;
  readonly cells: (p: { won: string | number; lost: string | number }) => string;
  readonly ch_dives: string;
  readonly ch_dives_aside: string;
  readonly ch_ground: string;
  readonly ch_ground_aside: string;
  readonly ch_ledger: string;
  readonly ch_moments: string;
  readonly ch_moments_aside: string;
  readonly ch_objects: string;
  readonly ch_objects_aside: string;
  readonly ch_war: string;
  readonly ch_war_aside: string;
  readonly chat_faction: (p: { n: number }) => string;
  readonly chat_line: (p: { name: string | number; text: string | number }) => string;
  readonly cover_hub: string;
  readonly cover_line: string;
  readonly cover_on: string;
  readonly down: (p: { n: string | number }) => string;
  readonly ended: string;
  readonly events: (p: { n: number }) => string;
  readonly fell: string;
  readonly fig_battles: string;
  readonly fig_captains_captured: string;
  readonly fig_captains_hurt: string;
  readonly fig_captains_recruited: string;
  readonly fig_cargo_blocked: string;
  readonly fig_cargo_landed: string;
  readonly fig_cargo_lost: string;
  readonly fig_cells_lost: string;
  readonly fig_cells_won: string;
  readonly fig_cores: string;
  readonly fig_credits: string;
  readonly fig_dives: string;
  readonly fig_dmg_dealt: string;
  readonly fig_dmg_dealt_title: string;
  readonly fig_dmg_taken: string;
  readonly fig_dmg_taken_title: string;
  readonly fig_dockings: string;
  readonly fig_fire_events: string;
  readonly fig_fleets_lost: string;
  readonly fig_iso_bought: string;
  readonly fig_isotopes: string;
  readonly fig_jobs_done: string;
  readonly fig_kills: string;
  readonly fig_msg_dive: string;
  readonly fig_msg_hold: string;
  readonly fig_msg_loss: string;
  readonly fig_msg_trade: string;
  readonly fig_msg_war: string;
  readonly fig_msg_world: string;
  readonly fig_obj_held: string;
  readonly fig_obj_lost: string;
  readonly fig_obj_taken: string;
  readonly fig_practice: string;
  readonly fig_prints_bought: string;
  readonly fig_repairs: string;
  readonly fig_research_done: string;
  readonly fig_sales: string;
  readonly fig_salvage: string;
  readonly fig_ships_ready: string;
  readonly fig_torp_hit: string;
  readonly fig_torp_struck: string;
  readonly fig_torps_stowed: string;
  readonly fleets: (p: { sunk: string | number; lost: string | number }) => string;
  readonly fold_close: string;
  readonly fold_open: string;
  readonly g_cores: string;
  readonly g_dives: string;
  readonly g_held: string;
  readonly g_iso: string;
  readonly g_lost: string;
  readonly g_sunk: string;
  readonly g_taken: string;
  readonly g_total: string;
  readonly g_won: string;
  readonly held: string;
  readonly lab_chat: string;
  readonly lab_cover: string;
  readonly lab_losses: string;
  readonly lab_markers: string;
  readonly lab_sickbay: string;
  readonly lab_siege: string;
  readonly lab_water: string;
  readonly lab_windows: string;
  readonly lab_works: string;
  readonly ledger_aside: string;
  readonly left_hours: (p: { hours: string | number; min: string | number }) => string;
  readonly left_min: (p: { min: string | number }) => string;
  readonly less_one: string;
  readonly line_cells: string;
  readonly line_lost: (p: { n: string | number }) => string;
  readonly line_quiet: string;
  readonly line_siege: (p: { site: string | number; at: string | number }) => string;
  readonly line_unread: (p: { n: string | number }) => string;
  readonly line_wait: string;
  readonly line_works: (p: { n: number }) => string;
  readonly link_down: string;
  readonly loss_captured: (p: { n: string | number }) => string;
  readonly loss_cargo: (p: { n: string | number }) => string;
  readonly loss_fleets: (p: { n: number }) => string;
  readonly loss_hurt: (p: { n: string | number }) => string;
  readonly m_battle: string;
  readonly m_dive: string;
  readonly m_goto: string;
  readonly m_loss: string;
  readonly m_none: string;
  readonly m_replay: string;
  readonly m_sale: string;
  readonly mark_these: string;
  readonly marker_row: (p: { kind: string | number; name: string | number }) => string;
  readonly mauled: string;
  readonly more: (p: { n: string | number }) => string;
  readonly obj_held: (p: { n: string | number }) => string;
  readonly obj_lost: (p: { n: string | number }) => string;
  readonly obj_taken: (p: { n: string | number }) => string;
  readonly open_faction_chat: string;
  readonly open_squad_chat: string;
  readonly open_window: string;
  readonly page_head: string;
  readonly quiet: string;
  readonly range_away: string;
  readonly range_d7: string;
  readonly range_h24: string;
  readonly range_no_away: string;
  readonly range_season: string;
  readonly recent_fold_close: string;
  readonly recent_fold_open: string;
  readonly recent_head: string;
  readonly row_auction: string;
  readonly row_cells: string;
  readonly row_cover: string;
  readonly row_fleets: string;
  readonly row_sickbay: string;
  readonly row_siege: string;
  readonly row_squad: string;
  readonly row_works: string;
  readonly same: string;
  readonly show_every: string;
  readonly show_marker: string;
  readonly show_only: string;
  readonly show_window: string;
  readonly sickbay_fit: (p: { name: string | number; left: string | number }) => string;
  readonly sickbay_in: (p: { name: string | number; left: string | number }) => string;
  readonly siege_ended: (p: { site: string | number }) => string;
  readonly siege_fell: (p: { site: string | number; foe: string | number }) => string;
  readonly siege_fell_bare: (p: { site: string | number }) => string;
  readonly siege_held: (p: { site: string | number }) => string;
  readonly siege_in: (p: { site: string | number; attacker: string | number; left: string | number }) => string;
  readonly siege_live: (p: { site: string | number; attacker: string | number; left: string | number }) => string;
  readonly siege_live_bare: (p: { site: string | number; left: string | number }) => string;
  readonly siege_mauled: (p: { site: string | number }) => string;
  readonly siege_open: (p: { site: string | number; attacker: string | number }) => string;
  readonly since_day: (p: { day: string | number }) => string;
  readonly slot_days: (p: { n: number }) => string;
  readonly slot_hours: (p: { n: string | number }) => string;
  readonly span: (p: { from: string | number; to: string | number }) => string;
  readonly squad_hub: (p: { n: number }) => string;
  readonly t_day: string;
  readonly t_delta: string;
  readonly t_figure: string;
  readonly thousand: (p: { n: string | number }) => string;
  readonly up: (p: { n: string | number }) => string;
  readonly water_cells: (p: { won: string | number; lost: string | number }) => string;
  readonly water_objects: (p: { list: string | number }) => string;
  readonly window_attack: (p: { site: string | number }) => string;
  readonly window_defend: (p: { site: string | number }) => string;
  readonly window_open: string;
  readonly works_hub: (p: { levels: string | number; nodes: string | number }) => string;
  readonly works_hulls: (p: { n: number }) => string;
  readonly works_levels: (p: { n: number }) => string;
  readonly works_recruits: (p: { n: number }) => string;
  readonly works_repairs: (p: { n: number }) => string;
  readonly works_research: (p: { n: number }) => string;
  readonly works_torps: (p: { n: number }) => string;
}

export const briefing: Briefing = tables?.briefing ?? source.briefing;

/** the phrase list of a cache note, which the deposit sheet offers and the hub checks */
export interface CacheNote {
  readonly phrases: readonly string[];
}

export const cacheNote: CacheNote = tables?.cacheNote ?? source.cacheNote;

/** ui.card — the card kit: the peek, the card and the page of a map object. */
export interface Card {
  readonly arm_cancel: string;
  readonly armed_aim_chip: (p: { order: string | number }) => string;
  readonly armed_chip: (p: { order: string | number }) => string;
  readonly aspect_beam: string;
  readonly aspect_bow: string;
  readonly aspect_stern: string;
  readonly aspect_title: string;
  readonly aura_lift: (p: { pct: string | number; px: string | number }) => string;
  readonly aura_off: string;
  readonly aura_on: (p: { px: string | number; pct: string | number }) => string;
  readonly aura_title: string;
  readonly auto_field_off: string;
  readonly auto_field_on: string;
  readonly back_mark: string;
  readonly back_title: string;
  readonly beam_needs_set: string;
  readonly beam_off: string;
  readonly beam_on: (p: { left: string | number }) => string;
  readonly beam_title: (p: { dur: string | number }) => string;
  readonly boarding_status: string;
  readonly bounty_credits: (p: { credits: string | number }) => string;
  readonly bro_grapnel_company: string;
  readonly bro_lantern_kin: string;
  readonly bro_ninefathom: string;
  readonly bro_saltjaw: string;
  readonly bro_undertow: string;
  readonly build_named: (p: { name: string | number }) => string;
  readonly cache_cancel: string;
  readonly cache_close: string;
  readonly cache_fee: (p: { n: string | number }) => string;
  readonly cache_find_note: string;
  readonly cache_find_player_note: string;
  readonly cache_finds: (p: { n: number }) => string;
  readonly cache_finds_head: string;
  readonly cache_found_chip: string;
  readonly cache_full_title: string;
  readonly cache_kind_event: string;
  readonly cache_kind_other: string;
  readonly cache_kind_pirate: string;
  readonly cache_kind_player: string;
  readonly cache_kind_ruin: string;
  readonly cache_kind_seeded: string;
  readonly cache_leave_btn: string;
  readonly cache_leave_btn_title: string;
  readonly cache_leave_hint: string;
  readonly cache_leave_kind: (p: { fleet: string | number }) => string;
  readonly cache_leave_title: string;
  readonly cache_note_bad_length: (p: { min: string | number; max: string | number }) => string;
  readonly cache_note_btn: string;
  readonly cache_note_btn_title: string;
  readonly cache_note_head: string;
  readonly cache_note_hint_text: (p: { min: string | number; max: string | number }) => string;
  readonly cache_note_none: string;
  readonly cache_note_none_left: string;
  readonly cache_note_once: string;
  readonly cache_note_only_you: string;
  readonly cache_note_pick: string;
  readonly cache_note_quoted: (p: { note: string | number }) => string;
  readonly cache_note_save: string;
  readonly cache_note_text: string;
  readonly cache_note_title: string;
  readonly cache_note_unset: string;
  readonly cache_of: (p: { n: string | number; max: string | number }) => string;
  readonly cache_read_btn: string;
  readonly cache_read_btn_title: string;
  readonly cache_search_here: string;
  readonly cache_search_here_title: string;
  readonly cache_show: string;
  readonly cache_yours_head: string;
  readonly captain: (p: { name: string | number; phase: string | number }) => string;
  readonly career_age: (p: { age: string | number; phase: string | number }) => string;
  readonly career_decline: string;
  readonly career_decline_from: (p: { age: string | number }) => string;
  readonly career_peak: string;
  readonly career_rise: string;
  readonly cl_cargo_head: string;
  readonly cl_fold: (p: { n: number }) => string;
  readonly cl_fold_side: (p: { n: string | number; side: string | number }) => string;
  readonly cl_next_title: string;
  readonly cl_page: (p: { page: string | number; pages: string | number }) => string;
  readonly cl_prev_title: string;
  readonly close_title: string;
  readonly cls_gulper: string;
  readonly cls_murkhide: string;
  readonly cls_myriad: string;
  readonly cls_quillback: string;
  readonly cls_thrummer: string;
  readonly commander_unknown: string;
  readonly commit: (p: { verb: string | number; fleet: string | number }) => string;
  readonly compare: string;
  readonly compare_kind: string;
  readonly compare_note: string;
  readonly compare_tag: string;
  readonly compare_title: string;
  readonly compressed_cargo: (p: { units: string | number }) => string;
  readonly compressed_title: (p: { alloy: string | number; biomass: string | number; volatiles: string | number; isotopes: string | number }) => string;
  readonly cond_anchor: string;
  readonly cond_aura_pts: (p: { short: string | number; pts: string | number }) => string;
  readonly cond_aura_sep: string;
  readonly cond_command: string;
  readonly cond_command_lift_why: (p: { name: string | number; pct: string | number }) => string;
  readonly cond_command_why: (p: { name: string | number; pct: string | number }) => string;
  readonly cond_deep_run: string;
  readonly cond_drift: string;
  readonly cond_echo: string;
  readonly cond_factor: (p: { f: string | number }) => string;
  readonly cond_ghost: string;
  readonly cond_harbour: string;
  readonly cond_lane: string;
  readonly cond_lift: (p: { pct: string | number }) => string;
  readonly cond_net: string;
  readonly cond_pressure: string;
  readonly cond_screen: string;
  readonly cond_share: (p: { pct: string | number }) => string;
  readonly cond_signature: string;
  readonly cond_slow: string;
  readonly cond_surge: string;
  readonly cond_terrain: string;
  readonly cond_value: (p: { factor: string | number; left: string | number }) => string;
  readonly cond_wear: (p: { n: string | number }) => string;
  readonly cond_wire: string;
  readonly contact_lost: string;
  readonly contact_title: string;
  readonly contested_no: string;
  readonly contested_title: string;
  readonly contested_yes: string;
  readonly ddesign_broken_ridge: string;
  readonly ddesign_down_funnel: string;
  readonly ddesign_grappled_hauler: string;
  readonly ddesign_hook_spur: string;
  readonly ddesign_jaw_cut: string;
  readonly ddesign_lantern_wreck: string;
  readonly ddesign_rammed_pair: string;
  readonly ddesign_sounding_ledge: string;
  readonly ddesign_sunken_dreadnought: string;
  readonly ddesign_survey_ship: string;
  readonly deep: string;
  readonly deep_run: string;
  readonly den_at_sea: string;
  readonly den_cache_seen: string;
  readonly den_cache_taken: string;
  readonly den_home: string;
  readonly den_prize: string;
  readonly den_respawn: (p: { left: string | number }) => string;
  readonly den_sunk: string;
  readonly den_title: string;
  readonly den_unknown: string;
  readonly depth_band: (p: { band: string | number; rating: string | number }) => string;
  readonly echo_far: string;
  readonly echo_mid: string;
  readonly echo_near: string;
  readonly echo_title: (p: { px: string | number }) => string;
  readonly edit_group_title: string;
  readonly edit_title: string;
  readonly eff_brace: (p: { sec: string | number; mul: string | number }) => string;
  readonly eff_broadside: (p: { sec: string | number; mul: string | number; splash: string | number }) => string;
  readonly eff_canister: (p: { sec: string | number }) => string;
  readonly eff_crash_dive: (p: { noise: string | number; speed: string | number; sec: string | number }) => string;
  readonly eff_dig_in: (p: { sec: string | number; px: string | number }) => string;
  readonly eff_getaway: (p: { sec: string | number; speed: string | number; turn: string | number }) => string;
  readonly eff_muster: (p: { px: string | number; mul: string | number }) => string;
  readonly eff_outflank: (p: { sec: string | number; mul: string | number }) => string;
  readonly effect_after: string;
  readonly effect_now: string;
  readonly empty: string;
  readonly f_act: string;
  readonly f_aspect: string;
  readonly f_aura: string;
  readonly f_bounty: string;
  readonly f_brotherhood: string;
  readonly f_cache_fee: string;
  readonly f_cache_finds: string;
  readonly f_cache_season: string;
  readonly f_cache_today: string;
  readonly f_captain: string;
  readonly f_cargo: string;
  readonly f_clan: string;
  readonly f_commander: string;
  readonly f_compressed: string;
  readonly f_contested: string;
  readonly f_dead_zone: string;
  readonly f_depth: string;
  readonly f_design: string;
  readonly f_echo: string;
  readonly f_faction: string;
  readonly f_fit: string;
  readonly f_formation: string;
  readonly f_gait: string;
  readonly f_grants: string;
  readonly f_guns: string;
  readonly f_heal: string;
  readonly f_held_by: string;
  readonly f_lane_credit: string;
  readonly f_lane_gap: string;
  readonly f_lane_light: string;
  readonly f_lay: string;
  readonly f_life: string;
  readonly f_lighters: string;
  readonly f_loud: string;
  readonly f_monster: string;
  readonly f_muster: string;
  readonly f_next_field: string;
  readonly f_noise: string;
  readonly f_order: string;
  readonly f_reach: string;
  readonly f_road: string;
  readonly f_round: string;
  readonly f_route: string;
  readonly f_side: string;
  readonly f_signature: string;
  readonly f_sonar: string;
  readonly f_speed: string;
  readonly f_squad: string;
  readonly f_status: string;
  readonly f_sunk: string;
  readonly f_systems: string;
  readonly f_value: string;
  readonly f_weight: string;
  readonly f_work: string;
  readonly f_working: string;
  readonly f_yield: string;
  readonly f_your_pledge: string;
  readonly formation_member: (p: { name: string | number }) => string;
  readonly formation_on: (p: { n: string | number }) => string;
  readonly formation_title: string;
  readonly group_slot: (p: { n: string | number }) => string;
  readonly group_title: (p: { n: string | number }) => string;
  readonly guard_in_reach: string;
  readonly guard_title: string;
  readonly heal_blocked: string;
  readonly heard_title: string;
  readonly heat_toward: (p: { pct: string | number; hi: string | number }) => string;
  readonly hold_fire_on: string;
  readonly hold_fire_title: string;
  readonly kind_building: (p: { level: string | number; next: string | number }) => string;
  readonly kind_building_max: (p: { level: string | number }) => string;
  readonly kind_deposit: (p: { resource: string | number }) => string;
  readonly kind_hold: (p: { faction: string | number }) => string;
  readonly kind_hold_own: string;
  readonly kind_unclassified: string;
  readonly ladder_needs: (p: { codes: string | number }) => string;
  readonly ladder_this: string;
  readonly lane_chip: string;
  readonly lane_chip_own: string;
  readonly lane_chip_quiet: string;
  readonly lane_commanders: (p: { n: number }) => string;
  readonly lane_credit: (p: { h: string | number }) => string;
  readonly lane_credit_none: string;
  readonly lane_credit_title: string;
  readonly lane_gap: (p: { leg: string | number }) => string;
  readonly lane_gap_title: string;
  readonly lane_gap_view: (p: { leg: string | number }) => string;
  readonly lane_kind: string;
  readonly lane_lighter: (p: { name: string | number; n: string | number }) => string;
  readonly lane_lighters_none: string;
  readonly lane_lit: (p: { f: string | number; n: number }) => string;
  readonly lane_lit_title: string;
  readonly lane_note: string;
  readonly lane_offer: (p: { lane: string | number; dur: string | number }) => string;
  readonly lane_offer_title: (p: { lane: string | number }) => string;
  readonly lane_quiet_note: string;
  readonly lane_road: (p: { name: string | number }) => string;
  readonly lane_road_val: (p: { road: string | number; px: string | number; who: string | number }) => string;
  readonly lane_send: (p: { name: string | number }) => string;
  readonly lane_send_none: string;
  readonly lane_send_none_title: string;
  readonly lane_send_title: (p: { name: string | number }) => string;
  readonly lane_unlit: string;
  readonly lane_you: string;
  readonly lay_pick: string;
  readonly lay_pick_title: string;
  readonly lay_ready: string;
  readonly levels: string;
  readonly levels_at: (p: { level: string | number }) => string;
  readonly levels_cost: string;
  readonly levels_next: (p: { level: string | number }) => string;
  readonly levels_now: (p: { level: string | number }) => string;
  readonly levels_pick: (p: { level: string | number }) => string;
  readonly levels_pick_label: (p: { level: string | number }) => string;
  readonly levels_time: string;
  readonly loud_left: (p: { left: string | number }) => string;
  readonly loud_title: string;
  readonly lower_title: string;
  readonly mdesign_brood_sac: string;
  readonly mdesign_bud_gourd: string;
  readonly mdesign_coil_eel: string;
  readonly mdesign_comma_flock: string;
  readonly mdesign_discharge_ray: string;
  readonly mdesign_dot_cloud: string;
  readonly mdesign_gullet_sack: string;
  readonly mdesign_hinged_jaw: string;
  readonly mdesign_ink_veil: string;
  readonly mdesign_lamp_crown: string;
  readonly mdesign_lure_lamp: string;
  readonly mdesign_mantis_fold: string;
  readonly mdesign_quill_spine: string;
  readonly mdesign_ram_plate: string;
  readonly mdesign_ribbon_school: string;
  readonly mdesign_ring_maw: string;
  readonly mdesign_ring_pack: string;
  readonly mdesign_siphon_tube: string;
  readonly mdesign_trapdoor: string;
  readonly mdesign_twin_drum: string;
  readonly mix_part: (p: { n: string | number; name: string | number }) => string;
  readonly mix_sep: string;
  readonly mix_short: (p: { n: string | number; letter: string | number }) => string;
  readonly more_groups: string;
  readonly more_mark: string;
  readonly more_name: string;
  readonly more_title: string;
  readonly muster_on: (p: { px: string | number; mul: string | number }) => string;
  readonly muster_title: string;
  readonly no_captain: string;
  readonly none: string;
  readonly note_base_design: string;
  readonly note_commit_hint: string;
  readonly note_contact: string;
  readonly note_module: (p: { name: string | number; pct: string | number }) => string;
  readonly note_needs_banks: string;
  readonly note_no_rounds: string;
  readonly note_print: (p: { name: string | number; modules: string | number }) => string;
  readonly note_window_shut: string;
  readonly nothing_there: string;
  readonly npc_act_gather: string;
  readonly npc_act_hold: string;
  readonly npc_act_idle: string;
  readonly npc_act_launch: string;
  readonly npc_act_move: string;
  readonly npc_act_pulse: string;
  readonly npc_act_scatter: string;
  readonly npc_act_strike: string;
  readonly npc_act_tell: string;
  readonly npc_monster: string;
  readonly npc_monster_note: string;
  readonly npc_pirate: string;
  readonly npc_pirate_note: string;
  readonly npc_quill_pod: string;
  readonly npc_side: string;
  readonly o_aiming: string;
  readonly o_auto_field: string;
  readonly o_beam: string;
  readonly o_build_here: string;
  readonly o_caches: string;
  readonly o_caches_title: string;
  readonly o_collect: string;
  readonly o_collect_title: string;
  readonly o_commit: string;
  readonly o_decoy: string;
  readonly o_decoy_wait: (p: { left: string | number }) => string;
  readonly o_deep_run: string;
  readonly o_defend: string;
  readonly o_escort: string;
  readonly o_fire: string;
  readonly o_fire_base: string;
  readonly o_gather: string;
  readonly o_hold: string;
  readonly o_hold_fast: string;
  readonly o_hold_fast_title: string;
  readonly o_hold_fire: string;
  readonly o_hunt: string;
  readonly o_lane: string;
  readonly o_lay: string;
  readonly o_lay_empty_title: string;
  readonly o_lay_kind: (p: { kind: string | number }) => string;
  readonly o_lay_title: (p: { kind: string | number }) => string;
  readonly o_lay_wait: (p: { left: string | number }) => string;
  readonly o_move: string;
  readonly o_patrol: string;
  readonly o_pick_cell: string;
  readonly o_pick_field: string;
  readonly o_pick_lane: string;
  readonly o_pick_point: string;
  readonly o_pick_target: string;
  readonly o_plot: string;
  readonly o_rename: string;
  readonly o_return: string;
  readonly o_scan: string;
  readonly o_scan_wait: (p: { left: string | number }) => string;
  readonly o_search: string;
  readonly o_send_hauler: string;
  readonly o_share: string;
  readonly o_share_left: (p: { left: string | number }) => string;
  readonly o_surface: string;
  readonly object_default: string;
  readonly order_steer_figs: (p: { order: string | number; deg: string | number; step: string | number }) => string;
  readonly pd_from: (p: { level: string | number }) => string;
  readonly pd_wait: (p: { sec: string | number }) => string;
  readonly plan_combat: string;
  readonly plan_combat_historical: string;
  readonly plan_harbour: (p: { building: string | number; level: string | number }) => string;
  readonly plan_head: string;
  readonly plan_head_historical: string;
  readonly plan_hull: (p: { name: string | number; weight: string | number }) => string;
  readonly plan_limits: (p: { px: string | number }) => string;
  readonly plan_limits_historical: (p: { px: string | number }) => string;
  readonly plan_of_historical: (p: { used: string | number; cap: string | number }) => string;
  readonly plan_support: string;
  readonly plan_support_historical: string;
  readonly pledge_stands: string;
  readonly plot_back_leg: (p: { n: string | number }) => string;
  readonly plot_back_mark: string;
  readonly plot_box_off: string;
  readonly plot_box_on: string;
  readonly plot_done: string;
  readonly plot_end_title: string;
  readonly plot_endless: string;
  readonly plot_endless_title: string;
  readonly plot_full: string;
  readonly plot_grip: string;
  readonly plot_join_px: (p: { px: string | number }) => string;
  readonly plot_leg: (p: { n: string | number }) => string;
  readonly plot_leg_drop: string;
  readonly plot_leg_px: (p: { px: string | number }) => string;
  readonly plot_legs: (p: { n: number }) => string;
  readonly plot_legs_head: string;
  readonly plot_loop: string;
  readonly plot_mark: string;
  readonly plot_name_default: string;
  readonly plot_name_hint: (p: { min: string | number; max: string | number }) => string;
  readonly plot_pass_title: string;
  readonly plot_passes: (p: { n: string | number }) => string;
  readonly plot_rename_head: (p: { name: string | number }) => string;
  readonly plot_reorder: string;
  readonly plot_save: string;
  readonly plot_save_head: string;
  readonly plot_sub: (p: { name: string | number; px: string | number }) => string;
  readonly plot_tap: string;
  readonly plot_undo: string;
  readonly poi_cache: string;
  readonly poi_cache_dug: string;
  readonly poi_cache_kind: string;
  readonly poi_cache_note: string;
  readonly poi_cache_waits: string;
  readonly poi_found: string;
  readonly poi_gate: string;
  readonly poi_gate_kind: string;
  readonly poi_gate_note: string;
  readonly poi_lair: string;
  readonly poi_lair_kind: string;
  readonly poi_lair_note: string;
  readonly poi_monster_back: (p: { left: string | number }) => string;
  readonly poi_monster_gone: string;
  readonly poi_monster_home: string;
  readonly poi_monster_out: string;
  readonly poi_ruin: string;
  readonly poi_ruin_kind: string;
  readonly poi_ruin_note: string;
  readonly poi_vent: string;
  readonly poi_vent_dry: (p: { left: string | number }) => string;
  readonly poi_vent_kind: string;
  readonly poi_vent_note: string;
  readonly poi_vent_stock: (p: { n: string | number; full: string | number }) => string;
  readonly quiet_mending: string;
  readonly raise_title: string;
  readonly ready: string;
  readonly rename_title: string;
  readonly report_clear: string;
  readonly report_hull: string;
  readonly report_kind: (p: { from: string | number; time: string | number }) => string;
  readonly report_show: string;
  readonly report_title: string;
  readonly round_pick: (p: { name: string | number; held: string | number }) => string;
  readonly round_pick_title: string;
  readonly route_below: (p: { left: string | number }) => string;
  readonly route_below_now: string;
  readonly route_deepest: (p: { band: string | number }) => string;
  readonly route_head: string;
  readonly route_rated: (p: { band: string | number }) => string;
  readonly route_within: string;
  readonly seamount_bad_length: (p: { min: string | number; max: string | number }) => string;
  readonly seamount_first: string;
  readonly seamount_hint_text: (p: { min: string | number; max: string | number }) => string;
  readonly seamount_hint_words: string;
  readonly seamount_kind: string;
  readonly seamount_later_btn: string;
  readonly seamount_name_btn: string;
  readonly seamount_named_by: (p: { commander: string | number }) => string;
  readonly seamount_preview: (p: { name: string | number }) => string;
  readonly seamount_second: string;
  readonly seamount_text: string;
  readonly seamount_title: string;
  readonly seamount_unnamed_find: string;
  readonly search_btn: string;
  readonly search_btn_title: (p: { name: string | number }) => string;
  readonly search_fit_away: (p: { px: string | number }) => string;
  readonly search_fit_head: string;
  readonly search_here: string;
  readonly search_here_title: string;
  readonly search_no_fleet: string;
  readonly search_pick: string;
  readonly search_pick_title: string;
  readonly search_sheet_hint: string;
  readonly search_sheet_title: string;
  readonly search_unfit_cable: string;
  readonly search_wreck_pick_title: string;
  readonly search_wreck_sheet_title: string;
  readonly search_wreck_title: string;
  readonly sect_opens: string;
  readonly sect_path: string;
  readonly selchip_title: string;
  readonly shaft: string;
  readonly shafted: string;
  readonly show_fleet: (p: { name: string | number }) => string;
  readonly sig_active: (p: { left: string | number }) => string;
  readonly sig_active_open: string;
  readonly sig_brace: string;
  readonly sig_broadside: string;
  readonly sig_canister: string;
  readonly sig_charge_ready: string;
  readonly sig_charge_spent: string;
  readonly sig_crash_dive: string;
  readonly sig_dig_in: string;
  readonly sig_getaway: string;
  readonly sig_line: (p: { name: string | number; order: string | number }) => string;
  readonly sig_line_getaway: (p: { name: string | number; order: string | number }) => string;
  readonly sig_line_hostile: (p: { cls: string | number; order: string | number }) => string;
  readonly sig_muster: string;
  readonly sig_offline: (p: { trigger: string | number }) => string;
  readonly sig_outflank: string;
  readonly sig_ready: (p: { order: string | number }) => string;
  readonly sig_recharge: (p: { dur: string | number }) => string;
  readonly sig_recharge_wait: string;
  readonly sig_spent: (p: { order: string | number }) => string;
  readonly slowed: string;
  readonly so_anchored: string;
  readonly so_anchoring: string;
  readonly so_armed: string;
  readonly so_arming: string;
  readonly so_deployable: string;
  readonly so_heard_kind: string;
  readonly so_heard_note: string;
  readonly so_heard_title: string;
  readonly so_inert: string;
  readonly so_kind_hostile: (p: { family: string | number }) => string;
  readonly so_kind_mate: (p: { family: string | number }) => string;
  readonly so_kind_own: (p: { family: string | number }) => string;
  readonly so_list_back: (p: { n: string | number }) => string;
  readonly so_list_hull: string;
  readonly so_list_kind: string;
  readonly so_list_more: (p: { n: string | number }) => string;
  readonly so_list_title: (p: { n: number }) => string;
  readonly so_mine: string;
  readonly so_note_hostile_deployable: string;
  readonly so_note_mine: string;
  readonly so_note_mine_hostile: string;
  readonly so_note_own_deployable: string;
  readonly sonar_heard: string;
  readonly speed: (p: { speed: string | number; noise: string | number }) => string;
  readonly squad_member: string;
  readonly st_at_sea: string;
  readonly st_base_design: string;
  readonly st_cadet: string;
  readonly st_done: string;
  readonly st_heard: string;
  readonly st_locked: string;
  readonly st_max: string;
  readonly st_open: string;
  readonly st_print: (p: { name: string | number }) => string;
  readonly st_prisoner: string;
  readonly st_queued: string;
  readonly st_ready: string;
  readonly st_recovering: string;
  readonly st_scanned: string;
  readonly st_scanned_age: (p: { age: string | number }) => string;
  readonly st_short: string;
  readonly st_window: (p: { hour: string | number }) => string;
  readonly step_next: string;
  readonly step_next_title: string;
  readonly step_of: (p: { n: string | number; m: string | number }) => string;
  readonly step_prev: string;
  readonly step_prev_title: string;
  readonly story_less: string;
  readonly story_more: string;
  readonly stow_empty: string;
  readonly stow_head: (p: { used: string | number; cap: string | number }) => string;
  readonly stow_last: string;
  readonly stow_lay: string;
  readonly stow_row: (p: { name: string | number; n: string | number }) => string;
  readonly stow_row_sub_deployable: (p: { cargo: string | number }) => string;
  readonly stow_row_sub_mine: (p: { cargo: string | number }) => string;
  readonly taken_hull: string;
  readonly taken_hull_note: string;
  readonly talent_title: string;
  readonly telegraph_full: string;
  readonly telegraph_half: string;
  readonly telegraph_slow: string;
  readonly telegraph_stop: string;
  readonly trig_below_half: (p: { pct: string | number }) => string;
  readonly trig_formation_travel: string;
  readonly trig_hit_first: string;
  readonly trig_opening_shot: string;
  readonly unclaimed: string;
  readonly unknown: string;
  readonly v_cargo: string;
  readonly v_gauge: string;
  readonly v_hull: string;
  readonly v_magazine: string;
  readonly v_pledges: string;
  readonly v_point_def: string;
  readonly v_ready: string;
  readonly v_refit: string;
  readonly v_reserve: string;
  readonly v_rounds: string;
  readonly v_scan: string;
  readonly v_shield: string;
  readonly v_stow: string;
  readonly v_tubes: string;
  readonly v_window: string;
  readonly wait_min: (p: { n: string | number }) => string;
  readonly wait_sec: (p: { n: string | number }) => string;
  readonly window_in: (p: { left: string | number }) => string;
  readonly window_open: string;
  readonly work_left: (p: { left: string | number }) => string;
  readonly work_sailing: string;
  readonly worked_out: string;
  readonly wreck_ago: (p: { ago: string | number }) => string;
  readonly wreck_cargo: string;
  readonly wreck_note: string;
  readonly wreck_pirate_note: string;
  readonly wreck_recovered: string;
  readonly wreck_seen: (p: { ago: string | number }) => string;
  readonly wreck_title: string;
}

export const card: Card = tables?.card ?? source.card;

/** ui.chart — every sentence the chart furniture writes on the map and in its DOM pieces (ui-map-interface.md §17, R548). */
export interface Chart {
  readonly aim_historical: (p: { px: string | number }) => string;
  readonly aim_modern: (p: { px: string | number }) => string;
  readonly band_words: readonly string[];
  readonly band_words_historical: readonly string[];
  readonly bank_part: (p: { count: string | number; short: string | number }) => string;
  readonly bank_sub_modern: (p: { fields: string | number; yield: string | number }) => string;
  readonly bearing_eta_hours_historical: (p: { n: string | number }) => string;
  readonly bearing_eta_minutes_historical: (p: { n: string | number }) => string;
  readonly bearing_historical: (p: { point: string | number; hour: string | number; eta: string | number }) => string;
  readonly bearing_historical_brief: (p: { point: string | number }) => string;
  readonly bearing_historical_short: (p: { point: string | number; eta: string | number }) => string;
  readonly bearing_modern: (p: { brg: string | number; eta: string | number }) => string;
  readonly bearing_modern_brief: (p: { brg: string | number }) => string;
  readonly bearing_modern_short: (p: { brg: string | number; eta: string | number }) => string;
  readonly burgee_historical: (p: { clan: string | number; faction: string | number }) => string;
  readonly burgee_modern: (p: { tag: string | number; clan: string | number; squad: string | number }) => string;
  readonly cable_historical: string;
  readonly cable_modern: (p: { rung: string | number }) => string;
  readonly cartouche_min_title: string;
  readonly cartouche_scale: (p: { cells: string | number; px: string | number }) => string;
  readonly cartouche_season_historical: (p: { season: string | number; day: string | number }) => string;
  readonly cartouche_season_modern: (p: { season: string | number; day: string | number }) => string;
  readonly cartouche_season_stage_historical: (p: { season: string | number; day: string | number; stage: string | number }) => string;
  readonly cartouche_season_stage_modern: (p: { season: string | number; day: string | number; stage: string | number }) => string;
  readonly cartouche_season_truce_historical: (p: { season: string | number; day: string | number; left: string | number }) => string;
  readonly cartouche_season_truce_modern: (p: { season: string | number; day: string | number; left: string | number }) => string;
  readonly cartouche_title_historical: (p: { world: string | number }) => string;
  readonly cartouche_title_modern: (p: { world: string | number; region: string | number }) => string;
  readonly compass_home: (p: { brg: string | number }) => string;
  readonly compass_north: string;
  readonly compass_points: readonly string[];
  readonly designation: (p: { n: string | number; cls: string | number }) => string;
  readonly designation_historical: (p: { nth: string | number }) => string;
  readonly designation_historical_cls: (p: { nth: string | number; cls: string | number }) => string;
  readonly designation_historical_n: (p: { n: string | number }) => string;
  readonly designation_unknown: (p: { n: string | number }) => string;
  readonly faction_key_title: string;
  readonly faction_key_you: (p: { name: string | number }) => string;
  readonly fairway_narrows: string;
  readonly gut_historical: string;
  readonly harbour_limits_historical: string;
  readonly harbour_limits_modern: string;
  readonly hemi_e: string;
  readonly hemi_n: string;
  readonly hemi_s: string;
  readonly hemi_w: string;
  readonly heraldry_historical: (p: { faction: string | number }) => string;
  readonly heraldry_modern: (p: { name: string | number; index: string | number }) => string;
  readonly heraldry_sub_modern: string;
  readonly hold_fire_legend: string;
  readonly hold_site_historical: (p: { name: string | number }) => string;
  readonly hold_site_modern: (p: { name: string | number }) => string;
  readonly imprint_historical_1: (p: { name: string | number; edition: string | number }) => string;
  readonly imprint_historical_2: (p: { notices: string | number; build: string | number }) => string;
  readonly imprint_modern_1: (p: { world: string | number; edition: string | number; notices: string | number; protocol: string | number }) => string;
  readonly imprint_modern_2: (p: { hash: string | number; build: string | number }) => string;
  readonly lane_corsairs: string;
  readonly lane_course: (p: { deg: string | number }) => string;
  readonly lane_gap_historical: string;
  readonly lane_gap_tag: string;
  readonly lane_lights_line: (p: { deg: string | number }) => string;
  readonly lane_quiet_historical: string;
  readonly legend_bank: string;
  readonly legend_battle_mark: string;
  readonly legend_card_title: string;
  readonly legend_card_title_historical: string;
  readonly legend_commodity: string;
  readonly legend_contested: string;
  readonly legend_current: string;
  readonly legend_current_historical: string;
  readonly legend_current_row: (p: { n: string | number }) => string;
  readonly legend_current_row_historical: (p: { n: string | number }) => string;
  readonly legend_danger_line: string;
  readonly legend_depth: string;
  readonly legend_depth_historical: string;
  readonly legend_drying_rock: string;
  readonly legend_factions_historical: string;
  readonly legend_harbour_limits: string;
  readonly legend_heat: (p: { mode: string | number }) => string;
  readonly legend_light: string;
  readonly legend_limit_line: string;
  readonly legend_min_title: string;
  readonly legend_npc_monsters: string;
  readonly legend_npc_pirates: string;
  readonly legend_open_title: string;
  readonly legend_rock_awash: string;
  readonly legend_spoil_ground: string;
  readonly legend_tidal_diamond: string;
  readonly legend_tide: (p: { f: string | number; step: string | number; steps: string | number }) => string;
  readonly legend_tide_historical: (p: { f: string | number; step: string | number; steps: string | number }) => string;
  readonly legend_tide_next: (p: { at: string | number }) => string;
  readonly legend_tide_next_historical: (p: { at: string | number }) => string;
  readonly legend_tide_steady: string;
  readonly legend_tide_steady_historical: string;
  readonly legend_tide_turns: (p: { at: string | number }) => string;
  readonly legend_tide_turns_historical: (p: { at: string | number }) => string;
  readonly legend_title_historical: string;
  readonly legend_title_modern: string;
  readonly legend_torpedo_run: string;
  readonly letters: string;
  readonly light_historical: (p: { every: string | number; range: string | number }) => string;
  readonly light_hull_historical: (p: { cls: string | number; range: string | number }) => string;
  readonly light_modern: (p: { every: string | number; range: string | number }) => string;
  readonly light_share_historical: (p: { every: string | number; range: string | number }) => string;
  readonly light_share_modern: (p: { every: string | number; range: string | number }) => string;
  readonly limit_historical: string;
  readonly limit_modern: (p: { rings: string | number }) => string;
  readonly mark_historical: (p: { day: string | number }) => string;
  readonly mark_modern: (p: { day: string | number; at: string | number }) => string;
  readonly monster_bio: string;
  readonly monster_last: (p: { time: string | number }) => string;
  readonly monster_last_historical: string;
  readonly monsters_historical: string;
  readonly monsters_modern: string;
  readonly monument_champion_historical: (p: { season: string | number }) => string;
  readonly monument_champion_modern: (p: { season: string | number }) => string;
  readonly monument_champion_world_historical: (p: { world: string | number; season: string | number }) => string;
  readonly monument_champion_world_modern: (p: { world: string | number; season: string | number }) => string;
  readonly named_trench_dedication_historical: (p: { war: string | number; clan: string | number }) => string;
  readonly named_trench_dedication_modern: (p: { war: string | number; clan: string | number }) => string;
  readonly nature_ridge: string;
  readonly nature_trench: string;
  readonly picket_line: (p: { r: string | number }) => string;
  readonly picket_line_historical: string;
  readonly poi_abbr_cache: string;
  readonly poi_abbr_dry: (p: { left: string | number }) => string;
  readonly poi_abbr_dug: string;
  readonly poi_abbr_ebb: (p: { mul: string | number }) => string;
  readonly poi_abbr_empty: string;
  readonly poi_abbr_empty_left: (p: { left: string | number }) => string;
  readonly poi_abbr_flood: (p: { mul: string | number }) => string;
  readonly poi_abbr_gate: string;
  readonly poi_abbr_lair: string;
  readonly poi_abbr_left: (p: { n: string | number }) => string;
  readonly poi_abbr_ruin: string;
  readonly poi_abbr_search: string;
  readonly poi_abbr_slack: string;
  readonly poi_abbr_taken: string;
  readonly poi_abbr_vent: string;
  readonly poi_dot_cache: string;
  readonly poi_dot_dug: string;
  readonly poi_dot_ebb: (p: { mul: string | number }) => string;
  readonly poi_dot_empty: string;
  readonly poi_dot_flood: (p: { mul: string | number }) => string;
  readonly poi_dot_gate: string;
  readonly poi_dot_lair: string;
  readonly poi_dot_ruin: string;
  readonly poi_dot_ruin_cores: (p: { n: string | number }) => string;
  readonly poi_dot_slack: (p: { mul: string | number }) => string;
  readonly poi_dot_vent: string;
  readonly poi_dot_vent_left: (p: { left: string | number }) => string;
  readonly poi_dot_vent_stock: (p: { n: string | number }) => string;
  readonly pool_monument_historical: (p: { name: string | number; world: string | number }) => string;
  readonly pool_monument_modern: (p: { name: string | number; world: string | number }) => string;
  readonly pos: (p: { lat: string | number; lon: string | number }) => string;
  readonly pos_lat: (p: { d: string | number; m: string | number; h: string | number }) => string;
  readonly pos_lon: (p: { d: string | number; m: string | number; h: string | number }) => string;
  readonly profile_foot: string;
  readonly profile_kind: (p: { cells: string | number }) => string;
  readonly profile_step: (p: { k: string | number }) => string;
  readonly quake_historical: (p: { day: string | number; hour: string | number }) => string;
  readonly quake_modern: (p: { stage: string | number; px: string | number; pct: string | number; next: string | number }) => string;
  readonly quake_ring_historical: (p: { pct: string | number }) => string;
  readonly quake_ring_modern: (p: { px: string | number }) => string;
  readonly reef_coral: string;
  readonly reef_title_historical: (p: { name: string | number }) => string;
  readonly reef_title_modern: (p: { name: string | number }) => string;
  readonly reload_label_ready: (p: { n: string | number; round: string | number }) => string;
  readonly reload_label_reloading: (p: { n: string | number; round: string | number; sec: string | number }) => string;
  readonly reload_tag_empty: string;
  readonly reload_tag_ready: string;
  readonly reload_tag_reloading: (p: { sec: string | number }) => string;
  readonly restricted_historical: (p: { hour: string | number }) => string;
  readonly restricted_modern: (p: { at: string | number }) => string;
  readonly restricted_open_modern: (p: { at: string | number }) => string;
  readonly restricted_shut_historical: (p: { hour: string | number }) => string;
  readonly restricted_shut_modern: (p: { at: string | number }) => string;
  readonly restricted_word_historical: string;
  readonly rings_historical: (p: { k: string | number }) => string;
  readonly rings_historical_one: string;
  readonly rings_modern: (p: { k: string | number }) => string;
  readonly rings_modern_one: (p: { px: string | number }) => string;
  readonly rock_historical: string;
  readonly rock_modern: string;
  readonly run_historical: string;
  readonly run_hold_historical: string;
  readonly run_hold_modern: (p: { kind: string | number; px: string | number }) => string;
  readonly run_modern: (p: { kind: string | number; px: string | number }) => string;
  readonly sail_ordinals: readonly string[];
  readonly seamount_dedication_historical: (p: { commander: string | number }) => string;
  readonly seamount_dedication_modern: (p: { commander: string | number }) => string;
  readonly speed_historical: (p: { px: string | number }) => string;
  readonly speed_modern: (p: { px: string | number }) => string;
  readonly spoil_historical: string;
  readonly spoil_modern: string;
  readonly spoil_respawn: (p: { short: string | number; in: string | number }) => string;
  readonly spoil_silts: string;
  readonly sweep_reveal: (p: { left: string | number; painted: string | number }) => string;
  readonly tidal_contested: (p: { own: string | number }) => string;
  readonly tidal_contested_historical: (p: { own: string | number }) => string;
  readonly tidal_establishment: (p: { hour: string | number }) => string;
  readonly tidal_open: (p: { at: string | number }) => string;
  readonly tidal_open_historical: (p: { hour: string | number }) => string;
  readonly tidal_opens: (p: { in: string | number }) => string;
  readonly tidal_opens_historical: (p: { in: string | number }) => string;
  readonly tidal_quiet: (p: { own: string | number }) => string;
  readonly tidal_quiet_historical: (p: { own: string | number }) => string;
  readonly tidal_span_historical: (p: { m: string | number }) => string;
  readonly warning_lines_modern: readonly string[];
  readonly warning_sub_historical: string;
  readonly warning_title_historical: string;
  readonly warning_title_modern: string;
  readonly watch_designation: (p: { n: string | number }) => string;
  readonly watch_head: (p: { min: string | number }) => string;
  readonly watch_head_historical: string;
  readonly watch_quiet: string;
  readonly watch_quiet_historical: string;
  readonly works_historical: (p: { job: string | number }) => string;
  readonly works_modern: (p: { job: string | number; min: string | number }) => string;
  readonly works_next: (p: { job: string | number }) => string;
}

export const chart: Chart = tables?.chart ?? source.chart;

/** ui.chatfilter — the word list of the chat filter (ui-map-interface.md §8 "The chat filter", R2937): strong profanity and slurs, matched as whole words. */
export interface Chatfilter {
  readonly words: string;
}

export const chatfilter: Chatfilter = tables?.chatfilter ?? source.chatfilter;

/** ui.choice — the choice controls of every surface (ui-map-interface.md §18, R2011): the pill group, the tab strip, the option list, the select box, the preview tiles, the stepper, the tag and the button. */
export interface Choice {
  readonly close_title: string;
  readonly locked_title: string;
  readonly now: string;
}

export const choice: Choice = tables?.choice ?? source.choice;

/** ui.hub.chronicle — the season chronicle book: the day pages, the season page and the lines the client writes from the facts. */
export interface Chronicle {
  readonly book_title: string;
  readonly close_down: readonly string[];
  readonly close_level: readonly string[];
  readonly close_up: readonly string[];
  readonly closed_tag: string;
  readonly copy_by_hand: string;
  readonly copy_link: string;
  readonly day_header: (p: { day: string | number; season: string | number; world: string | number }) => string;
  readonly kind_building_done: readonly string[];
  readonly kind_cache_taken: readonly string[];
  readonly kind_captain_captured: readonly string[];
  readonly kind_captain_ransomed: readonly string[];
  readonly kind_captain_recruited: readonly string[];
  readonly kind_captain_taken: readonly string[];
  readonly kind_cells_taken: readonly string[];
  readonly kind_expedition_core: readonly string[];
  readonly kind_expedition_hurt: readonly string[];
  readonly kind_expedition_hurt_core: readonly string[];
  readonly kind_expedition_ok: readonly string[];
  readonly kind_first_siege: readonly string[];
  readonly kind_fleet_killed: readonly string[];
  readonly kind_fleet_lost: readonly string[];
  readonly kind_fleet_lost_captain: readonly string[];
  readonly kind_hold_under_fire: readonly string[];
  readonly kind_milestone_first_kill: readonly string[];
  readonly kind_milestone_first_loss: readonly string[];
  readonly kind_milestone_first_ship: readonly string[];
  readonly kind_milestone_first_siege: readonly string[];
  readonly kind_milestone_first_tech: readonly string[];
  readonly kind_object_fell: readonly string[];
  readonly kind_quake_stage: readonly string[];
  readonly kind_research_done: readonly string[];
  readonly kind_season_captains: readonly string[];
  readonly kind_season_honour: readonly string[];
  readonly kind_season_most_lost: readonly string[];
  readonly kind_season_most_mined: readonly string[];
  readonly kind_season_most_spent: readonly string[];
  readonly kind_season_rank: readonly string[];
  readonly kind_season_score: readonly string[];
  readonly kind_season_tech: readonly string[];
  readonly kind_season_title: readonly string[];
  readonly kind_siege_broken: readonly string[];
  readonly kind_siege_fell: readonly string[];
  readonly kind_siege_held: readonly string[];
  readonly kind_siege_mauled: readonly string[];
  readonly kind_siege_opened_attack: readonly string[];
  readonly kind_siege_opened_defend: readonly string[];
  readonly kind_siege_repulsed: readonly string[];
  readonly kind_siege_took: readonly string[];
  readonly kind_territory_lost: readonly string[];
  readonly kind_torpedo_hit: readonly string[];
  readonly kind_torpedo_struck: readonly string[];
  readonly kind_truce_ended: readonly string[];
  readonly label_captains: string;
  readonly label_ledger: string;
  readonly label_milestones: string;
  readonly label_tech: string;
  readonly link_copied: string;
  readonly live_tag: string;
  readonly moment_day: (p: { day: string | number }) => string;
  readonly moment_mark: string;
  readonly moments: string;
  readonly neutral_foe: string;
  readonly no_page: string;
  readonly no_volume: string;
  readonly no_volume_why: string;
  readonly not_shared: string;
  readonly not_shared_why: string;
  readonly open_book: string;
  readonly quiet: readonly string[];
  readonly reader_anon: (p: { world: string | number }) => string;
  readonly reader_home: string;
  readonly reader_title: (p: { commander: string | number; world: string | number }) => string;
  readonly reader_what: string;
  readonly replay: string;
  readonly replay_link_gone: string;
  readonly season_header: (p: { season: string | number; world: string | number }) => string;
  readonly share_live: string;
  readonly share_off: string;
  readonly share_on: string;
  readonly share_what: string;
  readonly times_suffix: (p: { times: string | number }) => string;
  readonly voice_command: readonly string[];
  readonly voice_engineering: readonly string[];
  readonly voice_gunnery: readonly string[];
  readonly voice_helmsmanship: readonly string[];
  readonly voice_prospecting: readonly string[];
  readonly voice_quiet_hand: readonly string[];
  readonly voice_remark: (p: { captain: string | number; remark: string | number }) => string;
  readonly volume_label: (p: { season: string | number; world: string | number }) => string;
  readonly volume_newer: string;
  readonly volume_older: string;
  readonly volume_place: (p: { at: string | number; of: string | number }) => string;
}

export const chronicle: Chronicle = tables?.chronicle ?? source.chronicle;

/** ui.clan_look — the clan identity pack: the CHAT INK fold of SETTINGS · ACCOUNT, the BANNER section of the CLAN panel, and the names of the chat inks and the banner styles (monetization.md §3.3, R3290). */
export interface ClanLook {
  readonly banner_lede: string;
  readonly banner_plain: string;
  readonly banner_rule: string;
  readonly banner_saving: string;
  readonly banner_style_name_dashed_rule: string;
  readonly banner_style_name_double_rule: string;
  readonly banner_style_name_hatched: string;
  readonly banner_style_name_pennant: string;
  readonly banner_style_name_side_bars: string;
  readonly chat_ink_name_coral: string;
  readonly chat_ink_name_pearl: string;
  readonly chat_ink_name_rose: string;
  readonly chat_ink_name_sand: string;
  readonly chat_ink_name_sky: string;
  readonly ink_lede: string;
  readonly ink_none: string;
  readonly ink_rule: string;
  readonly ink_saving: string;
  readonly ink_section: string;
  readonly sec_banner: string;
}

export const clanLook: ClanLook = tables?.clanLook ?? source.clanLook;

/** ui.connection — the game socket: the two refusals that stop it for good and are shown as a full-screen stop. */
export interface Connection {
  readonly protocol_refused: (p: { proto: string | number }) => string;
  readonly ticket_refused: string;
}

export const connection: Connection = tables?.connection ?? source.connection;

/** designer/app.ts — the map designer's map chips and the toast it answers an action with. */
export interface DesignerApp {
  readonly chip_size: (p: { cols: string | number; rows: string | number; cells: string | number }) => string;
  readonly live_core_figure: string;
  readonly notice_downloaded: (p: { file: string | number }) => string;
  readonly notice_downloaded_errors: (p: { count: number; file: string | number }) => string;
  readonly notice_draft_restored: string;
  readonly notice_dropped: (p: { count: number }) => string;
  readonly notice_laid_rock: string;
  readonly notice_loaded_clean: (p: { file: string | number }) => string;
  readonly notice_loaded_errors: (p: { count: number; file: string | number }) => string;
  readonly notice_marker_ceiling: (p: { max_markers: string | number }) => string;
  readonly notice_new_map: string;
  readonly notice_no_seat: (p: { slot: string | number }) => string;
  readonly notice_no_variant: string;
  readonly notice_not_a_map: (p: { file: string | number; error: string | number }) => string;
  readonly notice_open_path_differs: (p: { opened: string | number; category: string | number; file: string | number }) => string;
  readonly notice_preset_dropped: (p: { count: number; preset: string | number }) => string;
  readonly notice_seat_ceiling: (p: { max_players: string | number }) => string;
  readonly notice_sym_dropped: string;
  readonly notice_sym_pick_120: string;
  readonly notice_sym_pick_180: string;
  readonly notice_sym_rocked: (p: { count: number }) => string;
  readonly notice_sym_set: (p: { cell: string | number; at: string | number }) => string;
  readonly notice_undo_back: string;
  readonly notice_unpaired: string;
  readonly notice_wrote: (p: { path: string | number }) => string;
  readonly notice_wrote_errors: (p: { path: string | number; count: string | number }) => string;
}

export const designerApp: DesignerApp = tables?.designerApp ?? source.designerApp;

/** designer/community.ts — the community publish of the map designer: the press of the lab bar, the path chip, the gate and the publish sheet (community-maps.md §9.1, R1975). */
export interface DesignerCommunity {
  readonly arm_body: (p: { likes: string | number; name: string | number; plays: number; revision: string | number }) => string;
  readonly arm_head: (p: { name: string | number }) => string;
  readonly btn_publish: string;
  readonly btn_sign_in: string;
  readonly btn_sign_in_short: string;
  readonly check_cap: string;
  readonly check_clean: (p: { kb: string | number }) => string;
  readonly check_errors: (p: { count: number }) => string;
  readonly check_ok: (p: { count: number; kb: string | number }) => string;
  readonly check_open: string;
  readonly chip_featured: string;
  readonly chip_in_play: (p: { revision: string | number }) => string;
  readonly chip_taken_down: string;
  readonly chip_waits: (p: { revision: string | number }) => string;
  readonly done: (p: { revision: string | number; hash: string | number }) => string;
  readonly done_same: (p: { revision: string | number; hash: string | number }) => string;
  readonly eff_full: string;
  readonly eff_new: string;
  readonly eff_pick: string;
  readonly eff_pin: (p: { revision: string | number }) => string;
  readonly eff_revision: (p: { revision: string | number }) => string;
  readonly eff_same: (p: { revision: string | number }) => string;
  readonly eff_same_hint: string;
  readonly effect_head: string;
  readonly lock_body: (p: { slots: string | number }) => string;
  readonly lock_head: string;
  readonly lock_link: string;
  readonly note_cap: string;
  readonly note_hint: string;
  readonly open_failed: (p: { error: string | number }) => string;
  readonly opened: (p: { name: string | number; revision: string | number }) => string;
  readonly opened_copy: (p: { code: string | number }) => string;
  readonly place: (p: { code: string | number; revision: string | number }) => string;
  readonly place_dot: (p: { revision: string | number }) => string;
  readonly press_busy: string;
  readonly press_cancel: string;
  readonly press_pick: string;
  readonly press_publish: (p: { revision: string | number }) => string;
  readonly press_replace: (p: { name: string | number }) => string;
  readonly press_same: string;
  readonly refused: (p: { error: string | number }) => string;
  readonly rev: (p: { revision: string | number }) => string;
  readonly same_cap: string;
  readonly same_line: (p: { revision: string | number; hash: string | number }) => string;
  readonly sheet_close: string;
  readonly sheet_head: string;
  readonly sign_in_body: string;
  readonly sign_in_head: string;
  readonly sign_in_link: string;
  readonly size_cap: string;
  readonly size_line: (p: { kb: string | number; max_kb: string | number }) => string;
  readonly slot_empty: (p: { slot: string | number }) => string;
  readonly slot_empty_sub: string;
  readonly slot_open: string;
  readonly slot_open_title: string;
  readonly slot_sub: (p: { code: string | number; likes: string | number; plays: number; revision: string | number }) => string;
  readonly slot_tag: (p: { slot: string | number }) => string;
  readonly slots_failed: (p: { error: string | number }) => string;
  readonly slots_head: string;
  readonly slots_loading: string;
  readonly slots_used: (p: { used: string | number; slots: string | number }) => string;
}

export const designerCommunity: DesignerCommunity = tables?.designerCommunity ?? source.designerCommunity;

/** designer/drawer.ts — the map designer's drawer markup: the tab strip, the tool palette and the five settings tabs. */
export interface DesignerDrawer {
  readonly add_slot: string;
  readonly add_variant: string;
  readonly advanced_title: string;
  readonly base_no: string;
  readonly base_yes: string;
  readonly bases_placed: string;
  readonly bound_finding: (p: { field: string | number; value: string | number; min: string | number; max: string | number }) => string;
  readonly bounty_less: string;
  readonly bounty_more: string;
  readonly bounty_value: (p: { credits: string | number }) => string;
  readonly brief_base: string;
  readonly brief_battery: string;
  readonly brief_breakwater: string;
  readonly brief_den: string;
  readonly brief_deployable: string;
  readonly brief_erase: string;
  readonly brief_fairway: string;
  readonly brief_fbase: string;
  readonly brief_field: string;
  readonly brief_fleet: string;
  readonly brief_inspect: string;
  readonly brief_lair: string;
  readonly brief_marker: string;
  readonly brief_ridge: string;
  readonly brief_seamine: string;
  readonly brief_sov: string;
  readonly brief_spire: string;
  readonly brief_throne: string;
  readonly brief_trench: string;
  readonly brief_ward: string;
  readonly brief_water: string;
  readonly brush_cells: (p: { cells: number }) => string;
  readonly brush_note: (p: { cells: number; radius: string | number; size: string | number }) => string;
  readonly btn_download: string;
  readonly btn_load: string;
  readonly btn_load_map: string;
  readonly btn_new: string;
  readonly btn_open: string;
  readonly btn_publish: string;
  readonly btn_redo: string;
  readonly btn_sym_cancel: string;
  readonly btn_sym_pick: string;
  readonly btn_undo: string;
  readonly buyable_chip: string;
  readonly cell_ref: (p: { cell: string | number }) => string;
  readonly chip_fit: string;
  readonly chip_fit_title: string;
  readonly chip_inspect_title: string;
  readonly clean_report: (p: { cells: string | number; seats: string | number; rows: string | number }) => string;
  readonly clean_sub: string;
  readonly count_errors: string;
  readonly count_file: string;
  readonly count_warnings: string;
  readonly current_scale_less: string;
  readonly current_scale_more: string;
  readonly del_title: string;
  readonly download_broken: string;
  readonly errors_chip: (p: { count: number }) => string;
  readonly fix_title: string;
  readonly group_advanced: string;
  readonly group_auto_spawn: string;
  readonly group_brush_subject: string;
  readonly group_clocks: string;
  readonly group_dimensions: string;
  readonly group_economy: string;
  readonly group_file: string;
  readonly group_identity: string;
  readonly group_players: string;
  readonly group_rules: string;
  readonly group_sea_objects: string;
  readonly group_ship_variants: string;
  readonly group_sovereignty: string;
  readonly group_starting_torpedoes: string;
  readonly group_structures: string;
  readonly group_symmetry: string;
  readonly group_torpedoes: string;
  readonly group_win: string;
  readonly group_winline: string;
  readonly guard_default: (p: { value: string | number }) => string;
  readonly handle_title: string;
  readonly heading_less: string;
  readonly heading_more: string;
  readonly heading_value: (p: { deg: string | number }) => string;
  readonly insp_at: (p: { col: string | number; row: string | number }) => string;
  readonly insp_empty: string;
  readonly insp_errors: (p: { count: number }) => string;
  readonly insp_findings: string;
  readonly insp_fleet: string;
  readonly insp_laid: string;
  readonly insp_marker: string;
  readonly insp_note: string;
  readonly insp_object: string;
  readonly insp_pinned: string;
  readonly insp_sov: string;
  readonly insp_terrain: string;
  readonly insp_title: (p: { cell: string | number }) => string;
  readonly insp_warnings: (p: { count: number }) => string;
  readonly key_base: string;
  readonly key_capture: string;
  readonly key_den: string;
  readonly key_deployable: string;
  readonly key_fairway: string;
  readonly key_fbase: string;
  readonly key_field: string;
  readonly key_finding: string;
  readonly key_fleet: string;
  readonly key_lair: string;
  readonly key_marker: string;
  readonly key_objective: string;
  readonly key_ridge: string;
  readonly key_seamine: string;
  readonly key_sov: string;
  readonly key_sov_rock: string;
  readonly key_structure: string;
  readonly key_symmetry: string;
  readonly key_title: string;
  readonly key_trench: string;
  readonly key_unpaired: string;
  readonly key_water: string;
  readonly line_seats: (p: { count: number }) => string;
  readonly live_capture_default: (p: { seconds: string | number }) => string;
  readonly marker_arrow: string;
  readonly marker_circle: string;
  readonly marker_headings: readonly string[];
  readonly mend_base_slot: (p: { erase: string | number }) => string;
  readonly mend_cell_unique: (p: { erase: string | number }) => string;
  readonly mend_den_apron: (p: { erase: string | number }) => string;
  readonly mend_den_brotherhood: string;
  readonly mend_den_design: string;
  readonly mend_den_wave: string;
  readonly mend_fairway_cell_unique: (p: { erase: string | number }) => string;
  readonly mend_fairway_chain: (p: { erase: string | number }) => string;
  readonly mend_fairway_on_ridge: (p: { erase: string | number; water: string | number }) => string;
  readonly mend_field_units: string;
  readonly mend_fleet_class_cap: (p: { erase: string | number }) => string;
  readonly mend_fleet_on_ridge: (p: { erase: string | number; water: string | number }) => string;
  readonly mend_fleet_slot: (p: { erase: string | number }) => string;
  readonly mend_fleet_variant: (p: { erase: string | number }) => string;
  readonly mend_guard_reach: string;
  readonly mend_guard_reload: string;
  readonly mend_lair_bounty: string;
  readonly mend_lair_design: string;
  readonly mend_lair_kind: string;
  readonly mend_lair_respawn: string;
  readonly mend_lair_trench: (p: { erase: string | number }) => string;
  readonly mend_load: string;
  readonly mend_load_title: string;
  readonly mend_npc_field: (p: { erase: string | number }) => string;
  readonly mend_object_on_ridge: (p: { erase: string | number; water: string | number }) => string;
  readonly mend_objective_unused: string;
  readonly mend_sapper: string;
  readonly mend_sapper_title: string;
  readonly mend_sell: string;
  readonly mend_sell_title: string;
  readonly mend_sov_on_ridge: (p: { sov: string | number; water: string | number }) => string;
  readonly mend_stow: string;
  readonly mend_stow_title: string;
  readonly mend_structure_flag: (p: { erase: string | number }) => string;
  readonly mend_structure_objective: string;
  readonly mend_structure_team: string;
  readonly mend_symmetry_content: (p: { erase: string | number }) => string;
  readonly mend_symmetry_terrain: string;
  readonly mend_win_cell: (p: { water: string | number }) => string;
  readonly menu_edit: string;
  readonly menu_file: string;
  readonly menu_repo: string;
  readonly name_placeholder: string;
  readonly no_cell: string;
  readonly no_seat_yet: string;
  readonly no_variant_yet: string;
  readonly not_buyable_chip: string;
  readonly note_advanced_head: string;
  readonly note_auto: string;
  readonly note_auto_head: string;
  readonly note_base: string;
  readonly note_breakwater: string;
  readonly note_capture: (p: { count: string | number; objectives: string | number }) => string;
  readonly note_check: string;
  readonly note_clocks_head: string;
  readonly note_combat_pace: string;
  readonly note_den: string;
  readonly note_deployable: string;
  readonly note_dimensions: string;
  readonly note_economy: string;
  readonly note_economy_head: string;
  readonly note_erase: string;
  readonly note_fairway: (p: { min_cells: string | number; max_chains: string | number }) => string;
  readonly note_fbase: string;
  readonly note_field: string;
  readonly note_file_head: string;
  readonly note_fleet: string;
  readonly note_grid: string;
  readonly note_hold_auto_capture: string;
  readonly note_identity: string;
  readonly note_inspect: string;
  readonly note_lair: string;
  readonly note_marker: (p: { max_markers: string | number }) => string;
  readonly note_not_buyable: string;
  readonly note_players: (p: { max_players: string | number; max_per_team: string | number; max_teams: string | number }) => string;
  readonly note_players_head: (p: { max_players: string | number }) => string;
  readonly note_plot: string;
  readonly note_revision: string;
  readonly note_rounds: string;
  readonly note_rules: string;
  readonly note_rules_head: string;
  readonly note_sea_objects: string;
  readonly note_sea_objects_head: string;
  readonly note_seamine: string;
  readonly note_shield_regen: string;
  readonly note_ships: string;
  readonly note_ships_head: string;
  readonly note_sov: (p: { painted: string | number }) => string;
  readonly note_sov_head: string;
  readonly note_sov_off: string;
  readonly note_starting: string;
  readonly note_starting_head: string;
  readonly note_status_community: string;
  readonly note_stow: string;
  readonly note_structure: string;
  readonly note_structures_head: string;
  readonly note_symmetry: string;
  readonly note_symmetry_head: string;
  readonly note_terrain: string;
  readonly note_timeout: (p: { wall: string | number }) => string;
  readonly note_torpedoes: string;
  readonly note_torpedoes_head: string;
  readonly note_win: string;
  readonly note_win_cell: string;
  readonly note_win_head: string;
  readonly note_win_none: string;
  readonly note_win_objectives: (p: { have: string | number }) => string;
  readonly note_winline: string;
  readonly note_winline_head: string;
  readonly npc_sec: (p: { sec: string | number }) => string;
  readonly objective_needs_capturable: string;
  readonly open_close_title: string;
  readonly open_none: string;
  readonly open_title: string;
  readonly owner_neutral: string;
  readonly preview_bands_title: string;
  readonly rail_title: string;
  readonly reach_less: string;
  readonly reach_more: string;
  readonly reach_value: (p: { px: string | number }) => string;
  readonly ready_size: (p: { kb: string | number }) => string;
  readonly reload_less: string;
  readonly reload_more: string;
  readonly reload_value: (p: { sec: string | number }) => string;
  readonly respawn_less: string;
  readonly respawn_more: string;
  readonly respawn_once: string;
  readonly rounds_auto: string;
  readonly rounds_cargo: (p: { cargo: string | number; room: string | number }) => string;
  readonly row_add: string;
  readonly row_add_round: string;
  readonly row_add_ship: string;
  readonly row_auto_ship: (p: { variant: string | number }) => string;
  readonly row_auto_torpedo: (p: { kind: string | number }) => string;
  readonly row_base_fires: string;
  readonly row_bounty: string;
  readonly row_brotherhood: string;
  readonly row_brush: string;
  readonly row_capturable: string;
  readonly row_capture_sec: string;
  readonly row_category: string;
  readonly row_cells: string;
  readonly row_colour: string;
  readonly row_cols: string;
  readonly row_combat_pace: string;
  readonly row_credits_per_sec: string;
  readonly row_current_scale: string;
  readonly row_currents: string;
  readonly row_depth: string;
  readonly row_description: string;
  readonly row_design: string;
  readonly row_field_units: string;
  readonly row_heading: string;
  readonly row_hold_auto_capture: string;
  readonly row_hold_sec: string;
  readonly row_kind: string;
  readonly row_mined_rate: string;
  readonly row_mirror_edits: string;
  readonly row_monster: string;
  readonly row_name: string;
  readonly row_no_shield_regen: string;
  readonly row_objective: string;
  readonly row_owner: string;
  readonly row_plot: string;
  readonly row_preset: string;
  readonly row_preview_bands: string;
  readonly row_reach: string;
  readonly row_regen_calm: string;
  readonly row_regen_refill: string;
  readonly row_reload: string;
  readonly row_respawn: string;
  readonly row_revision: string;
  readonly row_rounds: string;
  readonly row_rows: string;
  readonly row_scan_cooldown: string;
  readonly row_sea_cap: string;
  readonly row_sea_grant: string;
  readonly row_sea_sell: string;
  readonly row_seat: string;
  readonly row_shield_type: string;
  readonly row_slot: (p: { slot: string | number }) => string;
  readonly row_sonar: string;
  readonly row_sov_enabled: string;
  readonly row_starting_credits: string;
  readonly row_status: string;
  readonly row_stow: string;
  readonly row_sym_centre: string;
  readonly row_symmetry: string;
  readonly row_tacticalscale: string;
  readonly row_team: string;
  readonly row_timeout: string;
  readonly row_timescale: string;
  readonly row_unpaired: string;
  readonly row_version: string;
  readonly row_wave: string;
  readonly row_weapon_type: string;
  readonly scale_value: (p: { scale: string | number }) => string;
  readonly sea_cap_less: string;
  readonly sea_cap_more: string;
  readonly sea_cap_value: (p: { cap: string | number }) => string;
  readonly ship_class_cap_note: (p: { cap: string | number; hull: string | number }) => string;
  readonly slot_chip: (p: { slot: string | number }) => string;
  readonly start_base_key: (p: { key: string | number; seat: string | number }) => string;
  readonly start_base_touch: (p: { seat: string | number }) => string;
  readonly start_copy: string;
  readonly start_kind: string;
  readonly start_press_base: string;
  readonly start_title: string;
  readonly status_community: string;
  readonly struct_capturable: string;
  readonly struct_fixed: string;
  readonly struct_guard: (p: { reach: string | number; reload: string | number }) => string;
  readonly struct_objective: string;
  readonly sym_centre_at: (p: { cell: string | number; at: string | number }) => string;
  readonly sym_centre_grid: string;
  readonly sym_d2: string;
  readonly sym_d2_rows: (p: { rows: string | number }) => string;
  readonly sym_line_kind: string;
  readonly sym_line_mirror_off: string;
  readonly sym_line_mirror_on: string;
  readonly sym_line_none: string;
  readonly sym_none: string;
  readonly sym_rot120: string;
  readonly sym_rot180: string;
  readonly tabs: readonly string[];
  readonly tag_dev: string;
  readonly team_chip: (p: { team: string | number }) => string;
  readonly todo_chip: (p: { count: string | number }) => string;
  readonly tool_base: string;
  readonly tool_battery: string;
  readonly tool_breakwater: string;
  readonly tool_den: string;
  readonly tool_deployable: string;
  readonly tool_erase: string;
  readonly tool_fairway: string;
  readonly tool_fbase: string;
  readonly tool_field: string;
  readonly tool_fleet: string;
  readonly tool_inspect: string;
  readonly tool_lair: string;
  readonly tool_marker: string;
  readonly tool_ridge: string;
  readonly tool_seamine: string;
  readonly tool_sov: string;
  readonly tool_spire: string;
  readonly tool_throne: string;
  readonly tool_trench: string;
  readonly tool_ward: string;
  readonly tool_water: string;
  readonly tools_erase: string;
  readonly tools_npc: string;
  readonly tools_objects: string;
  readonly tools_sea: string;
  readonly tools_structures: string;
  readonly tools_terrain: string;
  readonly tools_units: string;
  readonly typed_basic_chip: string;
  readonly unclaimed_chip: string;
  readonly unit_kb: string;
  readonly unit_rounds: string;
  readonly unit_sea_objects: string;
  readonly valid_chip: string;
  readonly validator_head: string;
  readonly wall_minutes: (p: { minutes: string | number }) => string;
  readonly wall_seconds: (p: { seconds: string | number }) => string;
  readonly watermark: string;
  readonly wave_less: string;
  readonly wave_more: string;
  readonly white_chip: string;
  readonly win_chip_hold_structures: string;
  readonly win_chip_kill_all: string;
  readonly win_chip_kill_class: string;
  readonly win_chip_kills: string;
  readonly win_chip_mine: string;
  readonly win_chip_scan_class: string;
  readonly win_chip_sov_cell: string;
  readonly win_chip_sov_share: string;
}

export const designerDrawer: DesignerDrawer = tables?.designerDrawer ?? source.designerDrawer;

/** designer/loadmap.ts — the LOAD MAP window of the map designer: the bundled maps by category, each with a still preview and its facts (arcade.md §10.3, R2078). */
export interface DesignerLoad {
  readonly categories: string;
  readonly close_title: string;
  readonly filter: string;
  readonly filter_active: string;
  readonly filter_all: string;
  readonly filter_draft: string;
  readonly filter_retired: string;
  readonly load_failed: (p: { error: string | number }) => string;
  readonly loading: string;
  readonly none: string;
  readonly none_status: string;
  readonly revision: (p: { revision: string | number }) => string;
  readonly row_title: (p: { name: string | number }) => string;
  readonly seats: (p: { count: number }) => string;
  readonly size: (p: { cols: string | number; rows: string | number }) => string;
  readonly sub: string;
  readonly symmetry: (p: { kind: string | number }) => string;
  readonly tag_draft: string;
  readonly tag_retired: string;
  readonly teams: (p: { count: number }) => string;
  readonly timeout_min: (p: { minutes: string | number }) => string;
  readonly timeout_none: string;
  readonly timeout_sec: (p: { seconds: string | number }) => string;
  readonly title: string;
  readonly versus: string;
}

export const designerLoad: DesignerLoad = tables?.designerLoad ?? source.designerLoad;

/** designer/publish.ts — what the dev publish client says when the write does not happen. */
export interface DesignerPublish {
  readonly no_answer: (p: { error: string | number }) => string;
  readonly read_failed: (p: { status: string | number }) => string;
  readonly write_failed: (p: { status: string | number }) => string;
}

export const designerPublish: DesignerPublish = tables?.designerPublish ?? source.designerPublish;

/** designer/render.ts — the one caption the designer's map surface draws: the slot mark on a player base. */
export interface DesignerRender {
  readonly slot_caption: (p: { slot: string | number }) => string;
}

export const designerRender: DesignerRender = tables?.designerRender ?? source.designerRender;

/** ui.effects — the name, the description and the how-to-get-it line of every effect of data/contracts/effects.toml. */
export interface Effects {
  readonly anchor_rings_desc: string;
  readonly anchor_rings_how: string;
  readonly anchor_rings_name: string;
  readonly aurora_desc: string;
  readonly aurora_how: string;
  readonly aurora_name: string;
  readonly basilisk_gaze_desc: string;
  readonly basilisk_gaze_how: string;
  readonly basilisk_gaze_name: string;
  readonly beacon_crown_desc: string;
  readonly beacon_crown_how: string;
  readonly beacon_crown_name: string;
  readonly beacon_lantern_desc: string;
  readonly beacon_lantern_how: string;
  readonly beacon_lantern_name: string;
  readonly bow_arcs_desc: string;
  readonly bow_arcs_how: string;
  readonly bow_arcs_name: string;
  readonly bow_shimmer_desc: string;
  readonly bow_shimmer_how: string;
  readonly bow_shimmer_name: string;
  readonly bubble_breath_desc: string;
  readonly bubble_breath_how: string;
  readonly bubble_breath_name: string;
  readonly bubble_column_desc: string;
  readonly bubble_column_how: string;
  readonly bubble_column_name: string;
  readonly bubble_ring_desc: string;
  readonly bubble_ring_how: string;
  readonly bubble_ring_name: string;
  readonly bulwark_lattice_desc: string;
  readonly bulwark_lattice_how: string;
  readonly bulwark_lattice_name: string;
  readonly cavitation_cloud_desc: string;
  readonly cavitation_cloud_how: string;
  readonly cavitation_cloud_name: string;
  readonly chase_flare_desc: string;
  readonly chase_flare_how: string;
  readonly chase_flare_name: string;
  readonly comet_tail_desc: string;
  readonly comet_tail_how: string;
  readonly comet_tail_name: string;
  readonly compass_rose_desc: string;
  readonly compass_rose_how: string;
  readonly compass_rose_name: string;
  readonly corsair_blaze_desc: string;
  readonly corsair_blaze_how: string;
  readonly corsair_blaze_name: string;
  readonly crown_desc: string;
  readonly crown_how: string;
  readonly crown_name: string;
  readonly cutlass_glint_desc: string;
  readonly cutlass_glint_how: string;
  readonly cutlass_glint_name: string;
  readonly echo_lines_desc: string;
  readonly echo_lines_how: string;
  readonly echo_lines_name: string;
  readonly ember_bed_desc: string;
  readonly ember_bed_how: string;
  readonly ember_bed_name: string;
  readonly ember_rim_desc: string;
  readonly ember_rim_how: string;
  readonly ember_rim_name: string;
  readonly ember_trail_desc: string;
  readonly ember_trail_how: string;
  readonly ember_trail_name: string;
  readonly falconet_feathers_desc: string;
  readonly falconet_feathers_how: string;
  readonly falconet_feathers_name: string;
  readonly frost_desc: string;
  readonly frost_how: string;
  readonly frost_name: string;
  readonly guardian_rays_desc: string;
  readonly guardian_rays_how: string;
  readonly guardian_rays_name: string;
  readonly halo_desc: string;
  readonly halo_how: string;
  readonly halo_name: string;
  readonly halo_round_desc: string;
  readonly halo_round_how: string;
  readonly halo_round_name: string;
  readonly heartbeat_desc: string;
  readonly heartbeat_how: string;
  readonly heartbeat_name: string;
  readonly heavy_wake_desc: string;
  readonly heavy_wake_how: string;
  readonly heavy_wake_name: string;
  readonly hold_compass_desc: string;
  readonly hold_compass_how: string;
  readonly hold_compass_name: string;
  readonly hold_halo_desc: string;
  readonly hold_halo_how: string;
  readonly hold_halo_name: string;
  readonly interceptor_thread_desc: string;
  readonly interceptor_thread_how: string;
  readonly interceptor_thread_name: string;
  readonly kelp_drift_desc: string;
  readonly kelp_drift_how: string;
  readonly kelp_drift_name: string;
  readonly kelp_garden_desc: string;
  readonly kelp_garden_how: string;
  readonly kelp_garden_name: string;
  readonly kraken_ink_desc: string;
  readonly kraken_ink_how: string;
  readonly kraken_ink_name: string;
  readonly lancer_spearhead_desc: string;
  readonly lancer_spearhead_how: string;
  readonly lancer_spearhead_name: string;
  readonly lantern_chain_desc: string;
  readonly lantern_chain_how: string;
  readonly lantern_chain_name: string;
  readonly lantern_desc: string;
  readonly lantern_how: string;
  readonly lantern_name: string;
  readonly light_lantern_desc: string;
  readonly light_lantern_how: string;
  readonly light_lantern_name: string;
  readonly lighthouse_desc: string;
  readonly lighthouse_how: string;
  readonly lighthouse_name: string;
  readonly moonlight_desc: string;
  readonly moonlight_how: string;
  readonly moonlight_name: string;
  readonly orbiting_sentries_desc: string;
  readonly orbiting_sentries_how: string;
  readonly orbiting_sentries_name: string;
  readonly pearl_chain_desc: string;
  readonly pearl_chain_how: string;
  readonly pearl_chain_name: string;
  readonly pulse_core_desc: string;
  readonly pulse_core_how: string;
  readonly pulse_core_name: string;
  readonly ring_chain_desc: string;
  readonly ring_chain_how: string;
  readonly ring_chain_name: string;
  readonly ring_wake_desc: string;
  readonly ring_wake_how: string;
  readonly ring_wake_name: string;
  readonly sea_glitter_desc: string;
  readonly sea_glitter_how: string;
  readonly sea_glitter_name: string;
  readonly searchlight_desc: string;
  readonly searchlight_how: string;
  readonly searchlight_name: string;
  readonly seeker_eye_desc: string;
  readonly seeker_eye_how: string;
  readonly seeker_eye_name: string;
  readonly seeker_pulse_desc: string;
  readonly seeker_pulse_how: string;
  readonly seeker_pulse_name: string;
  readonly sentinel_watch_desc: string;
  readonly sentinel_watch_how: string;
  readonly sentinel_watch_name: string;
  readonly silt_plume_desc: string;
  readonly silt_plume_how: string;
  readonly silt_plume_name: string;
  readonly spiral_desc: string;
  readonly spiral_how: string;
  readonly spiral_name: string;
  readonly spokes_desc: string;
  readonly spokes_how: string;
  readonly spokes_name: string;
  readonly star_field_desc: string;
  readonly star_field_how: string;
  readonly star_field_name: string;
  readonly stardust_wake_desc: string;
  readonly stardust_wake_how: string;
  readonly stardust_wake_name: string;
  readonly third_eye_desc: string;
  readonly third_eye_how: string;
  readonly third_eye_name: string;
  readonly tidal_pull_desc: string;
  readonly tidal_pull_how: string;
  readonly tidal_pull_name: string;
  readonly twin_sprites_desc: string;
  readonly twin_sprites_how: string;
  readonly twin_sprites_name: string;
  readonly twin_tails_desc: string;
  readonly twin_tails_how: string;
  readonly twin_tails_name: string;
}

export const effects: Effects = tables?.effects ?? source.effects;

/** ui.fast — the client: the one stop it has no screen of its own for, and what a sign-in redirect says. */
export interface Fast {
  readonly no_webgl2: string;
  readonly replay_link_silent: string;
  readonly signin_already_linked: string;
  readonly signin_identity_taken: string;
  readonly signin_method_off: string;
  readonly signin_name_taken: string;
  readonly signin_reauth: string;
  readonly signin_refused: string;
  readonly signin_state: string;
  readonly signin_unknown: (p: { code: string | number }) => string;
}

export const fast: Fast = tables?.fast ?? source.fast;

/** ui.format — the overlay's pure text helpers (hold, seaquake, link banner, anchor, systems). */
export interface Format {
  readonly anchor_idle: string;
  readonly anchor_setting: (p: { left: string | number }) => string;
  readonly anchor_weigh: string;
  readonly anchor_weighing: (p: { left: string | number }) => string;
  readonly benefit_archive: (p: { pct: string | number }) => string;
  readonly benefit_battery: string;
  readonly benefit_drydock: (p: { repair: string | number; hull: string | number }) => string;
  readonly benefit_forge: (p: { pct: string | number }) => string;
  readonly benefit_kelp: (p: { pct: string | number }) => string;
  readonly benefit_marshal: (p: { pct: string | number }) => string;
  readonly benefit_short_archive: (p: { pct: string | number }) => string;
  readonly benefit_short_battery: string;
  readonly benefit_short_drydock: (p: { repair: string | number }) => string;
  readonly benefit_short_forge: (p: { pct: string | number }) => string;
  readonly benefit_short_kelp: (p: { pct: string | number }) => string;
  readonly benefit_short_marshal: (p: { pct: string | number }) => string;
  readonly benefit_short_spire: (p: { px: string | number }) => string;
  readonly benefit_short_throne: (p: { pts: string | number }) => string;
  readonly benefit_short_ward: (p: { px: string | number }) => string;
  readonly benefit_spire: (p: { px: string | number }) => string;
  readonly benefit_throne: (p: { pts: string | number; resist: string | number }) => string;
  readonly benefit_ward: (p: { px: string | number }) => string;
  readonly hold_empty: (p: { cap: string | number }) => string;
  readonly hold_parts: (p: { parts: string | number; total: string | number; cap: string | number }) => string;
  readonly link_lost: string;
  readonly link_not_retrying: string;
  readonly link_reconnecting: string;
  readonly link_retry_in: (p: { sec: string | number }) => string;
  readonly quake_tab_floor_moved: (p: { left: string | number }) => string;
  readonly quake_tab_has_won: (p: { left: string | number }) => string;
  readonly quake_tab_season_over: (p: { left: string | number }) => string;
  readonly quake_tab_war_economy: (p: { left: string | number }) => string;
  readonly types_untyped: string;
  readonly unit_approx: (p: { n: string | number }) => string;
  readonly unit_change: (p: { now: string | number; after: string | number }) => string;
  readonly unit_held: (p: { n: string | number }) => string;
  readonly unit_px: (p: { n: string | number }) => string;
  readonly unit_rate: (p: { n: string | number }) => string;
}

export const format: Format = tables?.format ?? source.format;

/** ui.glossary — the player glossary (R1557): the word and the definition of every game term a player reads, for the GLOSSARY card of HELP and the term buttons of the game. */
export interface Glossary {
  readonly advisor: string;
  readonly advisor_def: string;
  readonly alloy: string;
  readonly alloy_def: string;
  readonly autopilot: string;
  readonly autopilot_def: string;
  readonly beacon: string;
  readonly beacon_def: string;
  readonly biomass: string;
  readonly biomass_def: string;
  readonly build_queue: string;
  readonly build_queue_def: string;
  readonly cadet: string;
  readonly cadet_def: string;
  readonly captain: string;
  readonly captain_def: string;
  readonly career_phase: string;
  readonly career_phase_def: string;
  readonly cataclysm: string;
  readonly cataclysm_def: string;
  readonly cell: string;
  readonly cell_def: string;
  readonly clan: string;
  readonly clan_def: string;
  readonly commander: string;
  readonly commander_def: string;
  readonly contact: string;
  readonly contact_def: string;
  readonly credits: string;
  readonly credits_def: string;
  readonly data_core: string;
  readonly data_core_def: string;
  readonly deposit: string;
  readonly deposit_def: string;
  readonly draft: string;
  readonly draft_def: string;
  readonly dredger: string;
  readonly dredger_def: string;
  readonly empire: string;
  readonly empire_def: string;
  readonly expedition: string;
  readonly expedition_def: string;
  readonly faction: string;
  readonly faction_def: string;
  readonly faction_installation: string;
  readonly faction_installation_def: string;
  readonly fleet: string;
  readonly fleet_def: string;
  readonly frontier: string;
  readonly frontier_def: string;
  readonly hold: string;
  readonly hold_def: string;
  readonly honour: string;
  readonly honour_def: string;
  readonly hull: string;
  readonly hull_def: string;
  readonly isotopes: string;
  readonly isotopes_def: string;
  readonly keystone: string;
  readonly keystone_def: string;
  readonly map_marker: string;
  readonly map_marker_def: string;
  readonly master: string;
  readonly master_def: string;
  readonly mission: string;
  readonly mission_def: string;
  readonly module_family: string;
  readonly module_family_def: string;
  readonly print: string;
  readonly print_def: string;
  readonly research: string;
  readonly research_def: string;
  readonly seaquake: string;
  readonly seaquake_def: string;
  readonly season: string;
  readonly season_def: string;
  readonly siege: string;
  readonly siege_def: string;
  readonly sonar: string;
  readonly sonar_def: string;
  readonly sov: string;
  readonly sov_def: string;
  readonly squad: string;
  readonly squad_def: string;
  readonly talent: string;
  readonly talent_def: string;
  readonly territory: string;
  readonly territory_def: string;
  readonly torpedo: string;
  readonly torpedo_def: string;
  readonly volatiles: string;
  readonly volatiles_def: string;
  readonly wardroom: string;
  readonly wardroom_def: string;
  readonly world: string;
  readonly world_def: string;
}

export const glossary: Glossary = tables?.glossary ?? source.glossary;

/** ui/guestwarn.ts — the guest warning before the season roll: the card on the map from seaquake stage 1, and its twin on the hub PLAY panel (deployment.md §10.3, R607, R1565). */
export interface GuestWarn {
  readonly body: string;
  readonly head: string;
  readonly hub_lede: (p: { left: string | number }) => string;
  readonly later: string;
  readonly register: string;
  readonly summary: string;
}

export const guestWarn: GuestWarn = tables?.guestWarn ?? source.guestWarn;

/** ui/howplays.ts — the HOW IT PLAYS card (player-reach.md §8.7, R2445): one page for each mode, with the goal, the loop, the team and what stays, and the foot line of the drills. */
export interface HowPlays {
  readonly arcade_goal: string;
  readonly arcade_loop: string;
  readonly arcade_stays: string;
  readonly arcade_together: string;
  readonly clanwar_goal: string;
  readonly clanwar_loop: string;
  readonly clanwar_stays: string;
  readonly clanwar_together: string;
  readonly close: string;
  readonly core_goal: (p: { days: string | number }) => string;
  readonly core_loop: string;
  readonly core_stays: string;
  readonly core_together: (p: { squad: string | number; members: string | number }) => string;
  readonly drill_go: string;
  readonly drill_line: string;
  readonly drill_title: string;
  readonly event_goal: string;
  readonly event_loop: string;
  readonly event_stays: string;
  readonly event_together: string;
  readonly head_goal: string;
  readonly head_loop: string;
  readonly head_stays: string;
  readonly head_together: string;
  readonly open_label: (p: { mode: string | number }) => string;
  readonly switch_label: string;
  readonly title: string;
  readonly trials_line: string;
}

export const howPlays: HowPlays = tables?.howPlays ?? source.howPlays;

/** ui.hub — the hub shell: the header, the tier badge, the one-time rename tray, the two tab rows and the legal strip. */
export interface Hub {
  readonly busy_join: string;
  readonly busy_line: (p: { label: string | number }) => string;
  readonly busy_signout: string;
  readonly cancel: string;
  readonly dock_names: readonly string[];
  readonly end_guest_seat: string;
  readonly end_guest_seat_armed: string;
  readonly foot_names: readonly string[];
  readonly foot_names_short: readonly string[];
  readonly go_back: string;
  readonly nav_dock: string;
  readonly nav_strip: string;
  readonly notice_dismiss: string;
  readonly notice_more: string;
  readonly rename_card: string;
  readonly rename_confirm_card: string;
  readonly rename_confirm_join: string;
  readonly rename_confirm_lede: string;
  readonly rename_lede: string;
  readonly rename_more: string;
  readonly rename_placeholder: string;
  readonly rename_said: (p: { name: string | number }) => string;
  readonly rename_title: string;
  readonly row_name_new: string;
  readonly row_name_now: string;
  readonly save: string;
  readonly saving: string;
  readonly sign_out: string;
  readonly sign_out_armed: string;
  readonly strip_names: readonly string[];
  readonly use_this_name: string;
  readonly wordmark: string;
}

export const hub: Hub = tables?.hub ?? source.hub;

/** ui.hub.panels.alerts — the ALERTS section of the ☸ OPTIONS menu and of the hub's SETTINGS panel: one switch per push class, the quiet hours and the night switch of the siege class (player-reach.md §3.5, R1301, R1731). */
export interface HubAlerts {
  readonly buzz_foot: (p: { sec: string | number }) => string;
  readonly buzz_try: string;
  readonly buzz_try_title: string;
  readonly checking: string;
  readonly class_cup: string;
  readonly class_cup_desc: string;
  readonly class_economy: string;
  readonly class_economy_desc: string;
  readonly class_fleet: string;
  readonly class_fleet_desc: string;
  readonly class_hold: string;
  readonly class_hold_desc: string;
  readonly class_pirates: string;
  readonly class_pirates_desc: string;
  readonly class_sea_mines: string;
  readonly class_sea_mines_desc: string;
  readonly class_siege: string;
  readonly class_siege_desc: string;
  readonly col_buzz: string;
  readonly col_event: string;
  readonly col_push: string;
  readonly ev_cup: string;
  readonly ev_economy: string;
  readonly ev_hit: string;
  readonly ev_hit_desc: (p: { sec: string | number }) => string;
  readonly ev_hold: string;
  readonly ev_lost: string;
  readonly ev_pirates: string;
  readonly ev_sea_mines: string;
  readonly ev_siege: string;
  readonly head_push: string;
  readonly head_push_buzz: string;
  readonly ios_step: (p: { share: string | number }) => string;
  readonly lede: string;
  readonly lede_buzz: string;
  readonly lede_no_buzz: string;
  readonly night: string;
  readonly night_desc: string;
  readonly none: string;
  readonly privacy: string;
  readonly privacy_app: string;
  readonly quiet: string;
  readonly quiet_desc: (p: { zone: string | number }) => string;
  readonly quiet_from: string;
  readonly quiet_to: string;
  readonly refused: string;
  readonly refused_app: string;
  readonly unavailable: string;
  readonly unsupported: string;
}

export const hubAlerts: HubAlerts = tables?.hubAlerts ?? source.hubAlerts;

/** ui.hub.panels.blocks — the block list of the SOCIAL section of the ☸ OPTIONS menu and of the hub's SETTINGS panel, with LIFT (deployment.md §7.6, R1731). */
export interface HubBlocks {
  readonly checking: string;
  readonly count: (p: { have: string | number; cap: string | number }) => string;
  readonly empty: string;
  readonly empty_why: string;
  readonly head: string;
  readonly lede: string;
  readonly lift: string;
}

export const hubBlocks: HubBlocks = tables?.hubBlocks ?? source.hubBlocks;

/** ui.hub.panels.chatrelay — the CHAT RELAY page of the hub's CLAN panel, a section of its own after DISCORD (R1945): the webhook URL, the language and the switch of the chat relay, TEST and the state (player-reach.md §3.10, R1641). */
export interface HubChatRelay {
  readonly busy_remove: string;
  readonly busy_save: string;
  readonly busy_test: string;
  readonly lang: string;
  readonly lang_desc: string;
  readonly lede: string;
  readonly notice_removed: string;
  readonly notice_saved: string;
  readonly off_line: (p: { count: string | number }) => string;
  readonly privacy: string;
  readonly refusal_none: string;
  readonly remove: string;
  readonly remove_armed: string;
  readonly save: string;
  readonly save_hint: string;
  readonly state_none: string;
  readonly state_off: string;
  readonly state_on: string;
  readonly switch: string;
  readonly switch_desc: string;
  readonly test: string;
  readonly url: string;
  readonly url_label: string;
  readonly url_placeholder: string;
  readonly url_stored: (p: { url: string | number }) => string;
}

export const hubChatRelay: HubChatRelay = tables?.hubChatRelay ?? source.hubChatRelay;

/** ui.hub_clan — the hub's CLAN panel: the browse and found screens, the roster, the squads, the applications and the clan chat. */
export interface HubClan {
  readonly apply_cancel: string;
  readonly apply_send: string;
  readonly apps_approve: string;
  readonly apps_more: (p: { count: string | number }) => string;
  readonly apps_none: string;
  readonly apps_none_closed: string;
  readonly apps_none_invite: string;
  readonly apps_none_open: string;
  readonly apps_refuse: string;
  readonly browse_again: string;
  readonly browse_button: string;
  readonly browse_faction_all: string;
  readonly browse_faction_label: string;
  readonly browse_first_page: string;
  readonly browse_label: string;
  readonly browse_matching: (p: { query: string | number }) => string;
  readonly browse_none_listed: string;
  readonly browse_none_match: string;
  readonly browse_none_press: string;
  readonly browse_none_why: string;
  readonly busy_applying: string;
  readonly busy_approve: string;
  readonly busy_assign: string;
  readonly busy_create: string;
  readonly busy_leave: string;
  readonly busy_line: (p: { label: string | number }) => string;
  readonly busy_policy: string;
  readonly busy_refuse: string;
  readonly busy_register: string;
  readonly busy_remove: string;
  readonly busy_role: string;
  readonly busy_withdraw: string;
  readonly card_applications: string;
  readonly card_clan_chat: string;
  readonly card_clans: string;
  readonly card_hours: string;
  readonly card_roster: string;
  readonly chat_actions: string;
  readonly chat_block: string;
  readonly chat_blocked: string;
  readonly chat_dialling: string;
  readonly chat_empty: string;
  readonly chat_gap: (p: { missed: string | number }) => string;
  readonly chat_line: (p: { sender: string | number; body: string | number }) => string;
  readonly chat_more: string;
  readonly chat_no_clan: string;
  readonly chat_no_clan_why: string;
  readonly chat_not_connected: string;
  readonly chat_not_open: string;
  readonly chat_not_open_why: string;
  readonly chat_placeholder: string;
  readonly chat_refused: string;
  readonly chat_refused_why: string;
  readonly chat_retrying: (p: { n: string | number }) => string;
  readonly chat_send: string;
  readonly chat_unavailable: string;
  readonly chat_unavailable_why: string;
  readonly count_of: (p: { have: string | number; cap: string | number }) => string;
  readonly create_button: string;
  readonly create_lede_banner: string;
  readonly create_lede_free: string;
  readonly create_name_label: string;
  readonly create_pick_faction: string;
  readonly create_tag_label: string;
  readonly cw_closed: string;
  readonly cw_honour_value: (p: { n: string | number }) => string;
  readonly cw_no_run: string;
  readonly cw_no_run_why: string;
  readonly cw_not_registered: string;
  readonly cw_officer_only: string;
  readonly cw_outcome_no_opponent: string;
  readonly cw_outcome_no_world: string;
  readonly cw_outcome_placed: (p: { division: string | number; banner: string | number }) => string;
  readonly cw_outcome_waiting: string;
  readonly cw_pick: string;
  readonly cw_pick_all: string;
  readonly cw_pick_count: (p: { count: string | number; division: string | number }) => string;
  readonly cw_pick_none: string;
  readonly cw_register: string;
  readonly cw_row_cutoff: string;
  readonly cw_row_division: string;
  readonly cw_row_honour: string;
  readonly cw_row_opens: string;
  readonly cw_row_registered: string;
  readonly cw_row_run: string;
  readonly cw_update: string;
  readonly cw_withdraw: string;
  readonly cw_withdraw_armed: string;
  readonly edit_open: string;
  readonly edit_shut: string;
  readonly find_lede_faction: string;
  readonly find_lede_size: (p: { max_members: string | number }) => string;
  readonly find_lede_squads: string;
  readonly found_cards_label: string;
  readonly found_chart_alt: (p: { name: string | number }) => string;
  readonly found_chart_alt_none: string;
  readonly found_chart_head: string;
  readonly found_chart_line: string;
  readonly found_chart_none: string;
  readonly found_form_head: string;
  readonly found_players: (p: { n: number }) => string;
  readonly hand_over: string;
  readonly hand_over_armed: string;
  readonly head_discord: string;
  readonly head_members: (p: { have: string | number; cap: string | number }) => string;
  readonly hours_ask: string;
  readonly hours_ask_press: string;
  readonly hours_lede: (p: { min: string | number }) => string;
  readonly hours_more: (p: { n: number }) => string;
  readonly hours_none: string;
  readonly hours_none_why: (p: { min: string | number }) => string;
  readonly hours_sub: (p: { band: string | number }) => string;
  readonly leave_clan: string;
  readonly leave_clan_armed: string;
  readonly make_member: string;
  readonly make_officer: string;
  readonly no_banner_on_record: string;
  readonly no_squad: string;
  readonly nobody_yet: string;
  readonly note_label: string;
  readonly notice_applied: string;
  readonly pill_apply: string;
  readonly pill_closed: string;
  readonly pill_full: string;
  readonly pill_join: string;
  readonly policy_label_closed: string;
  readonly policy_label_invite: string;
  readonly policy_label_open: string;
  readonly refusal_already_applied: string;
  readonly refusal_already_in_clan: string;
  readonly refusal_bad_request: (p: { factions: string | number; name_max: string | number; name_min: string | number; squads: number; tag_max: string | number; tag_min: string | number }) => string;
  readonly refusal_clan_closed: string;
  readonly refusal_clan_full: string;
  readonly refusal_clan_taken: string;
  readonly refusal_forbidden: string;
  readonly refusal_owner_must_hand_over: string;
  readonly remove: string;
  readonly remove_armed: string;
  readonly role_member: string;
  readonly role_officer: string;
  readonly role_owner: string;
  readonly roster_more: (p: { count: string | number }) => string;
  readonly row_honour: string;
  readonly row_self_suffix: string;
  readonly sec_chat: string;
  readonly sec_cup: string;
  readonly sec_discord: string;
  readonly sec_find: string;
  readonly sec_invites: string;
  readonly sec_members: string;
  readonly sec_relay: string;
  readonly sec_start: string;
  readonly sec_war: string;
  readonly squad_n: (p: { idx: string | number }) => string;
  readonly squad_not_seated: string;
  readonly squad_single: string;
  readonly squads_plan: string;
  readonly sum_chat_new: (p: { n: string | number; line: string | number }) => string;
  readonly sum_find_hours: (p: { n: number }) => string;
  readonly sum_invites: (p: { n: string | number }) => string;
  readonly sum_members_apply: (p: { have: string | number; cap: string | number; n: string | number }) => string;
  readonly sum_war_none: string;
  readonly sum_war_open: string;
  readonly sum_war_registered: (p: { division: string | number }) => string;
  readonly title: string;
  readonly title_sub_no_clan: string;
}

export const hubClan: HubClan = tables?.hubClan ?? source.hubClan;

/** ui.hub.panels.cup and ui.cupmark — the clan cup in the CLAN section of the hub: the cup of now, the CUP page with the cup bracket and the cup day, the title line and the CUP RECORD, and the cup mark beside a clan tag (clan-cup.md §8, mockup round 078, cards 06 to 10, R1629). */
export interface HubCup {
  readonly after: string;
  readonly best_of: (p: { n: string | number }) => string;
  readonly bracket_cancelled: string;
  readonly bracket_cancelled_why: (p: { cup: string | number }) => string;
  readonly bracket_none: string;
  readonly bracket_now: (p: { time: string | number }) => string;
  readonly bracket_preview: string;
  readonly bracket_title: string;
  readonly btn_bracket: string;
  readonly btn_checkin: string;
  readonly btn_play: string;
  readonly btn_watch: string;
  readonly btn_watch_short: string;
  readonly busy_checkin: string;
  readonly busy_register: string;
  readonly busy_withdraw: string;
  readonly cancel_note: string;
  readonly cancelled_few: (p: { min: string | number; n: string | number }) => string;
  readonly cancelled_head: (p: { cup: string | number }) => string;
  readonly cancelled_ops: string;
  readonly card_title: string;
  readonly cat_capture_sov: string;
  readonly cat_ffa: string;
  readonly cat_sovereignty: string;
  readonly checkin_done: (p: { time: string | number }) => string;
  readonly checkin_missed: string;
  readonly checkin_open: (p: { time: string | number }) => string;
  readonly checkin_opens: (p: { time: string | number }) => string;
  readonly clans: (p: { n: number }) => string;
  readonly col_cup: string;
  readonly col_final: string;
  readonly col_quarter: string;
  readonly col_semi: string;
  readonly cup_name: (p: { month: string | number }) => string;
  readonly cup_name_year: (p: { month: string | number; year: string | number }) => string;
  readonly cutoff_line: (p: { date: string | number; time: string | number; left: string | number }) => string;
  readonly cutoff_passed: string;
  readonly cutoff_past: (p: { date: string | number; time: string | number }) => string;
  readonly date: (p: { day: string | number; n: string | number; month: string | number }) => string;
  readonly day_cancelled: string;
  readonly day_more: (p: { date: string | number }) => string;
  readonly day_note: (p: { min: string | number }) => string;
  readonly day_title: string;
  readonly days_short: readonly string[];
  readonly done_winner: (p: { tag: string | number; wins: string | number; losses: string | number; runner: string | number }) => string;
  readonly drawn_no_team: string;
  readonly ev_checkin_closes: string;
  readonly ev_checkin_closes_y: string;
  readonly ev_checkin_opens: string;
  readonly ev_checkin_opens_y: string;
  readonly ev_final_y: (p: { n: string | number }) => string;
  readonly ev_mine: string;
  readonly ev_title: string;
  readonly ev_title_y: string;
  readonly live: string;
  readonly maps_line: (p: { category: string | number; n: string | number }) => string;
  readonly mark_label: (p: { cup: string | number }) => string;
  readonly months: readonly string[];
  readonly months_short: readonly string[];
  readonly more_cancelled: string;
  readonly more_cup_day: string;
  readonly more_done: string;
  readonly more_registration: string;
  readonly next_cancelled: (p: { cup: string | number; date: string | number }) => string;
  readonly next_done: (p: { cup: string | number }) => string;
  readonly next_no_clan: string;
  readonly next_none: string;
  readonly next_now: string;
  readonly next_open_lede: string;
  readonly next_out: (p: { time: string | number }) => string;
  readonly next_title: string;
  readonly none: string;
  readonly officer_changes: string;
  readonly officer_only: string;
  readonly page_sub: (p: { date: string | number; clans: string | number; maps: string | number }) => string;
  readonly pick_lede: (p: { players: string | number; reserves: string | number }) => string;
  readonly picked: (p: { players: string | number; reserves: number }) => string;
  readonly place_against: (p: { round: string | number; time: string | number; tag: string | number }) => string;
  readonly place_bye: (p: { round: string | number }) => string;
  readonly place_live: (p: { round: string | number; tag: string | number }) => string;
  readonly place_out: (p: { round: string | number }) => string;
  readonly place_seed: (p: { seed: string | number }) => string;
  readonly place_waiting: (p: { round: string | number }) => string;
  readonly place_winner: string;
  readonly prize_value: string;
  readonly record_cancelled: string;
  readonly record_in: string;
  readonly record_in_round: (p: { round: string | number }) => string;
  readonly record_month: (p: { month: string | number; year: string | number }) => string;
  readonly record_more: (p: { n: number }) => string;
  readonly record_note: string;
  readonly record_registered: (p: { date: string | number }) => string;
  readonly record_title: string;
  readonly record_winner: (p: { wins: string | number; losses: string | number; tag: string | number }) => string;
  readonly reg_not_open: (p: { date: string | number }) => string;
  readonly register: string;
  readonly registered_full: (p: { n: string | number; max: string | number }) => string;
  readonly registered_line: (p: { n: string | number; min: string | number }) => string;
  readonly reserve_suffix: string;
  readonly round_at: (p: { round: string | number; time: string | number }) => string;
  readonly round_final: string;
  readonly round_n: (p: { n: string | number }) => string;
  readonly round_quarter: string;
  readonly round_semi: string;
  readonly row_against: string;
  readonly row_checkin: string;
  readonly row_cup: string;
  readonly row_cutoff: string;
  readonly row_maps: string;
  readonly row_next: string;
  readonly row_prize: string;
  readonly row_reg_opens: string;
  readonly row_registered: string;
  readonly row_reserve: string;
  readonly row_round: string;
  readonly row_team: string;
  readonly row_winner: string;
  readonly row_your_clan: string;
  readonly side_absent: string;
  readonly side_bye: string;
  readonly side_empty: string;
  readonly side_tbd: string;
  readonly strip_cancelled: string;
  readonly strip_head: string;
  readonly strip_next: string;
  readonly strip_none: string;
  readonly strip_today: string;
  readonly strip_won: (p: { tag: string | number }) => string;
  readonly sum_line: (p: { cup: string | number; state: string | number }) => string;
  readonly sum_no_team: string;
  readonly sum_registered: string;
  readonly time_pair: (p: { local: string | number; utc: string | number }) => string;
  readonly title_line: (p: { cup: string | number; date: string | number }) => string;
  readonly today: string;
  readonly update: string;
  readonly was_registered: string;
  readonly when_line: (p: { cup: string | number; date: string | number; time: string | number }) => string;
  readonly withdraw: string;
  readonly withdraw_armed: string;
}

export const hubCup: HubCup = tables?.hubCup ?? source.hubCup;

/** ui.hub_custom — the custom lobby of the hub: the HOST and JOIN acts of the EVENT tile and the lobby page (R3087, R3088). */
export interface HubCustom {
  readonly advanced: string;
  readonly any_faction: string;
  readonly auto: string;
  readonly autostart: (p: { left: string | number }) => string;
  readonly back: string;
  readonly bots: (p: { n: number }) => string;
  readonly budget_back: string;
  readonly cancel: string;
  readonly cancel_armed: string;
  readonly code: string;
  readonly code_bad: string;
  readonly code_label: string;
  readonly code_ph: string;
  readonly combat_pace: string;
  readonly copy: string;
  readonly draft_ends: (p: { left: string | number }) => string;
  readonly faction_count: (p: { total: string | number; humans: string | number; bots: string | number }) => string;
  readonly faction_held: string;
  readonly faction_pick: (p: { name: string | number }) => string;
  readonly factions: string;
  readonly factions_min: (p: { n: string | number }) => string;
  readonly fill: string;
  readonly fill_desc: string;
  readonly fill_off_desc: string;
  readonly flags: string;
  readonly flags_desc: string;
  readonly gone_cancelled: string;
  readonly gone_dissolved: string;
  readonly gone_failed: string;
  readonly gone_released: string;
  readonly gone_run_cancelled: string;
  readonly host: string;
  readonly host_mark: string;
  readonly host_name: string;
  readonly host_premium: string;
  readonly host_return: string;
  readonly humans: (p: { n: number }) => string;
  readonly join: string;
  readonly join_name: string;
  readonly join_world: string;
  readonly kick: string;
  readonly kick_armed: string;
  readonly leave: string;
  readonly leave_armed: string;
  readonly link: string;
  readonly loading: string;
  readonly locked: string;
  readonly map: string;
  readonly map_note: string;
  readonly members: string;
  readonly name: string;
  readonly next_run: (p: { label: string | number; at: string | number }) => string;
  readonly nobody: string;
  readonly open: string;
  readonly population: string;
  readonly season_days: string;
  readonly seats: string;
  readonly seed: string;
  readonly settings: string;
  readonly share: string;
  readonly squad_n: (p: { n: string | number }) => string;
  readonly squad_pick: (p: { name: string | number }) => string;
  readonly stage1: string;
  readonly stage2: string;
  readonly start: string;
  readonly start_armed: string;
  readonly state_cancelled: string;
  readonly state_dissolved: string;
  readonly state_draft: string;
  readonly state_ended: string;
  readonly state_live: string;
  readonly state_open: string;
  readonly state_starting: string;
  readonly tactical_scale: string;
  readonly timescale: string;
  readonly title: string;
  readonly truce_hours: string;
  readonly wall: (p: { length: string | number }) => string;
  readonly world_closes: (p: { left: string | number }) => string;
  readonly world_open: string;
  readonly world_opening: string;
  readonly world_opens: (p: { left: string | number }) => string;
  readonly you: string;
}

export const hubCustom: HubCustom = tables?.hubCustom ?? source.hubCustom;

/** ui.hub.panels.dailyplan — the DAILY PLAN of the ALERTS section of the hub's SETTINGS panel: the hour of the daily plan push (player-reach.md §3.3, R3280). */
export interface HubDailyPlan {
  readonly at_desc: (p: { hour: string | number }) => string;
  readonly checking: string;
  readonly head: string;
  readonly hour: string;
  readonly hour_desc: (p: { zone: string | number }) => string;
  readonly lede: string;
  readonly off: string;
  readonly off_desc: string;
}

export const hubDailyPlan: HubDailyPlan = tables?.hubDailyPlan ?? source.hubDailyPlan;

/** ui.hub.panels.discord — the DISCORD page of the hub's CLAN panel: the webhook URL, the language and the classes of the clan posts, TEST and the state (player-reach.md §3.9, R1311). */
export interface HubDiscord {
  readonly busy_remove: string;
  readonly busy_save: string;
  readonly busy_test: string;
  readonly class_clanwar: string;
  readonly class_clanwar_desc: string;
  readonly class_members: string;
  readonly class_members_desc: string;
  readonly class_milestones: string;
  readonly class_milestones_desc: string;
  readonly class_registration: string;
  readonly class_registration_desc: string;
  readonly class_season: string;
  readonly class_season_desc: string;
  readonly class_siege: string;
  readonly class_siege_desc: string;
  readonly lang: string;
  readonly lang_desc: string;
  readonly lede: string;
  readonly notice_removed: string;
  readonly notice_saved: string;
  readonly notice_test_failed: (p: { status: string | number }) => string;
  readonly notice_test_ok: string;
  readonly notice_test_silent: string;
  readonly off_line: (p: { count: string | number }) => string;
  readonly privacy: string;
  readonly refusal_none: string;
  readonly refusal_role: string;
  readonly refusal_url: string;
  readonly remove: string;
  readonly remove_armed: string;
  readonly role_hint: string;
  readonly role_label: string;
  readonly save: string;
  readonly save_hint: string;
  readonly state_none: string;
  readonly state_off: string;
  readonly state_on: string;
  readonly switch: string;
  readonly switch_desc: string;
  readonly test: string;
  readonly url: string;
  readonly url_label: string;
  readonly url_placeholder: string;
  readonly url_stored: (p: { url: string | number }) => string;
}

export const hubDiscord: HubDiscord = tables?.hubDiscord ?? source.hubDiscord;

/** ui.hub.panels.hours — the STATED HOURS of the PLAY section of the hub's SETTINGS panel: the hours of the squad finder (player-reach.md §5.3, R1304, R1731). */
export interface HubHours {
  readonly band_afternoon: string;
  readonly band_afternoon_desc: string;
  readonly band_evening: string;
  readonly band_evening_desc: string;
  readonly band_morning: string;
  readonly band_morning_desc: string;
  readonly band_night: string;
  readonly band_night_desc: string;
  readonly band_none: string;
  readonly band_none_desc: string;
  readonly checking: string;
  readonly head: string;
  readonly hours: string;
  readonly hours_desc: (p: { zone: string | number }) => string;
  readonly lede: string;
}

export const hubHours: HubHours = tables?.hubHours ?? source.hubHours;

/** ui.hub_mods — the hub's MODDING panel: the six theme pickers with their shared preview, the player's own custom themes and the map designer. */
export interface HubMods {
  readonly axis_louder: string;
  readonly axis_quieter: string;
  readonly cat_chart: string;
  readonly cat_marks: string;
  readonly cat_music: string;
  readonly cat_sfx: string;
  readonly cat_ui: string;
  readonly cat_world: string;
  readonly change_code: string;
  readonly code_busy: string;
  readonly code_lede: (p: { len: string | number }) => string;
  readonly code_placeholder: string;
  readonly code_submit: string;
  readonly custom_line: string;
  readonly desc_chart: string;
  readonly desc_marks: string;
  readonly desc_music: string;
  readonly desc_sfx: string;
  readonly desc_ui: string;
  readonly desc_world: string;
  readonly designer_lede: string;
  readonly designer_limit: string;
  readonly designer_step_1: string;
  readonly designer_step_2: string;
  readonly designer_step_3: string;
  readonly designer_step_4: string;
  readonly effects_failed: (p: { message: string | number }) => string;
  readonly effects_lede: string;
  readonly err_entitlement: string;
  readonly err_failed: (p: { message: string | number }) => string;
  readonly err_malformed: (p: { len: string | number; alphabet: string | number }) => string;
  readonly err_not_found: string;
  readonly err_rate_limited: string;
  readonly err_unavailable: string;
  readonly expires_note: (p: { date: string | number }) => string;
  readonly fits_count: (p: { held: string | number; locked: string | number }) => string;
  readonly fits_fewer: string;
  readonly fits_head: (p: { slot: string | number }) => string;
  readonly fits_lede_child: (p: { slot: string | number; parent: string | number }) => string;
  readonly fits_lede_fleet: string;
  readonly fits_lede_hold: string;
  readonly fits_lede_torpedo: string;
  readonly fits_more: (p: { count: number }) => string;
  readonly follow_row: (p: { parent: string | number }) => string;
  readonly follow_wears: (p: { name: string | number }) => string;
  readonly follow_wears_none: string;
  readonly grant_ends: (p: { date: string | number }) => string;
  readonly grant_keeps: string;
  readonly group_fleet: (p: { count: number }) => string;
  readonly group_hold: string;
  readonly group_torpedo: (p: { count: number }) => string;
  readonly hint_music: string;
  readonly hint_sfx: string;
  readonly in_use: string;
  readonly legend_follow: string;
  readonly legend_none: string;
  readonly legend_own: string;
  readonly level_all: (p: { value: string | number }) => string;
  readonly level_auto: string;
  readonly level_flashy: string;
  readonly level_minimal: string;
  readonly locked_note: (p: { pick: string | number }) => string;
  readonly locked_tag: string;
  readonly make_code: string;
  readonly make_empty: string;
  readonly make_empty_why: string;
  readonly make_lede: string;
  readonly make_links: (p: { n: number }) => string;
  readonly make_no_key: string;
  readonly make_no_key_why: string;
  readonly make_version: (p: { version: string | number }) => string;
  readonly mix_fold: string;
  readonly mix_lede: string;
  readonly no_audio: string;
  readonly none_note: string;
  readonly not_held_head: string;
  readonly nothing_line: string;
  readonly nothing_row: string;
  readonly open_designer: string;
  readonly open_workshop: string;
  readonly ov_code: string;
  readonly ov_creator: string;
  readonly ov_effects: string;
  readonly ov_nobody: string;
  readonly ov_none: string;
  readonly ov_off: string;
  readonly ov_on: string;
  readonly ov_piece: (p: { piece: string | number; reading: string | number }) => string;
  readonly ov_pieces: string;
  readonly ov_shuffle: string;
  readonly ov_tracks: string;
  readonly ov_version: string;
  readonly ov_voices: string;
  readonly preview_close: string;
  readonly preview_hint: string;
  readonly preview_hint_effects: string;
  readonly preview_label: string;
  readonly preview_look: string;
  readonly preview_pick: (p: { what: string | number; value: string | number }) => string;
  readonly scope_fleet: string;
  readonly scope_hold: string;
  readonly scope_only: (p: { name: string | number }) => string;
  readonly scope_torpedo: string;
  readonly sec_designer: string;
  readonly sec_effects: string;
  readonly sec_themes: string;
  readonly sec_workshop: string;
  readonly see_the_shop: string;
  readonly slot_empty: string;
  readonly slot_fleet: string;
  readonly slot_follows: (p: { name: string | number }) => string;
  readonly slot_hold: string;
  readonly slot_torpedo: string;
  readonly sum_designer: string;
  readonly sum_effects: (p: { worn: string | number; held: string | number }) => string;
  readonly sum_themes: (p: { changed: string | number; total: string | number }) => string;
  readonly sum_themes_auto: string;
  readonly sum_themes_custom: (p: { changed: string | number; total: string | number; custom: string | number }) => string;
  readonly sum_workshop: (p: { links: number; made: string | number; total: string | number }) => string;
  readonly sum_workshop_locked: string;
  readonly sum_workshop_none: string;
  readonly suspended_note: string;
  readonly title: string;
  readonly title_sub: string;
  readonly unresolved_note: (p: { code: string | number }) => string;
  readonly unset_code: string;
  readonly use: string;
  readonly use_lede: string;
  readonly value_auto: string;
  readonly value_custom: string;
  readonly value_custom_code: (p: { code: string | number }) => string;
  readonly value_none: string;
  readonly wear: string;
  readonly whole_lede: string;
  readonly whole_look: string;
  readonly whole_mixed: string;
  readonly worn: string;
}

export const hubMods: HubMods = tables?.hubMods ?? source.hubMods;

/** ui.hub.panels.news — the hub's NEWS panel: the article list with the text of each article, and the community card. */
export interface HubNews {
  readonly body_empty: string;
  readonly body_empty_why: string;
  readonly card_community_title: string;
  readonly card_news_title: string;
  readonly community_join: string;
  readonly community_lede: string;
  readonly news_empty: string;
  readonly news_empty_why: string;
  readonly subtitle: string;
  readonly title: string;
}

export const hubNews: HubNews = tables?.hubNews ?? source.hubNews;

/** ui.hub_panel — the hub's markup primitives: the tier tag and the two lines every card shows for a read that waits or fails, and the two words of a switch. */
export interface HubPanel {
  readonly did_not_load: string;
  readonly dot_said: string;
  readonly heading_join: string;
  readonly included_in: (p: { plan: string | number }) => string;
  readonly not_held: string;
  readonly switch_off: string;
  readonly switch_on: string;
  readonly tier_free: string;
  readonly tier_granted: string;
  readonly tier_line: (p: { tier: string | number; state: string | number }) => string;
  readonly tier_not_in_plan: string;
  readonly tier_premium: string;
  readonly tier_supporter: string;
}

export const hubPanel: HubPanel = tables?.hubPanel ?? source.hubPanel;

/** ui.hub.panels.pickup — the LAST SEASON'S SQUAD and INVITES cards of the hub's CLAN panel: the pickup squad mates and the clan invites (player-reach.md §5.4, R1306). */
export interface HubPickup {
  readonly accept: string;
  readonly busy_accept: string;
  readonly busy_decline: string;
  readonly busy_invite: string;
  readonly card_squad: string;
  readonly decline: string;
  readonly decline_armed: string;
  readonly invite: string;
  readonly invite_clan: (p: { name: string | number; tag: string | number }) => string;
  readonly invite_from: (p: { name: string | number }) => string;
  readonly invite_left: (p: { left: string | number }) => string;
  readonly invites_lede: string;
  readonly mate_season: (p: { mode: string | number; season: string | number }) => string;
  readonly notice_invited: string;
  readonly reason_clan_full: string;
  readonly reason_in_clan: string;
  readonly reason_invite_cap: string;
  readonly reason_invited: string;
  readonly reason_no_clan: string;
  readonly reason_no_right: string;
  readonly refusal_already_invited: string;
  readonly refusal_invite_cap: string;
  readonly refusal_invite_expired: string;
  readonly refusal_invitee_in_clan: string;
  readonly refusal_not_pickup_mate: string;
  readonly squad_lede: string;
  readonly squad_more: string;
}

export const hubPickup: HubPickup = tables?.hubPickup ?? source.hubPickup;

/** ui.hub_play — the hub's PLAY panel: the four mode tiles and the seat cards under them. */
export interface HubPlay {
  readonly arcade_spent_upsell: (p: { line: string | number }) => string;
  readonly card_your_seat: (p: { mode: string | number }) => string;
  readonly clan_not_registered: string;
  readonly cta_resume: string;
  readonly fix_arcade: string;
  readonly fix_clan: string;
  readonly fix_shop: string;
  readonly mode_arcade_cta: string;
  readonly mode_arcade_kick: string;
  readonly mode_arcade_name: string;
  readonly mode_clanwar_cta: string;
  readonly mode_clanwar_kick: string;
  readonly mode_clanwar_name: string;
  readonly mode_core_cta: string;
  readonly mode_core_kick: string;
  readonly mode_core_name: string;
  readonly mode_custom_name: string;
  readonly mode_event_cta: string;
  readonly mode_event_kick: string;
  readonly mode_event_name: string;
  readonly no_modes: string;
  readonly no_modes_why: string;
  readonly no_open_seat: string;
  readonly no_open_seat_why: string;
  readonly no_seat: string;
  readonly no_seat_why: string;
  readonly open_sea_view: string;
  readonly push_ask: string;
  readonly push_ask_fix: string;
  readonly resume_seat: string;
  readonly row_away: string;
  readonly row_queue: string;
  readonly row_season: string;
  readonly row_season_end: string;
  readonly row_standing: string;
  readonly row_territory: string;
  readonly row_window: string;
  readonly row_world: string;
  readonly seat_undescribed: string;
  readonly seat_undescribed_why: string;
  readonly state_clan_not_registered: (p: { state: string | number }) => string;
  readonly state_commitment: (p: { days: string | number }) => string;
  readonly state_commitment_with: (p: { n: string | number; days: string | number }) => string;
  readonly state_your_seat: string;
  readonly state_your_seat_population: (p: { n: string | number }) => string;
  readonly state_your_seat_with: (p: { state: string | number }) => string;
  readonly title: string;
  readonly title_sub: string;
}

export const hubPlay: HubPlay = tables?.hubPlay ?? source.hubPlay;

/** ui.hub.panels.ranks — the hub's RANKS panel: six boards of all players, the three Honour ladders under one HONOUR toggle (R1737). */
export interface HubRanks {
  readonly board_clans: string;
  readonly board_honour: string;
  readonly board_memorials: string;
  readonly board_seasons: string;
  readonly card_history_title: string;
  readonly clan_row: (p: { tag: string | number; name: string | number }) => string;
  readonly clans_empty: string;
  readonly clans_empty_press: string;
  readonly clans_empty_why: string;
  readonly col_honour: string;
  readonly col_name: string;
  readonly col_seasons: string;
  readonly col_title: string;
  readonly gap_value: (p: { value: string | number }) => string;
  readonly history_empty: string;
  readonly history_empty_why: string;
  readonly honour_value: (p: { honour: string | number }) => string;
  readonly ladder_arcade_press: string;
  readonly ladder_empty: string;
  readonly ladder_empty_press: string;
  readonly ladder_empty_why: string;
  readonly ladder_row: (p: { place: string | number; name: string | number }) => string;
  readonly memorial_label: (p: { world: string | number; season: string | number }) => string;
  readonly memorial_score: (p: { score: string | number }) => string;
  readonly memorial_shown: (p: { n: number }) => string;
  readonly memorials_empty: string;
  readonly memorials_empty_why: string;
  readonly memorials_lede: string;
  readonly season_closed_ago: (p: { ago: string | number }) => string;
  readonly season_empty: string;
  readonly season_empty_why: string;
  readonly season_label: (p: { world: string | number; season: string | number }) => string;
  readonly season_open: string;
  readonly season_open_why: string;
  readonly show_row: string;
  readonly snapshot_empty: string;
  readonly snapshot_empty_why: string;
  readonly snapshot_label: (p: { board: string | number; season: string | number }) => string;
  readonly snapshot_more: (p: { mode: string | number; ago: string | number }) => string;
  readonly subtitle: string;
  readonly sum_clan: (p: { tag: string | number; place: string | number }) => string;
  readonly sum_clan_tag: (p: { tag: string | number }) => string;
  readonly sum_ladder: (p: { tier: string | number; place: string | number }) => string;
  readonly sum_mode: (p: { mode: string | number; value: string | number }) => string;
  readonly sum_no_clan: string;
  readonly sum_place: (p: { place: string | number; value: string | number }) => string;
  readonly sum_season: (p: { season: string | number; place: string | number }) => string;
  readonly sum_season_open: (p: { season: string | number }) => string;
  readonly title: string;
  readonly title_clans: string;
  readonly title_clanwar: string;
  readonly title_event: string;
  readonly title_honour: string;
  readonly to_record: string;
  readonly toggle_clanwar: string;
  readonly toggle_core: string;
  readonly toggle_event: string;
  readonly toggle_label: string;
  readonly unranked: string;
  readonly unranked_you: string;
  readonly you_below: string;
  readonly you_board_empty: string;
  readonly you_card: string;
  readonly you_first: string;
  readonly you_label: string;
  readonly you_next: string;
  readonly you_no_clan: string;
  readonly you_off_page: string;
}

export const hubRanks: HubRanks = tables?.hubRanks ?? source.hubRanks;

/** ui.hub_record — the hub's RECORD panel: the standing, the lifetime counters, the badges and the season chronicle. */
export interface HubRecord {
  readonly card_chronicle: string;
  readonly card_last_season: string;
  readonly card_newest: string;
  readonly card_standing: string;
  readonly chronicle_lede: string;
  readonly chronicle_writing: (p: { days: number }) => string;
  readonly honour_value: (p: { n: string | number }) => string;
  readonly last_captains_lost: (p: { n: string | number; lost: string | number }) => string;
  readonly last_chronicle: string;
  readonly last_honour_value: (p: { n: string | number }) => string;
  readonly last_place_of: (p: { place: string | number; of: string | number }) => string;
  readonly last_row_captains: string;
  readonly last_row_clan: string;
  readonly last_row_honour: string;
  readonly last_row_you: string;
  readonly last_sea: string;
  readonly last_share: string;
  readonly newest_none: string;
  readonly nothing_recorded: string;
  readonly pick_hint: string;
  readonly pick_label: string;
  readonly reach_label: string;
  readonly reach_none: string;
  readonly reach_play: string;
  readonly reach_value: (p: { now: string | number; next: string | number }) => string;
  readonly row_best_score: string;
  readonly row_fleets_lost: string;
  readonly row_hex_taken: string;
  readonly row_honour_clanwar: string;
  readonly row_honour_core: string;
  readonly row_honour_event: string;
  readonly row_progress: string;
  readonly row_seasons_played: string;
  readonly sec_achievements: string;
  readonly sec_chronicle: string;
  readonly sec_overview: string;
  readonly sec_statistics: string;
  readonly see_the_shop: string;
  readonly stats_empty_press: string;
  readonly stats_empty_why: string;
  readonly stats_more: string;
  readonly sum_achievements: (p: { held: string | number; total: string | number }) => string;
  readonly sum_chronicle: (p: { days: number; season: string | number }) => string;
  readonly sum_chronicle_none: string;
  readonly sum_overview_honour: (p: { honour: string | number }) => string;
  readonly sum_statistics: (p: { score: string | number; seasons: number }) => string;
  readonly sum_statistics_none: string;
  readonly title: string;
  readonly title_sub: string;
  readonly to_achievements: string;
  readonly to_ranks: string;
  readonly volumes_label: string;
}

export const hubRecord: HubRecord = tables?.hubRecord ?? source.hubRecord;

/** ui.hub.panels.report — the report form of the hub: the REPORT control beside a piece of content another player wrote, and the inline form under it (deployment.md §7.6). */
export interface HubReport {
  readonly busy: string;
  readonly cancel: string;
  readonly lede: string;
  readonly note_box: string;
  readonly pick_reason: string;
  readonly reason_field: string;
  readonly reason_harassment: string;
  readonly reason_hate: string;
  readonly reason_illegal: string;
  readonly reason_impersonation: string;
  readonly reason_other: string;
  readonly reason_sexual: string;
  readonly reason_spam: string;
  readonly reason_violence: string;
  readonly received_pill: string;
  readonly report: string;
  readonly send: string;
}

export const hubReport: HubReport = tables?.hubReport ?? source.hubReport;

/** ui.hub.panels.settings — the hub's SETTINGS panel in the look of the ☸ OPTIONS menu (R1731): the six sections of the menu less HELP, and the ACCOUNT page with its three folded sections. */
export interface HubSettings {
  readonly account_lede: string;
  readonly account_lede_guest: string;
  readonly account_what: string;
  readonly advisor_desc: string;
  readonly erase_armed: string;
  readonly erase_busy: string;
  readonly erase_go: string;
  readonly erase_lede: string;
  readonly erase_lede_guest: string;
  readonly erase_mismatch: string;
  readonly erase_name_box: (p: { name: string | number }) => string;
  readonly erase_password_box: string;
  readonly erase_section: string;
  readonly password_busy: string;
  readonly password_changed: string;
  readonly password_continue: string;
  readonly password_current_box: string;
  readonly password_lede: string;
  readonly password_new_box: string;
  readonly password_section: string;
  readonly reauth_busy: string;
  readonly reauth_go: string;
  readonly reauth_lede: string;
  readonly signin_apple: string;
  readonly signin_apple_desc: string;
  readonly signin_busy: string;
  readonly signin_checking: string;
  readonly signin_continue: string;
  readonly signin_email: string;
  readonly signin_email_box: string;
  readonly signin_email_desc: string;
  readonly signin_google: string;
  readonly signin_google_desc: string;
  readonly signin_has_password: string;
  readonly signin_link: string;
  readonly signin_linked: string;
  readonly signin_off: string;
  readonly signin_password_box: string;
  readonly signin_section: string;
  readonly sound_absent: string;
  readonly subtitle: string;
  readonly title: string;
}

export const hubSettings: HubSettings = tables?.hubSettings ?? source.hubSettings;

/** ui.hub.panels.shop — the hub's SHOP panel: the never-sell rule, the free column, the plan comparison and the checkout hand-off. */
export interface HubShop {
  readonly card_handoff_title: string;
  readonly card_plans_title: string;
  readonly card_rule_title: string;
  readonly entitlement_granted: string;
  readonly free_arcade: string;
  readonly free_arcade_value: string;
  readonly free_core: string;
  readonly free_core_value: string;
  readonly free_queue: string;
  readonly free_queue_value: (p: { hours: string | number }) => string;
  readonly free_summary: string;
  readonly free_summary_value: string;
  readonly free_wardroom: string;
  readonly free_wardroom_value: string;
  readonly handoff_client_token: string;
  readonly handoff_environment: string;
  readonly handoff_lede: string;
  readonly handoff_on_cancel: string;
  readonly handoff_on_success: string;
  readonly handoff_plan: string;
  readonly handoff_price_id: string;
  readonly handoff_token_none: string;
  readonly handoff_token_sent: string;
  readonly pill_clear: string;
  readonly plan_choose: (p: { plan: string | number }) => string;
  readonly plan_free_note: string;
  readonly plan_free_price: string;
  readonly plan_held_head: string;
  readonly plan_held_pill: string;
  readonly plan_opening: string;
  readonly plan_price_interval: (p: { price: string | number; interval: string | number }) => string;
  readonly plans_empty: string;
  readonly plans_empty_why: string;
  readonly plans_empty_why_held: (p: { plan: string | number }) => string;
  readonly refusal_other: string;
  readonly refusal_plan_unknown: string;
  readonly refusal_registration_required: string;
  readonly rule: string;
  readonly shop_disabled_why: string;
  readonly shop_disabled_why_held: (p: { plan: string | number }) => string;
  readonly shop_not_connected: string;
  readonly subtitle: string;
  readonly title: string;
}

export const hubShop: HubShop = tables?.hubShop ?? source.hubShop;

/** ui.hub_state — the hub's pure figure helpers: the spans, the mode tiles, the arcade counter, the seat summary and the rename refusals. */
export interface HubState {
  readonly ago: (p: { span: string | number }) => string;
  readonly arcade_left_line: (p: { left: string | number; limit: string | number }) => string;
  readonly arcade_not_loaded: string;
  readonly arcade_reset_suffix: (p: { left: string | number }) => string;
  readonly arcade_spent_line: (p: { limit: string | number; when: string | number }) => string;
  readonly arcade_unlimited_corner: string;
  readonly arcade_unlimited_line: string;
  readonly as_of: (p: { ago: string | number }) => string;
  readonly away_nothing: string;
  readonly away_raids: (p: { n: number }) => string;
  readonly away_unread: (p: { n: number }) => string;
  readonly cells_taken: (p: { n: number }) => string;
  readonly corner_clans: string;
  readonly corner_closed: string;
  readonly corner_event: string;
  readonly corner_open: string;
  readonly just_now: string;
  readonly maintenance_at: (p: { time: string | number; left: string | number }) => string;
  readonly never: string;
  readonly no_clan_reason: string;
  readonly no_word_yet: string;
  readonly now: string;
  readonly ordinal_nd: (p: { n: string | number }) => string;
  readonly ordinal_rd: (p: { n: string | number }) => string;
  readonly ordinal_st: (p: { n: string | number }) => string;
  readonly ordinal_th: (p: { n: string | number }) => string;
  readonly queue_busy: (p: { n: number }) => string;
  readonly queue_idle: (p: { left: string | number }) => string;
  readonly queue_left: (p: { busy: string | number; h: string | number }) => string;
  readonly rank_of: (p: { rank: string | number; total: string | number }) => string;
  readonly reason_key_only: (p: { key: string | number }) => string;
  readonly reason_no_free_seat: string;
  readonly reason_no_window: string;
  readonly reason_not_open_yet: string;
  readonly reason_starts_in: (p: { left: string | number }) => string;
  readonly reason_tier_only: (p: { tier: string | number }) => string;
  readonly rename_invalid_name: (p: { name_min: string | number; name_max: string | number }) => string;
  readonly rename_name_taken: string;
  readonly rename_other: string;
  readonly rename_spent: string;
  readonly season: (p: { n: string | number }) => string;
  readonly season_ends: (p: { time: string | number; left: string | number }) => string;
  readonly span_dh: (p: { d: string | number; h: string | number }) => string;
  readonly span_hm: (p: { h: string | number; m: string | number }) => string;
  readonly span_ms: (p: { m: string | number; s: string | number }) => string;
  readonly state_always_open: string;
  readonly state_running: string;
  readonly state_running_ends: (p: { left: string | number }) => string;
  readonly state_with_population: (p: { state: string | number; n: string | number }) => string;
  readonly tile_siege_in: (p: { site: string | number; left: string | number }) => string;
  readonly tile_siege_open: (p: { site: string | number }) => string;
  readonly tile_window_at: (p: { time: string | number; left: string | number }) => string;
  readonly tile_window_open: (p: { left: string | number }) => string;
  readonly window_at: (p: { time: string | number; left: string | number }) => string;
  readonly window_join: string;
  readonly window_open_now: (p: { left: string | number }) => string;
  readonly zone_label: (p: { zone: string | number; mark: string | number }) => string;
}

export const hubState: HubState = tables?.hubState ?? source.hubState;

/** ui.hub.panels.support — the hub's HELP panel: the questions and answers, the touch gestures, the key sheet and where to ask a person. */
export interface HubSupport {
  readonly a_account_device_1: string;
  readonly a_account_device_2: string;
  readonly a_arcade_runs_1: (p: { free: string | number; guest: string | number }) => string;
  readonly a_arcade_runs_2: string;
  readonly a_better_design_1: string;
  readonly a_better_design_2: string;
  readonly a_block_report_1: string;
  readonly a_block_report_2: (p: { note: string | number }) => string;
  readonly a_build_first_1: string;
  readonly a_build_first_2: string;
  readonly a_captain_life_1: (p: { attrs: string | number; cap: string | number; per_point: string | number; peaked: string | number }) => string;
  readonly a_captain_life_2: (p: { min: string | number; max: string | number; years: string | number; peak: string | number; decline: string | number; slots: string | number; slots_max: string | number }) => string;
  readonly a_clan_free: string;
  readonly a_clan_squad_1: (p: { members: string | number; squads: number }) => string;
  readonly a_clan_squad_2: string;
  readonly a_connection_1: string;
  readonly a_connection_2: string;
  readonly a_credits_1: string;
  readonly a_credits_2: string;
  readonly a_drill_1: string;
  readonly a_drill_2: string;
  readonly a_enemy_hold_1: string;
  readonly a_enemy_hold_2: string;
  readonly a_expedition_1: string;
  readonly a_expedition_2: string;
  readonly a_fight_1: string;
  readonly a_fight_2: string;
  readonly a_fleet_sunk_1: string;
  readonly a_fleet_sunk_2: string;
  readonly a_fog_of_war_1: string;
  readonly a_fog_of_war_2: string;
  readonly a_give_order_1: string;
  readonly a_give_order_2: string;
  readonly a_honour_1: string;
  readonly a_honour_2: string;
  readonly a_join_1: string;
  readonly a_join_2: string;
  readonly a_never_sell_1: string;
  readonly a_never_sell_2: string;
  readonly a_next_step_1: string;
  readonly a_next_step_2: (p: { seasons: string | number }) => string;
  readonly a_offline_1: string;
  readonly a_offline_2: (p: { hours: string | number }) => string;
  readonly a_phone_play_1: string;
  readonly a_phone_play_2: string;
  readonly a_put_to_sea_1: string;
  readonly a_put_to_sea_2: string;
  readonly a_queue_ceiling_1: (p: { hours: string | number; extended: string | number }) => string;
  readonly a_queue_ceiling_2: string;
  readonly a_queue_stuck_1: string;
  readonly a_queue_stuck_2: string;
  readonly a_rename_1: string;
  readonly a_rename_2: (p: { name_min: string | number; name_max: string | number }) => string;
  readonly a_repair_1: string;
  readonly a_repair_2: string;
  readonly a_report_problem_1: (p: { max: string | number }) => string;
  readonly a_report_problem_2: string;
  readonly a_research_1: string;
  readonly a_research_2: string;
  readonly a_resources_1: string;
  readonly a_resources_2: string;
  readonly a_screen_size_1: string;
  readonly a_screen_size_2: string;
  readonly a_season_end_1: (p: { days: string | number }) => string;
  readonly a_season_end_2: string;
  readonly a_season_reset_1: string;
  readonly a_season_reset_2: string;
  readonly a_siege_1: string;
  readonly a_siege_2: string;
  readonly a_squad_1: string;
  readonly a_squad_2: (p: { intel: string | number }) => string;
  readonly a_stay_unheard_1: string;
  readonly a_stay_unheard_2: string;
  readonly a_supply_1: string;
  readonly a_supply_2: string;
  readonly a_territory_1: string;
  readonly a_territory_2: string;
  readonly a_torpedoes_1: string;
  readonly a_torpedoes_2: string;
  readonly a_two_clocks_1: string;
  readonly a_two_clocks_2: string;
  readonly a_win_arcade_1: string;
  readonly a_win_arcade_2: string;
  readonly a_win_core_1: (p: { days: string | number }) => string;
  readonly a_win_core_2: (p: { squad: string | number; members: string | number }) => string;
  readonly ask_lede: string;
  readonly card_glossary_count: (p: { count: string | number }) => string;
  readonly card_glossary_title: string;
  readonly card_keys_title: string;
  readonly card_qa_count: (p: { count: string | number }) => string;
  readonly gesture_aim_first: string;
  readonly gesture_aim_first_does: string;
  readonly gesture_aim_second: string;
  readonly gesture_aim_second_does: string;
  readonly gesture_drag: string;
  readonly gesture_drag_does: string;
  readonly gesture_long_press: string;
  readonly gesture_long_press_does: string;
  readonly gesture_pinch: string;
  readonly gesture_pinch_does: string;
  readonly gesture_tap_empty: string;
  readonly gesture_tap_empty_does: string;
  readonly gesture_tap_minimap: string;
  readonly gesture_tap_minimap_does: string;
  readonly gesture_tap_order: string;
  readonly gesture_tap_order_does: string;
  readonly gesture_tap_other_fleet: string;
  readonly gesture_tap_other_fleet_does: string;
  readonly gesture_tap_water: string;
  readonly gesture_tap_water_does: string;
  readonly gestures_lede: string;
  readonly glossary_filter: string;
  readonly glossary_lede: string;
  readonly glossary_none: string;
  readonly group_combat: string;
  readonly group_device: string;
  readonly group_empire: string;
  readonly group_fleets: string;
  readonly group_money: string;
  readonly group_seasons: string;
  readonly group_start: string;
  readonly group_territory: string;
  readonly how_lede: string;
  readonly keys_lede: string;
  readonly pill_contact: string;
  readonly pill_discord: string;
  readonly pill_nettest: string;
  readonly pill_show_mail: string;
  readonly q_account_device: string;
  readonly q_arcade_runs: string;
  readonly q_better_design: string;
  readonly q_block_report: string;
  readonly q_build_first: string;
  readonly q_captain_life: string;
  readonly q_clan_squad: string;
  readonly q_connection: string;
  readonly q_credits: string;
  readonly q_drill: string;
  readonly q_enemy_hold: string;
  readonly q_expedition: string;
  readonly q_fight: string;
  readonly q_fleet_sunk: string;
  readonly q_fog_of_war: string;
  readonly q_give_order: string;
  readonly q_honour: string;
  readonly q_join: string;
  readonly q_never_sell: string;
  readonly q_next_step: string;
  readonly q_offline: string;
  readonly q_phone_play: string;
  readonly q_put_to_sea: string;
  readonly q_queue_ceiling: string;
  readonly q_queue_stuck: string;
  readonly q_rename: string;
  readonly q_repair: string;
  readonly q_report_problem: string;
  readonly q_research: string;
  readonly q_resources: string;
  readonly q_screen_size: string;
  readonly q_season_end: string;
  readonly q_season_reset: string;
  readonly q_siege: string;
  readonly q_squad: string;
  readonly q_stay_unheard: string;
  readonly q_supply: string;
  readonly q_territory: string;
  readonly q_torpedoes: string;
  readonly q_two_clocks: string;
  readonly q_win_arcade: string;
  readonly q_win_core: string;
  readonly sec_ask: string;
  readonly sec_questions: string;
  readonly sec_touch: string;
  readonly subtitle: string;
  readonly sum_ask_shown: string;
  readonly sum_glossary_filter: (p: { shown: string | number; count: string | number }) => string;
  readonly sum_keys: (p: { count: string | number }) => string;
  readonly sum_questions_open: (p: { open: string | number; count: string | number }) => string;
  readonly sum_touch: (p: { count: string | number }) => string;
  readonly title: string;
}

export const hubSupport: HubSupport = tables?.hubSupport ?? source.hubSupport;

/** ui.hub_wardroom — the hub's WARDROOM panel: the core roster, the event roster, Cryo Freeze and the captain designer. */
export interface HubWardroom {
  readonly age: (p: { n: string | number }) => string;
  readonly card_cryo: string;
  readonly card_designer: string;
  readonly card_fleet_livery: string;
  readonly card_fleet_names: string;
  readonly clanwar_empty: string;
  readonly clanwar_empty_why: string;
  readonly clanwar_lede: string;
  readonly core_empty: string;
  readonly core_empty_press: string;
  readonly core_empty_why: string;
  readonly core_lede: string;
  readonly count: (p: { n: string | number; max: string | number }) => string;
  readonly cryo_lede: string;
  readonly cryo_unheld: string;
  readonly designer_close: string;
  readonly designer_lede: string;
  readonly designer_pick: string;
  readonly designer_pick_strip: string;
  readonly designer_pick_why: string;
  readonly dg_combat: string;
  readonly dg_draw_faction: string;
  readonly dg_draw_pool: string;
  readonly dg_faction: string;
  readonly dg_faction_sub: string;
  readonly dg_ii_note: string;
  readonly dg_name: string;
  readonly dg_name_faction: string;
  readonly dg_name_pool: string;
  readonly dg_ordinal: string;
  readonly dg_ordinal_sub: string;
  readonly dg_role: string;
  readonly dg_role_sub: string;
  readonly dg_second: string;
  readonly dg_support: string;
  readonly dg_sv_note: string;
  readonly dossier_empty: string;
  readonly dossier_label: string;
  readonly dossier_line: (p: { age: string | number; phase: string | number; seasons: number }) => string;
  readonly dossier_talents: (p: { list: string | number }) => string;
  readonly dossier_value: (p: { v: string | number; cap: string | number }) => string;
  readonly event_empty: string;
  readonly event_empty_held: string;
  readonly event_empty_unheld: string;
  readonly event_lede: string;
  readonly face_label: (p: { n: string | number }) => string;
  readonly fleet_add: string;
  readonly fleet_count: (p: { n: string | number; max: string | number }) => string;
  readonly fleet_empty: string;
  readonly fleet_empty_why: string;
  readonly fleet_full: (p: { max: string | number }) => string;
  readonly fleet_hint: (p: { min: string | number; max: string | number }) => string;
  readonly fleet_label: string;
  readonly fleet_lede: string;
  readonly fleet_placeholder: (p: { n: string | number }) => string;
  readonly fleet_remove: string;
  readonly fleet_remove_label: (p: { n: string | number }) => string;
  readonly fleet_reset: string;
  readonly fleet_reset_armed: string;
  readonly fleet_reset_done: string;
  readonly fleet_side_label: string;
  readonly fleet_side_livery: (p: { name: string | number }) => string;
  readonly fleet_stored: (p: { names: string | number }) => string;
  readonly gender_f: string;
  readonly gender_f_title: string;
  readonly gender_m: string;
  readonly gender_m_title: string;
  readonly label_backstory: string;
  readonly label_name: string;
  readonly label_portrait: string;
  readonly label_voice: string;
  readonly livery_decals: string;
  readonly livery_hint: string;
  readonly livery_label: string;
  readonly livery_lede: string;
  readonly livery_name_bow_band: string;
  readonly livery_name_centre_stripe: string;
  readonly livery_name_chevron: string;
  readonly livery_name_cockpit_bar: string;
  readonly livery_name_cockpit_diamond: string;
  readonly livery_name_cockpit_ring: string;
  readonly livery_name_cockpit_square: string;
  readonly livery_name_cockpit_triangle: string;
  readonly livery_name_dazzle: string;
  readonly livery_name_deck_ring: string;
  readonly livery_name_hatching: string;
  readonly livery_name_inner_silhouette: string;
  readonly livery_name_rivets: string;
  readonly livery_name_stern_band: string;
  readonly livery_name_tally_one: string;
  readonly livery_name_tally_three: string;
  readonly livery_name_tally_two: string;
  readonly livery_name_tips: string;
  readonly livery_name_twin_stripes: string;
  readonly livery_name_wing_band: string;
  readonly livery_none: string;
  readonly livery_off: string;
  readonly livery_patterns: string;
  readonly livery_picked: (p: { name: string | number }) => string;
  readonly livery_reset: string;
  readonly livery_reset_armed: string;
  readonly livery_reset_done: string;
  readonly livery_stored: (p: { name: string | number }) => string;
  readonly name_hint: string;
  readonly names_side_label: string;
  readonly phase_decline: string;
  readonly phase_peak: string;
  readonly phase_rise: string;
  readonly preview_label: string;
  readonly private_hint: string;
  readonly reroll: string;
  readonly reset: string;
  readonly reset_armed: string;
  readonly reset_done: string;
  readonly save: string;
  readonly saved: string;
  readonly saving: string;
  readonly sec_rosters: string;
  readonly see_the_shop: string;
  readonly strip_more: (p: { n: string | number }) => string;
  readonly sum_clanwar: (p: { n: string | number }) => string;
  readonly sum_core: (p: { n: string | number }) => string;
  readonly sum_event: (p: { n: string | number }) => string;
  readonly sum_names: (p: { n: number }) => string;
  readonly title: string;
  readonly title_sub: string;
  readonly to_designer: string;
  readonly toggle_clanwar: string;
  readonly toggle_core: string;
  readonly toggle_event: string;
  readonly toggle_label: string;
  readonly too_long: (p: { limit: string | number }) => string;
  readonly too_short: (p: { limit: string | number }) => string;
  readonly voice_count: (p: { n: string | number; max: string | number }) => string;
  readonly voice_placeholder: (p: { n: string | number }) => string;
}

export const hubWardroom: HubWardroom = tables?.hubWardroom ?? source.hubWardroom;

/** ui.impersonation — the gold strip an operator sees while they play a player's account. */
export interface Impersonation {
  readonly banner: (p: { name: string | number; operator: string | number }) => string;
  readonly stop: string;
}

export const impersonation: Impersonation = tables?.impersonation ?? source.impersonation;

/** ui/inbox/ — the record of the INBOX: the head, the views, the bucket filter, the rows, the folds and the open message (docs/design/inbox.md §6, round 089). */
export interface Inbox {
  readonly achieved: (p: { n: number }) => string;
  readonly achievement_body: (p: { grade: string | number; achievement: string | number }) => string;
  readonly achievements: string;
  readonly back: string;
  readonly battle_copy: string;
  readonly battle_damage: (p: { dealt: string | number; taken: string | number; gauge: string | number }) => string;
  readonly battle_failed: (p: { site: string | number }) => string;
  readonly battle_foe: (p: { foe: string | number; ours: string | number; theirs: string | number }) => string;
  readonly battle_gauge_lost: (p: { site: string | number }) => string;
  readonly battle_held: (p: { site: string | number }) => string;
  readonly battle_lost: (p: { site: string | number; foe: string | number }) => string;
  readonly battle_taken: (p: { site: string | number }) => string;
  readonly battle_won: (p: { site: string | number }) => string;
  readonly boarding_body: (p: { fleet: string | number; class: string | number }) => string;
  readonly bucket_names: readonly string[];
  readonly bucket_tags: readonly string[];
  readonly buyers: (p: { n: number }) => string;
  readonly cache_finders: (p: { n: number }) => string;
  readonly cache_finders_body: (p: { n: number }) => string;
  readonly cache_found_body: (p: { fleet: string | number; kind: string | number }) => string;
  readonly cache_found_core: string;
  readonly cache_found_event: (p: { label: string | number }) => string;
  readonly cache_found_player: string;
  readonly cache_found_reward: (p: { alloy: string | number; biomass: string | number; volatiles: string | number; isotopes: string | number }) => string;
  readonly cache_taken_body: (p: { finder: string | number }) => string;
  readonly cap_label: (p: { n: number }) => string;
  readonly captains: string;
  readonly cause_seaquake: string;
  readonly cells_lost: (p: { n: number }) => string;
  readonly clan_copy: string;
  readonly clan_page: string;
  readonly club_body: (p: { room: string | number; faction: string | number; net: string | number; window: string | number }) => string;
  readonly club_day: string;
  readonly club_fold_body: (p: { amount: string | number; n: number; net: string | number }) => string;
  readonly club_in_day: string;
  readonly club_in_night: string;
  readonly club_night: string;
  readonly club_share_body: (p: { amount: string | number; total: string | number; members: string | number }) => string;
  readonly club_shares: (p: { n: number }) => string;
  readonly club_split: (p: { total: string | number; members: string | number }) => string;
  readonly club_window_body: (p: { from: string | number; to: string | number }) => string;
  readonly credits: (p: { n: string | number }) => string;
  readonly damage_cols: readonly string[];
  readonly damage_kinds: readonly string[];
  readonly damage_title: string;
  readonly dealt_cols: readonly string[];
  readonly depth_cells: readonly string[];
  readonly dive_body: (p: { dive: string | number; captain: string | number; hours: string | number }) => string;
  readonly dive_hurt: (p: { captain: string | number; sickbay_until: string | number }) => string;
  readonly dive_isotopes: (p: { isotopes: string | number }) => string;
  readonly dive_isotopes_core: (p: { isotopes: string | number }) => string;
  readonly dive_years: (p: { captain: string | number; n: number }) => string;
  readonly empty: string;
  readonly empty_filter: string;
  readonly empty_today: string;
  readonly empty_unread: string;
  readonly expires: (p: { date: string | number }) => string;
  readonly fate_captured: string;
  readonly fate_wounded: string;
  readonly featured_body: (p: { site: string | number; window_start: string | number; window_end: string | number }) => string;
  readonly featured_rule: string;
  readonly fell_body: (p: { site: string | number; foe: string | number }) => string;
  readonly filter_all: string;
  readonly filter_all_title: string;
  readonly filter_label: (p: { bucket: string | number; n: number }) => string;
  readonly filter_title: (p: { bucket: string | number }) => string;
  readonly fire_body: (p: { faction: string | number; events: string | number; first: string | number; last: string | number }) => string;
  readonly fleets_cols: readonly string[];
  readonly fold_title: string;
  readonly for_class: (p: { class: string | number }) => string;
  readonly fragment_body: (p: { fleet: string | number }) => string;
  readonly fragment_note: string;
  readonly fragments_body: (p: { n: number }) => string;
  readonly fragments_held: (p: { n: number }) => string;
  readonly freed_body: (p: { fleet: string | number; class: string | number }) => string;
  readonly go_to: string;
  readonly go_to_title: (p: { place: string | number }) => string;
  readonly held_body: (p: { site: string | number; foe: string | number }) => string;
  readonly hits: (p: { n: number }) => string;
  readonly hits_cols: readonly string[];
  readonly honour: (p: { n: string | number }) => string;
  readonly hull_pct: (p: { n: string | number }) => string;
  readonly hull_sunk: string;
  readonly hull_taken_body: (p: { fleet: string | number; class: string | number }) => string;
  readonly hull_taken_note: string;
  readonly isotopes: string;
  readonly killed_body: (p: { fleet: string | number; class: string | number; owner: string | number; faction: string | number }) => string;
  readonly killed_salvage: (p: { alloy: string | number; biomass: string | number; volatiles: string | number }) => string;
  readonly killed_share: (p: { share: string | number; damage: string | number }) => string;
  readonly landed: (p: { n: string | number }) => string;
  readonly launcher_battery: string;
  readonly launcher_hold: (p: { owner: string | number }) => string;
  readonly launcher_tube: string;
  readonly loading: string;
  readonly lost_by: (p: { fleet: string | number; class: string | number; killer: string | number; killer_owner: string | number }) => string;
  readonly lost_captured: (p: { captain: string | number; captor_faction: string | number; ransom: string | number }) => string;
  readonly lost_cargo: (p: { cargo: string | number }) => string;
  readonly lost_none: string;
  readonly lost_sunk: (p: { fleet: string | number; class: string | number }) => string;
  readonly lost_wounded: (p: { captain: string | number; sickbay_until: string | number }) => string;
  readonly mark_all: string;
  readonly mark_these: string;
  readonly mates: (p: { n: number }) => string;
  readonly mates_cols: readonly string[];
  readonly mauled_body: (p: { foe: string | number; site: string | number }) => string;
  readonly monster_body: (p: { fleet: string | number; class: string | number }) => string;
  readonly monster_commanders: (p: { n: number }) => string;
  readonly monster_sunk_body: (p: { fleet: string | number; class: string | number }) => string;
  readonly monster_sunk_core: string;
  readonly monster_sunk_last: string;
  readonly monster_sunk_practice: (p: { points: string | number }) => string;
  readonly more: (p: { n: string | number }) => string;
  readonly moved_body: (p: { to_cell: string | number }) => string;
  readonly npc_contacts: (p: { n: number }) => string;
  readonly object_damage_body: (p: { dealt: string | number; taken: string | number }) => string;
  readonly object_heal_body: string;
  readonly object_lost_body: (p: { gain: string | number }) => string;
  readonly object_next_body: (p: { at: string | number }) => string;
  readonly only_battle: string;
  readonly only_range: string;
  readonly open_ambush: (p: { aspect: string | number; damage: string | number }) => string;
  readonly open_beam: string;
  readonly open_bow: string;
  readonly open_heard: (p: { aspect: string | number; damage: string | number }) => string;
  readonly open_page: string;
  readonly open_stern: string;
  readonly outcome_failed: string;
  readonly outcome_gauge_lost: string;
  readonly outcome_held: string;
  readonly outcome_lost: string;
  readonly outcome_taken: string;
  readonly outcome_won: string;
  readonly pay_ransom: (p: { ransom: string | number }) => string;
  readonly pickup_squad: string;
  readonly pirate_body: (p: { fleet: string | number; class: string | number }) => string;
  readonly place_hold: (p: { commander: string | number }) => string;
  readonly pledge: string;
  readonly points: (p: { n: string | number }) => string;
  readonly print: string;
  readonly prints: (p: { n: number }) => string;
  readonly range: (p: { first: string | number; last: string | number }) => string;
  readonly rank: (p: { rank: string | number; of: string | number }) => string;
  readonly read: string;
  readonly recovered_body: (p: { fleet: string | number; class: string | number }) => string;
  readonly redraft_body: (p: { slot: string | number; design: string | number; module: string | number }) => string;
  readonly redraft_discarded: string;
  readonly redraft_discarded_body: string;
  readonly redraft_improved: string;
  readonly redraft_improved_body: string;
  readonly redraft_module: (p: { module: string | number; tier: string | number }) => string;
  readonly redraft_roll_body: (p: { old: string | number; old_grade: string | number; new: string | number; new_grade: string | number }) => string;
  readonly redraft_rolls: (p: { old: string | number; new: string | number }) => string;
  readonly redraft_tiers: readonly string[];
  readonly replace: (p: { price: string | number }) => string;
  readonly replace_queued: string;
  readonly replace_sent: string;
  readonly replace_title: string;
  readonly replay: string;
  readonly replay_title: string;
  readonly report: string;
  readonly report_title: string;
  readonly room_body: (p: { fleet: string | number; class: string | number; for_class: string | number }) => string;
  readonly sale_isotopes_body: (p: { buyer: string | number; qty: string | number; price: string | number; unit: string | number }) => string;
  readonly sale_print_body: (p: { buyer: string | number; print: string | number; price: string | number }) => string;
  readonly score: (p: { ours: string | number; theirs: string | number }) => string;
  readonly sea_lost: (p: { n: string | number }) => string;
  readonly sea_lost_cleared: (p: { by: string | number; count: string | number }) => string;
  readonly sea_lost_destroyed: (p: { by: string | number; count: string | number }) => string;
  readonly sea_lost_expired: (p: { count: string | number }) => string;
  readonly sea_lost_kind: (p: { kind: string | number }) => string;
  readonly sea_lost_rock: (p: { count: string | number }) => string;
  readonly sea_mine_damage: (p: { damage: string | number }) => string;
  readonly sea_mine_hulls: (p: { count: string | number; damage: string | number }) => string;
  readonly sea_mine_sank: string;
  readonly sea_mine_struck_body: (p: { fleet: string | number; class: string | number; owner: string | number; kind: string | number }) => string;
  readonly sea_mine_tripped_body: (p: { fleet: string | number; class: string | number; owner: string | number; kind: string | number }) => string;
  readonly sea_reason_cleared: string;
  readonly sea_reason_destroyed: string;
  readonly sea_reason_expired: string;
  readonly sea_reason_rock: string;
  readonly season: (p: { season: string | number }) => string;
  readonly season_body: (p: { season: string | number; rank: string | number; of: string | number; points: string | number }) => string;
  readonly season_figures: readonly string[];
  readonly season_honour: (p: { honour: string | number; title: string | number }) => string;
  readonly shots: (p: { n: number }) => string;
  readonly show: string;
  readonly show_all: string;
  readonly show_title: string;
  readonly side_attack: string;
  readonly side_defence: string;
  readonly siege_body: (p: { foe: string | number; site: string | number; window_start: string | number; window_end: string | number }) => string;
  readonly span_hm: (p: { h: string | number; m: string | number }) => string;
  readonly span_m: (p: { m: string | number }) => string;
  readonly spilled: (p: { n: string | number }) => string;
  readonly spilled_body: (p: { units: string | number; spilled: string | number }) => string;
  readonly squad_body: string;
  readonly sr_fold: (p: { n: number }) => string;
  readonly sr_row: (p: { kind: string | number; subject: string | number; stamp: string | number }) => string;
  readonly sr_row_unread: (p: { kind: string | number; subject: string | number; stamp: string | number }) => string;
  readonly storage_full: string;
  readonly struck_cols: readonly string[];
  readonly sunk: (p: { n: string | number }) => string;
  readonly taken_body: (p: { captain: string | number; owner: string | number; ransom: string | number }) => string;
  readonly title: string;
  readonly torpedo_hit_body: (p: { torpedo: string | number; launcher: string | number; count: string | number; faction: string | number }) => string;
  readonly torpedo_sank: (p: { sunk: string | number }) => string;
  readonly torpedo_struck_body: (p: { torpedo: string | number; launcher: string | number; owner: string | number; count: string | number }) => string;
  readonly type_achievement: string;
  readonly type_battle_report: string;
  readonly type_boarding_started: string;
  readonly type_boarding_stopped: string;
  readonly type_cache_found: string;
  readonly type_cache_taken: string;
  readonly type_captain_taken: string;
  readonly type_cargo_spilled: string;
  readonly type_club_paid: string;
  readonly type_expedition: string;
  readonly type_featured_next: string;
  readonly type_fleet_killed: string;
  readonly type_fleet_lost: string;
  readonly type_fragment_found: string;
  readonly type_hold_moved: string;
  readonly type_hold_under_fire: string;
  readonly type_hull_taken: string;
  readonly type_monster_heard: string;
  readonly type_monster_sunk: string;
  readonly type_object_fallen: string;
  readonly type_object_held: string;
  readonly type_object_mauled: string;
  readonly type_pickup_squad: string;
  readonly type_pirate_contact: string;
  readonly type_redraft_done: string;
  readonly type_room_made: string;
  readonly type_sale: string;
  readonly type_sea_mine_struck: string;
  readonly type_sea_mine_tripped: string;
  readonly type_sea_object_lost: string;
  readonly type_season_closed: string;
  readonly type_siege_defend: string;
  readonly type_territory_lost: string;
  readonly type_torpedo_hit: string;
  readonly type_torpedo_struck: string;
  readonly type_wreck_recovered: string;
  readonly unread_mark: string;
  readonly view_all: string;
  readonly view_all_title: string;
  readonly view_today: string;
  readonly view_today_title: string;
  readonly view_unread: string;
  readonly view_unread_count: (p: { n: string | number }) => string;
  readonly view_unread_title: string;
  readonly water_body: (p: { faction: string | number; cells: string | number }) => string;
  readonly window_ended: string;
  readonly window_in: (p: { span: string | number }) => string;
  readonly window_open: string;
  readonly yes: string;
  readonly your_hold: string;
}

export const inbox: Inbox = tables?.inbox ?? source.inbox;

/** ui/inbox/needsyou.ts — NEEDS YOU of the INBOX (inbox.md §8, R1846): the group head, the time rail with its day breaks, the map inset of an item and the words a screen reader reads. An empty group draws nothing, so it has no words. */
export interface InboxNeeds {
  readonly fold_title: string;
  readonly group_label: string;
  readonly head: (p: { count: string | number }) => string;
  readonly no_pin: string;
  readonly pin_label: (p: { num: string | number }) => string;
  readonly today: string;
  readonly unfold_title: string;
  readonly yesterday: string;
}

export const inboxNeeds: InboxNeeds = tables?.inboxNeeds ?? source.inboxNeeds;

/** ui.keymap — the KEYS reference: the group headings and what each binding does. The key labels themselves are not text, because the handlers claim them. */
export interface Keymap {
  readonly does_admin: string;
  readonly does_anchor: string;
  readonly does_base_tubes: string;
  readonly does_card_deploy: string;
  readonly does_card_repair: string;
  readonly does_card_steer_port: string;
  readonly does_card_steer_starboard: string;
  readonly does_card_telegraph_down: string;
  readonly does_card_telegraph_up: string;
  readonly does_casino_bet: string;
  readonly does_casino_call: string;
  readonly does_casino_clear: string;
  readonly does_casino_double: string;
  readonly does_casino_fold: string;
  readonly does_casino_hit: string;
  readonly does_casino_rebet: string;
  readonly does_casino_spin: string;
  readonly does_casino_stand: string;
  readonly does_casino_take_back: string;
  readonly does_defend: string;
  readonly does_depth_look: string;
  readonly does_escape: string;
  readonly does_escort: string;
  readonly does_fire: string;
  readonly does_fluff: string;
  readonly does_gather: string;
  readonly does_group_assign: string;
  readonly does_group_recall: string;
  readonly does_heat: string;
  readonly does_help: string;
  readonly does_hex_borders: string;
  readonly does_hex_fills: string;
  readonly does_hold_fire: string;
  readonly does_hold_round: string;
  readonly does_home: string;
  readonly does_hunt: string;
  readonly does_inbox: string;
  readonly does_kraken: string;
  readonly does_lane: string;
  readonly does_marker: string;
  readonly does_menu_focus: string;
  readonly does_menu_next: string;
  readonly does_menu_prev: string;
  readonly does_move: string;
  readonly does_music: string;
  readonly does_next_fleet: string;
  readonly does_next_round: string;
  readonly does_pan: string;
  readonly does_pan_name: string;
  readonly does_patrol: string;
  readonly does_photo: string;
  readonly does_plot_done: string;
  readonly does_quick: string;
  readonly does_return: string;
  readonly does_row_ends: string;
  readonly does_row_step: string;
  readonly does_scan: string;
  readonly does_screenshake: string;
  readonly does_section_next: string;
  readonly does_section_prev: string;
  readonly does_sections: string;
  readonly does_sonar_visuals: string;
  readonly does_sov_borders: string;
  readonly does_sov_fills: string;
  readonly does_terrain: string;
  readonly group_base: string;
  readonly group_casino: string;
  readonly group_debug: string;
  readonly group_docked: string;
  readonly group_groups: string;
  readonly group_helm: string;
  readonly group_layers: string;
  readonly group_map: string;
  readonly group_menus: string;
  readonly group_orders: string;
  readonly group_view: string;
}

export const keymap: Keymap = tables?.keymap ?? source.keymap;

/** labkit/ — the lab shell the three labs share: the bar, the fold, the parameter row, the legend card, the map chips and the telephone sheet (R1960, lab-shell.md). */
export interface Labkit {
  readonly back_hub: string;
  readonly back_section_title: string;
  readonly back_title: string;
  readonly card_close_title: string;
  readonly changed: (p: { count: number }) => string;
  readonly fold_title: string;
  readonly layer_title: string;
  readonly legend: string;
  readonly legend_hint: string;
  readonly legend_shown: (p: { on: string | number; all: string | number }) => string;
  readonly legend_title: string;
  readonly more: string;
  readonly more_title: string;
  readonly note_less: string;
  readonly note_more: string;
  readonly note_more_title: string;
  readonly off: string;
  readonly on: string;
  readonly reset: string;
  readonly reset_one_title: string;
  readonly reset_title: string;
  readonly sheet_title: string;
  readonly zoom: (p: { pct: string | number }) => string;
  readonly zoom_in_title: string;
  readonly zoom_out_title: string;
}

export const labkit: Labkit = tables?.labkit ?? source.labkit;

/** ui/ladder.ts and arcade/ladderpage.ts — the arcade ladder (arcade.md §18.5, §18.6): the ladder tiers, the ladder mark, the lobby card, the end card block, the LADDER section of the arcade and the RANKS list. */
export interface Ladder {
  readonly card_figures: (p: { rating: string | number; deviation: string | number }) => string;
  readonly card_last: (p: { bound: string | number }) => string;
  readonly card_more: string;
  readonly card_rises: string;
  readonly card_to_next: (p: { n: string | number; name: string | number; bound: string | number }) => string;
  readonly card_unrated: string;
  readonly card_unrated_why: string;
  readonly end_down: (p: { n: string | number }) => string;
  readonly end_fine: string;
  readonly end_head: string;
  readonly end_level: string;
  readonly end_move: (p: { from: string | number; to: string | number }) => string;
  readonly end_private: string;
  readonly end_tier: (p: { name: string | number; n: string | number; total: string | number }) => string;
  readonly end_unrated: string;
  readonly end_up: (p: { n: string | number }) => string;
  readonly guest_line: string;
  readonly guest_register: string;
  readonly last_tier: string;
  readonly lobby_kick: string;
  readonly lobby_open: string;
  readonly lobby_title: string;
  readonly lobby_week: (p: { won: string | number; lost: string | number }) => string;
  readonly next: (p: { name: string | number }) => string;
  readonly outcome_draw: string;
  readonly outcome_lost: string;
  readonly outcome_won: string;
  readonly page_all: string;
  readonly page_loading: string;
  readonly page_own: string;
  readonly page_recent: string;
  readonly page_recent_count: (p: { n: string | number }) => string;
  readonly page_top: string;
  readonly page_you: string;
  readonly ranks_count: (p: { n: number }) => string;
  readonly ranks_empty: string;
  readonly ranks_empty_why: (p: { days: string | number }) => string;
  readonly ranks_more: string;
  readonly ranks_note: string;
  readonly ranks_own: string;
  readonly ranks_pill: string;
  readonly ranks_unplaced: string;
  readonly ranks_you: (p: { name: string | number }) => string;
  readonly row_best: string;
  readonly row_matches: string;
  readonly row_place: string;
  readonly row_won_lost: string;
  readonly sum_guest: string;
  readonly tier_names: readonly string[];
  readonly tier_of: (p: { n: string | number; total: string | number }) => string;
  readonly won_lost: (p: { won: string | number; lost: string | number }) => string;
  readonly won_lost_drawn: (p: { won: string | number; lost: string | number; drawn: string | number }) => string;
}

export const ladder: Ladder = tables?.ladder ?? source.ladder;

/** ui/landing.ts — the landing screen: the two consoles, their readouts, the account rail and the footer. */
export interface Landing {
  readonly brand: string;
  readonly btn_busy: (p: { label: string | number }) => string;
  readonly btn_continue: string;
  readonly btn_forgot: string;
  readonly btn_sign_out: string;
  readonly busy_forgot: string;
  readonly busy_opening_seat: string;
  readonly busy_signing_in: string;
  readonly busy_signing_out: string;
  readonly commanders_at_sea: (p: { count: string | number }) => string;
  readonly console_arcade_blurb: string;
  readonly console_arcade_kicker_open: string;
  readonly console_arcade_kicker_shut: string;
  readonly console_conquest_blurb: (p: { days: string | number }) => string;
  readonly console_conquest_kicker: string;
  readonly cta_continue: string;
  readonly cta_opens_soon: string;
  readonly cta_play_now: string;
  readonly cta_take_a_seat: string;
  readonly err_forgot_no_email: string;
  readonly err_password_mismatch: string;
  readonly fine_print: string;
  readonly foot_links: readonly string[];
  readonly foot_links_short: readonly string[];
  readonly forgot_link_hint: (p: { button: string | number }) => string;
  readonly forgot_sent: string;
  readonly guest_chip: (p: { name: string | number; honour: string | number }) => string;
  readonly hint_first_time: string;
  readonly hint_guest_play: string;
  readonly hint_guest_seat: string;
  readonly maintenance: string;
  readonly oauth_apple: string;
  readonly oauth_google: string;
  readonly oauth_or: string;
  readonly placeholder_email: string;
  readonly placeholder_password: string;
  readonly rail_played_before: string;
  readonly rail_sign_in: string;
  readonly read_account: string;
  readonly read_account_not_needed: string;
  readonly read_categories_open: string;
  readonly read_day_costs: string;
  readonly read_day_costs_value: string;
  readonly read_empires: string;
  readonly read_in_the_water: string;
  readonly read_matches_running: string;
  readonly read_season_ends: string;
  readonly read_worlds_open: string;
  readonly tagline: string;
}

export const landing: Landing = tables?.landing ?? source.landing;

/** ui.live — the two live regions of the game page (R2052): what a screen reader hears beside the notices, the advisor line and a siege warning. */
export interface Live {
  readonly advisor: (p: { line: string | number }) => string;
  readonly more: (p: { n: number }) => string;
  readonly siege: (p: { site: string | number; at: string | number }) => string;
}

export const live: Live = tables?.live ?? source.live;

/** ui.main — the boot module: the map tooltips, the aim read-out, the heatmap notice and the statistics line. */
export interface Main {
  readonly aim_base_round: (p: { round: string | number }) => string;
  readonly aim_dumb_hint: string;
  readonly aim_out_of_reach: (p: { over: string | number }) => string;
  readonly aim_reach: (p: { reach: string | number; range: string | number }) => string;
  readonly aim_seeker_hint: string;
  readonly aim_title: string;
  readonly base_round_default: string;
  readonly base_tubes_ready: (p: { free: number }) => string;
  readonly base_tubes_reloading: (p: { sec: string | number }) => string;
  readonly commit_window_shut: (p: { place: string | number; hour: string | number }) => string;
  readonly deposit_respawn: string;
  readonly first_find: (p: { kind: string | number }) => string;
  readonly fleet_condition: (p: { hull: string | number; shields: string | number }) => string;
  readonly heatmap_off: string;
  readonly heatmap_on: (p: { label: string | number }) => string;
  readonly protocol_mismatch: (p: { server: string | number; client: string | number }) => string;
  readonly ridge_line: string;
  readonly ridge_title: string;
  readonly site_point_defense_ready: string;
  readonly site_your_hold: string;
  readonly stats_offline: (p: { retries: number }) => string;
  readonly stats_render: (p: { fps: string | number; scale: string | number; world: string | number; map: string | number; backend: string | number }) => string;
  readonly stats_wire: (p: { tick: string | number; contacts: string | number; rtt: string | number; kbs: string | number }) => string;
  readonly water_base_cell: string;
  readonly water_beam: (p: { faction: string | number; gauge: string | number }) => string;
  readonly water_current: (p: { n: string | number; brg: string | number }) => string;
  readonly water_current_none: string;
  readonly water_depth: (p: { band: string | number; m: string | number }) => string;
  readonly water_marks: (p: { n: number }) => string;
  readonly water_object_tile: string;
  readonly water_open_sea_title: string;
  readonly water_sovereignty: (p: { faction: string | number }) => string;
  readonly water_spent: string;
  readonly water_territory_title: string;
  readonly water_trench: string;
  readonly water_unclaimed: string;
  readonly water_unsurveyed: string;
}

export const main: Main = tables?.main ?? source.main;

/** ui/maintenance.ts — the full-screen cover a maintenance window draws over the frozen scene (the release manager, deployment.md §6.1). */
export interface Maintenance {
  readonly line_back_at: (p: { time: string | number }) => string;
  readonly line_reloading: string;
  readonly line_running_long: string;
  readonly note_default: string;
  readonly title: string;
}

export const maintenance: Maintenance = tables?.maintenance ?? source.maintenance;

/** ui.markers — the map markers (player-reach.md §2, R1291, R1294): the marker menu, the MARK and REMOVE button of the pinned peek, and the pencil word of the pencil look. */
export interface Markers {
  readonly audience_faction: string;
  readonly audience_hint: string;
  readonly audience_squad: string;
  readonly kind_attack: string;
  readonly kind_danger: string;
  readonly kind_defend: string;
  readonly kind_gather: string;
  readonly mark: string;
  readonly menu_label: string;
  readonly pencil_attack: string;
  readonly pencil_danger: string;
  readonly pencil_defend: string;
  readonly pencil_gather: string;
  readonly remove: string;
}

export const markers: Markers = tables?.markers ?? source.markers;

/** arcade/viewer/card.ts — the match card: the replay page's cover, and the card over a live match until the first picture arrives (R1117). */
export interface MatchCard {
  readonly bot: string;
  readonly captains: (p: { n: number }) => string;
  readonly duration: (p: { clock: string | number }) => string;
  readonly first_picture: string;
  readonly kept_until: (p: { date: string | number }) => string;
  readonly live: (p: { sec: string | number }) => string;
  readonly share: string;
  readonly sound: string;
  readonly title_live: string;
  readonly title_replay: string;
  readonly waiting: string;
  readonly watch: string;
}

export const matchCard: MatchCard = tables?.matchCard ?? source.matchCard;

/** nettest/ — the network check page /nettest: the checks of the path from this device to the game, the verdict, and the result to copy or to send (fault-reports.md §9, R1707). */
export interface Nettest {
  readonly back: string;
  readonly check_arcade_ws: string;
  readonly check_catalog: string;
  readonly check_env: string;
  readonly check_game_ws: string;
  readonly check_idle: (p: { sec: string | number }) => string;
  readonly check_latency: (p: { count: string | number }) => string;
  readonly check_maint: string;
  readonly check_me: string;
  readonly copied: string;
  readonly copy: string;
  readonly copy_failed: string;
  readonly env_app: string;
  readonly env_conn: (p: { type: string | number }) => string;
  readonly env_offline: string;
  readonly env_online: string;
  readonly env_tab: string;
  readonly failed: (p: { reason: string | number }) => string;
  readonly idle_held: (p: { ms: string | number }) => string;
  readonly idle_left: (p: { left: string | number }) => string;
  readonly idle_lost: string;
  readonly idle_recovered: (p: { ms: string | number }) => string;
  readonly idle_skip: string;
  readonly latency: (p: { min: string | number; median: string | number; max: string | number }) => string;
  readonly latency_lost: (p: { lost: string | number; count: string | number }) => string;
  readonly lede: string;
  readonly maint_none: string;
  readonly maint_on: string;
  readonly me_in: (p: { name: string | number }) => string;
  readonly me_out: string;
  readonly ms: (p: { ms: string | number }) => string;
  readonly ms_proto: (p: { ms: string | number; proto: string | number }) => string;
  readonly no_host: string;
  readonly report_text: (p: { verdict: string | number }) => string;
  readonly rerun: string;
  readonly result: string;
  readonly send: string;
  readonly send_failed: (p: { reason: string | number }) => string;
  readonly send_wait: (p: { wait: string | number }) => string;
  readonly sending: string;
  readonly sent: (p: { ref: string | number }) => string;
  readonly signed_out: string;
  readonly state_fail: string;
  readonly state_ok: string;
  readonly state_run: string;
  readonly state_skip: string;
  readonly state_slow: string;
  readonly state_wait: string;
  readonly status: (p: { status: string | number }) => string;
  readonly timeout: (p: { ms: string | number }) => string;
  readonly title: string;
  readonly verdict_host: (p: { ports: string | number }) => string;
  readonly verdict_idle: string;
  readonly verdict_maint: string;
  readonly verdict_offline: string;
  readonly verdict_ok: string;
  readonly verdict_running: string;
  readonly verdict_site: string;
  readonly verdict_slow: string;
  readonly ws_closed: (p: { ms: string | number; code: string | number }) => string;
  readonly ws_failed: (p: { code: string | number }) => string;
  readonly ws_open: (p: { ms: string | number }) => string;
  readonly ws_timeout: (p: { ms: string | number }) => string;
}

export const nettest: Nettest = tables?.nettest ?? source.nettest;

/** ui.notices — the notices column and the timer line, under every notices style of the World theme (ui-map-interface.md §8, R824). */
export interface Notices {
  readonly glyph_error: string;
  readonly glyph_link: string;
  readonly glyph_maintenance: string;
  readonly glyph_note: string;
  readonly glyph_quake: string;
  readonly glyph_seaview: string;
  readonly glyph_truce: string;
  readonly go_tell: string;
  readonly lane_more: (p: { n: number }) => string;
  readonly ribbon_more: (p: { n: number }) => string;
  readonly timer_card_label: string;
  readonly timer_card_short: string;
  readonly timer_card_tail: string;
  readonly timer_floor_shift: string;
  readonly timer_link_label: string;
  readonly timer_link_short: string;
  readonly timer_link_tail: string;
  readonly timer_maintenance_label: string;
  readonly timer_maintenance_sentence: (p: { left: string | number }) => string;
  readonly timer_maintenance_short: string;
  readonly timer_quake_label: string;
  readonly timer_quake_tail: (p: { stage: string | number }) => string;
  readonly timer_seaview_label: string;
  readonly timer_seaview_sentence: (p: { left: string | number }) => string;
  readonly timer_seaview_short: string;
  readonly timer_seaview_tail: string;
  readonly timer_settlement: string;
  readonly timer_truce_label: string;
  readonly timer_truce_short: string;
  readonly timer_truce_tail: string;
  readonly timer_war_economy: string;
}

export const notices: Notices = tables?.notices ?? source.notices;

/** ui.options — the ☸ OPTIONS menu of the game and the kit the hub SETTINGS panel shares (ui-map-interface.md §13, R1731): the seven sections, the QUICK row, the session block, the ACCOUNT page and the words of every shared row. */
export interface Options {
  readonly acc_hub: string;
  readonly acc_hub_aside: string;
  readonly account_none: string;
  readonly alerts_none: string;
  readonly arcade: string;
  readonly arcade_title: string;
  readonly casino_desk_docked: string;
  readonly casino_desk_undocked: string;
  readonly changed_title: string;
  readonly chart_historical: string;
  readonly chart_modern: string;
  readonly chart_off: string;
  readonly chat_desk_docked: string;
  readonly chat_desk_large: string;
  readonly chat_desk_small: string;
  readonly chat_how: string;
  readonly chat_none: string;
  readonly close_title: string;
  readonly dev_current: (p: { build: string | number }) => string;
  readonly esc: string;
  readonly guest_lede: string;
  readonly head_line: (p: { world: string | number; day: string | number }) => string;
  readonly hub_foot: string;
  readonly identity_confirm: string;
  readonly identity_dark: string;
  readonly identity_light: string;
  readonly kind_guest: string;
  readonly kind_registered: string;
  readonly lang_confirm: string;
  readonly lang_go: string;
  readonly lang_no: string;
  readonly leave_days: (p: { n: string | number }) => string;
  readonly leave_hub: string;
  readonly leave_hub_title: string;
  readonly leave_long: string;
  readonly leave_off: string;
  readonly leave_until: (p: { at: string | number }) => string;
  readonly legend_account: string;
  readonly legend_changed: string;
  readonly legend_device: string;
  readonly legend_empire: string;
  readonly legend_nomark: string;
  readonly link_delete: string;
  readonly link_delete_what: string;
  readonly link_hours: string;
  readonly link_hours_what: string;
  readonly link_password: string;
  readonly link_password_what: string;
  readonly link_signin: string;
  readonly link_signin_what: string;
  readonly link_themes: string;
  readonly link_themes_what: string;
  readonly logout: string;
  readonly logout_armed: string;
  readonly logout_armed_what: string;
  readonly logout_what: string;
  readonly me_pickup: string;
  readonly mute_title: (p: { name: string | number }) => string;
  readonly no_audio: string;
  readonly quick: string;
  readonly quick_advisor: string;
  readonly quick_effects: string;
  readonly quick_music: string;
  readonly quick_shake: string;
  readonly register: string;
  readonly register_title: string;
  readonly row_advisor: string;
  readonly row_advisor_what: string;
  readonly row_casino_desk: string;
  readonly row_casino_desk_what: string;
  readonly row_chart: string;
  readonly row_chart_what: string;
  readonly row_chat_count: string;
  readonly row_chat_count_what: string;
  readonly row_chat_desk: string;
  readonly row_chat_desk_what: string;
  readonly row_chat_filter: string;
  readonly row_chat_filter_what: string;
  readonly row_chat_time: string;
  readonly row_chat_time_what: (p: { zone: string | number }) => string;
  readonly row_devstats: string;
  readonly row_devstats_what: string;
  readonly row_fluff: string;
  readonly row_fluff_what: string;
  readonly row_identity: string;
  readonly row_identity_what: string;
  readonly row_inbox_count: string;
  readonly row_inbox_count_what: string;
  readonly row_keys: string;
  readonly row_keys_btn: string;
  readonly row_keys_what: string;
  readonly row_lang: string;
  readonly row_lang_what: string;
  readonly row_leave: string;
  readonly row_leave_what: string;
  readonly row_mark_arcade: string;
  readonly row_mark_arcade_what: string;
  readonly row_mark_core: string;
  readonly row_mark_core_what: string;
  readonly row_mirror: string;
  readonly row_mirror_what: string;
  readonly row_music: string;
  readonly row_music_what: string;
  readonly row_nettest: string;
  readonly row_nettest_btn: string;
  readonly row_nettest_what: string;
  readonly row_photo: string;
  readonly row_photo_btn: string;
  readonly row_photo_what: string;
  readonly row_player: string;
  readonly row_player_btn: string;
  readonly row_player_what: string;
  readonly row_render: string;
  readonly row_render_what: string;
  readonly row_report: string;
  readonly row_report_btn: string;
  readonly row_report_what: string;
  readonly row_scale: string;
  readonly row_scale_what: string;
  readonly row_seaidle: string;
  readonly row_seaidle_min: string;
  readonly row_seaidle_min_what: string;
  readonly row_seaidle_what: string;
  readonly row_sealife: string;
  readonly row_sealife_what: string;
  readonly row_seapower: string;
  readonly row_seapower_what: string;
  readonly row_seaveil: string;
  readonly row_seaveil_what: string;
  readonly row_sfx: string;
  readonly row_sfx_what: string;
  readonly row_shake: string;
  readonly row_shake_what: string;
  readonly row_sheets: string;
  readonly row_sheets_what: string;
  readonly row_sonar: string;
  readonly row_sonar_what: string;
  readonly row_standing: string;
  readonly row_standing_what: string;
  readonly row_tab_dots: string;
  readonly row_tab_dots_what: string;
  readonly row_tabs: string;
  readonly row_tabs_what: string;
  readonly row_takeover: string;
  readonly row_takeover_what: string;
  readonly row_theme: string;
  readonly row_theme_what: string;
  readonly scale_step: (p: { percent: string | number }) => string;
  readonly scope_device: string;
  readonly scope_device_title: string;
  readonly scope_empire: string;
  readonly scope_empire_title: string;
  readonly seaidle_min_fig: (p: { min: string | number }) => string;
  readonly seaidle_min_label: string;
  readonly sec_account: string;
  readonly sec_account_what: string;
  readonly sec_alerts: string;
  readonly sec_alerts_what: string;
  readonly sec_audio: string;
  readonly sec_audio_what: string;
  readonly sec_help: string;
  readonly sec_help_what: string;
  readonly sec_iface: string;
  readonly sec_iface_what: string;
  readonly sec_map: string;
  readonly sec_map_what: string;
  readonly sec_play: string;
  readonly sec_play_what: string;
  readonly sec_seaview: string;
  readonly sec_seaview_what: string;
  readonly sec_social: string;
  readonly sec_social_what: string;
  readonly sections: string;
  readonly session: string;
  readonly sheets_three: string;
  readonly sheets_two: string;
  readonly standing_checking: string;
  readonly standing_long: (p: { hours: string | number }) => string;
  readonly standing_mark: string;
  readonly sum_alerts: string;
  readonly sum_audio: (p: { music: string | number; sfx: string | number }) => string;
  readonly sum_audio_none: string;
  readonly sum_blocked: (p: { count: number }) => string;
  readonly sum_chart_historical: string;
  readonly sum_chart_modern: string;
  readonly sum_chart_off: string;
  readonly sum_chat_count_off: string;
  readonly sum_chat_time_on: (p: { counts: string | number }) => string;
  readonly sum_counts_off: string;
  readonly sum_counts_on: string;
  readonly sum_help: string;
  readonly sum_iface: (p: { theme: string | number; scale: string | number; lang: string | number }) => string;
  readonly sum_inbox_count_off: string;
  readonly sum_map: (p: { chart: string | number; sonar: string | number }) => string;
  readonly sum_no_account: string;
  readonly sum_off: string;
  readonly sum_on: string;
  readonly sum_play: (p: { advisor: string | number }) => string;
  readonly sum_play_standing: (p: { advisor: string | number; standing: string | number }) => string;
  readonly sum_seaview_off: string;
  readonly sum_seaview_on: (p: { min: string | number }) => string;
  readonly sum_social: (p: { counts: string | number; blocked: string | number }) => string;
  readonly tabs_glyph: string;
  readonly tabs_word: string;
  readonly theme_auto: string;
  readonly theme_custom: (p: { code: string | number }) => string;
  readonly theme_custom_none: string;
  readonly theme_next: string;
  readonly theme_prev: string;
  readonly title: string;
  readonly unmute_title: (p: { name: string | number }) => string;
  readonly vol_label: (p: { name: string | number }) => string;
  readonly vol_note: string;
  readonly where_account: string;
  readonly where_alerts: string;
  readonly where_audio: string;
  readonly where_desk: string;
  readonly where_iface: string;
  readonly where_map: string;
  readonly where_phone: string;
  readonly where_play: string;
  readonly where_seaview: string;
  readonly where_social: string;
  readonly where_title: string;
  readonly who_title: string;
  readonly word_na: string;
  readonly word_na_title: string;
  readonly word_off: string;
  readonly word_on: string;
}

export const options: Options = tables?.options ?? source.options;

/** ui.overlay — the DOM chrome: top bar, empire dock, selection panel, cards, chat and notices. */
export interface Overlay {
  readonly admin_advance: string;
  readonly admin_advance_step_title: (p: { step: string | number }) => string;
  readonly admin_advance_title: string;
  readonly admin_autopilot: string;
  readonly admin_caches: string;
  readonly admin_caches_title: string;
  readonly admin_drain_end: string;
  readonly admin_drain_end_title: string;
  readonly admin_fog: string;
  readonly admin_grant: string;
  readonly admin_map_clock: (p: { scale: string | number }) => string;
  readonly admin_map_clock_title: string;
  readonly admin_maxbase: string;
  readonly admin_maxfleet: string;
  readonly admin_maxfleet_title: string;
  readonly admin_reload_wardroom: string;
  readonly admin_reload_wardroom_title: string;
  readonly admin_reseed: string;
  readonly admin_reseed_armed: string;
  readonly admin_reseed_title: string;
  readonly admin_restart: string;
  readonly admin_restart_armed: string;
  readonly admin_roll: string;
  readonly admin_roll_armed: string;
  readonly admin_row_economy: string;
  readonly admin_row_empire: string;
  readonly admin_row_progress: string;
  readonly admin_row_seaquake: string;
  readonly admin_row_server: string;
  readonly admin_row_view: string;
  readonly admin_rush: string;
  readonly admin_saverestart: string;
  readonly admin_scale_title: (p: { n: string | number }) => string;
  readonly admin_stage1: string;
  readonly admin_stage2: string;
  readonly admin_stage3: string;
  readonly admin_sub: string;
  readonly admin_title: string;
  readonly admin_veil: string;
  readonly admin_veil_title: string;
  readonly admin_world_clock: (p: { scale: string | number }) => string;
  readonly admin_world_clock_title: string;
  readonly advance_steps: readonly string[];
  readonly attr_short: readonly string[];
  readonly auc_add_offer: string;
  readonly auc_browse: string;
  readonly auction_head: (p: { count: string | number; credits: string | number }) => string;
  readonly auction_lot: string;
  readonly auction_lot_name: (p: { qty: string | number }) => string;
  readonly auction_lots_head: string;
  readonly auction_no_lots: string;
  readonly auction_no_prints: string;
  readonly auction_nothing_sellable: string;
  readonly auction_print_sub: (p: { types: string | number; inventor: string | number; seller: string | number }) => string;
  readonly auction_prints_head: string;
  readonly auction_sell_iso_head: (p: { held: string | number }) => string;
  readonly auction_sell_print_head: string;
  readonly auction_total_placeholder: string;
  readonly auction_unit: (p: { price: string | number }) => string;
  readonly auction_units_placeholder: string;
  readonly audio_empty: string;
  readonly audio_foot: string;
  readonly audio_next_title: string;
  readonly audio_pause_title: string;
  readonly audio_play_title: string;
  readonly audio_prev_title: string;
  readonly audio_shuffle_title: string;
  readonly audio_stop_title: string;
  readonly audio_title: string;
  readonly audio_tracks: (p: { count: number }) => string;
  readonly bar_dev_title: string;
  readonly bar_home_title: string;
  readonly bar_inbox: string;
  readonly bar_inbox_title: string;
  readonly bar_music: string;
  readonly bar_opts: string;
  readonly bar_opts_title: string;
  readonly bar_pct: (p: { pct: string | number }) => string;
  readonly bar_rank_label: (p: { title: string | number; rank: string | number }) => string;
  readonly bar_rank_label_new: (p: { title: string | number }) => string;
  readonly bar_standing: string;
  readonly bar_standing_title: string;
  readonly bartip_clock_title: string;
  readonly bartip_cores_depth: (p: { depth: string | number; pct: string | number }) => string;
  readonly bartip_cores_does: (p: { work: string | number }) => string;
  readonly bartip_cores_have: (p: { have: string | number }) => string;
  readonly bartip_cores_how: (p: { chances: string | number }) => string;
  readonly bartip_cores_how_plain: string;
  readonly bartip_cores_title: string;
  readonly bartip_full: string;
  readonly bartip_season_resets: (p: { season: string | number; left: string | number }) => string;
  readonly bartip_stored: (p: { have: string | number; cap: string | number }) => string;
  readonly bartip_uncapped: (p: { have: string | number }) => string;
  readonly bartip_world_real: (p: { world: string | number; real: string | number; scale: string | number }) => string;
  readonly beam_fleet: (p: { fleet: string | number; owner: string | number }) => string;
  readonly beam_taking: (p: { from: string | number; pos: string | number }) => string;
  readonly beams_empty: string;
  readonly beams_head: string;
  readonly bj_bust: string;
  readonly bj_dealer_shows: (p: { card: string | number }) => string;
  readonly bj_dealer_soft_17: string;
  readonly bj_double: string;
  readonly bj_hit: string;
  readonly bj_insurance_ask: string;
  readonly bj_insurance_cost: (p: { amount: string | number; pays: string | number }) => string;
  readonly bj_insurance_pays: (p: { pays: string | number }) => string;
  readonly bj_natural: string;
  readonly bj_natural_pays: (p: { num: string | number; den: string | number }) => string;
  readonly bj_no: string;
  readonly bj_shoe: (p: { decks: string | number }) => string;
  readonly bj_shoe_spanish: (p: { decks: string | number }) => string;
  readonly bj_split: string;
  readonly bj_stand: string;
  readonly bj_yes: string;
  readonly bj_you_have: (p: { value: string | number }) => string;
  readonly break_armed: string;
  readonly brief_alloy_rate: string;
  readonly brief_base_cap: string;
  readonly brief_base_tubes: string;
  readonly brief_biomass_rate: string;
  readonly brief_build_slots: string;
  readonly brief_captain_slots: string;
  readonly brief_capture_chance: string;
  readonly brief_capture_range: string;
  readonly brief_combat_cap: string;
  readonly brief_copy_slots: string;
  readonly brief_deployable_cap: string;
  readonly brief_dive_risk: string;
  readonly brief_hospital_hours: string;
  readonly brief_hours: (p: { n: string | number }) => string;
  readonly brief_isotope_lots: string;
  readonly brief_lane_light_cap: string;
  readonly brief_master_slots: string;
  readonly brief_mission_cap: string;
  readonly brief_opens: (p: { what: string | number }) => string;
  readonly brief_opens_base_tubes: string;
  readonly brief_opens_build_slot: (p: { n: string | number }) => string;
  readonly brief_opens_module_slot: (p: { n: string | number }) => string;
  readonly brief_opens_oracle_share: string;
  readonly brief_opens_point_defence: string;
  readonly brief_opens_recv_fleet: string;
  readonly brief_opens_recv_installation: string;
  readonly brief_opens_recv_warship: string;
  readonly brief_opens_share_fleet: string;
  readonly brief_opens_shield_types: string;
  readonly brief_opens_tech_tier: (p: { n: string | number }) => string;
  readonly brief_opens_weapon_types: string;
  readonly brief_palisade_cap: string;
  readonly brief_per_hour: (p: { n: string | number }) => string;
  readonly brief_print_listings: string;
  readonly brief_prison_cells: string;
  readonly brief_px: (p: { n: string | number }) => string;
  readonly brief_queue_speed: string;
  readonly brief_research_speed: string;
  readonly brief_sea_mine_cap: string;
  readonly brief_sea_object_rack: string;
  readonly brief_ship_round_storage: string;
  readonly brief_ship_speed: string;
  readonly brief_sonar_range: string;
  readonly brief_storage_cap: string;
  readonly brief_support_cap: string;
  readonly brief_torpedo_storage: string;
  readonly brief_training_speed: string;
  readonly brief_volatiles_rate: string;
  readonly brig_empty: string;
  readonly brig_head: (p: { n: string | number; cells: string | number }) => string;
  readonly brig_no_prison: string;
  readonly brig_prisoner: (p: { owner: string | number; ransom: string | number }) => string;
  readonly brig_prisoner_held: (p: { owner: string | number; held: string | number; ransom: string | number }) => string;
  readonly btn_aboard: string;
  readonly btn_assign_named: (p: { name: string | number }) => string;
  readonly btn_break: string;
  readonly btn_bring_ashore: string;
  readonly btn_build: string;
  readonly btn_build_batch: (p: { n: string | number }) => string;
  readonly btn_buy: string;
  readonly btn_captain: string;
  readonly btn_commit: string;
  readonly btn_commit_no: string;
  readonly btn_core_cancel: string;
  readonly btn_decrypt: string;
  readonly btn_defend: string;
  readonly btn_delist: string;
  readonly btn_deploy: string;
  readonly btn_done: string;
  readonly btn_install: string;
  readonly btn_list: string;
  readonly btn_load: string;
  readonly btn_load_save: string;
  readonly btn_locked: string;
  readonly btn_max: string;
  readonly btn_order: string;
  readonly btn_pass: (p: { price: string | number }) => string;
  readonly btn_pay: (p: { ransom: string | number }) => string;
  readonly btn_pick_target: string;
  readonly btn_plan_centre: string;
  readonly btn_plan_engage: string;
  readonly btn_plan_flank: string;
  readonly btn_plan_front: string;
  readonly btn_plan_hold: string;
  readonly btn_plan_rear: string;
  readonly btn_recruit: string;
  readonly btn_redraft: string;
  readonly btn_release: string;
  readonly btn_release_price: (p: { price: string | number }) => string;
  readonly btn_rename_cancel: string;
  readonly btn_rename_save: string;
  readonly btn_rename_title: string;
  readonly btn_repair: string;
  readonly btn_report_name: string;
  readonly btn_report_name_title: string;
  readonly btn_scrap: string;
  readonly btn_sell: string;
  readonly btn_send_dive: string;
  readonly btn_send_named: (p: { name: string | number }) => string;
  readonly btn_show: string;
  readonly btn_spend_core: string;
  readonly btn_start_dive: string;
  readonly btn_stow: string;
  readonly bucket_combat: string;
  readonly bucket_head_combat: (p: { w: string | number; cap: string | number }) => string;
  readonly bucket_head_support: (p: { w: string | number; cap: string | number }) => string;
  readonly bucket_support: string;
  readonly cap_back: string;
  readonly cap_back_title: string;
  readonly cap_close: string;
  readonly cap_close_title: string;
  readonly cap_eff_command: (p: { pct: string | number }) => string;
  readonly cap_eff_engineering: (p: { pct: string | number }) => string;
  readonly cap_eff_gunnery: (p: { pct: string | number }) => string;
  readonly cap_eff_helm: (p: { pct: string | number }) => string;
  readonly cap_eff_prospecting: (p: { pct: string | number; cut: string | number }) => string;
  readonly cap_eff_silent: (p: { pct: string | number }) => string;
  readonly cap_inbox: string;
  readonly cap_inbox_title: string;
  readonly cap_menu: string;
  readonly cap_menu_title: string;
  readonly cap_nobody: string;
  readonly cap_practice_command: string;
  readonly cap_practice_engineering: string;
  readonly cap_practice_gunnery: string;
  readonly cap_practice_helm: string;
  readonly cap_practice_prospecting: string;
  readonly cap_practice_silent: string;
  readonly cap_support_none: string;
  readonly capcard_talent_mark: string;
  readonly capcard_why_cadet: string;
  readonly capcard_why_held: string;
  readonly capinfo_backstory: string;
  readonly capinfo_decline: string;
  readonly capinfo_now: string;
  readonly capinfo_peak: (p: { n: number }) => string;
  readonly capinfo_practice: string;
  readonly capinfo_practice_decline: (p: { pct: string | number }) => string;
  readonly capinfo_retire: string;
  readonly capinfo_retire_val: (p: { pct: string | number }) => string;
  readonly capinfo_rise: (p: { n: number }) => string;
  readonly capinfo_sub: string;
  readonly capinfo_sub_cadet: string;
  readonly caprow_aboard: (p: { name: string | number }) => string;
  readonly caprow_age: (p: { age: string | number }) => string;
  readonly caprow_age_career: (p: { age: string | number; career: string | number }) => string;
  readonly caprow_captured: (p: { who: string | number; ransom: string | number }) => string;
  readonly caprow_cell_talent: (p: { attr: string | number; v: string | number }) => string;
  readonly caprow_cell_title: (p: { attr: string | number; v: string | number }) => string;
  readonly caprow_codes_label: (p: { names: string | number }) => string;
  readonly caprow_diving: (p: { dive: string | number; left: string | number }) => string;
  readonly caprow_free: string;
  readonly caprow_legend: string;
  readonly caprow_more_title: (p: { name: string | number }) => string;
  readonly caprow_outfitting: (p: { dive: string | number }) => string;
  readonly caprow_phase_age: (p: { age: string | number; phase: string | number }) => string;
  readonly caprow_practice: (p: { attr: string | number; pct: string | number; n: string | number }) => string;
  readonly caprow_recovering: (p: { left: string | number }) => string;
  readonly caprow_st_ashore: string;
  readonly caprow_st_at_sea: string;
  readonly caprow_st_cadet: string;
  readonly caprow_st_captured: string;
  readonly caprow_st_diving: string;
  readonly caprow_st_docked: string;
  readonly caprow_st_outfitting: string;
  readonly caprow_st_recovering: string;
  readonly caprow_st_training: string;
  readonly caprow_training: (p: { attr: string | number; left: string | number }) => string;
  readonly caprow_training_queued: (p: { attr: string | number }) => string;
  readonly capsum_command: (p: { pct: string | number }) => string;
  readonly capsum_engineering: (p: { pct: string | number }) => string;
  readonly capsum_gunnery: (p: { pct: string | number }) => string;
  readonly capsum_helm: (p: { pct: string | number }) => string;
  readonly capsum_prospecting: (p: { pct: string | number; cut: string | number }) => string;
  readonly capsum_silent: (p: { pct: string | number; max: string | number }) => string;
  readonly captain_ashore: string;
  readonly captain_ashore_hint: string;
  readonly captain_commanding: (p: { id: string | number }) => string;
  readonly captain_expedition: string;
  readonly captain_fleet_title: string;
  readonly captain_in_pens: (p: { name: string | number }) => string;
  readonly captain_outfitting: (p: { dive: string | number }) => string;
  readonly captain_prisoner: (p: { who: string | number; ransom: string | number }) => string;
  readonly captain_recovering: (p: { left: string | number }) => string;
  readonly captrain_at_cap: string;
  readonly captrain_dots: (p: { n: string | number; cap: string | number }) => string;
  readonly captrain_full: string;
  readonly captrain_max: string;
  readonly captrain_off_busy: (p: { attr: string | number }) => string;
  readonly captrain_off_decline: string;
  readonly captrain_off_recovering: (p: { left: string | number }) => string;
  readonly captrain_pct: (p: { pct: string | number }) => string;
  readonly captrain_pick_chip: (p: { short: string | number; v: string | number; next: string | number }) => string;
  readonly captrain_pick_close: string;
  readonly captrain_pick_head: string;
  readonly captrain_pick_max: (p: { short: string | number }) => string;
  readonly captrain_pick_none: string;
  readonly captrain_pick_open: string;
  readonly captrain_pick_press: string;
  readonly captrain_pick_title: string;
  readonly captrain_press_title: (p: { attr: string | number }) => string;
  readonly captrain_queued: (p: { attr: string | number }) => string;
  readonly captrain_row: (p: { short: string | number }) => string;
  readonly captrain_season_full: (p: { cap: string | number }) => string;
  readonly captrain_training: (p: { attr: string | number; left: string | number }) => string;
  readonly captrain_value: (p: { attr: string | number; v: string | number; cap: string | number }) => string;
  readonly capture_from: (p: { who: string | number; pos: string | number; when: string | number }) => string;
  readonly capture_log_empty: string;
  readonly capture_log_head: string;
  readonly capture_took: (p: { faction: string | number }) => string;
  readonly capture_took_fleet: (p: { fleet: string | number; owner: string | number }) => string;
  readonly casino_buy_in: (p: { min: string | number; max: string | number }) => string;
  readonly casino_card_machine: string;
  readonly casino_card_quiet: string;
  readonly casino_card_tables: (p: { tables: string | number; seated: string | number }) => string;
  readonly casino_chips: (p: { amount: string | number }) => string;
  readonly casino_close_title: string;
  readonly casino_club_even: (p: { time: string | number }) => string;
  readonly casino_club_gain: (p: { time: string | number; pct: string | number; room: string | number; amount: string | number; each: string | number }) => string;
  readonly casino_club_loss: (p: { amount: string | number; time: string | number; room: string | number }) => string;
  readonly casino_club_of: (p: { faction: string | number; members: number }) => string;
  readonly casino_club_row_even: (p: { room: string | number }) => string;
  readonly casino_club_row_gain: (p: { pct: string | number; room: string | number }) => string;
  readonly casino_club_row_loss: (p: { room: string | number }) => string;
  readonly casino_delta_down: (p: { amount: string | number }) => string;
  readonly casino_delta_even: string;
  readonly casino_delta_up: (p: { amount: string | number }) => string;
  readonly casino_dock_title: string;
  readonly casino_game_blackjack: string;
  readonly casino_game_holdem: string;
  readonly casino_game_roulette: string;
  readonly casino_game_slots: string;
  readonly casino_hand_settled: string;
  readonly casino_head: string;
  readonly casino_help_k_bet: string;
  readonly casino_help_k_blinds: string;
  readonly casino_help_k_buy_in: string;
  readonly casino_help_k_dealer: string;
  readonly casino_help_k_house: string;
  readonly casino_help_k_insure: string;
  readonly casino_help_k_keys: string;
  readonly casino_help_k_natural: string;
  readonly casino_help_k_payback: string;
  readonly casino_help_k_pull: string;
  readonly casino_help_k_rake: string;
  readonly casino_help_k_rebet: string;
  readonly casino_help_k_shoe: string;
  readonly casino_help_k_take: string;
  readonly casino_help_k_top_up: string;
  readonly casino_help_k_two: string;
  readonly casino_help_key: (p: { key: string | number; name: string | number }) => string;
  readonly casino_house_blackjack: (p: { decks: string | number; pct: string | number }) => string;
  readonly casino_house_holdem: (p: { pct: string | number; cap: string | number }) => string;
  readonly casino_house_of: string;
  readonly casino_house_roulette: (p: { pct: string | number }) => string;
  readonly casino_house_slots: (p: { pct: string | number }) => string;
  readonly casino_join: string;
  readonly casino_leave_machine: string;
  readonly casino_leave_table: string;
  readonly casino_leave_table_armed: string;
  readonly casino_lobby_rules: string;
  readonly casino_min_bet: (p: { amount: string | number }) => string;
  readonly casino_next_spin: (p: { sec: string | number }) => string;
  readonly casino_no_bet: string;
  readonly casino_no_buy_in: string;
  readonly casino_no_table: string;
  readonly casino_open: string;
  readonly casino_open_tables: string;
  readonly casino_pane_away: string;
  readonly casino_pane_idle: string;
  readonly casino_place_bet: string;
  readonly casino_pot: (p: { amount: string | number }) => string;
  readonly casino_price_bet: (p: { min: string | number }) => string;
  readonly casino_price_hand: (p: { min: string | number }) => string;
  readonly casino_price_pull: (p: { min: string | number }) => string;
  readonly casino_queue_fill_in: (p: { sec: string | number }) => string;
  readonly casino_queue_filled: (p: { filled: string | number; seats: string | number }) => string;
  readonly casino_queue_leave: string;
  readonly casino_queue_leave_armed: string;
  readonly casino_queue_wait: string;
  readonly casino_queue_waited: (p: { sec: string | number }) => string;
  readonly casino_queued: string;
  readonly casino_quick_join: string;
  readonly casino_room_bezants: string;
  readonly casino_room_chevronels: string;
  readonly casino_room_frond: string;
  readonly casino_room_gears: string;
  readonly casino_room_other: (p: { faction: string | number }) => string;
  readonly casino_room_title: (p: { room: string | number }) => string;
  readonly casino_room_waves: string;
  readonly casino_roster_label: (p: { parts: string | number }) => string;
  readonly casino_roster_part: (p: { faction: string | number; pct: string | number }) => string;
  readonly casino_seat_folded: string;
  readonly casino_seat_n: (p: { n: string | number }) => string;
  readonly casino_shut: string;
  readonly casino_shut_why: string;
  readonly casino_stake_label: string;
  readonly casino_stake_short: string;
  readonly casino_stakes_back: string;
  readonly casino_stakes_shut: string;
  readonly casino_table_gone: string;
  readonly casino_table_row: (p: { game: string | number; tier: string | number; seated: string | number; seats: string | number }) => string;
  readonly casino_tier_pill: (p: { min: string | number }) => string;
  readonly casino_turn_left: (p: { sec: string | number }) => string;
  readonly casino_undock_title: string;
  readonly casino_visit_net: string;
  readonly casino_wheel_runs: string;
  readonly casino_with_key: (p: { name: string | number; key: string | number }) => string;
  readonly casino_word_down: string;
  readonly casino_word_even: string;
  readonly casino_word_lost: string;
  readonly casino_word_push: string;
  readonly casino_word_up: string;
  readonly casino_word_won: string;
  readonly casino_you_hold: (p: { amount: string | number }) => string;
  readonly casino_you_sit: (p: { id: string | number }) => string;
  readonly casino_your_turn: string;
  readonly centre_map_title: string;
  readonly channels: readonly string[];
  readonly chat_big_title: string;
  readonly chat_close_title: string;
  readonly chat_dock: string;
  readonly chat_dock_title: string;
  readonly chat_empty: string;
  readonly chat_grip_title: string;
  readonly chat_head: string;
  readonly chat_meta_down: string;
  readonly chat_min_title: string;
  readonly chat_missed: (p: { n: number }) => string;
  readonly chat_no_clan: string;
  readonly chat_placeholder: string;
  readonly chat_quick_title: string;
  readonly chat_reconnecting: string;
  readonly chat_report: string;
  readonly chat_send: string;
  readonly chat_show: string;
  readonly chat_small_title: string;
  readonly chat_undock: string;
  readonly chat_undock_title: string;
  readonly chatline_read: (p: { channel: string | number }) => string;
  readonly chatline_title: string;
  readonly chatline_unread: (p: { where: string | number }) => string;
  readonly chatline_wait: string;
  readonly clan_at_sea: string;
  readonly clan_comms: string;
  readonly clan_head: (p: { name: string | number; tag: string | number; squad: string | number }) => string;
  readonly clan_hub_note: string;
  readonly clan_member_comms: (p: { level: string | number }) => string;
  readonly clan_no_bonuses: string;
  readonly clan_none_head: string;
  readonly clan_none_note: (p: { members: string | number; squad_size: string | number; squads: number }) => string;
  readonly clan_online: string;
  readonly clan_reserve: string;
  readonly clan_roster_head: (p: { n: string | number; max: string | number }) => string;
  readonly clan_squad: (p: { n: string | number }) => string;
  readonly clock_rule: (p: { day: string | number }) => string;
  readonly close_title: string;
  readonly com_archive_empty: string;
  readonly com_archive_hide: string;
  readonly com_archive_show: (p: { n: string | number }) => string;
  readonly com_assign: string;
  readonly com_assign_title: (p: { name: string | number }) => string;
  readonly com_board_none: string;
  readonly com_board_refill: (p: { left: string | number }) => string;
  readonly com_card_kind_open: string;
  readonly com_card_kind_pending: string;
  readonly com_card_kind_taken: string;
  readonly com_chip_open: string;
  readonly com_chip_pending: string;
  readonly com_chip_taken: string;
  readonly com_count_resets: (p: { left: string | number }) => string;
  readonly com_day_full: (p: { n: string | number }) => string;
  readonly com_f_band: string;
  readonly com_f_fleet: string;
  readonly com_f_left: string;
  readonly com_f_pays: string;
  readonly com_fit_away: (p: { px: string | number }) => string;
  readonly com_fit_count: (p: { n: string | number; total: string | number }) => string;
  readonly com_fit_head: string;
  readonly com_fleet_gone: string;
  readonly com_head_archive: (p: { n: string | number }) => string;
  readonly com_head_open: (p: { n: string | number }) => string;
  readonly com_head_pending: (p: { n: string | number }) => string;
  readonly com_head_taken: (p: { n: string | number }) => string;
  readonly com_hint: string;
  readonly com_hold_full: (p: { n: string | number }) => string;
  readonly com_info_title: string;
  readonly com_kind_cache: string;
  readonly com_kind_den: string;
  readonly com_kind_other: string;
  readonly com_kind_sound: string;
  readonly com_kind_survey: string;
  readonly com_left: (p: { left: string | number }) => string;
  readonly com_more_unfit: (p: { n: number }) => string;
  readonly com_no_fleet: string;
  readonly com_note: string;
  readonly com_note_taken: (p: { name: string | number }) => string;
  readonly com_open: string;
  readonly com_open_title: string;
  readonly com_paid: string;
  readonly com_paid_line: (p: { fleet: string | number; day: string | number }) => string;
  readonly com_paid_title: string;
  readonly com_pay_practice: (p: { n: string | number }) => string;
  readonly com_pay_round_any: string;
  readonly com_pay_rounds: (p: { n: string | number; name: string | number }) => string;
  readonly com_pay_ship: (p: { name: string | number }) => string;
  readonly com_pay_ship_any: string;
  readonly com_pending: string;
  readonly com_pending_line: (p: { name: string | number }) => string;
  readonly com_pending_short: string;
  readonly com_pending_wait: (p: { name: string | number }) => string;
  readonly com_show: string;
  readonly com_taken: string;
  readonly com_task_cache: string;
  readonly com_task_den: string;
  readonly com_task_sound: string;
  readonly com_task_survey: string;
  readonly com_today: (p: { n: string | number; max: string | number }) => string;
  readonly com_today_full: (p: { n: string | number; max: string | number; left: string | number }) => string;
  readonly com_today_title: (p: { max: string | number }) => string;
  readonly com_unfit_busy: string;
  readonly com_unfit_captain: string;
  readonly com_unfit_gun: string;
  readonly com_unfit_rating: (p: { band: string | number }) => string;
  readonly commit_card_ask: (p: { fleet: string | number; place: string | number }) => string;
  readonly core_card_ask: string;
  readonly deploy_ask: (p: { fleet: string | number }) => string;
  readonly deploy_ask_damaged: (p: { pct: string | number }) => string;
  readonly deploy_ask_no_captain: (p: { fleet: string | number }) => string;
  readonly deploy_ask_repairing: (p: { fleet: string | number }) => string;
  readonly deploy_status_damaged: string;
  readonly deploy_status_repairing: string;
  readonly deposit_names: readonly string[];
  readonly depot_empty: string;
  readonly depot_head_deployables: (p: { n: string | number; cap: string | number }) => string;
  readonly depot_head_mines: (p: { n: string | number; cap: string | number }) => string;
  readonly depot_head_rack: (p: { w: string | number; cap: string | number }) => string;
  readonly depot_held_title: string;
  readonly depot_limit_lane_lights: (p: { l: string | number; lcap: string | number }) => string;
  readonly depot_limit_palisades: (p: { p: string | number; pcap: string | number }) => string;
  readonly depot_line_deployable: (p: { n: string | number }) => string;
  readonly depot_line_mine: (p: { n: string | number }) => string;
  readonly depot_none: string;
  readonly depot_queued_title: string;
  readonly depot_show_title: string;
  readonly dev_branch: (p: { branch: string | number }) => string;
  readonly dev_restart: string;
  readonly dev_title: (p: { build: string | number; branch: string | number; head: string | number }) => string;
  readonly eff_alloy_rate: string;
  readonly eff_base_cap: string;
  readonly eff_base_tubes: string;
  readonly eff_biomass_rate: string;
  readonly eff_build_slots: string;
  readonly eff_captain_slots: string;
  readonly eff_capture_chance: string;
  readonly eff_capture_range: string;
  readonly eff_change: (p: { n: string | number }) => string;
  readonly eff_combat_cap: string;
  readonly eff_copy_slots: string;
  readonly eff_deployable_cap: string;
  readonly eff_dive_risk: string;
  readonly eff_hospital_hours: string;
  readonly eff_isotope_lots: string;
  readonly eff_lane_light_cap: string;
  readonly eff_master_slots: string;
  readonly eff_mission_cap: string;
  readonly eff_mul: (p: { n: string | number }) => string;
  readonly eff_palisade_cap: string;
  readonly eff_pct: (p: { n: string | number }) => string;
  readonly eff_print_listings: string;
  readonly eff_prison_cells: string;
  readonly eff_queue_speed: string;
  readonly eff_research_speed: string;
  readonly eff_sea_mine_cap: string;
  readonly eff_sea_object_rack: string;
  readonly eff_ship_round_storage: string;
  readonly eff_ship_speed: string;
  readonly eff_sonar_range: string;
  readonly eff_step: (p: { now: string | number; next: string | number }) => string;
  readonly eff_storage_cap: string;
  readonly eff_support_cap: string;
  readonly eff_torpedo_storage: string;
  readonly eff_training_speed: string;
  readonly eff_volatiles_rate: string;
  readonly empire_waiting: string;
  readonly exp_cap_line: (p: { risk: string | number; isotopes: string | number }) => string;
  readonly exp_cap_practice: (p: { attr: string | number; fig: string | number }) => string;
  readonly exp_captains: string;
  readonly exp_depth: (p: { depth: string | number }) => string;
  readonly exp_dive_control: (p: { level: string | number }) => string;
  readonly exp_in_queue: string;
  readonly exp_left: (p: { left: string | number }) => string;
  readonly exp_no_control: string;
  readonly exp_nobody: string;
  readonly exp_outfitting: string;
  readonly exp_risk: (p: { injury: string | number }) => string;
  readonly exp_risk_none: string;
  readonly exp_sheet_kind: (p: { depth: string | number; time: string | number; clock: string | number }) => string;
  readonly exp_sheet_note: string;
  readonly exp_slots: (p: { n: string | number; cap: string | number }) => string;
  readonly exp_start: string;
  readonly exp_sum_by_captain: string;
  readonly exp_sum_core: string;
  readonly exp_sum_core_what: string;
  readonly exp_sum_iso_fig: (p: { n: string | number }) => string;
  readonly exp_sum_isotopes: string;
  readonly exp_sum_none: string;
  readonly exp_sum_pct: (p: { pct: string | number }) => string;
  readonly exp_sum_range: (p: { lo: string | number; hi: string | number }) => string;
  readonly exp_sum_risk: string;
  readonly exp_sum_yield: string;
  readonly exp_surfaces: (p: { clock: string | number }) => string;
  readonly exp_underway: string;
  readonly exp_underway_none: string;
  readonly exp_yield: (p: { isotopes: string | number; core: string | number }) => string;
  readonly expedition_and_tech: (p: { tech: string | number }) => string;
  readonly expedition_core_gain: (p: { sooner: string | number }) => string;
  readonly expedition_core_none: string;
  readonly expedition_core_warn: (p: { wasted: string | number; worth: string | number }) => string;
  readonly expedition_core_waste: (p: { wasted: string | number }) => string;
  readonly expedition_needs_rad: (p: { level: string | number }) => string;
  readonly expedition_no_captain: string;
  readonly expedition_outfitting: string;
  readonly expedition_running: (p: { depth: string | number; left: string | number }) => string;
  readonly fatal_protocol_hint: string;
  readonly fatal_protocol_reload_in: (p: { sec: string | number }) => string;
  readonly fatal_protocol_title: string;
  readonly fatal_reload: string;
  readonly fatal_start_over: string;
  readonly fatal_ticket_hint: string;
  readonly fatal_ticket_title: string;
  readonly fit_family_marks: readonly string[];
  readonly fit_grade_fine: string;
  readonly fit_grade_flawed: string;
  readonly fit_grade_perfect: string;
  readonly fit_grade_superb: string;
  readonly fit_module: (p: { family: string | number; tier: string | number; grade: string | number }) => string;
  readonly fit_shield_marks: readonly string[];
  readonly fit_weapon_marks: readonly string[];
  readonly fl_assign_captain: string;
  readonly fl_cargo: (p: { fig: string | number }) => string;
  readonly fl_dock_row_title: (p: { name: string | number }) => string;
  readonly fl_docked: string;
  readonly fl_group_title: (p: { n: string | number }) => string;
  readonly fl_more_title: (p: { name: string | number }) => string;
  readonly fl_quick_repair_title: (p: { cost: string | number; time: string | number }) => string;
  readonly fl_repair_title: (p: { time: string | number }) => string;
  readonly fl_rounds: (p: { fig: string | number }) => string;
  readonly fl_row_title: (p: { name: string | number }) => string;
  readonly fl_start_mission: string;
  readonly fl_tubes: (p: { fig: string | number }) => string;
  readonly fleets_dive: string;
  readonly fleets_empty: string;
  readonly fleets_head: (p: { n: string | number; cap: string | number }) => string;
  readonly fleets_head_combat: (p: { n: string | number }) => string;
  readonly fleets_head_support: (p: { n: string | number }) => string;
  readonly fleets_pledged: string;
  readonly fleets_pledged_at: (p: { place: string | number; window: string | number }) => string;
  readonly grade_fine: string;
  readonly grade_flawed: string;
  readonly grade_perfect: string;
  readonly grade_standard: string;
  readonly grade_superb: string;
  readonly grip_title: string;
  readonly groups_label: string;
  readonly head_build: (p: { build: string | number }) => string;
  readonly head_commits: (p: { n: number }) => string;
  readonly head_dev: string;
  readonly head_hold: string;
  readonly head_inbox: string;
  readonly head_opts: string;
  readonly hint_aim: string;
  readonly hint_aim_base: string;
  readonly hint_aim_base_touch: string;
  readonly hint_aim_touch: string;
  readonly hint_deploy: string;
  readonly hint_deploy_touch: string;
  readonly hint_escort: string;
  readonly hint_escort_touch: string;
  readonly hint_gather: string;
  readonly hint_gather_touch: string;
  readonly hint_gather_vent: string;
  readonly hint_gather_vent_touch: string;
  readonly hint_hunt: string;
  readonly hint_hunt_touch: string;
  readonly hint_move: string;
  readonly hint_move_touch: string;
  readonly hint_patrol: string;
  readonly hint_patrol_touch: string;
  readonly hint_search: string;
  readonly hint_search_touch: string;
  readonly how_age: (p: { min: string | number; max: string | number; years: string | number }) => string;
  readonly how_attr: (p: { rate: string | number; measure: string | number }) => string;
  readonly how_auction_slots: (p: { lots: string | number; prints: string | number }) => string;
  readonly how_brig: string;
  readonly how_cap: (p: { cap: string | number }) => string;
  readonly how_capture: string;
  readonly how_career: (p: { peak: string | number; decline: string | number }) => string;
  readonly how_count: (p: { n: number }) => string;
  readonly how_decline: string;
  readonly how_draft_path: string;
  readonly how_escrow: string;
  readonly how_fleet_path: string;
  readonly how_fleet_slots: string;
  readonly how_go: (p: { where: string | number }) => string;
  readonly how_head: string;
  readonly how_in_decline: (p: { pct: string | number }) => string;
  readonly how_k_age: string;
  readonly how_k_brig: string;
  readonly how_k_cap: string;
  readonly how_k_capture: string;
  readonly how_k_career: string;
  readonly how_k_decline: string;
  readonly how_k_escrow: string;
  readonly how_k_in_decline: string;
  readonly how_k_keystone: string;
  readonly how_k_lot: string;
  readonly how_k_path: string;
  readonly how_k_peak: string;
  readonly how_k_practice: string;
  readonly how_k_print_sale: string;
  readonly how_k_retire: string;
  readonly how_k_roll: string;
  readonly how_k_season_cap: string;
  readonly how_k_sells: string;
  readonly how_k_shelf: string;
  readonly how_k_shipyard: string;
  readonly how_k_slots: string;
  readonly how_k_smoothing: string;
  readonly how_k_squad: string;
  readonly how_k_survey: string;
  readonly how_k_talent: string;
  readonly how_k_training: string;
  readonly how_keystone: string;
  readonly how_lot: (p: { min: string | number; max: string | number }) => string;
  readonly how_peak: (p: { factor: string | number }) => string;
  readonly how_practice: string;
  readonly how_print_sale: string;
  readonly how_retire: (p: { base: string | number; per: string | number }) => string;
  readonly how_roll: (p: { low: string | number; high: string | number }) => string;
  readonly how_season_cap: (p: { cap: string | number; growth: string | number }) => string;
  readonly how_sells: string;
  readonly how_shelf: (p: { hours: string | number }) => string;
  readonly how_shipyard: string;
  readonly how_smoothing: (p: { n: string | number }) => string;
  readonly how_squad: (p: { level: string | number }) => string;
  readonly how_survey: (p: { min: string | number }) => string;
  readonly how_talent: (p: { mul: string | number }) => string;
  readonly how_training: (p: { hours: string | number }) => string;
  readonly info_anchored: string;
  readonly info_anchored_noise: string;
  readonly info_anchored_range: string;
  readonly info_and_takes: string;
  readonly info_beacon_beam: (p: { n: string | number }) => string;
  readonly info_btn_building_title: string;
  readonly info_btn_captain_title: string;
  readonly info_btn_module_title: string;
  readonly info_btn_seaobject_title: string;
  readonly info_btn_ship_title: string;
  readonly info_btn_tech_title: string;
  readonly info_btn_torpedo_title: string;
  readonly info_bucket_of: (p: { used: string | number; cap: string | number }) => string;
  readonly info_bucket_use: (p: { bucket: string | number }) => string;
  readonly info_capped_base: (p: { level: string | number }) => string;
  readonly info_costs: string;
  readonly info_damage: string;
  readonly info_ff_hits_own: string;
  readonly info_ff_spares_own: string;
  readonly info_friendly_fire: string;
  readonly info_from: string;
  readonly info_grade_odds: (p: { low: string | number; high: string | number; pct: string | number; onein: string | number }) => string;
  readonly info_hold: string;
  readonly info_in_the_queue: string;
  readonly info_list_time: string;
  readonly info_magazine: string;
  readonly info_magazine_val: (p: { n: string | number }) => string;
  readonly info_module_build_share: (p: { share: string | number }) => string;
  readonly info_module_draft: string;
  readonly info_module_gate: (p: { code: string | number; tech: string | number }) => string;
  readonly info_module_isotopes: (p: { n: string | number }) => string;
  readonly info_module_sub: string;
  readonly info_module_tier: (p: { tier: string | number }) => string;
  readonly info_module_worth: (p: { pct: string | number }) => string;
  readonly info_needs: string;
  readonly info_next_level_costs: (p: { level: string | number }) => string;
  readonly info_noise_mul_val: (p: { mul: string | number }) => string;
  readonly info_none: string;
  readonly info_opens_at: (p: { level: string | number }) => string;
  readonly info_opens_buildings: string;
  readonly info_opens_hulls: string;
  readonly info_opens_modules: string;
  readonly info_opens_rounds: string;
  readonly info_per_hull: (p: { n: string | number }) => string;
  readonly info_px: (p: { n: string | number }) => string;
  readonly info_queued_more: (p: { n: string | number }) => string;
  readonly info_rack_cap: string;
  readonly info_rate_val: (p: { rate: string | number }) => string;
  readonly info_reach: string;
  readonly info_repair_val: (p: { range: string | number; pct: string | number; every: string | number }) => string;
  readonly info_repairs: string;
  readonly info_research_lab_level: (p: { level: string | number }) => string;
  readonly info_role: string;
  readonly info_round_costs: string;
  readonly info_rounds_held: string;
  readonly info_ship_rack: string;
  readonly info_ship_sub: (p: { bucket: string | number; weight: string | number }) => string;
  readonly info_shipyard_level: (p: { level: string | number }) => string;
  readonly info_shot: string;
  readonly info_so_cargo: string;
  readonly info_so_costs: string;
  readonly info_so_depot: (p: { level: string | number }) => string;
  readonly info_so_hears: string;
  readonly info_so_hears_val: (p: { n: string | number }) => string;
  readonly info_so_held: string;
  readonly info_so_kind: (p: { family: string | number; level: string | number }) => string;
  readonly info_so_length: string;
  readonly info_so_listens: string;
  readonly info_so_rack: string;
  readonly info_so_radius: string;
  readonly info_so_trigger: string;
  readonly info_source_level: (p: { name: string | number; level: string | number }) => string;
  readonly info_speed: string;
  readonly info_speed_val: (p: { n: string | number }) => string;
  readonly info_splash: string;
  readonly info_stows: string;
  readonly info_stows_val: (p: { n: string | number; round: string | number }) => string;
  readonly info_strong_vs: string;
  readonly info_tech_sub: (p: { code: string | number; tier: string | number }) => string;
  readonly info_tender_aura: (p: { range: string | number; pct: string | number }) => string;
  readonly info_tender_restock: (p: { every: string | number }) => string;
  readonly info_weak_vs: string;
  readonly info_your_rate: string;
  readonly install_armed: string;
  readonly intel_centre_title: string;
  readonly intel_empty: string;
  readonly intel_head: string;
  readonly intel_line: (p: { pos: string | number; age: string | number; types: string | number; scanner: string | number }) => string;
  readonly invention_empty: string;
  readonly invention_family_taken: string;
  readonly invention_fit_bonus: (p: { low: string | number; high: string | number }) => string;
  readonly invention_fit_build: string;
  readonly invention_fit_draft: string;
  readonly invention_fit_head: string;
  readonly invention_fit_odds: (p: { pct: string | number; onein: string | number }) => string;
  readonly invention_fit_time: string;
  readonly invention_fit_top: (p: { grade: string | number }) => string;
  readonly invention_head: string;
  readonly invention_hull: string;
  readonly invention_needs_sd: (p: { level: string | number }) => string;
  readonly invention_shield: string;
  readonly invention_slots: (p: { used: string | number; slots: string | number }) => string;
  readonly invention_submit: string;
  readonly invention_unarmed: (p: { hull: string | number }) => string;
  readonly invention_weapon: string;
  readonly keys_fold_count: (p: { n: string | number }) => string;
  readonly keys_foot: string;
  readonly keys_title: string;
  readonly lib_in_use: string;
  readonly lib_more_title: (p: { name: string | number }) => string;
  readonly lib_spent: string;
  readonly line_block: string;
  readonly line_blocked: string;
  readonly line_more: string;
  readonly line_more_title: string;
  readonly line_report: string;
  readonly load_held: (p: { n: string | number }) => string;
  readonly load_kind: (p: { cls: string | number; now: string | number }) => string;
  readonly load_less: (p: { name: string | number }) => string;
  readonly load_max: (p: { name: string | number }) => string;
  readonly load_more: (p: { name: string | number }) => string;
  readonly load_note_auto: string;
  readonly load_note_short: string;
  readonly load_title: (p: { hull: string | number }) => string;
  readonly map_min_title: string;
  readonly mission_attacking: string;
  readonly mission_withdrawing: string;
  readonly module_effects: readonly string[];
  readonly module_graded: (p: { module: string | number; grade: string | number }) => string;
  readonly module_roll: (p: { pct: string | number }) => string;
  readonly module_roll_graded: (p: { pct: string | number; grade: string | number }) => string;
  readonly module_slot: (p: { module: string | number; tier: string | number }) => string;
  readonly module_tiers: readonly string[];
  readonly opens_base_tubes: string;
  readonly opens_build_slot: (p: { n: string | number }) => string;
  readonly opens_module_slot: (p: { n: string | number }) => string;
  readonly opens_oracle_share: string;
  readonly opens_point_defence: string;
  readonly opens_recv_fleet: string;
  readonly opens_recv_installation: string;
  readonly opens_recv_warship: string;
  readonly opens_share_fleet: string;
  readonly opens_shield_types: string;
  readonly opens_tech_tier: (p: { n: string | number }) => string;
  readonly opens_weapon_types: string;
  readonly pens_section_empty: string;
  readonly pens_section_head: string;
  readonly pens_section_head_combat: (p: { w: string | number; cap: string | number }) => string;
  readonly pens_section_head_support: (p: { w: string | number; cap: string | number }) => string;
  readonly pick_free: (p: { n: string | number }) => string;
  readonly pick_kind: (p: { cls: string | number; n: string | number }) => string;
  readonly pick_title: (p: { hull: string | number }) => string;
  readonly poker_all_in: string;
  readonly poker_all_in_armed: string;
  readonly poker_amount: string;
  readonly poker_bet: string;
  readonly poker_blinds: (p: { small: string | number; big: string | number }) => string;
  readonly poker_board: string;
  readonly poker_button: (p: { n: string | number }) => string;
  readonly poker_call: string;
  readonly poker_call_amount: (p: { amount: string | number }) => string;
  readonly poker_check: string;
  readonly poker_fold: string;
  readonly poker_fold_armed: string;
  readonly poker_half_pot: string;
  readonly poker_min: string;
  readonly poker_pot: string;
  readonly poker_raise: string;
  readonly poker_rake: (p: { pct: string | number; cap: string | number }) => string;
  readonly poker_say_low: (p: { sec: number }) => string;
  readonly poker_say_turn: (p: { sec: number }) => string;
  readonly poker_showdown: string;
  readonly poker_timed_out: string;
  readonly poker_top_up: string;
  readonly poker_top_up_to: (p: { amount: string | number }) => string;
  readonly poker_top_up_when: string;
  readonly poker_wait_after: (p: { name: string | number }) => string;
  readonly poker_wait_deal: (p: { sec: string | number }) => string;
  readonly poker_wait_folded: string;
  readonly poker_wait_next: string;
  readonly poker_wait_players: string;
  readonly poker_wait_soon: string;
  readonly poker_wait_turn: (p: { name: string | number; sec: string | number }) => string;
  readonly poker_you_all_in: string;
  readonly poker_your_hand: string;
  readonly prep_auto: string;
  readonly prep_no_captain: string;
  readonly print_btn: (p: { runs: string | number }) => string;
  readonly print_install_title: string;
  readonly print_installed: string;
  readonly print_inventor: (p: { name: string | number }) => string;
  readonly print_master: string;
  readonly print_no_modules: string;
  readonly print_runs: (p: { n: string | number }) => string;
  readonly print_spent: string;
  readonly prints_no_copies: string;
  readonly prints_no_copies_first: string;
  readonly prints_no_masters: string;
  readonly prints_shelf_head: (p: { shelf: string | number; held: string | number; slots: string | number }) => string;
  readonly production_building: string;
  readonly production_charting: string;
  readonly production_full: string;
  readonly production_full_in: (p: { left: string | number }) => string;
  readonly production_gathered: string;
  readonly production_graph_label: (p: { name: string | number }) => string;
  readonly production_graphs_head: string;
  readonly production_head: string;
  readonly production_head_aside: string;
  readonly production_isotopes_src: string;
  readonly production_mined: string;
  readonly production_mint_src: string;
  readonly production_no_income: string;
  readonly production_no_rate: string;
  readonly production_rate: (p: { rate: string | number }) => string;
  readonly quake_rule_1: string;
  readonly quake_rule_1_next: (p: { next: string | number }) => string;
  readonly quake_rule_2: string;
  readonly quake_rule_3: string;
  readonly queue_big_title: string;
  readonly queue_budget: (p: { used: string | number; max: string | number }) => string;
  readonly queue_cancel: string;
  readonly queue_cancel_armed: string;
  readonly queue_cancel_blocked: (p: { job: string | number; succ: string | number }) => string;
  readonly queue_earlier: string;
  readonly queue_head: (p: { active: string | number; slots: string | number; budget: string | number }) => string;
  readonly queue_head_idle: string;
  readonly queue_idle: (p: { mint: string | number }) => string;
  readonly queue_idle_full: (p: { mint: string | number }) => string;
  readonly queue_later: string;
  readonly queue_min_title: string;
  readonly queue_move_blocked: (p: { job: string | number; pred: string | number }) => string;
  readonly queue_restore_title: string;
  readonly queue_rush: (p: { cost: string | number }) => string;
  readonly queue_rush_blocked: (p: { job: string | number; pred: string | number }) => string;
  readonly queue_small_title: string;
  readonly queue_starts_in: (p: { span: string | number }) => string;
  readonly queue_to_bottom: string;
  readonly queue_to_top: string;
  readonly queue_waiting: string;
  readonly queue_waits_for: (p: { job: string | number }) => string;
  readonly rate_per_hour: (p: { rate: string | number }) => string;
  readonly recruitment_empty: string;
  readonly recruitment_head: string;
  readonly recruitment_next_offer: (p: { left: string | number }) => string;
  readonly redraft_title: string;
  readonly refuse_module_gate: (p: { family: string | number; tier: string | number; code: string | number; tech: string | number }) => string;
  readonly refuse_module_slots: (p: { slots: number }) => string;
  readonly refuse_no_price: string;
  readonly refuse_no_qty_price: string;
  readonly release_armed: string;
  readonly rename_head: (p: { name: string | number }) => string;
  readonly rename_hint: (p: { prefix: string | number; min: string | number; max: string | number }) => string;
  readonly report_head_cache_note: string;
  readonly report_head_commander: (p: { name: string | number }) => string;
  readonly report_head_fleet: (p: { name: string | number }) => string;
  readonly report_head_line: (p: { name: string | number }) => string;
  readonly report_head_seamount: (p: { name: string | number }) => string;
  readonly res_credits: string;
  readonly role_artillery: string;
  readonly role_brawler: string;
  readonly role_command: string;
  readonly role_skirmish: string;
  readonly role_support: string;
  readonly role_torpedo: string;
  readonly role_tower: string;
  readonly roles_artillery: string;
  readonly roles_brawler: string;
  readonly roles_command: string;
  readonly roles_skirmish: string;
  readonly roles_support: string;
  readonly roles_torpedo: string;
  readonly roles_tower: string;
  readonly roulette_ball_on: (p: { number: string | number }) => string;
  readonly roulette_bets_shut: string;
  readonly roulette_black: string;
  readonly roulette_clear: string;
  readonly roulette_clear_armed: string;
  readonly roulette_column: string;
  readonly roulette_corner: string;
  readonly roulette_double_zero: string;
  readonly roulette_dozen: string;
  readonly roulette_even: string;
  readonly roulette_help_bet: string;
  readonly roulette_help_rebet: string;
  readonly roulette_help_take: string;
  readonly roulette_help_two: string;
  readonly roulette_high: string;
  readonly roulette_last: string;
  readonly roulette_line: string;
  readonly roulette_low: string;
  readonly roulette_no_bet: string;
  readonly roulette_not_adjacent: string;
  readonly roulette_odd: string;
  readonly roulette_pays: (p: { pays: string | number }) => string;
  readonly roulette_pick_second: (p: { number: string | number }) => string;
  readonly roulette_place_bet: string;
  readonly roulette_rebet: string;
  readonly roulette_red: string;
  readonly roulette_split: string;
  readonly roulette_straight: string;
  readonly roulette_street: string;
  readonly roulette_take_back: string;
  readonly roulette_two_corner: string;
  readonly roulette_two_line: string;
  readonly roulette_two_split: string;
  readonly roulette_wheel_runs: string;
  readonly roulette_your_bets: (p: { amount: string | number }) => string;
  readonly roulette_zero: string;
  readonly routes_delete: string;
  readonly routes_delete_armed: string;
  readonly routes_delete_title: string;
  readonly routes_empty: string;
  readonly routes_head: (p: { n: string | number }) => string;
  readonly routes_hint_none: string;
  readonly routes_hint_send: (p: { name: string | number }) => string;
  readonly routes_lane: string;
  readonly routes_lane_by: (p: { name: string | number }) => string;
  readonly routes_lane_full: (p: { n: string | number }) => string;
  readonly routes_lane_mark: string;
  readonly routes_lane_off_title: string;
  readonly routes_lane_on_title: string;
  readonly routes_lane_quiet: string;
  readonly routes_lane_ridge: string;
  readonly routes_lane_short: (p: { n: string | number }) => string;
  readonly routes_lanes_head: (p: { n: string | number }) => string;
  readonly routes_lanes_hint: string;
  readonly routes_legs: (p: { n: string | number }) => string;
  readonly routes_loops: (p: { n: string | number }) => string;
  readonly routes_px: (p: { px: string | number }) => string;
  readonly routes_rename: string;
  readonly routes_road_head: (p: { road: string | number; who: string | number }) => string;
  readonly routes_send: string;
  readonly routes_send_none: string;
  readonly routes_send_title: (p: { name: string | number }) => string;
  readonly routes_view: string;
  readonly routes_view_title: string;
  readonly row_held: (p: { n: string | number }) => string;
  readonly row_held_title: string;
  readonly row_lvl: (p: { level: string | number }) => string;
  readonly row_lvl_label: (p: { level: string | number }) => string;
  readonly row_lvl_queued_label: (p: { level: string | number; n: string | number }) => string;
  readonly row_queued: (p: { n: string | number }) => string;
  readonly row_short_in: (p: { wait: string | number }) => string;
  readonly scrap_armed: string;
  readonly seaobject_uses: readonly string[];
  readonly shelf_copies: string;
  readonly shelf_masters: string;
  readonly short_needs: (p: { missing: string | number }) => string;
  readonly short_needs_wait: (p: { missing: string | number; wait: string | number }) => string;
  readonly shot_every: (p: { dmg: string | number; sec: string | number }) => string;
  readonly site_kinds: readonly string[];
  readonly slot_empty: string;
  readonly slot_empty_key: (p: { key: string | number }) => string;
  readonly slot_empty_title: (p: { n: string | number; key: string | number }) => string;
  readonly slot_replaced: (p: { name: string | number; n: string | number; left: string | number }) => string;
  readonly slot_set: (p: { name: string | number; n: string | number }) => string;
  readonly slot_sig_docked: (p: { order: string | number }) => string;
  readonly slot_sig_none: (p: { name: string | number }) => string;
  readonly slot_sig_state: (p: { order: string | number; state: string | number }) => string;
  readonly slot_tip: string;
  readonly slot_title: (p: { name: string | number }) => string;
  readonly slot_undo: string;
  readonly slots_help_pull: string;
  readonly slots_line_pays: (p: { pays: string | number }) => string;
  readonly slots_no_line: string;
  readonly slots_pulls: (p: { count: number }) => string;
  readonly slots_reels_run: string;
  readonly slots_rtp: (p: { pct: string | number }) => string;
  readonly slots_spin: string;
  readonly slots_sym_anchor: string;
  readonly slots_sym_any: string;
  readonly slots_sym_blank: string;
  readonly slots_sym_kraken: string;
  readonly slots_sym_pearl: string;
  readonly slots_sym_shell: string;
  readonly slots_sym_trident: string;
  readonly slots_three_pay: (p: { symbol: string | number; pays: string | number }) => string;
  readonly sov_charting: string;
  readonly sov_head: string;
  readonly sov_legend_count: (p: { count: string | number; pct: string | number }) => string;
  readonly sov_line_building: string;
  readonly sov_line_label: string;
  readonly sov_no_samples: string;
  readonly sov_pie_label: string;
  readonly sov_series_head: string;
  readonly sov_slice_title: (p: { name: string | number; count: string | number; pct: string | number }) => string;
  readonly standings_flag_key: string;
  readonly standings_held: string;
  readonly standings_history: string;
  readonly standings_history_placeholder: string;
  readonly standings_no_captures: string;
  readonly standings_resets: (p: { left: string | number }) => string;
  readonly standings_row_sub: (p: { cells: string | number; kills: string | number; sieges: string | number }) => string;
  readonly standings_seaquake: string;
  readonly standings_season: (p: { season: string | number }) => string;
  readonly standings_taken: string;
  readonly standings_top_commanders: string;
  readonly standings_top_squads: string;
  readonly standings_who: string;
  readonly standings_you: string;
  readonly standings_you_line: (p: { rank: string | number; score: string | number; title: string | number }) => string;
  readonly standings_you_title: string;
  readonly stow_held: (p: { n: string | number }) => string;
  readonly stow_less: (p: { name: string | number }) => string;
  readonly stow_line_item: (p: { name: string | number; n: string | number }) => string;
  readonly stow_max: (p: { name: string | number }) => string;
  readonly stow_more: (p: { name: string | number }) => string;
  readonly stow_note_auto: string;
  readonly stow_note_full: string;
  readonly stow_note_no_depot: string;
  readonly stow_note_short: string;
  readonly stow_title: (p: { hull: string | number }) => string;
  readonly stow_weight: (p: { n: string | number }) => string;
  readonly structures_attacked: (p: { who: string | number }) => string;
  readonly structures_contested_head: string;
  readonly structures_empty: string;
  readonly structures_enemy_pledged: string;
  readonly structures_enemy_short: string;
  readonly structures_head: string;
  readonly structures_held_by: (p: { who: string | number }) => string;
  readonly structures_own_pledges: (p: { own: string | number }) => string;
  readonly structures_plan_head: (p: { fleet: string | number }) => string;
  readonly structures_pledged_short: (p: { own: string | number }) => string;
  readonly structures_win_hour: (p: { hour: string | number }) => string;
  readonly structures_win_in: (p: { left: string | number }) => string;
  readonly structures_win_left: (p: { left: string | number }) => string;
  readonly structures_win_open: string;
  readonly structures_window: (p: { hour: string | number; left: string | number }) => string;
  readonly structures_window_open: string;
  readonly structures_your_pledge: string;
  readonly structures_your_short: string;
  readonly structures_yours: string;
  readonly sub_auction: string;
  readonly sub_base: string;
  readonly sub_casino: string;
  readonly sub_commissions: string;
  readonly sub_depot: string;
  readonly sub_expeditions: string;
  readonly sub_intel: string;
  readonly sub_invention: string;
  readonly sub_masters: string;
  readonly sub_missions: string;
  readonly sub_prints: string;
  readonly sub_prison: string;
  readonly sub_production: string;
  readonly sub_recruitment: string;
  readonly sub_reports: string;
  readonly sub_routes: string;
  readonly sub_shipyard: string;
  readonly sub_sovereignty: string;
  readonly sub_structures: string;
  readonly sub_tech: string;
  readonly sub_torpedo: string;
  readonly sub_treasure: string;
  readonly sub_wardroom: string;
  readonly tab_build: string;
  readonly tab_captain: string;
  readonly tab_draft: string;
  readonly tab_economy: string;
  readonly tab_fleet: string;
  readonly tab_installations: string;
  readonly tab_short_build: string;
  readonly tab_short_captain: string;
  readonly tab_short_draft: string;
  readonly tab_short_economy: string;
  readonly tab_short_fleet: string;
  readonly tab_short_war: string;
  readonly tab_waits_said: (p: { name: string | number }) => string;
  readonly tab_war: string;
  readonly tech_decrypting: string;
  readonly tech_keys_held: (p: { code: string | number }) => string;
  readonly tech_keys_note: string;
  readonly tech_keys_one: string;
  readonly tech_keys_open: (p: { n: string | number }) => string;
  readonly tech_keys_queued: (p: { code: string | number }) => string;
  readonly tech_keystone_held: string;
  readonly tech_keystone_taken: string;
  readonly tech_keystones: string;
  readonly tech_needs_lab: (p: { level: string | number }) => string;
  readonly tech_next_head: string;
  readonly tech_next_lab_build: string;
  readonly tech_next_lab_raise: (p: { level: string | number; name: string | number }) => string;
  readonly tech_next_wait: string;
  readonly tech_recovered: string;
  readonly tech_requires: (p: { codes: string | number }) => string;
  readonly torpedo_head_hold: (p: { cap: string | number }) => string;
  readonly torpedo_head_ship: (p: { w: string | number; cap: string | number }) => string;
  readonly torpedo_use: (p: { firers: string | number; use: string | number }) => string;
  readonly trs_caches_empty: string;
  readonly trs_found_empty: string;
  readonly trs_found_hide: string;
  readonly trs_found_show: (p: { n: string | number }) => string;
  readonly trs_fragment_name: (p: { den: string | number }) => string;
  readonly trs_fragment_points: (p: { cell: string | number }) => string;
  readonly trs_fragment_taken: string;
  readonly trs_fragments_empty: string;
  readonly trs_head_caches: (p: { n: string | number }) => string;
  readonly trs_head_found: (p: { n: string | number }) => string;
  readonly trs_head_fragments: (p: { n: string | number }) => string;
  readonly trs_head_wrecks: (p: { n: string | number }) => string;
  readonly trs_hint: string;
  readonly trs_search: string;
  readonly trs_search_title: string;
  readonly trs_view: string;
  readonly trs_view_title: string;
  readonly trs_wreck_cells: (p: { n: number }) => string;
  readonly trs_wrecks_empty: string;
  readonly truce: (p: { left: string | number }) => string;
  readonly truce_first: (p: { left: string | number }) => string;
  readonly truce_tab: (p: { left: string | number }) => string;
  readonly wardroom_academy: (p: { level: string | number }) => string;
  readonly wardroom_empty: string;
  readonly wardroom_head: (p: { n: string | number; cap: string | number }) => string;
  readonly warlog_collapse: string;
  readonly warlog_expand: (p: { n: string | number }) => string;
  readonly why_depot_rack_full: string;
  readonly why_needs_banks: string;
  readonly why_needs_base: (p: { level: string | number }) => string;
  readonly why_needs_depot: (p: { level: string | number }) => string;
  readonly why_needs_foundations: string;
  readonly why_needs_shipyard: (p: { level: string | number }) => string;
  readonly why_needs_tech: (p: { tech: string | number }) => string;
  readonly why_rack_full: string;
  readonly word_a_doctrine: string;
  readonly word_auto: string;
  readonly word_beacon: string;
  readonly word_certification: string;
  readonly word_doctrine: string;
  readonly word_hold: string;
  readonly word_off: string;
  readonly word_on: string;
  readonly word_open_sea: string;
  readonly word_open_water: string;
  readonly word_tech: string;
  readonly word_torpedobanks: string;
  readonly word_unclaimed: string;
  readonly yard_autorebuild: string;
  readonly yard_autorebuild_what: string;
  readonly yard_cap: (p: { n: string | number }) => string;
  readonly yard_empty: string;
  readonly yard_head: string;
  readonly yard_print: (p: { runs: string | number; fit: string | number }) => string;
  readonly yard_spent: string;
  readonly yard_weight: (p: { weight: string | number }) => string;
}

export const overlay: Overlay = tables?.overlay ?? source.overlay;

/** ui/photomode.ts — photo mode: the slim bar, the zoom past the game's range, the mark and the save of a PNG (ui-map-interface.md §13.1, R1623). */
export interface Photo {
  readonly brand: string;
  readonly grid: string;
  readonly grid_title: string;
  readonly hint: string;
  readonly leave: string;
  readonly leave_title: string;
  readonly mark: string;
  readonly mark_line: (p: { world: string | number; season: string | number; day: string | number }) => string;
  readonly mark_title: string;
  readonly save: string;
  readonly save_failed: string;
  readonly saved: string;
  readonly zoom: string;
  readonly zoom_value: (p: { zoom: string | number }) => string;
}

export const photo: Photo = tables?.photo ?? source.photo;

/** ui.quickwheel — the quick lines (ui-map-interface.md §8 "Quick chat", R1607): the twelve lines, the words of the quick wheel, and the position pill of a quick line in the chat log. */
export interface Quickchat {
  readonly faction: string;
  readonly line_attack: string;
  readonly line_coming: string;
  readonly line_defend: string;
  readonly line_enemy: string;
  readonly line_help: string;
  readonly line_no: string;
  readonly line_regroup: string;
  readonly line_siege: string;
  readonly line_wait: string;
  readonly line_well_done: string;
  readonly line_withdraw: string;
  readonly line_yes: string;
  readonly needs_attack: string;
  readonly needs_coming: string;
  readonly needs_defend: string;
  readonly needs_enemy: string;
  readonly needs_help: string;
  readonly needs_regroup: string;
  readonly needs_siege: string;
  readonly needs_withdraw: string;
  readonly pos_cell: (p: { pos: string | number }) => string;
  readonly pos_name: (p: { name: string | number }) => string;
  readonly pos_siege: (p: { hour: string | number; name: string | number }) => string;
  readonly pos_title: string;
  readonly squad: string;
  readonly wheel_label: string;
  readonly word_attack: string;
  readonly word_coming: string;
  readonly word_defend: string;
  readonly word_enemy: string;
  readonly word_help: string;
  readonly word_no: string;
  readonly word_regroup: string;
  readonly word_siege: string;
  readonly word_wait: string;
  readonly word_well_done: string;
  readonly word_withdraw: string;
  readonly word_yes: string;
}

export const quickchat: Quickchat = tables?.quickchat ?? source.quickchat;

/** ui.relaymark — the → DISCORD mark of the clan chat while the chat relay of the clan is on: the CLAN CHAT card of the hub and the CLAN tab of the game chat (player-reach.md §3.10, R1641). */
export interface RelayMark {
  readonly line: string;
  readonly mark: string;
  readonly title: string;
}

export const relayMark: RelayMark = tables?.relayMark ?? source.relayMark;

/** ui.replay — the chrome of the replay film: its tag, its clock, its loop counter, its transport and its damage report. */
export interface Replay {
  readonly clock: (p: { at: string | number; total: string | number; rate: string | number }) => string;
  readonly col_commander: string;
  readonly col_damage: string;
  readonly col_faction: string;
  readonly col_hits: string;
  readonly col_hull: string;
  readonly col_kind: string;
  readonly col_shield: string;
  readonly col_source: string;
  readonly col_time: string;
  readonly exit_title: string;
  readonly film_tag: string;
  readonly loop_label: (p: { n: string | number }) => string;
  readonly monster: string;
  readonly nobody: string;
  readonly pause_title: string;
  readonly play_title: string;
  readonly report_label: string;
  readonly report_title: string;
  readonly report_toggle_title: string;
  readonly restart_in: (p: { n: string | number }) => string;
  readonly restart_title: string;
  readonly scrub_title: string;
  readonly span: (p: { from: string | number; to: string | number }) => string;
  readonly stop_title: string;
}

export const replay: Replay = tables?.replay ?? source.replay;

/** replay/main.ts — the standalone replay page: the cover a share link opens, before the viewer mounts. */
export interface ReplayPage {
  readonly failed: string;
  readonly gone: string;
  readonly loading: string;
  readonly no_code: string;
  readonly play_arcade: string;
  readonly title: string;
  readonly way_in: string;
}

export const replayPage: ReplayPage = tables?.replayPage ?? source.replayPage;

/** ui/reportsheet.ts — the REPORT sheet: a problem a player reports from the game, and the answer of the meta server (fault-reports.md §4.4, R1626). */
export interface ReportSheet {
  readonly always: string;
  readonly always_sub: (p: { account: string | number; build: string | number; browser: string | number }) => string;
  readonly always_sub_guest: (p: { account: string | number; build: string | number; browser: string | number }) => string;
  readonly cancel: string;
  readonly carries: string;
  readonly close: string;
  readonly close_title: string;
  readonly copied: string;
  readonly copy_ref: string;
  readonly count: (p: { count: string | number; max: string | number }) => string;
  readonly fine: string;
  readonly fleets: string;
  readonly fleets_none: string;
  readonly happened: string;
  readonly happened_hint: string;
  readonly kind: string;
  readonly lede: string;
  readonly limit_device: (p: { wait: string | number }) => string;
  readonly limit_head: string;
  readonly limit_server: (p: { wait: string | number }) => string;
  readonly log: string;
  readonly log_sub: (p: { lines: string | number; size: string | number }) => string;
  readonly nettest_line: string;
  readonly nettest_link: string;
  readonly outbox_sent: (p: { ref: string | number }) => string;
  readonly pick_kind: string;
  readonly refused: (p: { reason: string | number }) => string;
  readonly send: string;
  readonly send_wait: (p: { wait: string | number }) => string;
  readonly sending: string;
  readonly sent_body: string;
  readonly sent_fleets: (p: { count: number }) => string;
  readonly sent_head: string;
  readonly sent_with: (p: { list: string | number }) => string;
  readonly shot: string;
  readonly shot_none: string;
  readonly shot_sub: string;
  readonly size_kb: (p: { kb: string | number }) => string;
  readonly tick: string;
  readonly tick_sub: (p: { world: string | number; tick: string | number; day: string | number; clock: string | number }) => string;
  readonly title: string;
  readonly topic_balance: string;
  readonly topic_bug: string;
  readonly topic_connection: string;
  readonly topic_controls: string;
  readonly topic_display: string;
  readonly topic_other: string;
  readonly wait_body: string;
  readonly wait_head: string;
}

export const reportSheet: ReportSheet = tables?.reportSheet ?? source.reportSheet;

/** render/seamine-marks.ts, render/deployable-marks.ts and render/sapper-work-looks.ts — the words the marks of the Sapper part write on the map: the area of a field of sea mines, the radius figure of the blueprint look and the words of the work looks (v2-the-deep.md §11.8, R2652). */
export interface Seamarks {
  readonly area_enemy_mines: string;
  readonly area_hostile_sea_mines: string;
  readonly area_mined: string;
  readonly area_sea_mines: string;
  readonly heard: string;
  readonly hostile: string;
  readonly light_char: string;
  readonly light_char_historical: string;
  readonly mul: (p: { mul: string | number }) => string;
  readonly no_room: string;
  readonly of_cap: (p: { cap: string | number }) => string;
  readonly plus: (p: { n: string | number }) => string;
  readonly quiet_take: (p: { n: string | number; stow: string | number; cap: string | number }) => string;
  readonly radius: (p: { r: string | number }) => string;
  readonly tally: (p: { rank: string | number; cargo: string | number }) => string;
}

export const seamarks: Seamarks = tables?.seamarks ?? source.seamarks;

/** the word list of a seamount name, which the naming sheet offers and the hub checks */
export interface SeamountName {
  readonly first: readonly string[];
  readonly pattern: (p: { first: string | number; second: string | number }) => string;
  readonly second: readonly string[];
}

export const seamountName: SeamountName = tables?.seamountName ?? source.seamountName;

/** ui/seasonsummary.ts — the season summary card: the card that closes a season, from the lock of the scores to the roll (ui-map-interface.md §3.4, R1518). */
export interface SeasonSummary {
  readonly ach_loading: string;
  readonly ach_more: (p: { n: string | number }) => string;
  readonly ach_no_record: string;
  readonly ach_none: string;
  readonly all_zero: string;
  readonly banner_house: string;
  readonly banner_seats: (p: { seats: number }) => string;
  readonly btn_chronicle: string;
  readonly btn_chronicle_after_roll: string;
  readonly btn_close: string;
  readonly btn_menu: string;
  readonly btn_open: string;
  readonly captains_lost: (p: { n: number }) => string;
  readonly carry_asking: string;
  readonly carry_captains: (p: { n: string | number }) => string;
  readonly carry_clan_honour: string;
  readonly carry_honour: string;
  readonly carry_honour_total: (p: { total: string | number }) => string;
  readonly carry_lost_none: string;
  readonly carry_more: (p: { n: string | number }) => string;
  readonly carry_no_captain: string;
  readonly carry_risk: (p: { pct: string | number }) => string;
  readonly compare: readonly string[];
  readonly held_line: string;
  readonly honour_value: (p: { honour: string | number }) => string;
  readonly kick: (p: { mode: string | number; world: string | number }) => string;
  readonly mode_clanwar: string;
  readonly mode_core: string;
  readonly mode_custom: string;
  readonly mode_event: string;
  readonly next_in: (p: { left: string | number }) => string;
  readonly next_now: string;
  readonly ordinal: readonly string[];
  readonly place: (p: { rank: string | number; of: string | number }) => string;
  readonly place_clan: string;
  readonly place_faction: string;
  readonly place_you: string;
  readonly road_builder: (p: { name: string | number; h: string | number }) => string;
  readonly row_you: string;
  readonly score_by_source: string;
  readonly second: string;
  readonly section_achievements: string;
  readonly section_banners: string;
  readonly section_carry: string;
  readonly section_place: string;
  readonly section_top: (p: { rows: string | number }) => string;
  readonly section_you: string;
  readonly share: (p: { share: string | number }) => string;
  readonly share_pct: (p: { pct: string | number }) => string;
  readonly share_second: (p: { share: string | number }) => string;
  readonly sources: readonly string[];
  readonly stat_buildings: string;
  readonly stat_cells: string;
  readonly stat_expeditions: string;
  readonly stat_fleets_lost: string;
  readonly stat_gathered: string;
  readonly stat_kills: string;
  readonly stat_prisoners: string;
  readonly stat_sieges_lost: string;
  readonly stat_sieges_won: string;
  readonly stat_tech: string;
  readonly stat_throne: string;
  readonly stat_trades: string;
  readonly vs: string;
  readonly winner: string;
  readonly winner_clan: (p: { name: string | number }) => string;
  readonly winner_faction: (p: { name: string | number }) => string;
  readonly you_unranked: string;
  readonly you_won: string;
}

export const seasonSummary: SeasonSummary = tables?.seasonSummary ?? source.seasonSummary;

/** ui/settlement.ts — the drain banner: the band on the map while the drain of the settlement takes the board, with the clock to the season summary card (ui-map-interface.md §3.4.1, R2094). */
export interface Settlement {
  readonly kick: string;
  readonly line: (p: { left: string | number }) => string;
}

export const settlement: Settlement = tables?.settlement ?? source.settlement;

/** ui/share.ts — what the share helper says after it copied a link or handed one to the system share sheet. */
export interface Share {
  readonly copied_code: string;
  readonly copied_link: string;
  readonly copy_failed: string;
  readonly shared: string;
}

export const share: Share = tables?.share ?? source.share;

/** ui/siegewindow.ts — the siege window on the game screen: the window head of WAR, the window timer of the time cell, the squad readiness and RALLY (ui-map-interface.md §8 and §12.1, the game critique of 2026-10-14). */
export interface Siege {
  readonly alarm_what_open: (p: { target: string | number; at: string | number }) => string;
  readonly alarm_what_shut: (p: { target: string | number; at: string | number }) => string;
  readonly featured_tag: string;
  readonly featured_title: string;
  readonly foes_none: string;
  readonly foes_pledged: string;
  readonly foes_seen: (p: { n: string | number }) => string;
  readonly glyph: string;
  readonly head_label: string;
  readonly in: string;
  readonly in_set: string;
  readonly in_title: string;
  readonly none_mine: string;
  readonly none_set: string;
  readonly out_title: string;
  readonly own_near: (p: { n: string | number }) => string;
  readonly own_pledged: (p: { n: string | number }) => string;
  readonly rally: string;
  readonly rally_notice: (p: { target: string | number }) => string;
  readonly rally_sent: string;
  readonly rally_title: string;
  readonly ready_in: (p: { state: string | number }) => string;
  readonly ready_near: string;
  readonly ready_offline: string;
  readonly ready_online: string;
  readonly ready_reserve: string;
  readonly ready_sea: string;
  readonly ready_you: (p: { state: string | number }) => string;
  readonly role_attack: string;
  readonly role_defend: string;
  readonly role_free: string;
  readonly role_held: (p: { faction: string | number }) => string;
  readonly role_near: string;
  readonly show: string;
  readonly show_title: string;
  readonly side_foes: string;
  readonly side_own: string;
  readonly squad_in: (p: { n: string | number }) => string;
  readonly squad_none: string;
  readonly squad_window: (p: { at: string | number; target: string | number }) => string;
  readonly squad_window_open: (p: { at: string | number; target: string | number }) => string;
  readonly target: (p: { kind: string | number; site: string | number }) => string;
  readonly timer_label: string;
  readonly timer_sentence_open: (p: { target: string | number; at: string | number; left: string | number }) => string;
  readonly timer_sentence_shut: (p: { target: string | number; at: string | number; left: string | number }) => string;
  readonly timer_short: string;
  readonly timer_tail_open: string;
  readonly timer_tail_shut: string;
  readonly when_open: (p: { close: string | number }) => string;
  readonly when_shut: (p: { open: string | number; close: string | number }) => string;
}

export const siege: Siege = tables?.siege ?? source.siege;

/** sonarlab/ — the sonar lab page on the lab shell: the map of the depth bands, the heard field, the reach ring, the baffles and the contact lines, the column of LESSON, UNITS, UNIT and WORLD, the card of a unit or a pair, the presets and the key sentences (sonar-lab.md §5). */
export interface Sonarlab {
  readonly add: (p: { kind: string | number }) => string;
  readonly add_title: (p: { kind: string | number }) => string;
  readonly band_abyss: string;
  readonly band_deep: string;
  readonly band_shelf: string;
  readonly band_slope: string;
  readonly card_baffled: (p: { hearing: string | number }) => string;
  readonly card_band: string;
  readonly card_contacts: string;
  readonly card_noise: string;
  readonly card_noise_of: (p: { id: string | number }) => string;
  readonly card_range: string;
  readonly card_range_of: (p: { id: string | number }) => string;
  readonly card_thermo: string;
  readonly card_typed: string;
  readonly card_waiting: string;
  readonly cause_baffles: string;
  readonly cause_deep_run: string;
  readonly cause_heard: string;
  readonly cause_hidden: string;
  readonly cause_inert: string;
  readonly cause_range: string;
  readonly column_hide: string;
  readonly column_hint: string;
  readonly column_show: string;
  readonly copy_link: string;
  readonly copy_link_title: string;
  readonly defaults: string;
  readonly defaults_hint: string;
  readonly dice_title: string;
  readonly engine_error: (p: { error: string | number }) => string;
  readonly engine_failed: (p: { error: string | number }) => string;
  readonly engine_loading: string;
  readonly engine_missing: (p: { why: string | number }) => string;
  readonly engine_ms: (p: { ms: string | number }) => string;
  readonly engine_no_world: string;
  readonly export_hint: string;
  readonly field_more: string;
  readonly fit: string;
  readonly fit_hint: string;
  readonly fold_how: string;
  readonly fold_keys: string;
  readonly fold_presets: string;
  readonly fold_scene: string;
  readonly fold_unit: string;
  readonly fold_units: string;
  readonly fold_world: string;
  readonly how_baffles: (p: { hearing: string | number }) => string;
  readonly how_deep_run: string;
  readonly how_depth: (p: { bands: string | number }) => string;
  readonly how_field: string;
  readonly how_fixed: (p: { base: string | number; per: string | number; max: string | number; installation: string | number; spire: string | number; buoy: string | number }) => string;
  readonly how_heard: string;
  readonly how_noise: (p: { base: string | number; full: string | number }) => string;
  readonly how_pick: string;
  readonly how_quiet: (p: { cut: string | number; max: string | number; floor: string | number; damp: string | number; damp_floor: string | number }) => string;
  readonly how_range: (p: { tiers: string | number; roll_min: string | number; roll_max: string | number; ceiling: string | number }) => string;
  readonly how_share: (p: { cls: string | number; share: string | number }) => string;
  readonly how_switches: (p: { silent: string | number; anchor: string | number; gun: string | number; launch: string | number; ping: string | number; crash: string | number; trench: string | number }) => string;
  readonly how_typed: string;
  readonly import_hint: string;
  readonly key_column: string;
  readonly key_faster: string;
  readonly key_fit: string;
  readonly key_motion: string;
  readonly key_remove: string;
  readonly key_slower: string;
  readonly kind_buoy: string;
  readonly kind_hold: string;
  readonly kind_hull: string;
  readonly kind_installation: string;
  readonly kind_spire: string;
  readonly layer_baffles: string;
  readonly layer_bands: string;
  readonly layer_field: string;
  readonly layer_lines: string;
  readonly layer_patrols: string;
  readonly layer_rings: string;
  readonly layer_tags: string;
  readonly legend_bands: string;
  readonly legend_bands_off: string;
  readonly legend_field: string;
  readonly lesson_next: string;
  readonly lesson_next_title: string;
  readonly lesson_of: (p: { n: string | number; count: string | number }) => string;
  readonly lesson_prev: string;
  readonly lesson_prev_title: string;
  readonly lesson_try: string;
  readonly menu_file: string;
  readonly menu_run: string;
  readonly menu_view: string;
  readonly motion_none_title: string;
  readonly none: string;
  readonly notice_import_bad: (p: { file: string | number }) => string;
  readonly notice_imported: (p: { count: number }) => string;
  readonly notice_link: string;
  readonly notice_loaded: (p: { name: string | number }) => string;
  readonly notice_no_name: string;
  readonly notice_saved: (p: { name: string | number }) => string;
  readonly notice_storage_refused: string;
  readonly pair_dist: (p: { dist: string | number; reach: string | number }) => string;
  readonly pair_kind: string;
  readonly pair_name: (p: { src: string | number; tgt: string | number }) => string;
  readonly pause: string;
  readonly pct: (p: { n: string | number }) => string;
  readonly play: string;
  readonly preset_delete: string;
  readonly preset_delete_sure: string;
  readonly preset_export: string;
  readonly preset_import: string;
  readonly preset_load: string;
  readonly preset_name: string;
  readonly preset_none: string;
  readonly preset_save: string;
  readonly presets_pick: (p: { count: string | number }) => string;
  readonly probe_is: string;
  readonly probe_make: string;
  readonly probe_title: string;
  readonly probe_word: string;
  readonly product: (p: { range: string | number; noise: string | number; thermo: string | number; reach: string | number }) => string;
  readonly product_flat: (p: { range: string | number; noise: string | number; reach: string | number }) => string;
  readonly remove: string;
  readonly remove_title: string;
  readonly ring_inexact: string;
  readonly row_captain: string;
  readonly row_cell: string;
  readonly row_cell_title: string;
  readonly row_class: string;
  readonly row_class_npc: string;
  readonly row_damp: string;
  readonly row_damp_roll: string;
  readonly row_depth: string;
  readonly row_depth_title: string;
  readonly row_faction: string;
  readonly row_module: string;
  readonly row_module_roll: string;
  readonly row_moving: string;
  readonly row_probe: string;
  readonly row_probe_title: string;
  readonly row_quiet_hand: string;
  readonly row_sapper: string;
  readonly row_sapper_title: string;
  readonly row_scene: string;
  readonly row_seed: string;
  readonly row_size: string;
  readonly row_station: string;
  readonly row_typed: string;
  readonly scene_baffles: string;
  readonly scene_deep_run: string;
  readonly scene_note_baffles: string;
  readonly scene_note_deep_run: string;
  readonly scene_note_one_listener: string;
  readonly scene_note_oracle_share: string;
  readonly scene_note_overview: string;
  readonly scene_note_quiet_hand: string;
  readonly scene_note_thermocline: string;
  readonly scene_note_under_way: string;
  readonly scene_one_listener: string;
  readonly scene_oracle_share: string;
  readonly scene_overview: string;
  readonly scene_quiet_hand: string;
  readonly scene_thermocline: string;
  readonly scene_try_baffles: string;
  readonly scene_try_deep_run: string;
  readonly scene_try_one_listener: string;
  readonly scene_try_oracle_share: string;
  readonly scene_try_overview: string;
  readonly scene_try_quiet_hand: string;
  readonly scene_try_thermocline: string;
  readonly scene_try_under_way: string;
  readonly scene_under_way: string;
  readonly sheet_line: (p: { n: string | number; scene: string | number }) => string;
  readonly speed_now: string;
  readonly speed_step: (p: { step: string | number }) => string;
  readonly speed_title: string;
  readonly status: (p: { units: string | number; heard: string | number; pairs: string | number }) => string;
  readonly still: string;
  readonly storage_off: string;
  readonly tag_noise: (p: { value: string | number }) => string;
  readonly tag_range: (p: { px: string | number }) => string;
  readonly term_anchor: string;
  readonly term_buoy: string;
  readonly term_class: string;
  readonly term_crash_dive: string;
  readonly term_dampening: string;
  readonly term_echo: string;
  readonly term_installation: string;
  readonly term_module: string;
  readonly term_quiet_hand: string;
  readonly term_share: string;
  readonly term_silent_running: string;
  readonly term_speed: string;
  readonly term_spire: string;
  readonly term_station: string;
  readonly term_terrain: string;
  readonly thermo_caption: string;
  readonly thermo_corner: string;
  readonly thermo_pair: (p: { from: string | number; to: string | number }) => string;
  readonly tiers: readonly string[];
  readonly title: string;
  readonly toggle_anchor: string;
  readonly toggle_crash_dive: string;
  readonly toggle_deep_run: string;
  readonly toggle_gun_echo: string;
  readonly toggle_launch_echo: string;
  readonly toggle_ping_echo: string;
  readonly toggle_share: string;
  readonly toggle_silent: string;
  readonly toggle_title_anchor: string;
  readonly toggle_title_crash_dive: string;
  readonly toggle_title_deep_run: string;
  readonly toggle_title_gun_echo: string;
  readonly toggle_title_launch_echo: string;
  readonly toggle_title_ping_echo: string;
  readonly toggle_title_share: string;
  readonly toggle_title_silent: string;
  readonly typed_no_sonar: string;
  readonly under_way: string;
  readonly unit_name: (p: { id: string | number; what: string | number }) => string;
  readonly unit_none: string;
  readonly units_count: (p: { n: string | number; max: string | number }) => string;
  readonly units_pick: (p: { n: string | number }) => string;
  readonly value_mul: (p: { mul: string | number }) => string;
  readonly value_px: (p: { px: string | number }) => string;
  readonly verdict_deaf: (p: { cause: string | number }) => string;
  readonly verdict_heard: string;
  readonly world_pick: (p: { seed: string | number; size: string | number }) => string;
  readonly zoom: (p: { pct: string | number }) => string;
  readonly zoom_in: string;
  readonly zoom_out: string;
  readonly zoom_title: string;
}

export const sonarlab: Sonarlab = tables?.sonarlab ?? source.sonarlab;

/** ui/squad.ts — the squad on the map (ui-map-interface.md §8, R1571): the squad chip of the top bar, its roster card, the marks key, and the two notices of the squad (R199, R1304). */
export interface Squad {
  readonly changed_head: string;
  readonly changed_none: string;
  readonly changed_pickup: (p: { count: number }) => string;
  readonly changed_squad: (p: { count: number; n: string | number }) => string;
  readonly chip_pickup: string;
  readonly chip_squad: (p: { n: string | number }) => string;
  readonly chip_title: string;
  readonly faction_hold_no_mark: string;
  readonly faction_hold_no_plate: string;
  readonly key_count: (p: { count: number }) => string;
  readonly key_faction_hold: string;
  readonly key_foot: (p: { value: string | number; other: string | number }) => string;
  readonly key_head: string;
  readonly key_rest: string;
  readonly key_squad_hold: string;
  readonly key_you: string;
  readonly key_your_fleets: string;
  readonly key_your_hold: string;
  readonly marks_key: string;
  readonly open_clan: string;
  readonly own_hold_beam_column: string;
  readonly own_hold_breathing_lozenge: string;
  readonly own_hold_cross_rays: string;
  readonly own_hold_crown_chevrons: string;
  readonly own_hold_ground_plate: string;
  readonly own_hold_landing_pillars: string;
  readonly pickup_body: (p: { count: number }) => string;
  readonly pickup_head: string;
  readonly roster_at_sea: string;
  readonly roster_online: string;
  readonly roster_reserve: string;
  readonly roster_you: string;
  readonly squad_hold_half_plate: string;
  readonly squad_hold_no_mark: string;
  readonly squad_hold_short_column: string;
  readonly squad_hold_single_chevron: string;
  readonly squad_hold_small_lozenge: string;
  readonly squad_hold_waterline_ticks: string;
}

export const squad: Squad = tables?.squad ?? source.squad;

/** ui.state — the server-truth cache: the mission and resource tables, the heatmap mode list and the shared number and duration formats. */
export interface State {
  readonly cost_free: string;
  readonly dur_days: (p: { days: string | number; hours: string | number }) => string;
  readonly dur_hours: (p: { hours: string | number; min: string | number }) => string;
  readonly dur_minutes: (p: { min: string | number; sec: string | number }) => string;
  readonly dur_seconds: (p: { sec: string | number }) => string;
  readonly heat_activity_hi: string;
  readonly heat_activity_label: string;
  readonly heat_activity_lo: string;
  readonly heat_activity_season_hi: string;
  readonly heat_activity_season_label: string;
  readonly heat_activity_season_lo: string;
  readonly heat_activity_season_what: string;
  readonly heat_activity_what: string;
  readonly heat_beacon_hi: string;
  readonly heat_beacon_label: string;
  readonly heat_beacon_lo: string;
  readonly heat_beacon_what: string;
  readonly heat_currents_hi: string;
  readonly heat_currents_label: string;
  readonly heat_currents_lo: string;
  readonly heat_currents_what: string;
  readonly heat_depth_hi: string;
  readonly heat_depth_label: string;
  readonly heat_depth_lo: string;
  readonly heat_depth_what: string;
  readonly heat_kills_hi: string;
  readonly heat_kills_label: string;
  readonly heat_kills_lo: string;
  readonly heat_kills_season_hi: string;
  readonly heat_kills_season_label: string;
  readonly heat_kills_season_lo: string;
  readonly heat_kills_season_what: string;
  readonly heat_kills_what: string;
  readonly heat_off_label: string;
  readonly heat_off_what: string;
  readonly heat_sov_hi: string;
  readonly heat_sov_label: string;
  readonly heat_sov_lo: string;
  readonly heat_sov_what: string;
  readonly heat_stability_hi: string;
  readonly heat_stability_label: string;
  readonly heat_stability_lo: string;
  readonly heat_stability_what: string;
  readonly mission_names: readonly string[];
  readonly num_millions: (p: { n: string | number }) => string;
  readonly num_thousands: (p: { n: string | number }) => string;
}

export const state: State = tables?.state ?? source.state;

/** symbols/ — the ship symbols page: its back link, its two views, its four switches, the rules table and the words of every ship icon set (R850, themes.md §6.1). */
export interface Symbols {
  readonly back: string;
  readonly col_hull: string;
  readonly col_kind: string;
  readonly col_role: string;
  readonly col_says: string;
  readonly col_weight: string;
  readonly desc_arcs: string;
  readonly desc_arrows: string;
  readonly desc_by_name: string;
  readonly desc_chevrons: string;
  readonly desc_default: string;
  readonly desc_filigree: string;
  readonly desc_insignia: string;
  readonly desc_pips: string;
  readonly desc_plates: string;
  readonly desc_rungs: string;
  readonly desc_tails: string;
  readonly desc_teeth: string;
  readonly form_desk: string;
  readonly form_phone: string;
  readonly grammar: string;
  readonly grammar_arcs: string;
  readonly grammar_arrows: string;
  readonly grammar_by_name: string;
  readonly grammar_chevrons: string;
  readonly grammar_default: string;
  readonly grammar_filigree: string;
  readonly grammar_insignia: string;
  readonly grammar_pips: string;
  readonly grammar_plates: string;
  readonly grammar_rungs: string;
  readonly grammar_tails: string;
  readonly grammar_teeth: string;
  readonly ink_colour: string;
  readonly ink_grey: string;
  readonly kind_combat: string;
  readonly kind_support: string;
  readonly lede: string;
  readonly master_fill: string;
  readonly master_hollow: string;
  readonly role_artillery: string;
  readonly role_brawler: string;
  readonly role_cargo: string;
  readonly role_command: string;
  readonly role_engineer: string;
  readonly role_repair: string;
  readonly role_scout: string;
  readonly role_skirmish: string;
  readonly role_sonar: string;
  readonly role_sovereignty: string;
  readonly role_torpedo: string;
  readonly role_tower: string;
  readonly rules_bases: string;
  readonly rules_title: string;
  readonly rules_weight: string;
  readonly says_basilisk: string;
  readonly says_beacon: string;
  readonly says_bombard: string;
  readonly says_commodore: string;
  readonly says_corsair: string;
  readonly says_cutlass: string;
  readonly says_dredger: string;
  readonly says_falconet: string;
  readonly says_lancer: string;
  readonly says_oracle: string;
  readonly says_sapper: string;
  readonly says_sentinel: string;
  readonly says_tender: string;
  readonly says_vedette: string;
  readonly sw_form: string;
  readonly sw_ink: string;
  readonly sw_master: string;
  readonly sw_view: string;
  readonly sw_zoom: string;
  readonly title: string;
  readonly view_sets: string;
  readonly view_ships: string;
  readonly weight_heavy: string;
  readonly weight_light: string;
  readonly weight_medium: string;
  readonly weight_thin: string;
  readonly zoom_half: string;
  readonly zoom_one: string;
  readonly zoom_two: string;
}

export const symbols: Symbols = tables?.symbols ?? source.symbols;

/** terrainlab/ — the terrain lab page: the panel, the A/B compare, the presets, the tooltip and the key sentences (R1289, terrain-lab.md §7). */
export interface Terrainlab {
  readonly apron_value: string;
  readonly cache_value: (p: { id: string | number }) => string;
  readonly card_anchor: string;
  readonly card_cache: (p: { id: string | number }) => string;
  readonly card_cell: (p: { cell: string | number }) => string;
  readonly card_den: (p: { id: string | number }) => string;
  readonly card_deposit: (p: { resource: string | number }) => string;
  readonly card_hold: (p: { pocket: string | number }) => string;
  readonly card_lair: (p: { id: string | number }) => string;
  readonly card_note: string;
  readonly card_pocket: (p: { pocket: string | number }) => string;
  readonly card_point: (p: { kind: string | number; id: string | number }) => string;
  readonly card_seamount: (p: { id: string | number }) => string;
  readonly cell_place: (p: { cell: string | number; col: string | number; row: string | number }) => string;
  readonly cells_chip: (p: { cells: string | number }) => string;
  readonly copy_ab: string;
  readonly copy_ab_hint: string;
  readonly copy_ab_title: string;
  readonly copy_link: string;
  readonly default_value: (p: { value: string | number }) => string;
  readonly dice_title: string;
  readonly editing: (p: { side: string | number }) => string;
  readonly export_hint: string;
  readonly fact_ambush: string;
  readonly fact_amount: string;
  readonly fact_apron: string;
  readonly fact_body: string;
  readonly fact_brotherhood: string;
  readonly fact_buoy: string;
  readonly fact_cache: string;
  readonly fact_cell: string;
  readonly fact_design: string;
  readonly fact_faction: string;
  readonly fact_fairway: string;
  readonly fact_holds: string;
  readonly fact_hunt: string;
  readonly fact_monster: string;
  readonly fact_moved: string;
  readonly fact_owner: string;
  readonly fact_pirate_cache: string;
  readonly fact_quiet: string;
  readonly fact_seamount: string;
  readonly fact_sortie: string;
  readonly fact_terrain: string;
  readonly fact_window: string;
  readonly failed: (p: { side: string | number; error: string | number }) => string;
  readonly fairway_value: (p: { index: string | number }) => string;
  readonly fit: string;
  readonly hunt_value: (p: { brotherhood: string | number; id: string | number }) => string;
  readonly hunt_value_own: (p: { brotherhood: string | number; id: string | number }) => string;
  readonly import_hint: string;
  readonly key_dice: string;
  readonly key_fit: string;
  readonly key_next: string;
  readonly key_panel: string;
  readonly key_prev: string;
  readonly key_split: string;
  readonly key_swap: string;
  readonly keys: string;
  readonly kind_anchor: string;
  readonly kind_cache: string;
  readonly kind_cell: string;
  readonly kind_den: string;
  readonly kind_den_quiet: string;
  readonly kind_deposit: string;
  readonly kind_hold: string;
  readonly kind_hold_fallback: string;
  readonly kind_installation: string;
  readonly kind_lair: string;
  readonly kind_object: string;
  readonly kind_pocket: string;
  readonly kind_pocket_fallback: string;
  readonly kind_pocket_installation: string;
  readonly kind_pocket_middle: string;
  readonly kind_point: string;
  readonly kind_seamount: string;
  readonly layer_anchors: string;
  readonly layer_buoys: string;
  readonly layer_caches: string;
  readonly layer_dens: string;
  readonly layer_fairways: string;
  readonly layer_grid: string;
  readonly layer_holds: string;
  readonly layer_hunt: string;
  readonly layer_installations: string;
  readonly layer_lairs: string;
  readonly layer_objects: string;
  readonly layer_pockets: string;
  readonly layer_points: string;
  readonly layer_quiet: string;
  readonly layer_ranges: string;
  readonly layer_seamounts: string;
  readonly layer_sites: string;
  readonly layer_territory: string;
  readonly menu_lab: string;
  readonly menu_presets: string;
  readonly moved_value: (p: { id: string | number; cell: string | number }) => string;
  readonly ms: (p: { ms: string | number }) => string;
  readonly name: string;
  readonly next_title: string;
  readonly no_generator: string;
  readonly none: string;
  readonly notice_import_bad: (p: { file: string | number }) => string;
  readonly notice_imported: (p: { count: number }) => string;
  readonly notice_link: string;
  readonly notice_loaded: (p: { name: string | number; side: string | number }) => string;
  readonly notice_no_name: string;
  readonly notice_saved: (p: { name: string | number }) => string;
  readonly notice_storage_refused: string;
  readonly overlay: string;
  readonly overlay_height: string;
  readonly panel: string;
  readonly panel_hint: string;
  readonly panel_title: string;
  readonly pirate_cache_value: (p: { id: string | number; x: string | number; y: string | number }) => string;
  readonly pirates: string;
  readonly pirates_off: string;
  readonly pirates_on: string;
  readonly pirates_title: string;
  readonly preset_delete: string;
  readonly preset_delete_sure: string;
  readonly preset_export: string;
  readonly preset_import: string;
  readonly preset_load: string;
  readonly preset_load_title: (p: { side: string | number }) => string;
  readonly preset_name: string;
  readonly preset_none: string;
  readonly preset_save: (p: { side: string | number }) => string;
  readonly preset_save_title: (p: { side: string | number }) => string;
  readonly preset_seed: (p: { seed: string | number; seats: string | number }) => string;
  readonly preset_seed_title: string;
  readonly presets: string;
  readonly presets_pick: (p: { count: number }) => string;
  readonly prev_title: string;
  readonly quiet_stays: (p: { rings: string | number }) => string;
  readonly quiet_to: (p: { cell: string | number }) => string;
  readonly range_value: (p: { id: string | number; kind: string | number }) => string;
  readonly roll: string;
  readonly roll_bad: string;
  readonly roll_dice_title: string;
  readonly roll_empty: string;
  readonly roll_title: string;
  readonly seamount_value: (p: { id: string | number; cells: string | number }) => string;
  readonly seed: string;
  readonly seed_bad: string;
  readonly side_a: string;
  readonly side_b: string;
  readonly side_title: (p: { side: string | number }) => string;
  readonly size: string;
  readonly size_row: (p: { seats: string | number; cols: string | number; rows: string | number }) => string;
  readonly slot_cleanup: string;
  readonly slot_fairways: string;
  readonly slot_placement: string;
  readonly slot_sites: string;
  readonly slot_terrain: string;
  readonly sortie_value: (p: { brotherhood: string | number; id: string | number; every: string | number }) => string;
  readonly split: string;
  readonly split_title: string;
  readonly stats: string;
  readonly stats_ab: string;
  readonly stats_pick: (p: { ms: string | number }) => string;
  readonly status_cells: (p: { cells: string | number }) => string;
  readonly status_failed: (p: { side: string | number }) => string;
  readonly status_fallbacks: (p: { count: number; side: string | number }) => string;
  readonly storage_off: string;
  readonly terrain_height: (p: { terrain: string | number; height: string | number }) => string;
  readonly timings: string;
  readonly tip_ambush: (p: { id: string | number; kind: string | number }) => string;
  readonly tip_anchor: (p: { faction: string | number }) => string;
  readonly tip_apron: string;
  readonly tip_body: (p: { id: string | number; kind: string | number }) => string;
  readonly tip_buoy: (p: { kind: string | number }) => string;
  readonly tip_cache: (p: { id: string | number }) => string;
  readonly tip_cell: (p: { cell: string | number; col: string | number; row: string | number }) => string;
  readonly tip_den: (p: { id: string | number; brotherhood: string | number; design: string | number }) => string;
  readonly tip_den_moved: (p: { id: string | number; cell: string | number }) => string;
  readonly tip_den_plain: (p: { id: string | number }) => string;
  readonly tip_den_quiet: (p: { id: string | number; cell: string | number }) => string;
  readonly tip_den_stays: (p: { id: string | number }) => string;
  readonly tip_deposit: (p: { resource: string | number; amount: string | number }) => string;
  readonly tip_fairway: (p: { index: string | number }) => string;
  readonly tip_hold: (p: { faction: string | number; pocket: string | number }) => string;
  readonly tip_hold_fallback: (p: { faction: string | number; pocket: string | number }) => string;
  readonly tip_hunt: (p: { brotherhood: string | number; id: string | number }) => string;
  readonly tip_hunt_own: (p: { brotherhood: string | number; id: string | number }) => string;
  readonly tip_installation: (p: { name: string | number; faction: string | number }) => string;
  readonly tip_lair: (p: { id: string | number; kind: string | number; design: string | number }) => string;
  readonly tip_lair_plain: (p: { id: string | number }) => string;
  readonly tip_object: (p: { name: string | number; window: string | number }) => string;
  readonly tip_owner: (p: { faction: string | number }) => string;
  readonly tip_pirate_cache: (p: { id: string | number }) => string;
  readonly tip_pocket: (p: { pocket: string | number; faction: string | number; members: string | number }) => string;
  readonly tip_pocket_fallback: (p: { pocket: string | number; faction: string | number }) => string;
  readonly tip_pocket_installation: (p: { pocket: string | number; faction: string | number }) => string;
  readonly tip_pocket_middle: (p: { pocket: string | number; faction: string | number }) => string;
  readonly tip_point: (p: { id: string | number; kind: string | number }) => string;
  readonly tip_ridge: string;
  readonly tip_seamount: (p: { id: string | number; cells: string | number }) => string;
  readonly tip_sortie: (p: { brotherhood: string | number; id: string | number }) => string;
  readonly tip_trench: string;
  readonly tip_value: (p: { name: string | number; value: string | number }) => string;
  readonly tip_water: string;
  readonly total: string;
}

export const terrainlab: Terrainlab = tables?.terrainlab ?? source.terrainlab;

/** ui/timelapse/ — the three players of the season timelapse: the summary card, WAR · SOVEREIGNTY and the public reader (ui-map-interface.md §3.6, R1620). */
export interface Timelapse {
  readonly band: string;
  readonly legend_commander: (p: { commander: string | number }) => string;
  readonly legend_head: string;
  readonly legend_mine: string;
  readonly live: string;
  readonly on_the_map: string;
  readonly pause: string;
  readonly play: string;
  readonly reader_frames: (p: { frames: number }) => string;
  readonly reader_head: (p: { from: string | number; to: string | number }) => string;
  readonly scrub: string;
  readonly sea_none: string;
  readonly sea_none_why: string;
  readonly sea_page: string;
  readonly sea_season: (p: { season: string | number }) => string;
  readonly sea_title: (p: { world: string | number }) => string;
  readonly sea_what: string;
  readonly series_tag: string;
  readonly speed: (p: { n: string | number }) => string;
  readonly speed_title: string;
  readonly stamp: (p: { day: string | number; time: string | number }) => string;
  readonly stamp_now: (p: { day: string | number }) => string;
  readonly summary_every: (p: { hours: number }) => string;
  readonly summary_head: (p: { frames: number }) => string;
  readonly tick_day: (p: { day: string | number }) => string;
  readonly tick_now: string;
  readonly war_head: (p: { stamp: string | number }) => string;
  readonly war_note: string;
}

export const timelapse: Timelapse = tables?.timelapse ?? source.timelapse;

/** fast/touchlog.ts — the TOUCH LOG chip: the opt-in log of pointer events that a player copies into a report (ui-map-interface.md §8 "Touch log", R1497). */
export interface TouchLog {
  readonly chip: (p: { count: string | number }) => string;
  readonly clear: string;
  readonly copied: string;
  readonly copy: string;
  readonly select_and_copy: string;
  readonly share: string;
}

export const touchLog: TouchLog = tables?.touchLog ?? source.touchLog;

/** ui.trials — the sea trials on the advisor line (player-reach.md §8, R1572, R2131): the count, the eight first acts of a new commander, a SHOW button each, the drill row and the closing line. */
export interface Trials {
  readonly closing_head: string;
  readonly closing_long: string;
  readonly closing_short: (p: { done: string | number; total: string | number }) => string;
  readonly drill: string;
  readonly drill_go: string;
  readonly drill_tag: string;
  readonly drill_title: string;
  readonly fold: string;
  readonly label: (p: { done: string | number; total: string | number }) => string;
  readonly next: (p: { step: string | number }) => string;
  readonly show: string;
  readonly show_title: (p: { panel: string | number }) => string;
  readonly step_build_beacon: string;
  readonly step_build_dredger: string;
  readonly step_launch_fleet: string;
  readonly step_queue_building: string;
  readonly step_recruit_captain: string;
  readonly step_send_gather: string;
  readonly step_start_research: string;
  readonly step_take_cell: string;
  readonly title: string;
  readonly unfold: string;
}

export const trials: Trials = tables?.trials ?? source.trials;

/** ui.viewpanel — the map buttons and the VIEW panel (ui-map-interface.md §12.0, R1747, R1758): the VIEW button, the tiles of what stands over the map, the GO TO THE HOLD row and the rose press. */
export interface Viewpanel {
  readonly back: string;
  readonly chart_aside: string;
  readonly chart_head: string;
  readonly chat: string;
  readonly group_currents: string;
  readonly group_depth: string;
  readonly group_tracks: string;
  readonly group_wrecks: string;
  readonly head: string;
  readonly head_sub: string;
  readonly heat: string;
  readonly heat_aside_touch: string;
  readonly heat_none_what: string;
  readonly heat_off: string;
  readonly heat_paints: (p: { mode: string | number }) => string;
  readonly heat_row: (p: { mode: string | number }) => string;
  readonly home: string;
  readonly key: string;
  readonly layers: string;
  readonly legend: string;
  readonly map: string;
  readonly off: string;
  readonly on: string;
  readonly pieces_head: string;
  readonly reading_historical: string;
  readonly reading_modern: string;
  readonly reading_off: string;
  readonly rose_peek: string;
  readonly rose_title: string;
  readonly scale_cells: (p: { n: number }) => string;
  readonly sea: string;
  readonly sea_follow: string;
  readonly unread: (p: { n: number }) => string;
  readonly view: string;
  readonly view_title: string;
}

export const viewpanel: Viewpanel = tables?.viewpanel ?? source.viewpanel;

/** ui.warcharts — the WAR · SOV chart geometry; only the neutral series carries a word. */
export interface Warcharts {
  readonly unclaimed: string;
}

export const warcharts: Warcharts = tables?.warcharts ?? source.warcharts;

/** ui.welcome — the welcome card of the first join in the first Core season (player-reach.md §8.5, R1572, R2120): what the player commands, the situation of the empire, what the autopilot built behind one press, and where to look next. */
export interface Welcome {
  readonly built: string;
  readonly built_buildings: (p: { n: number }) => string;
  readonly built_captains: (p: { n: number }) => string;
  readonly built_fleets: (p: { n: number }) => string;
  readonly captain_ashore: string;
  readonly command: (p: { hold: string | number }) => string;
  readonly dir_e: string;
  readonly dir_n: string;
  readonly dir_ne: string;
  readonly dir_nw: string;
  readonly dir_s: string;
  readonly dir_se: string;
  readonly dir_sw: string;
  readonly dir_w: string;
  readonly find_clan: string;
  readonly find_clan_title: string;
  readonly fleet_pens: (p: { cls: string | number }) => string;
  readonly go: string;
  readonly handover: string;
  readonly head_buildings: string;
  readonly head_captains: string;
  readonly head_fleets: string;
  readonly head_neighbours: string;
  readonly head_research: string;
  readonly head_season: string;
  readonly heading: string;
  readonly how: string;
  readonly kicker: (p: { season: string | number; day: string | number; faction: string | number }) => string;
  readonly level: (p: { level: string | number }) => string;
  readonly neighbour: (p: { faction: string | number; dir: string | number }) => string;
  readonly neighbour_own: (p: { dir: string | number }) => string;
  readonly research_done: string;
  readonly research_queued: string;
  readonly season_clan: (p: { members: string | number }) => string;
  readonly season_goal: (p: { days: string | number }) => string;
  readonly season_stays: string;
  readonly season_team: string;
  readonly squad: (p: { squad: string | number; clan: string | number }) => string;
  readonly threat: (p: { hold: string | number; faction: string | number; dir: string | number }) => string;
  readonly threat_time: (p: { fleet: string | number; time: string | number }) => string;
  readonly trials: string;
  readonly truce: (p: { left: string | number }) => string;
  readonly truce_over: string;
  readonly where_advisor: string;
  readonly where_key: string;
  readonly where_support: string;
}

export const welcome: Welcome = tables?.welcome ?? source.welcome;

/** workshop/ — the theme workshop page: its gate, its six tabs, the save row and every refusal it shows (themes.md §6). */
export interface Workshop {
  readonly activated: (p: { code: string | number }) => string;
  readonly add: string;
  readonly alpha_edge: string;
  readonly alpha_panel: string;
  readonly back_hub: string;
  readonly bank: string;
  readonly cancel: string;
  readonly chart_changed: string;
  readonly chart_lede: string;
  readonly chart_pack: (p: { historical: string | number; modern: string | number }) => string;
  readonly chart_reading: string;
  readonly chart_switch: (p: { reading: string | number; value: string | number }) => string;
  readonly chk_contrast: (p: { ratio: string | number; floor: string | number }) => string;
  readonly chk_faint_panel: (p: { ratio: string | number; floor: string | number }) => string;
  readonly chk_faint_sheet: (p: { ratio: string | number; floor: string | number }) => string;
  readonly clip_gone: string;
  readonly clip_label: (p: { n: string | number }) => string;
  readonly confirm_links: (p: { count: number }) => string;
  readonly confirm_save: string;
  readonly contrast_bad: (p: { pair: string | number; ratio: string | number; floor: string | number }) => string;
  readonly contrast_ok: (p: { pair: string | number; ratio: string | number; floor: string | number }) => string;
  readonly copy_code: string;
  readonly discard: string;
  readonly err_activate: (p: { message: string | number }) => string;
  readonly err_entitlement: string;
  readonly err_failed: (p: { message: string | number }) => string;
  readonly err_impersonation: string;
  readonly err_invalid: (p: { field: string | number; reason: string | number }) => string;
  readonly err_no_meta: (p: { message: string | number }) => string;
  readonly err_signed_out: string;
  readonly err_too_large: (p: { max: string | number }) => string;
  readonly field_anchoring: string;
  readonly field_aura: string;
  readonly field_banner: string;
  readonly field_beam: string;
  readonly field_cache_work: string;
  readonly field_currents: string;
  readonly field_currents_heat: string;
  readonly field_damage: string;
  readonly field_deployable: string;
  readonly field_deployable_collect: string;
  readonly field_deployable_lay: string;
  readonly field_deposit: string;
  readonly field_depth: string;
  readonly field_detonation: string;
  readonly field_digits: string;
  readonly field_dock: string;
  readonly field_faction_edge: string;
  readonly field_faction_hull: string;
  readonly field_faction_key: string;
  readonly field_faction_site: string;
  readonly field_gather: string;
  readonly field_hit_hull: string;
  readonly field_hit_shield: string;
  readonly field_hit_sink: string;
  readonly field_hold: string;
  readonly field_hold_fire: string;
  readonly field_map_marker: string;
  readonly field_notices: string;
  readonly field_own_fleet: string;
  readonly field_own_hold: string;
  readonly field_poi: string;
  readonly field_reload: string;
  readonly field_sea_mine: string;
  readonly field_sea_mine_collect: string;
  readonly field_sea_mine_detonation: string;
  readonly field_sea_mine_lay: string;
  readonly field_shield: string;
  readonly field_ship: string;
  readonly field_shot_artillery: string;
  readonly field_shot_melee: string;
  readonly field_shot_sentinel: string;
  readonly field_spawn: string;
  readonly field_squad_fleet: string;
  readonly field_squad_hold: string;
  readonly field_structure: string;
  readonly field_terrain: string;
  readonly field_territory: string;
  readonly field_torpedo: string;
  readonly fields_lede: string;
  readonly gate_list_failed: string;
  readonly gate_no_maker: string;
  readonly gate_no_maker_why: string;
  readonly gate_no_meta: string;
  readonly gate_premium_makes: string;
  readonly gate_see_plans: string;
  readonly gate_signed_out: string;
  readonly gate_signed_out_why: string;
  readonly group_combat: string;
  readonly group_deployables: string;
  readonly group_faction: string;
  readonly group_interface: string;
  readonly group_map: string;
  readonly group_support: string;
  readonly header_code: (p: { code: string | number }) => string;
  readonly hulls_closed: string;
  readonly hulls_count: (p: { count: string | number }) => string;
  readonly hulls_lede: string;
  readonly hulls_none: string;
  readonly hulls_open: string;
  readonly hulls_overview: string;
  readonly impersonated: string;
  readonly keep_mine: string;
  readonly keep_range: string;
  readonly make_active: string;
  readonly meta_none: string;
  readonly meta_only_you: string;
  readonly meta_others: (p: { count: number }) => string;
  readonly meta_theme: (p: { code: string | number; version: string | number }) => string;
  readonly meta_unused: string;
  readonly move_down: string;
  readonly move_up: string;
  readonly moved: (p: { hex: string | number }) => string;
  readonly music_empty: string;
  readonly music_lede: string;
  readonly music_list: (p: { count: string | number; max: string | number }) => string;
  readonly no_bank: string;
  readonly no_bank_why: string;
  readonly off: string;
  readonly on: string;
  readonly open_hub: string;
  readonly order_warn: (p: { lower: string | number; upper: string | number }) => string;
  readonly pair_faint_panel: string;
  readonly pair_faint_sheet: string;
  readonly pair_text_panel: string;
  readonly pick_label: (p: { row: string | number }) => string;
  readonly reading_historical: string;
  readonly reading_modern: string;
  readonly reason_count: string;
  readonly reason_missing: string;
  readonly reason_not_object: string;
  readonly reason_pattern: string;
  readonly reason_range: string;
  readonly reason_syntax: string;
  readonly reason_type: string;
  readonly reason_unknown: string;
  readonly remove: string;
  readonly replay: string;
  readonly restored: string;
  readonly revert: string;
  readonly row_tracks: string;
  readonly row_voice: string;
  readonly sample: string;
  readonly save: string;
  readonly save_off: (p: { pair: string | number; floor: string | number }) => string;
  readonly saved: (p: { code: string | number; version: string | number }) => string;
  readonly saved_active: (p: { code: string | number; version: string | number }) => string;
  readonly saving: string;
  readonly sfx_clip_cap: (p: { count: string | number; max: string | number }) => string;
  readonly sfx_effect: string;
  readonly sfx_groups: readonly string[];
  readonly sfx_lede: string;
  readonly sfx_no_clips: string;
  readonly sfx_summary: (p: { fx: string | number; voice: string | number }) => string;
  readonly sfx_timing: string;
  readonly sfx_voice: string;
  readonly share_line: (p: { code: string | number }) => string;
  readonly shuffle: string;
  readonly started_from: (p: { name: string | number }) => string;
  readonly step_next: (p: { row: string | number }) => string;
  readonly step_pos: (p: { n: string | number; count: string | number }) => string;
  readonly step_prev: (p: { row: string | number }) => string;
  readonly stop_sample: string;
  readonly tab_chart: string;
  readonly tab_marks: string;
  readonly tab_music: string;
  readonly tab_sfx: string;
  readonly tab_ui: string;
  readonly tab_unsaved: string;
  readonly tab_world: string;
  readonly tabs_label: string;
  readonly timing_theme: string;
  readonly title: string;
  readonly token_accent: string;
  readonly token_deep: string;
  readonly token_faint: string;
  readonly token_ink: string;
  readonly token_panel: string;
  readonly token_sheet: string;
  readonly token_text: string;
  readonly track_gone: string;
  readonly ui_start: string;
  readonly undo: string;
  readonly unsaved_leave: (p: { count: number }) => string;
  readonly unsaved_tab: (p: { tab: string | number }) => string;
  readonly val_hsl: string;
  readonly val_hsl_value: (p: { h: string | number; s: string | number; l: string | number }) => string;
  readonly val_oklch: string;
  readonly val_oklch_value: (p: { l: string | number; c: string | number }) => string;
  readonly val_out: string;
  readonly val_range: string;
  readonly val_range_band: (p: { lmin: string | number; lmax: string | number; cmin: string | number; cmax: string | number }) => string;
  readonly val_range_ceiling: (p: { lmin: string | number; lmax: string | number; cmax: string | number }) => string;
  readonly val_span: (p: { h: string | number; lmin: string | number; lmax: string | number }) => string;
  readonly val_span_none: (p: { h: string | number }) => string;
  readonly values_closed: string;
  readonly values_lede: string;
  readonly values_open: string;
  readonly voice_after: string;
  readonly voice_delay: string;
}

export const workshop: Workshop = tables?.workshop ?? source.workshop;

/** workshop/labels.ts — the player names of the chart pieces of the Chart tab and of the cues of the SFX tab, in place of the slugs and the cue ids (themes.md §6.1, R2129). */
export interface WorkshopLabels {
  readonly cue_achievement: string;
  readonly cue_ambush_shot: string;
  readonly cue_arcade_base_fire: string;
  readonly cue_arcade_buy: string;
  readonly cue_arcade_capture_broken: string;
  readonly cue_arcade_capture_start: string;
  readonly cue_arcade_capture_threat: string;
  readonly cue_arcade_clock_tick: string;
  readonly cue_arcade_count: string;
  readonly cue_arcade_draw: string;
  readonly cue_arcade_fight: string;
  readonly cue_arcade_hold: string;
  readonly cue_arcade_hold_broken: string;
  readonly cue_arcade_kill: string;
  readonly cue_arcade_last_minute: string;
  readonly cue_arcade_lose: string;
  readonly cue_arcade_match_found: string;
  readonly cue_arcade_objective: string;
  readonly cue_arcade_queue_join: string;
  readonly cue_arcade_queue_leave: string;
  readonly cue_arcade_seat_loaded: string;
  readonly cue_arcade_sov_behind: string;
  readonly cue_arcade_sov_lead: string;
  readonly cue_arcade_spawn: string;
  readonly cue_arcade_step_reset: string;
  readonly cue_arcade_surrender: string;
  readonly cue_arcade_verdict: string;
  readonly cue_arcade_win: string;
  readonly cue_auction_sold: string;
  readonly cue_beacon_anchor: string;
  readonly cue_beacon_destroyed: string;
  readonly cue_beacon_hostile: string;
  readonly cue_beacon_pulse: string;
  readonly cue_blueprint_acquired: string;
  readonly cue_blueprint_masterwork: string;
  readonly cue_build_queued: string;
  readonly cue_captain_lost: string;
  readonly cue_captain_promoted: string;
  readonly cue_captain_recruited: string;
  readonly cue_captain_taken: string;
  readonly cue_cargo_delivered: string;
  readonly cue_casino_ball: string;
  readonly cue_casino_chip: string;
  readonly cue_casino_deal: string;
  readonly cue_casino_jackpot: string;
  readonly cue_casino_lose: string;
  readonly cue_casino_payout: string;
  readonly cue_casino_reel_stop: string;
  readonly cue_casino_seat: string;
  readonly cue_casino_wheel: string;
  readonly cue_casino_win: string;
  readonly cue_casino_your_turn: string;
  readonly cue_cataclysm: string;
  readonly cue_clan_hail: string;
  readonly cue_club_payout: string;
  readonly cue_contact_broken: string;
  readonly cue_contact_lost: string;
  readonly cue_contact_new: string;
  readonly cue_course_plotted: string;
  readonly cue_day_night: string;
  readonly cue_deposit_depleted: string;
  readonly cue_enemy_destroyed: string;
  readonly cue_expedition_departed: string;
  readonly cue_expedition_returned: string;
  readonly cue_fleet_departs: string;
  readonly cue_fleet_fatigued: string;
  readonly cue_fleet_fight: string;
  readonly cue_fleet_hit: string;
  readonly cue_fleet_returned: string;
  readonly cue_fleet_sink: string;
  readonly cue_guard_kill: string;
  readonly cue_honour_awarded: string;
  readonly cue_hull_repaired: string;
  readonly cue_insufficient_resources: string;
  readonly cue_magazine_empty: string;
  readonly cue_map_arrival: string;
  readonly cue_menu_back: string;
  readonly cue_menu_badge: string;
  readonly cue_menu_chat_recv: string;
  readonly cue_menu_chat_send: string;
  readonly cue_menu_error: string;
  readonly cue_menu_launch: string;
  readonly cue_menu_press: string;
  readonly cue_menu_purchase: string;
  readonly cue_menu_rename: string;
  readonly cue_menu_signin: string;
  readonly cue_menu_tab: string;
  readonly cue_menu_tick: string;
  readonly cue_menu_toggle: string;
  readonly cue_object_held: string;
  readonly cue_object_lost: string;
  readonly cue_order_ack: string;
  readonly cue_order_refused: string;
  readonly cue_quake_final: string;
  readonly cue_quake_settle: string;
  readonly cue_quake_stage1: string;
  readonly cue_quake_stage2: string;
  readonly cue_queue_complete: string;
  readonly cue_redraft_done: string;
  readonly cue_reload_complete: string;
  readonly cue_requirement_missing: string;
  readonly cue_research_complete: string;
  readonly cue_round_select: string;
  readonly cue_scan: string;
  readonly cue_sentinel_anchor: string;
  readonly cue_shields_down: string;
  readonly cue_ship_launched: string;
  readonly cue_siege_attack: string;
  readonly cue_siege_defend: string;
  readonly cue_siege_failed: string;
  readonly cue_signature_order: string;
  readonly cue_signature_ready: string;
  readonly cue_sonar_sweep: string;
  readonly cue_sov1_taken: string;
  readonly cue_sov2_taken: string;
  readonly cue_squad_ping: string;
  readonly cue_taking_damage: string;
  readonly cue_tech_unlocked: string;
  readonly cue_tender_anchor: string;
  readonly cue_territory_lost: string;
  readonly cue_torpedo_explode: string;
  readonly cue_torpedo_fire: string;
  readonly cue_torpedo_incoming: string;
  readonly cue_torpedo_repair: string;
  readonly cue_torpor_burst: string;
  readonly cue_trial_passed: string;
  readonly cue_truce_ended: string;
  readonly cue_truce_tick: string;
  readonly cue_under_attack: string;
  readonly cue_we_are_detected: string;
  readonly piece_banks: string;
  readonly piece_battle_marks: string;
  readonly piece_bearing_lines: string;
  readonly piece_border_band: string;
  readonly piece_bottom_nature: string;
  readonly piece_cables: string;
  readonly piece_cardinal_marks: string;
  readonly piece_cartouche: string;
  readonly piece_clan_burgee: string;
  readonly piece_coastal_profile: string;
  readonly piece_compass_rose: string;
  readonly piece_current_arrows: string;
  readonly piece_depth_tints: string;
  readonly piece_designations: string;
  readonly piece_edge_seam: string;
  readonly piece_epicentre: string;
  readonly piece_faction_key: string;
  readonly piece_fairways: string;
  readonly piece_graticule: string;
  readonly piece_harbour_limits: string;
  readonly piece_hazards: string;
  readonly piece_heraldry: string;
  readonly piece_here_be_monsters: string;
  readonly piece_hold_site: string;
  readonly piece_imprint: string;
  readonly piece_inbox_pins: string;
  readonly piece_isobaths: string;
  readonly piece_legend: string;
  readonly piece_light_chars: string;
  readonly piece_limit_line: string;
  readonly piece_listening_watch: string;
  readonly piece_map_markers: string;
  readonly piece_margin_warning: string;
  readonly piece_memorial_reef: string;
  readonly piece_neat_line: string;
  readonly piece_picket_line: string;
  readonly piece_place_names: string;
  readonly piece_points_of_interest: string;
  readonly piece_pool_monument: string;
  readonly piece_range_rings: string;
  readonly piece_restricted: string;
  readonly piece_ribbons: string;
  readonly piece_ship_tracks: string;
  readonly piece_shipping_lanes: string;
  readonly piece_shoal_stipple: string;
  readonly piece_sonar_sweep: string;
  readonly piece_soundings: string;
  readonly piece_speed_label: string;
  readonly piece_spoil_ground: string;
  readonly piece_tidal_diamond: string;
  readonly piece_torpedo_run: string;
  readonly piece_water_lines: string;
  readonly piece_works: string;
  readonly piece_wrecks: string;
}

export const workshopLabels: WorkshopLabels = tables?.workshopLabels ?? source.workshopLabels;

/** ui.world — the world module: the name water with no owner carries. The five faction names are the identity layer's. */
export interface World {
  readonly house_name: (p: { name: string | number }) => string;
  readonly unclaimed: string;
}

export const world: World = tables?.world ?? source.world;

/** One table per section, in one language: what the language parts
 *  of one language export together as `tables` (R1429, R3123). */
export interface StringTables {
  readonly achievements: Achievements;
  readonly advisor: Advisor;
  readonly alarms: Alarms;
  readonly api: Api;
  readonly arcadeCatalog: ArcadeCatalog;
  readonly arcadeChrome: ArcadeChrome;
  readonly arcadeCommunity: ArcadeCommunity;
  readonly arcadeDrill: ArcadeDrill;
  readonly arcadeFormat: ArcadeFormat;
  readonly arcadeHistory: ArcadeHistory;
  readonly arcadeHosting: ArcadeHosting;
  readonly arcadeLobby: ArcadeLobby;
  readonly arcadeMain: ArcadeMain;
  readonly arcadeMapschema: ArcadeMapschema;
  readonly arcadeMatch: ArcadeMatch;
  readonly arcadeMoments: ArcadeMoments;
  readonly arcadeStructures: ArcadeStructures;
  readonly arcadeViewer: ArcadeViewer;
  readonly arcadeWinline: ArcadeWinline;
  readonly banner: Banner;
  readonly battlelab: Battlelab;
  readonly brandart: Brandart;
  readonly brandartDiscord: BrandartDiscord;
  readonly briefing: Briefing;
  readonly cacheNote: CacheNote;
  readonly card: Card;
  readonly chart: Chart;
  readonly chatfilter: Chatfilter;
  readonly choice: Choice;
  readonly chronicle: Chronicle;
  readonly clanLook: ClanLook;
  readonly connection: Connection;
  readonly designerApp: DesignerApp;
  readonly designerCommunity: DesignerCommunity;
  readonly designerDrawer: DesignerDrawer;
  readonly designerLoad: DesignerLoad;
  readonly designerPublish: DesignerPublish;
  readonly designerRender: DesignerRender;
  readonly effects: Effects;
  readonly fast: Fast;
  readonly format: Format;
  readonly glossary: Glossary;
  readonly guestWarn: GuestWarn;
  readonly howPlays: HowPlays;
  readonly hub: Hub;
  readonly hubAlerts: HubAlerts;
  readonly hubBlocks: HubBlocks;
  readonly hubChatRelay: HubChatRelay;
  readonly hubClan: HubClan;
  readonly hubCup: HubCup;
  readonly hubCustom: HubCustom;
  readonly hubDailyPlan: HubDailyPlan;
  readonly hubDiscord: HubDiscord;
  readonly hubHours: HubHours;
  readonly hubMods: HubMods;
  readonly hubNews: HubNews;
  readonly hubPanel: HubPanel;
  readonly hubPickup: HubPickup;
  readonly hubPlay: HubPlay;
  readonly hubRanks: HubRanks;
  readonly hubRecord: HubRecord;
  readonly hubReport: HubReport;
  readonly hubSettings: HubSettings;
  readonly hubShop: HubShop;
  readonly hubState: HubState;
  readonly hubSupport: HubSupport;
  readonly hubWardroom: HubWardroom;
  readonly impersonation: Impersonation;
  readonly inbox: Inbox;
  readonly inboxNeeds: InboxNeeds;
  readonly keymap: Keymap;
  readonly labkit: Labkit;
  readonly ladder: Ladder;
  readonly landing: Landing;
  readonly live: Live;
  readonly main: Main;
  readonly maintenance: Maintenance;
  readonly markers: Markers;
  readonly matchCard: MatchCard;
  readonly nettest: Nettest;
  readonly notices: Notices;
  readonly options: Options;
  readonly overlay: Overlay;
  readonly photo: Photo;
  readonly quickchat: Quickchat;
  readonly relayMark: RelayMark;
  readonly replay: Replay;
  readonly replayPage: ReplayPage;
  readonly reportSheet: ReportSheet;
  readonly seamarks: Seamarks;
  readonly seamountName: SeamountName;
  readonly seasonSummary: SeasonSummary;
  readonly settlement: Settlement;
  readonly share: Share;
  readonly siege: Siege;
  readonly sonarlab: Sonarlab;
  readonly squad: Squad;
  readonly state: State;
  readonly symbols: Symbols;
  readonly terrainlab: Terrainlab;
  readonly timelapse: Timelapse;
  readonly touchLog: TouchLog;
  readonly trials: Trials;
  readonly viewpanel: Viewpanel;
  readonly warcharts: Warcharts;
  readonly welcome: Welcome;
  readonly workshop: Workshop;
  readonly workshopLabels: WorkshopLabels;
  readonly world: World;
}
